(function() {
    'use strict';

    angular
        .module('serviciosocialApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'search': {method: 'GET', url:'api/users/search', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    if(!response.inProduction) {
	                    element.removeClass('hidden');
					}
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' ];

    function AuthServerProvider ($http, $localStorage ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        // $state.go('accessdenied').then(function() {
                        //    LoginService.open();
                        // });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'ReporteModalService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService, ReporteModalService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        
        vm.proyectosAprobadosPorModalidad = proyectosAprobadosPorModalidad;
        vm.proyectosAprobadosPorModalidadFac = proyectosAprobadosPorModalidadFac;
        vm.proyectosAprobadosPorPerfilModalidad = proyectosAprobadosPorPerfilModalidad;
        vm.proyectosAprobadosPorPerfilModalidadFac = proyectosAprobadosPorPerfilModalidadFac;
        vm.proyectosPorDependenciaModalidadTipo = proyectosPorDependenciaModalidadTipo;
        vm.proyectosAprobadosPorArea = proyectosAprobadosPorArea;
        vm.proyectosAprobadosPorFuncion = proyectosAprobadosPorFuncion;
        vm.proyectosAprobadosConApoyoEconomico = proyectosAprobadosConApoyoEconomico;
        vm.proyectosAprobadosConApoyoEconomicoFac = proyectosAprobadosConApoyoEconomicoFac;
        vm.proyectosAprobadosPorDependenciaVigencia = proyectosAprobadosPorDependenciaVigencia;
        vm.directorioDependencias = directorioDependencias;
        vm.prestadoresPorPerfil = prestadoresPorPerfil;
        vm.plazasDisponiblesAll = plazasDisponiblesAll;
        vm.plazasDisponibles = plazasDisponibles;
        vm.plazasDisponiblesByFac = plazasDisponiblesByFac;
        vm.prestadoresPorPerfilFac = prestadoresPorPerfilFac;
        vm.prestadoresPorDependenciaProyecto = prestadoresPorDependenciaProyecto;
        vm.bajasPrestadores = bajasPrestadores;
        vm.bajasPrestadoresFac = bajasPrestadoresFac;
        vm.proyectosPorPeriodo = proyectosPorPeriodo;
        
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }
        
        function proyectosAprobadosPorModalidad() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorModalidad();
        }
        
        function proyectosAprobadosPorModalidadFac() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorModalidadFac();
        }

        function proyectosAprobadosPorPerfilModalidad() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorPerfilModalidad();
        }
        
        function proyectosAprobadosPorPerfilModalidadFac() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorPerfilModalidadFac();
        }
                
        function proyectosPorDependenciaModalidadTipo() {
            collapseNavbar();
            ReporteModalService.proyectosPorDependenciaModalidadTipo();
        }

        function proyectosAprobadosPorArea() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorArea();
        }

        function proyectosAprobadosPorFuncion() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorFuncion();
        }
        
        function proyectosAprobadosConApoyoEconomico() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosConApoyoEconomico();
        }
        
        function proyectosAprobadosConApoyoEconomicoFac() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosConApoyoEconomicoFac();
        }

        function proyectosAprobadosPorDependenciaVigencia() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorDependenciaVigencia();
        }
        
        function directorioDependencias() {
            collapseNavbar();
            ReporteModalService.directorioDependencias();
        }

        function prestadoresPorPerfil() {
            collapseNavbar();
            ReporteModalService.prestadoresPorPerfil();
        }
        
        function plazasDisponiblesAll() {
            collapseNavbar();
            ReporteModalService.plazasDisponiblesAll();
        }
        
        function plazasDisponibles() {
            collapseNavbar();
            ReporteModalService.plazasDisponibles();
        }
        
        function plazasDisponiblesByFac() {
            collapseNavbar();
            ReporteModalService.plazasDisponiblesByFac();
        }
        
        function prestadoresPorPerfilFac() {
            collapseNavbar();
            ReporteModalService.prestadoresPorPerfilFac();
        }

        function prestadoresPorDependenciaProyecto() {
            collapseNavbar();
            ReporteModalService.prestadoresPorDependenciaProyecto();
        }

        function bajasPrestadores() {
            collapseNavbar();
            ReporteModalService.bajasPrestadores();
        }
        
        function bajasPrestadoresFac() {
            collapseNavbar();
            ReporteModalService.bajasPrestadoresFac();
        }
        
        function proyectosPorPeriodo() {
            collapseNavbar();
            ReporteModalService.proyectosPorPeriodo();
        }
        
        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            })       
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('buscador-proyectos', {
            parent: 'app',
            url: '/buscador-proyectos',
            data: {
                authorities: [],
                pageTitle: 'Buscador de proyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/buscador-proyectos.html',
                    controller: 'BuscadorProyectosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
	        	periodos: ['BuscadorProyectos', function(BuscadorProyectos){
	        		return BuscadorProyectos.periodos().$promise;
	        	}],
	        	centrosDocentes: ['BuscadorProyectos', function(BuscadorProyectos){
	        		return BuscadorProyectos.centrosDocentes().$promise;
	        	}],
	        	programasEducativos: ['BuscadorProyectos', function(BuscadorProyectos){
	        		return BuscadorProyectos.programasEducativos().$promise;
	        	}],
            }
        })
        .state('buscador-proyectos-solicitud', {
            parent: 'buscador-proyectos',
            url: '/solicitud/{id}',
            data: {
                authorities: [],
                pageTitle: 'Solicitud de proyecto'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/buscador-proyectos-solicitud.html',
                    controller: 'BuscadorProyectosSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'BuscadorProyectos', function($stateParams, BuscadorProyectos) {
                    return BuscadorProyectos.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 0;
                }
            }
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Auth', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Auth, Principal, LoginService, $state) {
        var vm = this;
        
        vm.authenticationError = false;
        vm.loginSicei = loginSicei;
        vm.passwordSicei = null;
        vm.usernameSicei = null;
        vm.loginExterno = loginExterno;
        vm.passwordExterno = null;
        vm.usernameExterno = null;
        vm.rememberMe = true;
        
        vm.account = null;
        vm.isAuthenticated = null;
        vm.requestResetPassword = requestResetPassword;
        vm.register = register;
        
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {            	
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        
        function loginSicei (event) {
            event.preventDefault();
            Auth.login({
                username: vm.usernameSicei + "@sicei",
                password: vm.passwordSicei,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                getAccount();
            }).catch(function () {
                vm.authenticationError = true;
            });
        }
        
        function loginExterno (event) {
            event.preventDefault();
            Auth.login({
                username: vm.usernameExterno + "@externo",
                password: vm.passwordExterno,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                getAccount();
            }).catch(function () {
                vm.authenticationError = true;
            });
        }
        
        function register () {
            $state.go('register');
        }
        
        function requestResetPassword () {
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('BuscadorProyectosSolicitudController', BuscadorProyectosSolicitudController);

    BuscadorProyectosSolicitudController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'selectedTab'];

    function BuscadorProyectosSolicitudController ($timeout, $scope, $state, $stateParams, entity, selectedTab) {
        var vm = this;

        vm.sSProyecto = entity;
        vm.selectedTab = selectedTab;
        vm.clear = clear;
                
        loadProject();
        
        function loadProject(){
        	vm.isDisabled = true;
            $scope.active = vm.selectedTab;
        }
        
        function clear () {
        	$state.go("buscador-proyectos");
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('BuscadorProyectos', BuscadorProyectos);

    BuscadorProyectos.$inject = ['$resource', 'DateUtils'];

    function BuscadorProyectos ($resource, DateUtils) {
        var resourceUrl =  '';

        return $resource(resourceUrl, {}, {
            'proyectosVigentes': { 
            	method: 'GET', 
            	url:'buscador-proyectos/proyectos/vigentes/:idCentroDocente,:idProgramaEducativo,:fechaFin',
            	isArray: true
           	},
            'programasEducativos': { 
            	method: 'GET',
            	url:'buscador-proyectos/programas-educativos',
            	isArray: true
           	},
            'programasEducativosByCentroDocente': { 
            	method: 'GET',
            	url:'buscador-proyectos/programas-educativos/:idCentroDocente',
            	isArray: true
           	},
            'centrosDocentes': { 
            	method: 'GET',
            	url:'buscador-proyectos/centros-docentes',
            	isArray: true
           	},
            'periodos': { 
            	method: 'GET',
            	url:'buscador-proyectos/periodos',
            	isArray: true
           	},
            'getSolicitud': {
                method: 'GET',
            	url:'buscador-proyectos/:id/solicitud',                
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.periodoInicial.iniPeriodo = DateUtils.convertDateTimeFromServer(data.periodoInicial.iniPeriodo);
                        data.periodoInicial.finPeriodo = DateUtils.convertDateTimeFromServer(data.periodoInicial.finPeriodo);
                        data.periodoInicial.iniConvocatoria = DateUtils.convertDateTimeFromServer(data.periodoInicial.iniConvocatoria);
                        data.periodoInicial.finConvocatoria = DateUtils.convertDateTimeFromServer(data.periodoInicial.finConvocatoria);
                        data.inicioVigencia = DateUtils.convertDateTimeFromServer(data.inicioVigencia);
                        data.finVigencia = DateUtils.convertDateTimeFromServer(data.finVigencia);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('BuscadorProyectosController', BuscadorProyectosController);

    BuscadorProyectosController.$inject = ['$scope', '$state', 'Auth', 'BuscadorProyectos', 'SSProyecto', 'ProgramaEducativo', 'centrosDocentes', 'periodos', 'ParseLinks', 'AlertService'];

    function BuscadorProyectosController($scope, $state, Auth, BuscadorProyectos, SSProyecto, ProgramaEducativo, centrosDocentes, periodos, ParseLinks, AlertService) {
        var vm = this;
        
        vm.searchForm = {};
        vm.search = search;
        
        vm.proyectoAccion = proyectoAccion;
        vm.proyectoDetalleSolicitud = proyectoDetalleSolicitud;
        
         periodos.$promise.then(function(periodos) {
        	vm.periodos = periodos;
        	vm.selectedPeriodo = periodos[0];
        	console.log(vm.selectedPeriodo);

	        centrosDocentes.$promise.then(function(centrosDocentes) {
	        	vm.centrosDocentes = [];
	            vm.centrosDocentes.push({id: 0, nombre: '- Todos'});         	
	        	vm.centrosDocentes = vm.centrosDocentes.concat(centrosDocentes);
	        	vm.selectedCentroDocente = vm.centrosDocentes[0];
	        	
	            BuscadorProyectos.programasEducativosByCentroDocente({
	            	idCentroDocente: vm.selectedCentroDocente.id,
	            }).$promise.then(function(programasEducativos) {
	            	vm.programasEducativos = [];
	                vm.programasEducativos.push({id: 0, nombre: '- Todos -'}); 
	                vm.programasEducativos = vm.programasEducativos.concat(programasEducativos);
	               	vm.selectedProgramaEducativo = vm.programasEducativos[0];
	            	loadProyectos();
	             });
	        });

        });
        
        function search() {
        	if(vm.searchForm.centroDocente.$dirty == true){
            	BuscadorProyectos.programasEducativosByCentroDocente({
                	idCentroDocente: vm.selectedCentroDocente.id,
            	}).$promise.then(function(programasEducativos) {
	    	    	vm.programasEducativos = [];
	    	        vm.programasEducativos.unshift({id: 0, nombre: '- Todos -'}); 
	    	        vm.programasEducativos = vm.programasEducativos.concat(angular.copy(programasEducativos));
	    	        vm.selectedProgramaEducativo = vm.programasEducativos[0];
	    	        loadProyectos();
	    	        vm.searchForm.centroDocente.$setPristine();
	            });
            } else {
            	loadProyectos();
            }
        }
        
        function loadProyectos(){
        	var centroDocente = vm.selectedCentroDocente.id;
        	if(vm.selectedProgramaEducativo.id != 0){
        		centroDocente = vm.selectedProgramaEducativo.centroDocente.id;
        	}
        	BuscadorProyectos.proyectosVigentes({
	        	idCentroDocente: centroDocente,
	        	idProgramaEducativo: vm.selectedProgramaEducativo.id,
    	       	fechaFin: vm.selectedPeriodo.finPeriodo,
	        }).$promise.then(function(proyectos) {
	        	vm.sSProyectos = proyectos;
	        });         	
        }
        
        function proyectoDetalleSolicitud(idProyecto, propagation, $event){
        	$state.go('buscador-proyectos-solicitud',{id: idProyecto});
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
                
        function proyectoAccion(idProyecto, propagation, $event){
       		$state.go('buscador-proyectos-solicitud',{id: idProyecto});
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('StatusAlumnoPlanDeEstudiosDialogController', StatusAlumnoPlanDeEstudiosDialogController);

    StatusAlumnoPlanDeEstudiosDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'StatusAlumnoPlanDeEstudios'];

    function StatusAlumnoPlanDeEstudiosDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, StatusAlumnoPlanDeEstudios) {
        var vm = this;

        vm.statusAlumnoPlanDeEstudios = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.statusAlumnoPlanDeEstudios.id !== null) {
                StatusAlumnoPlanDeEstudios.update(vm.statusAlumnoPlanDeEstudios, onSaveSuccess, onSaveError);
            } else {
                StatusAlumnoPlanDeEstudios.save(vm.statusAlumnoPlanDeEstudios, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:statusAlumnoPlanDeEstudiosUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('StatusAlumnoPlanDeEstudiosDetailController', StatusAlumnoPlanDeEstudiosDetailController);

    StatusAlumnoPlanDeEstudiosDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'StatusAlumnoPlanDeEstudios'];

    function StatusAlumnoPlanDeEstudiosDetailController($scope, $rootScope, $stateParams, previousState, entity, StatusAlumnoPlanDeEstudios) {
        var vm = this;

        vm.statusAlumnoPlanDeEstudios = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:statusAlumnoPlanDeEstudiosUpdate', function(event, result) {
            vm.statusAlumnoPlanDeEstudios = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('StatusAlumnoPlanDeEstudiosDeleteController',StatusAlumnoPlanDeEstudiosDeleteController);

    StatusAlumnoPlanDeEstudiosDeleteController.$inject = ['$uibModalInstance', 'entity', 'StatusAlumnoPlanDeEstudios'];

    function StatusAlumnoPlanDeEstudiosDeleteController($uibModalInstance, entity, StatusAlumnoPlanDeEstudios) {
        var vm = this;

        vm.statusAlumnoPlanDeEstudios = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            StatusAlumnoPlanDeEstudios.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('status-alumno-plan-de-estudios', {
            parent: 'entity',
            url: '/status-alumno-plan-de-estudios',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'StatusAlumnoPlanDeEstudios'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios.html',
                    controller: 'StatusAlumnoPlanDeEstudiosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('status-alumno-plan-de-estudios-detail', {
            parent: 'status-alumno-plan-de-estudios',
            url: '/status-alumno-plan-de-estudios/{id}',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'StatusAlumnoPlanDeEstudios'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios-detail.html',
                    controller: 'StatusAlumnoPlanDeEstudiosDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'StatusAlumnoPlanDeEstudios', function($stateParams, StatusAlumnoPlanDeEstudios) {
                    return StatusAlumnoPlanDeEstudios.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'status-alumno-plan-de-estudios',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('status-alumno-plan-de-estudios-detail.edit', {
            parent: 'status-alumno-plan-de-estudios-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios-dialog.html',
                    controller: 'StatusAlumnoPlanDeEstudiosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatusAlumnoPlanDeEstudios', function(StatusAlumnoPlanDeEstudios) {
                            return StatusAlumnoPlanDeEstudios.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('status-alumno-plan-de-estudios.new', {
            parent: 'status-alumno-plan-de-estudios',
            url: '/new',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios-dialog.html',
                    controller: 'StatusAlumnoPlanDeEstudiosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('status-alumno-plan-de-estudios', null, { reload: 'status-alumno-plan-de-estudios' });
                }, function() {
                    $state.go('status-alumno-plan-de-estudios');
                });
            }]
        })
        .state('status-alumno-plan-de-estudios.edit', {
            parent: 'status-alumno-plan-de-estudios',
            url: '/{id}/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios-dialog.html',
                    controller: 'StatusAlumnoPlanDeEstudiosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatusAlumnoPlanDeEstudios', function(StatusAlumnoPlanDeEstudios) {
                            return StatusAlumnoPlanDeEstudios.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('status-alumno-plan-de-estudios', null, { reload: 'status-alumno-plan-de-estudios' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('status-alumno-plan-de-estudios.delete', {
            parent: 'status-alumno-plan-de-estudios',
            url: '/{id}/delete',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios-delete-dialog.html',
                    controller: 'StatusAlumnoPlanDeEstudiosDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['StatusAlumnoPlanDeEstudios', function(StatusAlumnoPlanDeEstudios) {
                            return StatusAlumnoPlanDeEstudios.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('status-alumno-plan-de-estudios', null, { reload: 'status-alumno-plan-de-estudios' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('StatusAlumnoPlanDeEstudios', StatusAlumnoPlanDeEstudios);

    StatusAlumnoPlanDeEstudios.$inject = ['$resource'];

    function StatusAlumnoPlanDeEstudios ($resource) {
        var resourceUrl =  'api/status-alumno-plan-de-estudios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('StatusAlumnoPlanDeEstudiosController', StatusAlumnoPlanDeEstudiosController);

    StatusAlumnoPlanDeEstudiosController.$inject = ['StatusAlumnoPlanDeEstudios'];

    function StatusAlumnoPlanDeEstudiosController(StatusAlumnoPlanDeEstudios) {

        var vm = this;

        vm.statusAlumnoPlanDeEstudios = [];

        loadAll();

        function loadAll() {
            StatusAlumnoPlanDeEstudios.query(function(result) {
                vm.statusAlumnoPlanDeEstudios = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('Sexo', Sexo);

    Sexo.$inject = ['$resource', 'DateUtils'];

    function Sexo ($resource, DateUtils) {
        var resourceUrl =  'api/sexos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSUnidadReceptoraDialogController', SSUnidadReceptoraDialogController);

    SSUnidadReceptoraDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSUnidadReceptora', 'SSSector', 'SSProyecto'];

    function SSUnidadReceptoraDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSUnidadReceptora, SSSector, SSProyecto) {
        var vm = this;

        vm.sSUnidadReceptora = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.sssectors = SSSector.query();
        vm.ssproyectos = SSProyecto.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSUnidadReceptora.id !== null) {
                SSUnidadReceptora.update(vm.sSUnidadReceptora, onSaveSuccess, onSaveError);
            } else {
                SSUnidadReceptora.save(vm.sSUnidadReceptora, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSUnidadReceptoraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSUnidadReceptoraDetailController', SSUnidadReceptoraDetailController);

    SSUnidadReceptoraDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSUnidadReceptora', 'SSSector', 'SSProyecto'];

    function SSUnidadReceptoraDetailController($scope, $rootScope, $stateParams, previousState, entity, SSUnidadReceptora, SSSector, SSProyecto) {
        var vm = this;

        vm.sSUnidadReceptora = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSUnidadReceptoraUpdate', function(event, result) {
            vm.sSUnidadReceptora = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSUnidadReceptoraDeleteController',SSUnidadReceptoraDeleteController);

    SSUnidadReceptoraDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSUnidadReceptora'];

    function SSUnidadReceptoraDeleteController($uibModalInstance, entity, SSUnidadReceptora) {
        var vm = this;

        vm.sSUnidadReceptora = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSUnidadReceptora.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-unidad-receptora', {
            parent: 'entity',
            url: '/ss-unidad-receptora',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSUnidadReceptoras'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-unidad-receptora/s-s-unidad-receptoras.html',
                    controller: 'SSUnidadReceptoraController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-unidad-receptora-detail', {
            parent: 'ss-unidad-receptora',
            url: '/ss-unidad-receptora/{id}',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSUnidadReceptora'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-unidad-receptora/ss-unidad-receptora-detail.html',
                    controller: 'SSUnidadReceptoraDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSUnidadReceptora', function($stateParams, SSUnidadReceptora) {
                    return SSUnidadReceptora.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-unidad-receptora',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-unidad-receptora-detail.edit', {
            parent: 'ss-unidad-receptora-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-unidad-receptora/ss-unidad-receptora-dialog.html',
                    controller: 'SSUnidadReceptoraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSUnidadReceptora', function(SSUnidadReceptora) {
                            return SSUnidadReceptora.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-unidad-receptora.new', {
            parent: 'ss-unidad-receptora',
            url: '/new',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-unidad-receptora/ss-unidad-receptora-dialog.html',
                    controller: 'SSUnidadReceptoraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                institucion: null,
                                institucionAbrev: null,
                                dependencia: null,
                                dependenciaAbrev: null,
                                unidadReceptora: null,
                                unidadReceptoraAbrev: null,
                                direccion: null,
                                email: null,
                                telefono1: null,
                                telefono2: null,
                                fax: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-unidad-receptora', null, { reload: 'ss-unidad-receptora' });
                }, function() {
                    $state.go('ss-unidad-receptora');
                });
            }]
        })
        .state('ss-unidad-receptora.edit', {
            parent: 'ss-unidad-receptora',
            url: '/{id}/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-unidad-receptora/ss-unidad-receptora-dialog.html',
                    controller: 'SSUnidadReceptoraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSUnidadReceptora', function(SSUnidadReceptora) {
                            return SSUnidadReceptora.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-unidad-receptora', null, { reload: 'ss-unidad-receptora' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-unidad-receptora.delete', {
            parent: 'ss-unidad-receptora',
            url: '/{id}/delete',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-unidad-receptora/ss-unidad-receptora-delete-dialog.html',
                    controller: 'SSUnidadReceptoraDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSUnidadReceptora', function(SSUnidadReceptora) {
                            return SSUnidadReceptora.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-unidad-receptora', null, { reload: 'ss-unidad-receptora' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSUnidadReceptora', SSUnidadReceptora);

    SSUnidadReceptora.$inject = ['$resource', 'DateUtils'];

    function SSUnidadReceptora ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-unidad-receptoras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSUnidadReceptoraController', SSUnidadReceptoraController);

    SSUnidadReceptoraController.$inject = ['SSUnidadReceptora'];

    function SSUnidadReceptoraController(SSUnidadReceptora) {

        var vm = this;

        vm.sSUnidadReceptoras = [];

        loadAll();

        function loadAll() {
            SSUnidadReceptora.query(function(result) {
                vm.sSUnidadReceptoras = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSSectorDialogController', SSSectorDialogController);

    SSSectorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSSector'];

    function SSSectorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSSector) {
        var vm = this;

        vm.sSSector = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSSector.id !== null) {
                SSSector.update(vm.sSSector, onSaveSuccess, onSaveError);
            } else {
                SSSector.save(vm.sSSector, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSSectorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSSectorDetailController', SSSectorDetailController);

    SSSectorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSSector'];

    function SSSectorDetailController($scope, $rootScope, $stateParams, previousState, entity, SSSector) {
        var vm = this;

        vm.sSSector = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSSectorUpdate', function(event, result) {
            vm.sSSector = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSSectorDeleteController',SSSectorDeleteController);

    SSSectorDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSSector'];

    function SSSectorDeleteController($uibModalInstance, entity, SSSector) {
        var vm = this;

        vm.sSSector = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSSector.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-sector', {
            parent: 'entity',
            url: '/ss-sector',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSSectors'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-sector/s-s-sectors.html',
                    controller: 'SSSectorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-sector-detail', {
            parent: 'ss-sector',
            url: '/ss-sector/{id}',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSSector'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-sector/ss-sector-detail.html',
                    controller: 'SSSectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSSector', function($stateParams, SSSector) {
                    return SSSector.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-sector',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-sector-detail.edit', {
            parent: 'ss-sector-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-sector/ss-sector-dialog.html',
                    controller: 'SSSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSSector', function(SSSector) {
                            return SSSector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-sector.new', {
            parent: 'ss-sector',
            url: '/new',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-sector/ss-sector-dialog.html',
                    controller: 'SSSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                descripcion: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-sector', null, { reload: 'ss-sector' });
                }, function() {
                    $state.go('ss-sector');
                });
            }]
        })
        .state('ss-sector.edit', {
            parent: 'ss-sector',
            url: '/{id}/edit',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-sector/ss-sector-dialog.html',
                    controller: 'SSSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSSector', function(SSSector) {
                            return SSSector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-sector', null, { reload: 'ss-sector' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-sector.delete', {
            parent: 'ss-sector',
            url: '/{id}/delete',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-sector/ss-sector-delete-dialog.html',
                    controller: 'SSSectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSSector', function(SSSector) {
                            return SSSector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-sector', null, { reload: 'ss-sector' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSSector', SSSector);

    SSSector.$inject = ['$resource', 'DateUtils'];

    function SSSector ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSSectorController', SSSectorController);

    SSSectorController.$inject = ['SSSector'];

    function SSSectorController(SSSector) {

        var vm = this;

        vm.sSSectors = [];

        loadAll();

        function loadAll() {
            SSSector.query(function(result) {
                vm.sSSectors = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('ReporteModalService', ReporteModalService);

    ReporteModalService.$inject = ['$uibModal'];

    function ReporteModalService ($uibModal) {
        var service = {
        	proyectosAprobadosPorModalidad: proyectosAprobadosPorModalidad,
        	proyectosAprobadosPorModalidadFac: proyectosAprobadosPorModalidadFac,
        	proyectosAprobadosPorPerfilModalidad: proyectosAprobadosPorPerfilModalidad,
        	proyectosAprobadosPorPerfilModalidadFac: proyectosAprobadosPorPerfilModalidadFac,
        	proyectosPorDependenciaModalidadTipo: proyectosPorDependenciaModalidadTipo,
        	proyectosAprobadosPorArea: proyectosAprobadosPorArea,
        	proyectosAprobadosPorFuncion: proyectosAprobadosPorFuncion,
        	proyectosAprobadosConApoyoEconomico: proyectosAprobadosConApoyoEconomico,
        	proyectosAprobadosConApoyoEconomicoFac: proyectosAprobadosConApoyoEconomicoFac,
        	proyectosAprobadosPorDependenciaVigencia: proyectosAprobadosPorDependenciaVigencia, 
        	directorioDependencias: directorioDependencias,
        	prestadoresPorPerfil: prestadoresPorPerfil,
        	plazasDisponiblesAll: plazasDisponiblesAll,
        	plazasDisponibles: plazasDisponibles,
        	plazasDisponiblesByFac: plazasDisponiblesByFac,
        	prestadoresPorPerfilFac: prestadoresPorPerfilFac,
        	prestadoresPorDependenciaProyecto: prestadoresPorDependenciaProyecto,
        	bajasPrestadores: bajasPrestadores,
        	bajasPrestadoresFac: bajasPrestadoresFac,
        	proyectosPorPeriodo: proyectosPorPeriodo
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function proyectosAprobadosPorModalidad () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorModalidadController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Modalidad (y Facultad)'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: ['SSAmbito', function(SSAmbito) {
                        return SSAmbito.query().$promise;
                    }],
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    programasEducativos:null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosPorModalidadFac () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorModalidadController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Modalidad'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: ['SSAmbito', function(SSAmbito) {
                        return SSAmbito.query().$promise;
                    }],
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.getByCurrentUser().$promise;
                    }],
                    programasEducativos:null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosPorPerfilModalidad () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorPerfilModalidadController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Perfil y Modalidad'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: ['SSAmbito', function(SSAmbito) {
                        return SSAmbito.query().$promise;
                    }],
                    centrosDocentes: null,
                    programasEducativos: ['ProgramaEducativo', function(ProgramaEducativo) {
		                return ProgramaEducativo.all().$promise;
		            }],
		            sSEstatusProyecto: null

               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosPorPerfilModalidadFac () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorPerfilModalidadController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Perfil y Modalidad'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: ['SSAmbito', function(SSAmbito) {
                        return SSAmbito.query().$promise;
                    }],
                    centrosDocentes: null,
                    programasEducativos: ['ProgramaEducativo', function(ProgramaEducativo) {
		                return ProgramaEducativo.getByCurrentUser().$promise;
		            }],
		            sSEstatusProyecto: null

               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosPorDependenciaModalidadTipo () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosPorDependenciaModalidadTipoController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos por Dependencia, Modalidad y Tipo (Aprobados y No Aprobados)'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: null,
                    programasEducativos: null,
		            sSEstatusProyecto: ['SSEstatusProyecto', function(SSEstatusProyecto) {
		                return SSEstatusProyecto.all().$promise;
		            }]
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosPorArea () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorAreaController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Área Prioritaria de Desarollo con Prestadores'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosPorFuncion () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorFuncionController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Función en la que Inciden con Prestadores'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosConApoyoEconomico () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosConApoyoEconomicoController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados con Apoyo Económico (por Facultad)'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosConApoyoEconomicoFac () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosConApoyoEconomicoController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados con Apoyo Económico'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.getByCurrentUser().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosPorDependenciaVigencia () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorDependenciaVigenciaController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Dependencia y Vigencia'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function directorioDependencias () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'DirectorioDependenciasController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Directorio de Dependencias que Registraron Proyectos'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function prestadoresPorPerfil () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'PrestadoresPorPerfilController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Prestadores Asignados de Acuerdo al Perfil Solicitado (por Facultad)'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function plazasDisponiblesAll () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'PrestadoresPlazasDisponiblesAllController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos con plazas disponibles'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function plazasDisponibles () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'PrestadoresPlazasDisponiblesController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos con plazas disponibles'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.getByCurrentUser().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function plazasDisponiblesByFac () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'PrestadoresPlazasDisponiblesController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos con plazas disponibles'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function prestadoresPorPerfilFac () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'PrestadoresPorPerfilController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Prestadores Asignados de Acuerdo al Perfil Solicitado'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.getByCurrentUser().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function prestadoresPorDependenciaProyecto () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'PrestadoresPorDependenciaProyectoController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Prestadores Asignados por Dependencia y por Proyectos de Acuerdo al Perfil'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: ['SSAmbito', function(SSAmbito) {
                        return SSAmbito.query().$promise;
                    }],
                    centrosDocentes: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function bajasPrestadores () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'BajasPrestadoresController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Bajas de Prestadores de Acuerdo al Perfil (por Facultad)'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    sSAmbitos: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function bajasPrestadoresFac () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'BajasPrestadoresController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Bajas de Prestadores de Acuerdo al Perfil'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.getByCurrentUser().$promise;
                    }],
                    sSAmbitos: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }

        function proyectosPorPeriodo () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosPorPeriodoController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos por Periodo'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    centrosDocentes: null,
                    sSAmbitos: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('ReporteDownloadService', ReporteDownloadService);

    ReporteDownloadService.$inject = ['$q','$http', '$filter'];

    function ReporteDownloadService ($q, $http, $filter) {
        var service = {
            	proyectosAprobadosPorModalidad: proyectosAprobadosPorModalidad,
            	proyectosAprobadosPorPerfilModalidad: proyectosAprobadosPorPerfilModalidad,
            	proyectosPorDependenciaModalidadTipo: proyectosPorDependenciaModalidadTipo,
            	proyectosAprobadosPorArea: proyectosAprobadosPorArea,
            	proyectosAprobadosPorFuncion: proyectosAprobadosPorFuncion,
            	proyectosAprobadosConApoyoEconomico: proyectosAprobadosConApoyoEconomico,
            	proyectosAprobadosPorDependenciaVigencia: proyectosAprobadosPorDependenciaVigencia, 
            	directorioDependencias: directorioDependencias,
            	plazasDisponibles: plazasDisponibles,
            	plazasDisponiblesAll: plazasDisponiblesAll,
            	prestadoresPorPerfil: prestadoresPorPerfil,
            	prestadoresPorDependenciaProyecto: prestadoresPorDependenciaProyecto,
            	bajasPrestadores: bajasPrestadores,
            	proyectosPorPeriodo: proyectosPorPeriodo
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function proyectosAprobadosPorModalidad (periodo, ambito, centroDocente) {
            
        	var defer = $q.defer();
                
            $http({
				url: 'api/s-s-reportes/proyectosAprobadosPorModalidad/'+ periodo + "/" + ambito + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosAprobadosPorModalidad_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosAprobadosPorPerfilModalidad (periodo, ambito, programaEducativo) {
            
        	var defer = $q.defer();
                
            $http({
				url: 'api/s-s-reportes/proyectosAprobadosPorPerfilModalidad/'+ periodo + "/" + ambito + "/" + programaEducativo,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosAprobadosPorPerfilModalidad_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosPorDependenciaModalidadTipo (periodo, estatus) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/proyectosPorDependenciaModalidadTipo/'+ periodo + "/" + estatus,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosPorDependenciaModalidadTipo_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosAprobadosPorArea (periodo, centroDocente) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/proyectosAprobadosPorArea/'+ periodo + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosAprobadosPorArea_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosAprobadosPorFuncion (periodo, centroDocente) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/proyectosAprobadosPorFuncion/'+ periodo + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosAprobadosPorFuncion_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosAprobadosConApoyoEconomico (periodo, centroDocente) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/proyectosAprobadosConApoyoEconomico/'+ periodo + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosAprobadosConApoyoEconomico_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosAprobadosPorDependenciaVigencia (periodo) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/proyectosAprobadosPorDependenciaVigencia/'+ periodo,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosAprobadosPorDependenciaVigencia_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function directorioDependencias (periodo) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/directorioDependencias/'+ periodo,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "directorioDependencias_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function plazasDisponiblesAll (periodo) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/prestadoresPlazasDisponibles/'+ periodo,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				console.log("idPeriodo "+periodo);
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "prestadoresPlazasDisponibles_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function plazasDisponibles (periodo, centroDocente) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/prestadoresPlazasDisponibles/'+ periodo + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				console.log("idPeriodo "+periodo);
				console.log("idCentroDocente "+centroDocente);
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "prestadoresPlazasDisponibles_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function prestadoresPorPerfil (periodo, centroDocente) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/prestadoresPorPerfil/'+ periodo + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "prestadoresPorPerfil_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function prestadoresPorDependenciaProyecto (periodo, ambito) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/prestadoresPorDependenciaProyecto/'+ periodo + "/" + ambito,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "prestadoresPorDependenciaProyecto_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function bajasPrestadores (periodo, centroDocente) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/bajasPrestadores/'+ periodo + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "bajasPrestadores_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosPorPeriodo (periodo) {
            
        	var defer = $q.defer();
                
            $http({
				url: 'api/s-s-reportes/proyectosPorPeriodo/'+ periodo,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosPorPeriodo_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProyectosPorPeriodoController', ProyectosPorPeriodoController);

    ProyectosPorPeriodoController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function ProyectosPorPeriodoController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });        
        vm.sSAmbitos = sSAmbitos;
        vm.centrosDocentes = centrosDocentes;
        vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;       	
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.proyectosPorPeriodo(
                    vm.selectedSSPeriodo.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProyectosPorDependenciaModalidadTipoController', ProyectosPorDependenciaModalidadTipoController);

    ProyectosPorDependenciaModalidadTipoController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function ProyectosPorDependenciaModalidadTipoController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedPeriodo = periodos[0];
        });
        
        vm.sSAmbitos = sSAmbitos;
        vm.centrosDocentes = centrosDocentes;
      	vm.programasEducativos = programasEducativos;
             
        sSEstatusProyecto.$promise.then(function(sSEstatusProyecto) {
        	vm.sSEstatusProyecto = sSEstatusProyecto;
        	vm.selectedssEstatusProyecto = sSEstatusProyecto[0];
        });
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.proyectosPorDependenciaModalidadTipo(
                    vm.selectedSSPeriodo.id,
                    vm.selectedSSEstatusProyecto
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProyectosAprobadosPorPerfilModalidadController', ProyectosAprobadosPorPerfilModalidadController);

    ProyectosAprobadosPorPerfilModalidadController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function ProyectosAprobadosPorPerfilModalidadController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        sSAmbitos.$promise.then(function(sSAmbitos) {
        	vm.sSAmbitos = sSAmbitos;
            vm.selectedSSAmbito = sSAmbitos[0];
        });
        
        vm.centrosDocentes = centrosDocentes;
        
        programasEducativos.$promise.then(function(programaEducativos) {
          	vm.programasEducativos = programaEducativos;
          	vm.selectedProgramaEducativo = programaEducativos[0];
        });
             
    	vm.sSEstatusProyecto = sSEstatusProyecto;       	
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.proyectosAprobadosPorPerfilModalidad(
                    vm.selectedSSPeriodo.id,
                    vm.selectedSSAmbito,
                    vm.selectedProgramaEducativo.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProyectosAprobadosPorModalidadController', ProyectosAprobadosPorModalidadController);

    ProyectosAprobadosPorModalidadController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function ProyectosAprobadosPorModalidadController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        sSAmbitos.$promise.then(function(sSAmbitos) {
        	vm.sSAmbitos = sSAmbitos;
            vm.selectedAmbito = sSAmbitos[0];
        });
        
        centrosDocentes.$promise.then(function(centroDocentes) {
        	vm.centrosDocentes = centroDocentes;
            vm.selectedCentroDocente = centroDocentes[0];
        });
        
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.proyectosAprobadosPorModalidad(
                vm.selectedSSPeriodo.id,
                vm.selectedSSAmbito,
                vm.selectedCentroDocente.id
            ).then(function () {
            	console.log("DONE");
            }).catch(function () {
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProyectosAprobadosPorFuncionController', ProyectosAprobadosPorFuncionController);

    ProyectosAprobadosPorFuncionController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function ProyectosAprobadosPorFuncionController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        vm.sSAmbitos = sSAmbitos;
        
        centrosDocentes.$promise.then(function(centroDocentes) {
        	vm.centrosDocentes = centroDocentes;
            vm.selectedCentroDocente = centroDocentes[0];
        });
        
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.proyectosAprobadosPorFuncion(
                    vm.selectedSSPeriodo.id,
                    vm.selectedCentroDocente.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProyectosAprobadosPorDependenciaVigenciaController', ProyectosAprobadosPorDependenciaVigenciaController);

    ProyectosAprobadosPorDependenciaVigenciaController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function ProyectosAprobadosPorDependenciaVigenciaController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        vm.sSAmbitos = sSAmbitos;
        vm.centrosDocentes = centrosDocentes;
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.proyectosAprobadosPorDependenciaVigencia(
                    vm.selectedSSPeriodo.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProyectosAprobadosPorAreaController', ProyectosAprobadosPorAreaController);

    ProyectosAprobadosPorAreaController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function ProyectosAprobadosPorAreaController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        vm.sSAmbitos = sSAmbitos;
        
        centrosDocentes.$promise.then(function(centroDocentes) {
        	vm.centrosDocentes = centroDocentes;
            vm.selectedCentroDocente = centroDocentes[0];
        });
        
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.proyectosAprobadosPorArea(
                    vm.selectedSSPeriodo.id,
                    vm.selectedCentroDocente.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProyectosAprobadosConApoyoEconomicoController', ProyectosAprobadosConApoyoEconomicoController);

    ProyectosAprobadosConApoyoEconomicoController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function ProyectosAprobadosConApoyoEconomicoController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        vm.sSAmbitos = sSAmbitos;
        
        centrosDocentes.$promise.then(function(centroDocentes) {
        	vm.centrosDocentes = centroDocentes;
            vm.selectedCentroDocente = centroDocentes[0];
        });
        
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;       	
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.proyectosAprobadosConApoyoEconomico(
                    vm.selectedSSPeriodo.id,
                    vm.selectedCentroDocente.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PrestadoresPorPerfilController', PrestadoresPorPerfilController);

    PrestadoresPorPerfilController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function PrestadoresPorPerfilController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        vm.sSAmbitos = sSAmbitos;
        
        centrosDocentes.$promise.then(function(centroDocentes) {
        	vm.centrosDocentes = centroDocentes;
            vm.selectedCentroDocente = centroDocentes[0];
        });
        
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.prestadoresPorPerfil(
                    vm.selectedSSPeriodo.id,
                    vm.selectedCentroDocente.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PrestadoresPorDependenciaProyectoController', PrestadoresPorDependenciaProyectoController);

    PrestadoresPorDependenciaProyectoController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function PrestadoresPorDependenciaProyectoController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        sSAmbitos.$promise.then(function(sSAmbitos) {
        	vm.sSAmbitos = sSAmbitos;
            vm.selectedSSAmbito = sSAmbitos[0];
        });

        vm.centrosDocentes = centrosDocentes;
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.prestadoresPorDependenciaProyecto(
                    vm.selectedSSPeriodo.id,
                    vm.selectedSSAmbito
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PrestadoresPlazasDisponiblesAllController', PrestadoresPlazasDisponiblesAllController);

    PrestadoresPlazasDisponiblesAllController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function PrestadoresPlazasDisponiblesAllController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        vm.sSAmbitos = sSAmbitos;
        
//        centrosDocentes.$promise.then(function(centroDocentes) {
//        	vm.centrosDocentes = centroDocentes;
//            vm.selectedCentroDocente = centroDocentes[0];
//        });
        
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.plazasDisponiblesAll(
                    vm.selectedSSPeriodo.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PrestadoresPlazasDisponiblesController', PrestadoresPlazasDisponiblesController);

    PrestadoresPlazasDisponiblesController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function PrestadoresPlazasDisponiblesController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        vm.sSAmbitos = sSAmbitos;
        
        centrosDocentes.$promise.then(function(centroDocentes) {
        	vm.centrosDocentes = centroDocentes;
            vm.selectedCentroDocente = centroDocentes[0];
        });
        
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.plazasDisponibles(
                    vm.selectedSSPeriodo.id,
                    vm.selectedCentroDocente.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('DirectorioDependenciasController', DirectorioDependenciasController);

    DirectorioDependenciasController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function DirectorioDependenciasController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        vm.sSAmbitos = sSAmbitos;
        vm.centrosDocentes = centrosDocentes;
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.directorioDependencias(
                    vm.selectedSSPeriodo.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('BajasPrestadoresController', BajasPrestadoresController);

    BajasPrestadoresController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function BajasPrestadoresController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        centrosDocentes.$promise.then(function(centroDocentes) {
        	vm.centrosDocentes = centroDocentes;
            vm.selectedCentroDocente = centroDocentes[0];
        });
        
        vm.sSAmbitos = sSAmbitos;
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;
                
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.bajasPrestadores(
                    vm.selectedSSPeriodo.id,
                    vm.selectedCentroDocente.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('TipoBaja', TipoBaja);

    TipoBaja.$inject = ['$resource', 'DateUtils'];

    function TipoBaja ($resource, DateUtils) {
        var resourceUrl =  'api/tipo-baja/:id';

        return $resource(resourceUrl, {}, {
            'all': { 
            	method: 'GET',
            	url:'api/tipo-baja-all',
            	isArray: true
           	},  
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-proyectos-solicitud', {
            parent: 'entity',
            url: '/solicitud',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                  templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud.html',
                  controller: 'SSProyectoSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {                    	
                        id: null,
                        nombre: null,
                        ambito: null,
                        semestres: null,
                        funcion: null,
                        modalidad: null,
                        area: null,
                        objetivosGenerales: null,
                        objetivosEspecificos: null,
                        beneficiarios: null,
                        recursosMateriales: null,
                        recursosHumanos: null,
                        recursosInfraestructura: null,
                        monto: 0,
                        viaticosAlimentos: false,
                        viaticosTransporte: false,
                        horarioPrestador: null,
                        induccion: null,
                        horasInduccion: 0,
                        supervisionInstrumentos: null,
                        supervisionPeriodicidad: null,
                        supervisionCriterios: null,                        
                        perfils: [],
                        respDePrestadors:[],
                        unidadesReceptoras: [{
                        	id: null,
                        	institucion: null,
                        	dependencia: null,
                        	unidadReceptora: null,
                        	direccion: null,
                        	email: null,
                        	telefono1: null,
                        	telefono2: null,
                        	fax: null,
                        	sector: null, 
                        }],
                        respDeProyectos: [{
                        	id: null,
                        	nombres: null,
                        	primerApellido: null,
                        	segundoApellido: null,
                        	sexo: null,
                        	titulo: null,
                        	email: null,
                        	telefono: null,
                        	telefono2: null,
                        }],
                        cveProgramaSII: null,
                        cveProgAprobadoSII: null,
                        descripcion: null,
                        estatus: null,
                        inicioVigencia: null,
                        finVigencia: null,
                        justificacion: null,
                        meta: null,
                        calendarizacion: null,
                        altaReg: null,
                        bajaReg: null,
                        ultActReg: null,
                        activo: null,
                        usuarioUltAct: null,
                        aprobadoanteriormente: false,
                        proyectoidanterior: null
                    };
                },
                selectedTab: function () {
                	return 0;
                },
                section: function () {
                	return 1;
                },
            }
        })
        .state('ss-proyecto-solicitud', {
            parent: 'ss-proyectos',
            url: '/solicitud/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud.html',
                    controller: 'SSProyectoSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 0;
                }
            }
        })
        .state('ss-proyecto-seguimiento', {
            parent: 'ss-proyectos',
            url: '/seguimiento/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud.html',
                    controller: 'SSProyectoSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 1;
                }
            }
        })
    }
})();

(function() {
	'use strict';

	angular
		.module('serviciosocialApp')
		.controller('SSProyectoSolicitudController', SSProyectoSolicitudController);

	SSProyectoSolicitudController.$inject = [ '$timeout', '$scope', '$state', '$uibModal',
			'$stateParams', '$location', 'entity', 'selectedTab',
			'SSProyecto', 'SSArea', 'SSFuncion', 'SSModalidad', 'SSPerfil',
			'ProgramaEducativo', 'SSSector', 'SSAmbito', 'SSPeriodo',
			'SSMovimientoEstatusProyecto', 'SSEditarEstatusModalService', 'SSEnviarSolicitudModalService'];

	function SSProyectoSolicitudController($timeout, $scope, $state, $uibModal,
			$stateParams, $location, entity, selectedTab,
			SSProyecto, SSArea, SSFuncion, SSModalidad, SSPerfil,
			ProgramaEducativo, SSSector,SSAmbito, SSPeriodo, 
			SSMovimientoEstatusProyecto, SSEditarEstatusModalService, SSEnviarSolicitudModalService) {
		var vm = this;
				
		/* PARAMETROS */
		vm.sSProyecto = entity;
		vm.selectedTab = selectedTab;		
		
		/* NAVEGACION */
    	vm.previousSection = previousSection;
    	vm.nextSection = nextSection;

    	/* FORMULARIO */
		vm.ssareas = SSArea.query();
		vm.ssfuncions = SSFuncion.query();
		vm.ssmodalidads = SSModalidad.query();
		vm.programasEducativos = ProgramaEducativo.distinct();
		vm.sssectores = SSSector.query();
		vm.ssambitos = SSAmbito.query();
		vm.periodoVigente = "";
		vm.semestres = [ "1", "2", "3", "4" ];
		
		/* METODOS */
		vm.editarEstatus = null;
		vm.agregarPerfil = agregarPerfil;
		vm.editarPerfil = editarPerfil;
		vm.removerPerfil = removerPerfil;
		vm.save = save;
		vm.send = send;
		vm.clear = clear;

		loadProject();

		
		
		function loadProject() {
//			console.log("Estoy aca");
			/* Obtener periodo de convocatoria vigente */
			SSPeriodo.getPeriodoConvocatoriaVigente().$promise.then(onSuccess, onError);
			
			/* Si el proyecto está guardado */ 
			if (vm.sSProyecto.id !== null) {
				
				/* Y se ha registrado, mostrar tab de seguimiento */
				SSMovimientoEstatusProyecto.hasBeenRegistered({
						idProyecto : vm.sSProyecto.id
					}).$promise.then(function(result) {
						vm.showSeguimiento = result;
					});
				/* Obtener lista de estatusProyecto */ 				
				SSMovimientoEstatusProyecto.getByProyecto({
						idProyecto : vm.sSProyecto.id
					}).$promise.then(function(result) {
						vm.sSMovimientoEstatusProyectos = result;
					});
			}
			
			$scope.active = vm.selectedTab;
			if(vm.selectedTab == 0){
		    	vm.section = 1;				
			}
		}
		
		/* Si hay convocatoria vigente: 
		 * validaciones para habilitar/deshabilitar formulario y asignar periodo vigente */
		function onSuccess(result) {
//			console.log(result);
			var today = new Date();			
			if (vm.sSProyecto.id == null){
				vm.isDisabled = false;
				vm.periodoVigente = result;
			} else if (vm.sSProyecto.estatus == 'EDICION' || 
					(vm.sSProyecto.estatus == 'REPLANTEADO' && today <= vm.sSProyecto.periodoInicial.finPeriodo)) {
				vm.isDisabled = false;
				vm.periodoVigente = vm.sSProyecto.periodoInicial;
			} else {
				vm.isDisabled = true;
				vm.periodoVigente = vm.sSProyecto.periodoInicial;
			}
		}

		/* Si no hay convocatoria vigente:
		 * validaciones para habilitar/deshabilitar formulario y asignar periodo vigente */
		function onError() {
			var today = new Date();
			
			if(vm.sSProyecto.id == null){
				vm.isDisabled = true;
				vm.periodoVigente = null;
				
			} else if(vm.sSProyecto.estatus == 'REPLANTEADO' && today <= vm.sSProyecto.periodoInicial.finPeriodo){
				vm.isDisabled = false;
				vm.periodoVigente = vm.sSProyecto.periodoInicial;
			
			} else {
				vm.isDisabled = true;
				vm.periodoVigente = vm.sSProyecto.periodoInicial;
			}
		}
		
		/* Navegar a seccion anterior */
        function previousSection(){
        	if(vm.section > 1 && vm.section < 5){
        		validateProjectSaving();
        		vm.section = vm.section - 1;
        	}
        }

		/* Navegar a seccion siguiente */
        function nextSection(){
        	if(vm.section > 0 && vm.section < 4){
        		validateProjectSaving();
        		vm.section = vm.section + 1;
        	}
        }
        
        /* Valida si necesita guardarse el proyecto */
        function validateProjectSaving(){
    		if(vm.section !== 3 && $scope.editForm.$dirty){
    			save();
    		}
        }
        
        /* Guardar proyecto */
		function save() {
			
			if(vm.sSProyecto.aprobadoanteriormente){
				//Valida que el num del proyecto aprobado con anterioridad exista
				existeNumProy();
			}else{
				salvar();
			}

		}
		
		function salvar(){
			vm.isSaving = true;
			vm.sSProyecto.inicioVigencia = vm.periodoVigente.iniPeriodo;
			vm.sSProyecto.finVigencia = vm.periodoVigente.finPeriodo;
			validarRespDeProyecto();
			validarUnidadReceptora();
			asignarFinVigencia();
			asignarAmbito();
			if (vm.sSProyecto.id !== null) {
				SSProyecto.updateBySolicitante(vm.sSProyecto, onUpdateSuccess, onSaveError);
			} else {
				SSProyecto.save(vm.sSProyecto, onSaveSuccess, onSaveError);
			}
			vm.noExisProyAproAnt = false;
		}
		
		function existeNumProy(){
			vm.noExisProyAproAnt = false;
			var promise = SSProyecto.getProyAproAnteriormente({id : vm.sSProyecto.proyectoidanterior});
//			console.log(promise);
			
			promise.$promise.then(function (result) {
				//Sucess
				vm.noExisProyAproAnt = false;
				console.log(result);	
				salvar();
			
			}).catch(function (error) {
				//ERROR
				vm.noExisProyAproAnt = true;
	            console.log(error);
	        });
		}
		
		function onUpdateSuccess(result) {
			$scope.editForm.$setPristine();
			vm.isSaving = false;
			vm.sSProyecto = result;
		}

		function onSaveSuccess(result) {
			$scope.editForm.$setPristine();
			vm.isSaving = false;
			vm.sSProyecto = result;
			$state.go("ss-proyecto-solicitud", {id : result.id, section : 2});
		}

		function onSaveError() {
			vm.isSaving = false;
		}
        
		function asignarAmbito(){
			if (vm.sSProyecto.unidadesReceptoras[0].sector != null) {
				if (vm.sSProyecto.unidadesReceptoras[0].sector.id == 5)
					vm.sSProyecto.ambito = "INTERNO";
				else
					vm.sSProyecto.ambito = "EXTERNO";
			} else {
				vm.sSProyecto.ambito = null;
			}
		}

		function validarRespDeProyecto() {
			if (vm.sSProyecto.respDeProyectos.length == 1) {
				if (vm.sSProyecto.respDeProyectos[0].id == null) {
					if (vm.sSProyecto.respDeProyectos[0].nombres == null)
						vm.sSProyecto.respDeProyectos[0].nombres = '';
					if (vm.sSProyecto.respDeProyectos[0].primerApellido == null)
						vm.sSProyecto.respDeProyectos[0].primerApellido = '';
					if (vm.sSProyecto.respDeProyectos[0].segundoApellido == null)
						vm.sSProyecto.respDeProyectos[0].segundoApellido = '';
					if (vm.sSProyecto.respDeProyectos[0].cargo == null)
						vm.sSProyecto.respDeProyectos[0].cargo = '';
				}
			} else {
				console.log("respDeProyectos not properly setted.");
			}
		}

		function validarUnidadReceptora() {
			if (vm.sSProyecto.unidadesReceptoras.length == 1) {
				if (vm.sSProyecto.unidadesReceptoras[0].id == null) {
					if (vm.sSProyecto.unidadesReceptoras[0].institucion == null)
						vm.sSProyecto.unidadesReceptoras[0].institucion = '';
					if (vm.sSProyecto.unidadesReceptoras[0].unidadReceptora == null)
						vm.sSProyecto.unidadesReceptoras[0].unidadReceptora = '';
					if (vm.sSProyecto.unidadesReceptoras[0].dependencia == null)
						vm.sSProyecto.unidadesReceptoras[0].dependencia = '';
				} 
			} else {
				console.log("unidadesReceptoras not properly setted.");
			}
		}
		
		/**
		 * Este metodo se encarga de poner la fecha final de un proyecto con base al siguiente criterio:
		 * 
		 * Un semestre equivale a 6 meses de duracion
		 * # Semestres | Meses acumulados
		 * 1 semestres | 6 meses (Medio año)
		 * 2 semestres | 12 meses (Un año)
		 * 3 semestres | 18 meses (Un año y medio)
		 * 4 semestres | 24 meses (Dos años)
		 */
		function asignarFinVigencia(){
//			console.log("asignarFinVigencia");
			/*
			if (vm.sSProyecto.semestres == 1)
				vm.sSProyecto.finVigencia = vm.periodoVigente.finPeriodo;
			else 
				if(vm.sSProyecto.semestres == 2 && vm.periodoVigente.finPeriodo.getMonth() == 5) 
					vm.sSProyecto.finVigencia = new Date(vm.periodoVigente.finPeriodo.getFullYear(), 11, 31); // 31 de Dic del mismo año
				else
					if(vm.sSProyecto.semestres == 2 && vm.periodoVigente.finPeriodo.getMonth() == 11)
						vm.sSProyecto.finVigencia = new Date(vm.periodoVigente.finPeriodo.getFullYear()+1, 5, 30); // 30 de Junio del sig año
					else
						if(vm.sSProyecto.semestres == 3)
							vm.sSProyecto.finVigencia = new Date(vm.periodoVigente.finPeriodo.getFullYear()+1,vm.periodoVigente.finPeriodo.getMonth(),vm.periodoVigente.finPeriodo.getDate()); // la misma fecha del año siguiente
						else
							if (vm.sSProyecto.semestres == 4 && vm.periodoVigente.finPeriodo.getMonth() == 5)
								vm.sSProyecto.finVigencia = new Date(vm.periodoVigente.finPeriodo.getFullYear()+1, 11, 31); // 31 de Dic del siguiente año
							else 
								if(vm.sSProyecto.semestres == 4 && vm.periodoVigente.finPeriodo.getMonth() == 11)
									vm.sSProyecto.finVigencia = new Date(vm.periodoVigente.finPeriodo.getFullYear()+2, 5, 30); // 30 de Junio de dos años adelante
			*/ 
			// Primero veamos cuantos meses se quieren aniadir
			var semestres = vm.sSProyecto.semestres;
//			console.log("Semestres: "+semestres);
			var aniadirMeses = 0; //Dato variable dependiendo del numero de semestres
			switch (semestres) {//El dato semestre puede venir como numero o como cadena
			  case '1':
				  aniadirMeses = 6;
//				  console.log("case 1");
			    break;
			  case '2':
				  aniadirMeses = 12;
//				  console.log("case 2");
			    break;
			  case '3':
				  aniadirMeses = 18;
//				  console.log("case 3");
			    break;
			  case '4':
				  aniadirMeses = 24;
//				  console.log("case 4");
				break;
			  case 1:
				  aniadirMeses = 6;
//				  console.log("case 1");
			    break;
			  case 2:
				  aniadirMeses = 12;
//				  console.log("case 2");
			    break;
			  case 3:
				  aniadirMeses = 18;
//				  console.log("case 3");
			    break;
			  case 4:
				  aniadirMeses = 24;
//				  console.log("case 4");
				break;
			  default://Para que no se quede son nada en caso de que no se hayan puesto los semestres aun
				  aniadirMeses = 6;
//			  		console.log("case default");
			    break;
			}
//			console.log("aniadirMeses: "+aniadirMeses);
			//Optengamos la fecha inicio del proyecto
			var date = vm.periodoVigente.iniPeriodo;
			
			//Comenzamos a calcular la fecha fin del proyecto
			var baseMeses = 12;//Constante, no deberia cambiar
			var mesBase = date.getMonth();
			var anioBase = date.getFullYear();
			var sumAux = mesBase + aniadirMeses;
//			console.log("sumAux: "+sumAux);
			var mesFinal = baseMeses;
			var anioFinal = anioBase;
			if(sumAux > baseMeses){
			    var cocienteEntero = Math.floor(sumAux/baseMeses);
//			    console.log("cocienteEntero: "+cocienteEntero);
			    var resto = sumAux % baseMeses;
//			    console.log("resto: "+resto);
			    if(resto !=0){
			        mesFinal = resto;
			        anioFinal = anioBase + cocienteEntero;
			    }else{
			        if(cocienteEntero>1){
			            anioFinal = anioBase + (cocienteEntero-1);
			        }
			    }
			}else{
			    mesFinal = sumAux;
//			    console.log("anioFinal: "+anioFinal);
			}
			// Se le tiene que restar -1 para que concuerde con el sistema de que enero es 0
			mesFinal = mesFinal - 1;
//			console.log("Mes:"+mesFinal);
//			console.log("Anio:"+anioFinal);
			var fechaDia = new Date(anioFinal, mesFinal, 1); 
			var diaFechaFinal = new Date(fechaDia.getFullYear(), fechaDia.getMonth() + 1, 0);
			var diaFinal = diaFechaFinal.getDate();
			vm.sSProyecto.finVigencia = new Date(anioFinal, mesFinal, diaFinal); 
//			console.log("Vigencia fin: "+vm.sSProyecto.finVigencia);
			
		}

		function agregarPerfil() {
			if (vm.sSProyecto.perfils == null) {
				vm.sSProyecto.perfils = [];
			}			
		    var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-perfil-proyecto/ss-perfil-proyecto.html',
                controller: 'SSPerfilProyectoController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            programaEducativo: null,
                            solicitados: null,
            				actividads : [],
            				respDePrestadors : [],
                        };
                    }
                }
            });
		      modalInstance.result.then(function (newPerfil) {
		    	  	vm.isSaving = true;
			    	var perfilToSave = newPerfil;
			        SSProyecto.savePerfilBySolicitante({
			        	perfil: perfilToSave, 
			        	proyecto: vm.sSProyecto.id},
			            function (result) {
							$scope.editForm.$setPristine();
							vm.isSaving = false;
							vm.sSProyecto = result;
			        });
		      }, function () {
		      });
		}
		
		function editarPerfil(index, perfil) {
		    var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-perfil-proyecto/ss-perfil-proyecto.html',
                controller: 'SSPerfilProyectoController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return perfil;
                    }
                }
            });
		    modalInstance.result.then(function (editedPerfil) {
		    	vm.isSaving = true;
		    	var perfilToSave = editedPerfil;
		        SSProyecto.savePerfilBySolicitante({
					perfil: perfilToSave, 
					proyecto: vm.sSProyecto.id},
		            function (result) {	        	
						$scope.editForm.$setPristine();
						vm.isSaving = false;
			            vm.sSProyecto = result;
		        	});
		    	}, function () {
		    	});
		}

		function removerPerfil(index) {
			vm.isSaving = true;
			var perfilToDelete = vm.sSProyecto.perfils[index];
            SSProyecto.deletePerfilBySolicitante({sSProyecto: vm.sSProyecto.id, sSPerfil: perfilToDelete.id},
            	function (result) {
            		vm.isSaving = false;
            		vm.sSProyecto = result;
            	});
		}
		
		function send() {
			SSEnviarSolicitudModalService.open();
		}

		function clear() {
			$state.go("ss-proyectos");
		}

	}
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoFacultadSolicitudController', SSProyectoFacultadSolicitudController);

    SSProyectoFacultadSolicitudController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'selectedTab', 'SSProyecto', 'SSArea', 'SSFuncion', 'SSModalidad', 'ProgramaEducativo', 'SSSector', 'SSAmbito', 'Sexo', 'SSPeriodo', 'SSMovimientoEstatusProyecto', 'SSEditarEstatusModalService'];

    function SSProyectoFacultadSolicitudController ($timeout, $scope, $state, $stateParams, entity, selectedTab, SSProyecto, SSArea, SSFuncion, SSModalidad, ProgramaEducativo, SSSector, SSAmbito, Sexo, SSPeriodo, SSMovimientoEstatusProyecto, SSEditarEstatusModalService) {
        var vm = this;

        /* PARAMETROS */
        vm.sSProyecto = entity;
        vm.selectedTab = selectedTab;
        
        /* FORMULARIO */
        vm.ssareas = SSArea.query();
        vm.ssfuncions = SSFuncion.query();
        vm.ssmodalidads = SSModalidad.query();
    	vm.programasEducativos = ProgramaEducativo.all();
        vm.sssectores = SSSector.query();
        vm.ssambitos = SSAmbito.query();
        vm.sexos = Sexo.query();
        vm.semestres =  ["1", "2", "3", "4"];
                
        /* METODOS */
        vm.editarEstatus = null;
        vm.agregarPerfil = null;
        vm.editarPerfil = null;
        vm.removerPerfil = null;
        vm.save = null;
        vm.clear = clear;

        loadProject();
        
        function loadProject(){
        	vm.isDisabled = true;
        	vm.showSeguimiento = true;
            SSMovimientoEstatusProyecto.getByProyecto({
            		idProyecto : vm.sSProyecto.id
            	}).$promise.then(function(result){
            		vm.sSMovimientoEstatusProyectos = result;
        	});
            $scope.active = vm.selectedTab;
        }
        
        function clear () {
        	$state.go("ss-proyectos-facultad");
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoFacultadController', SSProyectoFacultadController);

    SSProyectoFacultadController.$inject = ['$state', 'SSProyecto', 'periodos', 'programasEducativos', 'estatusProyectos', 'ParseLinks', 'AlertService'];

    function SSProyectoFacultadController($state, SSProyecto, periodos, programasEducativos, estatusProyectos, ParseLinks, AlertService) {

        var vm = this;
        vm.searchForm = {};
        vm.search = search;
        vm.searchType = "filters";

        vm.proyectoAccion = proyectoAccion;
        vm.proyectoDetalleAsignacion = proyectoDetalleAsignacion;
        vm.proyectoDetalleSolicitud = proyectoDetalleSolicitud;

        periodos.$promise.then(function (periodos) {
            vm.periodos = periodos;
            vm.selectedPeriodo = periodos[0];
        });

        vm.estatusProyecto = estatusProyectos;
        vm.selectedEstatusProyecto = estatusProyectos[0];

        programasEducativos.$promise.then(function (programasEducativos) {
            vm.programasEducativos = angular.copy(programasEducativos);
            vm.programasEducativos.unshift({ id: 0, nombre: '- Todos', centroDocente: { id: 0 } });
            console.log(vm.programasEducativos);
            vm.selectedProgramaEducativo = vm.programasEducativos[0];
            loadProyectos();
        });

        function search() {
            if (vm.searchType == "filters") {
                loadProyectos();
            } else if (vm.searchType == "student" && !(vm.alumno == null || vm.alumno == "")) {
                loadAlumno();
            } else {
                vm.sSProyectos = [];
            }
        }

        function loadAlumno() {
            SSProyecto.queryAlumnoFacultad({
                alumno: vm.alumno
            }).$promise.then(function (proyectos) {
                vm.sSProyectos = proyectos;
            });
        }

        function loadProyectos() {
            SSProyecto.queryCurrentUser({
                idCentroDocente: vm.selectedProgramaEducativo.centroDocente.id,
                idProgramaEducativo: vm.selectedProgramaEducativo.id,
                fechaIniPer: vm.selectedPeriodo.iniPeriodo,
                fechaFinPer: vm.selectedPeriodo.finPeriodo,
                estatusProyecto: vm.selectedEstatusProyecto
            }).$promise.then(function (proyectos) {
                vm.sSProyectos = proyectos;
            });

        }

        function proyectoDetalleAsignacion(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-facultad-detail', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoAccion(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-facultad-detail', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoDetalleSolicitud(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-facultad-solicitud', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoSeguimiento(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-facultad-seguimiento', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoDetailController', SSProyectoDetailController);

    SSProyectoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SSProyecto', 'SSPersona', 'SSUnidadReceptora', 'SSPerfil', 'SSPeriodo', 'SSArea', 'SSFuncion', 'SSModalidad', 'SSAsignacion', 'CartaLiberacionDownloadService', 'CartaAsignacionDownloadService', 'AlertService'];

    function SSProyectoDetailController($scope, $rootScope, $stateParams, entity, SSProyecto, SSPersona, SSUnidadReceptora, SSPerfil, SSPeriodo, SSArea, SSFuncion, SSModalidad, SSAsignacion, CartaLiberacionDownloadService, CartaAsignacionDownloadService, AlertService) {
        var vm = this;
        vm.cartaLiberacion = cartaLiberacion;
        vm.cartaAsignacion = cartaAsignacion;

        entity.$promise.then(function(result) {
        	vm.sSProyecto = result;
        	vm.periodos = result.periodos;
        	vm.selectedPeriodo = vm.periodos[0];
        });
        
        var unsubscribe = $rootScope.$on('serviciosocialApp:sSProyectoUpdate', function(event, result) {
            vm.sSProyecto = result;
        });
        
        $scope.$on('$destroy', unsubscribe);
        
        $scope.filterPerfiles = function (item) { 
			var currentAssignations = item.asignacions.filter(function(e){
				return (e.periodo.id == vm.selectedPeriodo.id && e.estatusPrestador != 'BAJA');	
			});
			return item.bajaReg === null || currentAssignations.length > 0
		};
		
		$scope.filterAsignacionesActivasEnPeriodo = function (item) { 
				return (item.periodo.id == vm.selectedPeriodo.id && item.estatusPrestador != 'BAJA');	
		};
		
        
        function cartaLiberacion(idAsignacion, matricula) {
        	CartaLiberacionDownloadService.download(idAsignacion, matricula)
            .then(function(data) {
            	AlertService.success("Carta de liberación generada.");
            })
            .catch(function(err) {
            	AlertService.error("Ocurrió un error al generar la carta de liberación");
           	});
        }
        
        function cartaAsignacion(asignacion, matricula) {        	
        	SSAsignacion.validarStatusAlumno({
				idAsignacion : asignacion
			}).$promise.then(function(result) {
				if(result.estatus == true){
		        	CartaAsignacionDownloadService.download(asignacion, matricula)
		            .then(function(data) {
		            	AlertService.success("Carta de asignación generada.");
		            })
		            .catch(function(err) {
		            	AlertService.error("Ocurrió un error al generar la carta de asignación");
		           });
		        } else {
					AlertService.error("El alumno no está activo en el plan de estudios.", {toast: true, position: 'bottom right'});					
				}
			});

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoDeleteController',SSProyectoDeleteController);

    SSProyectoDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSProyecto'];

    function SSProyectoDeleteController($uibModalInstance, entity, SSProyecto) {
        var vm = this;

        vm.sSProyecto = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        console.log(vm.sSProyecto);

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	console.log(id);
            SSProyecto.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoComiteSolicitudController', SSProyectoComiteSolicitudController);

    SSProyectoComiteSolicitudController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'selectedTab', 'SSProyecto', 'SSArea', 'SSFuncion', 'SSModalidad', 'ProgramaEducativo', 'SSSector', 'SSAmbito', 'Sexo', 'SSPeriodo', 'SSMovimientoEstatusProyecto', 'SSEditarEstatusModalService'];

    function SSProyectoComiteSolicitudController ($timeout, $scope, $state, $stateParams, entity, selectedTab, SSProyecto, SSArea, SSFuncion, SSModalidad, ProgramaEducativo, SSSector, SSAmbito, Sexo, SSPeriodo, SSMovimientoEstatusProyecto, SSEditarEstatusModalService) {
        var vm = this;

        /* PARAMETROS */
        vm.sSProyecto = entity;
        vm.selectedTab = selectedTab;
        
        /* FORMULARIO */
        vm.ssareas = SSArea.query();
        vm.ssfuncions = SSFuncion.query();
        vm.ssmodalidads = SSModalidad.query();
    	vm.programasEducativos = ProgramaEducativo.all();
        vm.sssectores = SSSector.query();
        vm.ssambitos = SSAmbito.query();
        vm.sexos = Sexo.query();
        vm.semestres =  ["1", "2", "3", "4"];
                
        /* METODOS */
        vm.editarEstatus = editarEstatus;
        vm.agregarPerfil = null;
        vm.editarPerfil = null;
        vm.removerPerfil = null;
        vm.save = null;
        vm.clear = clear;
        
        $scope.$on('updateEstatusProyectoSuccess', function() {   	
        	SSProyecto.getSolicitud({id : $stateParams.id}).$promise.then(function (result) {
            	vm.sSProyecto = result;
            	loadProject();
        	});
        });
        
        loadProject();
        
        function loadProject(){
        	vm.isDisabled = true;
        	vm.showSeguimiento = true;
            SSMovimientoEstatusProyecto.getByProyecto({
            		idProyecto : vm.sSProyecto.id
            	}).$promise.then(function(result){
            		vm.sSMovimientoEstatusProyectos = result;
        	});
            $scope.active = vm.selectedTab;
        }
        
        function editarEstatus() {
        	SSEditarEstatusModalService.openComite(vm.sSProyecto.id);
        }

        function clear () {
        	$state.go("ss-proyectos-comite");
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoComiteController', SSProyectoComiteController);

    SSProyectoComiteController.$inject = ['$state', 'SSProyecto', 'ProgramaEducativo', 'periodos', 'centrosDocentes', 'estatusProyectos', 'ParseLinks', 'AlertService'];

    function SSProyectoComiteController($state, SSProyecto, ProgramaEducativo, periodos, centrosDocentes, estatusProyectos, ParseLinks, AlertService) {

        var vm = this;
        vm.searchForm = {};
        vm.search = search;
        vm.searchType = "filters";

        vm.proyectoAccion = proyectoAccion;
        vm.proyectoDetalleSolicitud = proyectoDetalleSolicitud;
        vm.proyectoSeguimiento = proyectoSeguimiento;

        periodos.$promise.then(function (periodos) {
            vm.periodos = periodos;
            vm.selectedPeriodo = periodos[0];
        });

        vm.estatusProyecto = estatusProyectos;
        vm.selectedEstatusProyecto = estatusProyectos[0];

        centrosDocentes.$promise.then(function (centrosDocentes) {
            vm.centrosDocentes = [];
            vm.centrosDocentes.push({ id: 0, nombre: '- Todos' });
            vm.centrosDocentes = vm.centrosDocentes.concat(centrosDocentes);
            vm.selectedCentroDocente = vm.centrosDocentes[0];

            ProgramaEducativo.allByCentroDocente({
                idCentroDocente: vm.selectedCentroDocente.id,
            }).$promise.then(function (programasEducativos) {
                vm.programasEducativos = [];
                vm.programasEducativos.push({ id: 0, nombre: '- Todos' });
                vm.programasEducativos = vm.programasEducativos.concat(programasEducativos);
                vm.selectedProgramaEducativo = vm.programasEducativos[0];
                loadProyectos();
            });
        });

        function search() {
            if (vm.searchType == "filters") {
                if (vm.searchForm.centroDocente.$dirty == true) {
                    ProgramaEducativo.allByCentroDocente({
                        idCentroDocente: vm.selectedCentroDocente.id,
                    }).$promise.then(function (programasEducativos) {
                        vm.programasEducativos = [];
                        vm.programasEducativos.unshift({ id: 0, nombre: '- Todos' });
                        vm.programasEducativos = vm.programasEducativos.concat(angular.copy(programasEducativos));
                        vm.selectedProgramaEducativo = vm.programasEducativos[0];
                        loadProyectos();
                        vm.searchForm.centroDocente.$setPristine();
                    });
                } else {
                    loadProyectos();
                }
            } else if (vm.searchType == "student" && !(vm.alumno == null || vm.alumno == "")) {
                loadAlumno();
            } else {
                vm.sSProyectos = [];
            }
        }

        function loadAlumno() {
            SSProyecto.queryAlumno({
                alumno: vm.alumno
            }).$promise.then(function (proyectos) {
                vm.sSProyectos = proyectos;
            });
        }

        function loadProyectos() {
            var centroDocente = vm.selectedCentroDocente.id;
            if (vm.selectedProgramaEducativo.id != 0) {
                centroDocente = vm.selectedProgramaEducativo.centroDocente.id;
            }
            SSProyecto.query({
                idCentroDocente: centroDocente,
                idProgramaEducativo: vm.selectedProgramaEducativo.id,
                fechaIniPer: vm.selectedPeriodo.iniPeriodo,
                fechaFinPer: vm.selectedPeriodo.finPeriodo,
                estatusProyecto: vm.selectedEstatusProyecto
            }).$promise.then(function (proyectos) {
                vm.sSProyectos = proyectos;
            });
        }

        function proyectoDetalleSolicitud(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-comite-solicitud', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoSeguimiento(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-comite-seguimiento', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoAccion(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-comite-solicitud', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoCentralSolicitudController', SSProyectoCentralSolicitudController);

    SSProyectoCentralSolicitudController.$inject = ['$timeout', '$scope', '$state', '$uibModal', '$stateParams', 'entity', 'selectedTab', 'SSProyecto', 'SSArea', 'SSFuncion', 'SSModalidad', 'ProgramaEducativo', 'SSSector', 'SSAmbito', 'Sexo', 'SSMovimientoEstatusProyecto', 'SSEditarEstatusModalService'];

    function SSProyectoCentralSolicitudController ($timeout, $scope, $state, $uibModal, $stateParams, entity, selectedTab, SSProyecto, SSArea, SSFuncion, SSModalidad, ProgramaEducativo, SSSector, SSAmbito, Sexo, SSMovimientoEstatusProyecto, SSEditarEstatusModalService) {
        var vm = this;

        /* PARAMETROS */
        vm.sSProyecto = entity;
        vm.selectedTab = selectedTab;

        /* FORMULARIO */
        vm.ssareas = SSArea.query();
        vm.ssfuncions = SSFuncion.query();
        vm.ssmodalidads = SSModalidad.query();
    	vm.programasEducativos = ProgramaEducativo.all();
        vm.sssectores = SSSector.query();
        vm.ssambitos = SSAmbito.query();
        vm.sexos = Sexo.query();
        vm.periodoVigente = null;
        vm.semestres =  ["1", "2", "3", "4"];
        
        /* METODOS */
        vm.editarEstatus = editarEstatus;
        vm.agregarPerfil = agregarPerfil;
		vm.editarPerfil = editarPerfil;
        vm.removerPerfil = removerPerfil;
        vm.save = save;
        vm.clear = clear;
        
        $scope.$on('updateEstatusProyectoSuccess', function() {
        	SSProyecto.getSolicitud({id : $stateParams.id}).$promise.then(function (result) {
            	vm.sSProyecto = result;
            	loadProject();
        	});
        });
        
        loadProject();
        
        function loadProject(){
        	vm.isDisabled = false;
        	vm.showSeguimiento = true;        	
            SSMovimientoEstatusProyecto.getByProyecto({
            		idProyecto : vm.sSProyecto.id
            	}).$promise.then(function(result){
        		vm.sSMovimientoEstatusProyectos = result;
        	});
            $scope.active = vm.selectedTab;
        }
                
        function editarEstatus() {
        	SSEditarEstatusModalService.openCentral(vm.sSProyecto.id);
        }
        
		function save() {
			vm.isSaving = true;
			validarRespDeProyecto();
			validarUnidadReceptora();
			asignarAmbito();
			SSProyecto.updateByAdministrativo(vm.sSProyecto, onUpdateSuccess, onSaveError);
		}
        
		function onUpdateSuccess(result) {
			$scope.editForm.$setPristine();
			vm.isSaving = false;
			vm.sSProyecto = result;
		}

		function onSaveError() {
			vm.isSaving = false;
		}
		
		function asignarAmbito(){
			if (vm.sSProyecto.unidadesReceptoras[0].sector != null) {
				if (vm.sSProyecto.unidadesReceptoras[0].sector.id == 5)
					vm.sSProyecto.ambito = "INTERNO";
				else
					vm.sSProyecto.ambito = "EXTERNO";
			} else {
				vm.sSProyecto.ambito = null;
			}
		}
		
		
		function validarRespDeProyecto() {
			if (vm.sSProyecto.respDeProyectos.length == 1) {
				if (vm.sSProyecto.respDeProyectos[0].id == null) {
					if (vm.sSProyecto.respDeProyectos[0].nombres == null)
						vm.sSProyecto.respDeProyectos[0].nombres = '';
					if (vm.sSProyecto.respDeProyectos[0].primerApellido == null)
						vm.sSProyecto.respDeProyectos[0].primerApellido = '';
					if (vm.sSProyecto.respDeProyectos[0].segundoApellido == null)
						vm.sSProyecto.respDeProyectos[0].segundoApellido = '';
				}
			} else {
				console.log("respDeProyectos not properly setted.");
			}
		}

		function validarUnidadReceptora() {
			if (vm.sSProyecto.unidadesReceptoras.length == 1) {
				if (vm.sSProyecto.unidadesReceptoras[0].id == null) {
					if (vm.sSProyecto.unidadesReceptoras[0].institucion == null)
						vm.sSProyecto.unidadesReceptoras[0].institucion = '';
					if (vm.sSProyecto.unidadesReceptoras[0].unidadReceptora == null)
						vm.sSProyecto.unidadesReceptoras[0].unidadReceptora = '';
					if (vm.sSProyecto.unidadesReceptoras[0].dependencia == null)
						vm.sSProyecto.unidadesReceptoras[0].dependencia = '';
				}
			} else {
				console.log("unidadesReceptoras not properly setted.");
			}
		}
		
		
		function agregarPerfil() {
			if (vm.sSProyecto.perfils == null) {
				vm.sSProyecto.perfils = [];
			}			
		    var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-perfil-proyecto/ss-perfil-proyecto.html',
                controller: 'SSPerfilProyectoController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            programaEducativo: null,
                            solicitados: null,
            				actividads : [],
            				respDePrestadors : [],
                        };
                    }
                }
            });
		      modalInstance.result.then(function (newPerfil) {
			    	var perfilToSave = newPerfil;
			        SSProyecto.savePerfilByAdministrativo({
			        	perfil: perfilToSave, 
			        	proyecto: vm.sSProyecto.id},
			            function (result) {
							$scope.editForm.$setPristine();
							vm.isSaving = false;
							vm.sSProyecto = result;
			        });
		      }, function () {
		      });			
			
		}
		
		function editarPerfil(index, perfil) {
			var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-perfil-proyecto/ss-perfil-proyecto.html',
                controller: 'SSPerfilProyectoController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return perfil;
                    }
                }
            });
		    modalInstance.result.then(function (editedPerfil) {
		    	var perfilToSave = editedPerfil;
		    	SSProyecto.savePerfilByAdministrativo({
		    		perfil: perfilToSave, 
		    		proyecto: vm.sSProyecto.id},
		    		function (result) {
		    			$scope.editForm.$setPristine();
		    			vm.isSaving = false;
			            vm.sSProyecto = result;
		    		});
			    }, function () {
			    });
		}

		function removerPerfil(index) {
			var perfilToDelete = vm.sSProyecto.perfils[index];
            SSProyecto.deletePerfilByAdministrativo({
            	sSProyecto: vm.sSProyecto.id, 
            	sSPerfil: perfilToDelete.id},
            	function () {
            		vm.sSProyecto.perfils.splice(index, 1);
            	}, function () {
		    	});
		}
        
        function clear () {
        	$state.go("ss-proyectos-central");
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoCentralController', SSProyectoCentralController);

    SSProyectoCentralController.$inject = ['$state', 'SSProyecto', 'ProgramaEducativo', 'periodos', 'centrosDocentes', 'estatusProyectos', 'ParseLinks', 'AlertService'];

    function SSProyectoCentralController($state, SSProyecto, ProgramaEducativo, periodos, centrosDocentes, estatusProyectos, ParseLinks, AlertService) {

        var vm = this;
        vm.searchForm = {};
        vm.search = search;
        vm.searchType = "filters";

        vm.proyectoAccion = proyectoAccion;
        vm.proyectoDetalleSolicitud = proyectoDetalleSolicitud;
        vm.proyectoSeguimiento = proyectoSeguimiento;
        vm.proyectoDetalleAsignacion = proyectoDetalleAsignacion;
        vm.proyectoEditarVigencia = proyectoEditarVigencia;

        periodos.$promise.then(function (periodos) {
            vm.periodos = periodos;
            vm.selectedPeriodo = periodos[0];
        });

        vm.estatusProyecto = estatusProyectos;
        vm.selectedEstatusProyecto = estatusProyectos[0];

        centrosDocentes.$promise.then(function (centrosDocentes) {
            vm.centrosDocentes = [];
            vm.centrosDocentes.push({ id: 0, nombre: '- Todos' });
            vm.centrosDocentes = vm.centrosDocentes.concat(centrosDocentes);
            vm.selectedCentroDocente = vm.centrosDocentes[0];

            ProgramaEducativo.allByCentroDocente({
                idCentroDocente: vm.selectedCentroDocente.id,
            }).$promise.then(function (programasEducativos) {
                vm.programasEducativos = [];
                vm.programasEducativos.push({ id: 0, nombre: '- Todos' });
                vm.programasEducativos = vm.programasEducativos.concat(programasEducativos);
                vm.selectedProgramaEducativo = vm.programasEducativos[0];
                loadProyectos();
            });
        });

        function search() {
            if (vm.searchType == "filters") {
                if (vm.searchForm.centroDocente.$dirty == true) {
                    ProgramaEducativo.allByCentroDocente({
                        idCentroDocente: vm.selectedCentroDocente.id,
                    }).$promise.then(function (programasEducativos) {
                        vm.programasEducativos = [];
                        vm.programasEducativos.unshift({ id: 0, nombre: '- Todos' });
                        vm.programasEducativos = vm.programasEducativos.concat(angular.copy(programasEducativos));
                        vm.selectedProgramaEducativo = vm.programasEducativos[0];
                        loadProyectos();
                        vm.searchForm.centroDocente.$setPristine();
                    });
                } else {
                    loadProyectos();
                }
            } else if (vm.searchType == "student" && !(vm.alumno == null || vm.alumno == "")) {
                loadAlumno();
            } else {
                vm.sSProyectos = [];
            }
        }

        function loadAlumno() {
            SSProyecto.queryAlumno({
                alumno: vm.alumno
            }).$promise.then(function (proyectos) {
                vm.sSProyectos = proyectos;
            });
        }

        function loadProyectos() {
            var centroDocente = vm.selectedCentroDocente.id;
            if (vm.selectedProgramaEducativo.id != 0) {
                centroDocente = vm.selectedProgramaEducativo.centroDocente.id;
            }
            SSProyecto.query({
                idCentroDocente: centroDocente,
                idProgramaEducativo: vm.selectedProgramaEducativo.id,
                fechaIniPer: vm.selectedPeriodo.iniPeriodo,
                fechaFinPer: vm.selectedPeriodo.finPeriodo,
                estatusProyecto: vm.selectedEstatusProyecto
            }).$promise.then(function (proyectos) {
                vm.sSProyectos = proyectos;
            });
        }

        function proyectoDetalleSolicitud(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-central-solicitud', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoSeguimiento(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-central-seguimiento', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoDetalleAsignacion(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-central-detail', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoEditarVigencia(idProyecto, propagation, $event) {
            $state.go('ss-editar-vigencia', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoAccion(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-central-detail', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-proyectos-facultad', {
            parent: 'entity',
            url: '/ss-proyectos-facultad',
            data: {
                authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
                pageTitle: 'SSProyectosFacultad'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-fac.html',
                    controller: 'SSProyectoFacultadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	periodos: ['SSPeriodo', function(SSPeriodo){
            		return SSPeriodo.all().$promise;
            	}],
	        	programasEducativos: ['ProgramaEducativo', function(ProgramaEducativo){
	        		return ProgramaEducativo.getByCurrentUser().$promise;
	        	}],
	        	estatusProyectos: function () {
                	return ["APROBADO", "DICTAMEN", "REGISTRADO", "NO_APROBADO", "BAJA_TEMPORAL", "BAJA_DEFINITIVA"];
                }
            }
        })
        .state('ss-proyecto-facultad-detail', {
            parent: 'ss-proyectos-facultad',
            url: '/detail/{id}',
            data: {
                authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
                pageTitle: 'SSProyecto'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-fac-detail.html',
                    controller: 'SSProyectoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
            		return SSProyecto.getByCentroDocente({id : $stateParams.id});
            	}]
            }
        })
        .state('ss-proyectos-central', {
            parent: 'entity',
            url: '/ss-proyectos-central',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSProyectosCentral'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-central/ss-proyecto-central.html',
                    controller: 'SSProyectoCentralController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	periodos: ['SSPeriodo', function(SSPeriodo){
            		return SSPeriodo.all().$promise;
            	}],
	        	centrosDocentes: ['CentroDocente', function(CentroDocente){
	        		return CentroDocente.all().$promise;
	        	}],
	        	estatusProyectos: function () {
                	return ["REGISTRADO", "DICTAMEN", "APROBADO", "EDICION", "REPLANTEADO", "NO_APROBADO", "BAJA_TEMPORAL", "BAJA_DEFINITIVA"];
                }
            }
        })
        .state('ss-proyecto-central-detail', {
            parent: 'ss-proyectos-central',
            url: '/detail/{id}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSProyecto'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-central/ss-proyecto-central-detail.html',
                    controller: 'SSProyectoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
            		return SSProyecto.get({id : $stateParams.id});
            	}] 
            }
        })
        .state('ss-proyectos-comite', {
            parent: 'entity',
            url: '/ss-proyectos-comite',
            data: {
                authorities: ['MIEMBRO_COMITE_SS'],
                pageTitle: 'SSProyectosComite'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-comite.html',
                    controller: 'SSProyectoComiteController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	periodos: ['SSPeriodo', function(SSPeriodo){
            		return SSPeriodo.all().$promise;
            	}],
	        	centrosDocentes: ['CentroDocente', function(CentroDocente){
	        		return CentroDocente.all().$promise;
	        	}],
	        	estatusProyectos: function () {
                	return ["DICTAMEN", "APROBADO", "REPLANTEADO", "NO_APROBADO"];
                }
            }
        })
        .state('ss-editar-vigencia', {
            parent: 'ss-proyectos-central',
            url: '/{id}/editar-vigencia',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-editar-vigencia-dialog.html',
                    controller: 'EditarVigenciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SSProyecto', function(SSProyecto) {
                            return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                        }]

                    }
                }).result.then(function() {
                	$state.go('ss-proyectos-central', null, { reload: 'ss-proyectos-central' });
                }, function() {
                    $state.go('^');
                });                
            }]
        })
        
        .state('ss-asignar', {
            parent: 'ss-proyecto-facultad-detail',
            url: '/{periodo}/asignar/{perfil}',
            data: {
                authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-asignar-dialog.html',
                    controller: 'AsignarDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            	perfil: null,
                            	asignacion: {
                                    iniPrestacion: null,
                                    finPrestacion: null,
                                    duracionHoras: null,
                                    estatusPrestador: null,
                                    altaReg: null,
                                    bajaReg: null,
                                    ultActReg: null,
                                    activo: null,
                                    usuarioUltAct: null,
                                    expediente: null,
                                    fechaLiberacion: null,
                                    id: null,
                                    respDePrestador: null,
                                    prestador: null,
                                    perfil: null                          		
                            	},
                            	unidadReceptora: null,
                            	periodo: null
                            };
                        },
                        sSProyecto: ['SSProyecto', function(SSProyecto) {
                            return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                        }],
                        sSPerfil: ['SSPerfil', function(SSPerfil) {
                            return SSPerfil.get({id : $stateParams.perfil}).$promise;
                        }],
                        sSPeriodo: ['SSPeriodo', function(SSPeriodo) {
                            return SSPeriodo.get({id : $stateParams.periodo}).$promise;
                        }]

                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-facultad-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-cancelar-baja', {
        	parent: 'ss-proyecto-facultad-detail',
            url: '/cancelar-baja/{asig}',
            data: {
            	authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-cancelar-baja-dialog.html',
                    controller: 'CancelarBajaController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-facultad-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-liberar', {
            parent: 'ss-proyecto-facultad-detail',
            url: '/liberar/{asig}',
            data: {
                authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-liberar-dialog.html',
                    controller: 'LiberarDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-facultad-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-cambiar-fechas', {
            parent: 'ss-proyecto-central-detail',
            url: '/cambiar-fechas/{asig}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-cambiar-fechas-dialog.html',
                    controller: 'CambiarFechasDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }],
                        previousState: ["$state", function ($state) {
                        	var currentStateData = {
								name: $state.current.name || 'ss-proyecto',
								params: $state.params,
								url: $state.href($state.current.name, $state.params)
                        	};
                        	return currentStateData;
                        }]
                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-central-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-cancelar-asignacion', {
        	parent: 'ss-proyecto-central-detail',
            url: '/cancelar-asignacion/{asig}',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-cancelar-asignacion-dialog.html',
                    controller: 'CancelarAsignacionController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-central-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
		.state('ss-cancelar-liberacion', {
			parent: 'ss-proyecto-central-detail',
			url: '/cancelar-liberacion/{asig}',
			data: {
				authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
			},
			onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl: 'app/entities/s-s-proyecto/ss-cancelar-liberacion-dialog.html',
				    controller: 'CancelarLiberacionController',
				    controllerAs: 'vm',
				    size: 'md',
				    resolve: {
				        entity: ['SSAsignacion', function(SSAsignacion) {
				        	return SSAsignacion.get({id : $stateParams.asig}).$promise;
				    	}]
					}
				}).result.then(function() {
					$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-central-detail' });
				}, function() {
					$state.go('^', {id : $stateParams.id}, { reload: false });
				});
			}]
		})
        .state('ss-cambiar-fechas-confirmacion', {
            parent: 'ss-proyecto-central-detail',
            url: '/cambiar-fechas/{asig}/confirmacion',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-cambiar-fechas-confirmacion-dialog.html',
                    controller: 'SSCambiarFechasConfirmacionController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }],
                        previousState: ["$state", function ($state) {
                        	var currentStateData = {
								name: $state.current.name || 'ss-proyecto',
								params: $state.params,
								url: $state.href($state.current.name, $state.params)
                        	};
                        	return currentStateData;
                        }]
                    }
                }).result.then(function() {
                	$state.go('ss-cambiar-fechas', {asig : $stateParams.asig});
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-certificar', {
            parent: 'ss-proyecto-central-detail',
            url: '/certificar/{asig}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS', 'RESPONSABLE_DE_SS_DE_FACULTAD'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-certificar-dialog.html',
                    controller: 'CertificarDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }],
                        previousState: ["$state", function ($state) {
                        	var currentStateData = {
								name: $state.current.name || 'ss-proyecto',
								params: $state.params,
								url: $state.href($state.current.name, $state.params)
                        	};
                        	return currentStateData;
                        }]
                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-central-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-dar-baja', {
            parent: 'ss-proyecto-facultad-detail',
            url: '/baja/{asig}',
            data: {
                authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-baja-dialog.html',
                    controller: 'BajaDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        sSBaja: function () {
                            return {
                                fechaBaja: null,
                                tipoBaja: null,
                                motivo: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null,
                                asignacion: null
                            };
                        },
                        sSAsignacion: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-facultad-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-proyectos', {
            parent: 'entity',
            url: '/ss-proyectos',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto.html',
                    controller: 'SSProyectoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	entity: ['$stateParams', 'SSPeriodo', function($stateParams, SSPeriodo) {
            		return SSPeriodo.all();
            	}] 
            }
        })
        .state('ss-proyecto-central-solicitud', {
            parent: 'ss-proyectos-central',
            url: '/solicitud/{id}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud-admin.html',
                    controller: 'SSProyectoCentralSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 0;
                }
            }
        })
        .state('ss-proyecto-central-seguimiento', {
            parent: 'ss-proyectos-central',
            url: '/seguimiento/{id}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud-admin.html',
                    controller: 'SSProyectoCentralSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 4;
                }
            }
        })
        .state('ss-proyecto-comite-solicitud', {
            parent: 'ss-proyectos-comite',
            url: '/solicitud/{id}',
            data: {
                authorities: ['MIEMBRO_COMITE_SS'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud-admin.html',
                    controller: 'SSProyectoComiteSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 0;
                }
            }
        })
        .state('ss-proyecto-comite-seguimiento', {
            parent: 'ss-proyectos-comite',
            url: '/seguimiento/{id}',
            data: {
                authorities: ['MIEMBRO_COMITE_SS'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud-admin.html',
                    controller: 'SSProyectoComiteSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 4;
                }
            }
        })
	    .state('ss-proyecto-facultad-solicitud', {
	        parent: 'ss-proyectos-facultad',
	        url: '/solicitud/{id}',
	        data: {
	            authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
	            pageTitle: 'SSProyectos'
	        },
	        views: {
	            'content@': {
	                templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud-admin.html',
	                controller: 'SSProyectoFacultadSolicitudController',
	                controllerAs: 'vm'
	            }
	        },
	        resolve: {
	            entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
	                return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
	            }],
	            selectedTab: function () {
	            	return 0;
	            }
	        }
	    })
	    .state('ss-proyecto-facultad-seguimiento', {
	        parent: 'ss-proyectos-facultad',
	        url: '/seguimiento/{id}',
	        data: {
	            authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
	            pageTitle: 'SSProyectos'
	        },
	        views: {
	            'content@': {
	                templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud-admin.html',
	                controller: 'SSProyectoFacultadSolicitudController',
	                controllerAs: 'vm'
	            }
	        },
	        resolve: {
	            entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
	                return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
	            }],
	            selectedTab: function () {
	            	return 4;
	            }
	        }
	    })
        .state('ss-proyectos-delete', {
            parent: 'ss-proyectos',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-delete-dialog.html',
                    controller: 'SSProyectoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSProyecto', function(SSProyecto) {
                            return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-proyectos', null, { reload: 'ss-proyectos' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSProyecto', SSProyecto);

    SSProyecto.$inject = ['$resource', 'DateUtils'];

    function SSProyecto ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-proyectos/:id';

        return $resource(resourceUrl, {}, {
            'query': { 
            	method: 'GET', 
            	url:'api/s-s-proyectos:idCentroDocente,:idProgramaEducativo,:fechaIniPer,:fechaFinPer,:estatusProyecto',
            	isArray: true
           	},
            'queryCurrentUser': { 
            	method: 'GET', 
            	url:'api/s-s-proyectos-current-user:idCentroDocente,:idProgramaEducativo,:fechaIniPer,:fechaFinPer,:estatusProyecto',
            	isArray: true
           	},
            'queryAlumno': { 
            	method: 'GET', 
            	url:'api/s-s-proyectos-alumno/:alumno',
            	isArray: true
           	},
            'queryAlumnoFacultad': { 
            	method: 'GET', 
            	url:'api/s-s-proyectos-alumno-fac/:alumno',
            	isArray: true
           	},
            'getByPrestador': { 
            	method: 'GET', 
            	url:'api/s-s-proyectos/prestador/:fechaIniPer,:fechaFinPer',
            	isArray: true
           	},
            'getByCentroDocente': { 
            	method: 'GET', 
            	url:'api/s-s-proyectos/centro-docente/:id',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.inicioVigencia = DateUtils.convertDateTimeFromServer(data.inicioVigencia);
                        data.finVigencia = DateUtils.convertDateTimeFromServer(data.finVigencia);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }           	
            },
           	'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.inicioVigencia = DateUtils.convertDateTimeFromServer(data.inicioVigencia);
                        data.finVigencia = DateUtils.convertDateTimeFromServer(data.finVigencia);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'getSolicitud': {
                method: 'GET',
            	url:'api/s-s-proyectos/:id/solicitud',                
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if(data.periodoInicial){
	                        data.periodoInicial.iniPeriodo = DateUtils.convertDateTimeFromServer(data.periodoInicial.iniPeriodo);
	                        data.periodoInicial.finPeriodo = DateUtils.convertDateTimeFromServer(data.periodoInicial.finPeriodo);
	                        data.periodoInicial.iniConvocatoria = DateUtils.convertDateTimeFromServer(data.periodoInicial.iniConvocatoria);
	                        data.periodoInicial.finConvocatoria = DateUtils.convertDateTimeFromServer(data.periodoInicial.finConvocatoria);
						}
                        data.inicioVigencia = DateUtils.convertDateTimeFromServer(data.inicioVigencia);
                        data.finVigencia = DateUtils.convertDateTimeFromServer(data.finVigencia);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'updateBySolicitante': { 
            	method:'PUT',
            	url:'api/s-s-proyectos/solicitante', 
            },
            'updateByAdministrativo': { 
            	method:'PUT',
            	url:'api/s-s-proyectos/administrativo', 
            },
            'deletePerfilBySolicitante': { 
            	method:'GET',
            	url:'api/s-s-proyectos/:sSProyecto/solicitante/:sSPerfil/delete', 
            },
            'deletePerfilByAdministrativo': { 
            	method:'GET',
            	url:'api/s-s-proyectos/:sSProyecto/administrativo/:sSPerfil/delete', 
            },
            'savePerfilBySolicitante': { 
            	method:'PUT',
            	url:'api/s-s-proyectos/solicitante/saveperfil', 
            },
            'savePerfilByAdministrativo': { 
            	method:'PUT',
            	url:'api/s-s-proyectos/administrativo/saveperfil', 
            },
            'updateVigencia': { 
            	method:'PUT',
            	url:'api/s-s-proyectos/:id/updateVigencia', 
            },
            'register': { 
            	method:'PUT',
            	url:'api/s-s-proyectos/registro',                
            	},
            'save': { method:'POST' },
            'getProyAproAnteriormente': { 
            	method:'GET',
            	url:'api/s-s-proyectos/getProyAproAnteriormente/:id',       
            	transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoController', SSProyectoController);

    SSProyectoController.$inject = ['$state', 'SSProyecto', 'ParseLinks', 'entity', 'SSPeriodo', 'SolicitudDownloadService', 'AcuseDownloadService'];

    function SSProyectoController($state, SSProyecto, ParseLinks, entity, SSPeriodo, SolicitudDownloadService, AcuseDownloadService) {

        var vm = this;
        vm.searchForm = {};
        vm.search = search;
        vm.proyectoDetalle = proyectoDetalle;
        vm.proyectoSeguimiento = proyectoSeguimiento;
        vm.proyectoImprimir = proyectoImprimir;
        vm.proyectoAcuse = proyectoAcuse;
        vm.proyectoEliminar = proyectoEliminar;
        
        entity.$promise.then(function(periodos) {
        	vm.periodos = periodos;
        	vm.selectedPeriodo = periodos[0];
        	loadProyectos();
        });

        function search() {
            	loadProyectos();
        }

        function loadProyectos(){
        	SSProyecto.getByPrestador({
	        	fechaIniPer: vm.selectedPeriodo.iniPeriodo,
	        	fechaFinPer: vm.selectedPeriodo.finPeriodo,
        	}).$promise.then(function(proyectos) {
	        	vm.sSProyectos = proyectos;
	        });         	
        }
        
        function proyectoDetalle(idProyecto, propagation, $event){
        	$state.go('ss-proyecto-solicitud',{id: idProyecto});
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
        
        function proyectoSeguimiento(idProyecto, propagation, $event){
        	$state.go('ss-proyecto-seguimiento',{id: idProyecto});
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
        
        function proyectoImprimir(idProyecto, propagation, $event){
        	SolicitudDownloadService.download(idProyecto);
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
        
        function proyectoAcuse(idProyecto, propagation, $event){
        	AcuseDownloadService.download(idProyecto);
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
        
        function proyectoEliminar(idProyecto, propagation, $event){
        	$state.go('ss-proyectos-delete',{id: idProyecto});
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPerfilProyectoController', SSPerfilProyectoController);

    SSPerfilProyectoController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', '$uibModalInstance', 'entity', 'ProgramaEducativo', 'Sexo', 'Principal', 'SSPerfil'];

    function SSPerfilProyectoController ($scope, $rootScope, $state, $stateParams, $uibModalInstance, entity, ProgramaEducativo, Sexo, Principal, SSPerfil) {
        var vm = this;

        vm.perfil = angular.copy(entity);
        vm.programasEducativos = ProgramaEducativo.distinct();
        vm.sexos = Sexo.query();

		vm.respDePrestador = {
				id : null,
				nombres : '',
				primerApellido : '',
				segundoApellido : '',
				titulo : '',
				email : '',
				telefono : '',
				telefono2 : '',
		};
			
		vm.actividad = {
				id : null,
				nombre : '',
				descripcion : ''
		}
		
		vm.indexRespDePrestador = null;  
		vm.isAdminCentral = false;
		vm. debeGuardar = false;
		
		vm.agregarActividad = agregarActividad;
		vm.removerActividad = removerActividad;
		vm.agregarRespDePrestador = agregarRespDePrestador;
		vm.removerRespDePrestador = removerRespDePrestador;
		vm.formEditarRespDePrestador = formEditarRespDePrestador;
		vm.editarRespDePrestador = editarRespDePrestador;
		vm.reactivarPerfil = reactivarPerfil;
		vm.desactivarPerfil = desactivarPerfil;
        vm.clear = clear;
        vm.save = save;
        
        onLoad();
	        
	    function onLoad(){
			Principal.hasAuthority('ADMINISTRADOR_DE_PROGRAMA_SS').then(function(result) {
                vm.isAdminCentral = result;
            });
		}
			
		function agregarActividad() {
			if (vm.perfil.actividads == null) {
				vm.perfil.actividads = [];
			}
			vm.perfil.actividads.push({
				nombre : vm.actividad.nombre,
				descripcion : vm.actividad.descripcion
			});
			vm.actividad = {
				id : null,
				nombre : null,
				descripcion : null
			}
			vm.showActivityForm = false;
		}

		function removerActividad(index) {
			vm.perfil.actividads.splice(index, 1);
		}

		function agregarRespDePrestador() {
			if (vm.perfil.respDePrestadors == null) {
				vm.perfil.respDePrestadors = [];
			}
			
			vm.perfil.respDePrestadors.push({
				nombres : vm.respDePrestador.nombres,
				primerApellido : vm.respDePrestador.primerApellido,
				segundoApellido : vm.respDePrestador.segundoApellido,
				titulo : vm.respDePrestador.titulo,
				email : vm.respDePrestador.email,
				telefono : vm.respDePrestador.telefono,
				telefono2 : vm.respDePrestador.telefono2,
			});
			
			vm.respDePrestador = {
				id : null,
				nombres : null,
				primerApellido : null,
				segundoApellido : null,
				titulo : null,
				email : null,
				telefono : null,
				telefono2 : null,
			}
			
			vm.showRespDePrestadorForm = false;
		}
		
		
		function formEditarRespDePrestador($index, prestador) {
			vm.indexRespDePrestador = $index;
			vm.showRespDePrestadorForm = true;
			vm.respDePrestador = prestador;
		}
		
		function editarRespDePrestador() {
			
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].nombres = vm.respDePrestador.nombres;
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].primerApellido = vm.respDePrestador.primerApellido;
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].segundoApellido = vm.respDePrestador.segundoApellido;
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].titulo = vm.respDePrestador.titulo;
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].email = vm.respDePrestador.email;
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].telefono = vm.respDePrestador.telefono;
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].telefono2 = vm.respDePrestador.telefono2;
			
			vm.respDePrestador = {
				id : null,
				nombres : null,
				primerApellido : null,
				segundoApellido : null,
				titulo : null,
				email : null,
				telefono : null,
				telefono2 : null,
			}
			
			vm.showRespDePrestadorForm = false;
			vm.indexRespDePrestador = null;
		}

		function removerRespDePrestador(index) {
			vm.perfil.respDePrestadors.splice(index, 1);
		}
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {
            $uibModalInstance.close(vm.perfil);
        }
        
        
        function desactivarPerfil(){
			SSPerfil.deactivate(
            	vm.perfil.id
            ).$promise.then(function(result) {
            	actualizarDatos(result);
             });
		}
		
		function reactivarPerfil(){
			SSPerfil.reactivate(
            	vm.perfil.id
            ).$promise.then(function(result) {
            	actualizarDatos(result);
             });
		}
		
		function actualizarDatos(result){
			vm.perfil.bajaReg = result.bajaReg;
            vm.perfil.usuarioUltAct = result.usuarioUltAct;
            vm.debeGuardar = true;
		}
        
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('LiberarDialogController', LiberarDialogController);

    LiberarDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSAsignacion', 'CartaLiberacionDownloadService', 'AlertService'];

    function LiberarDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSAsignacion, CartaLiberacionDownloadService, AlertService) {
        var vm = this;

        entity.$promise.then(function(result) {
        	vm.sSAsignacion = result;
        });

        vm.numExpediente = "";
        vm.clear = clear;
        vm.save = save;
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            SSAsignacion.liberar({
        		idAsignacion: vm.sSAsignacion.id, 
        		numExpediente: vm.numExpediente
            }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
        	CartaLiberacionDownloadService.download(vm.sSAsignacion.id, vm.sSAsignacion.prestador.matriculaParteInvariable)
            .then(function(data) {
            	onDownloadSuccess(vm.sSAsignacion.id);
            })
            .catch(function(err) {
            	onDownloadError();
            });
        }
        	
        function onSaveError () {
            vm.isSaving = false;
        	AlertService.error("Ocurrió un error al liberar al alumno.");
        }

        function onDownloadSuccess(result){
            $scope.$emit('serviciosocialApp:sSProyectoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onDownloadError () {
            vm.isSaving = false;
        	AlertService.error("Ocurrió un error al generar la carta de liberación");
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSEstatusProyecto', SSEstatusProyecto);

    SSEstatusProyecto.$inject = ['$resource', 'DateUtils'];

    function SSEstatusProyecto ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-estatus-proyecto/:id';

        return $resource(resourceUrl, {}, {
            'all': { 
            	method: 'GET',
            	url:'api/s-s-estatus-proyecto-all',
            	isArray: true
           	},  
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('SSEnviarSolicitudModalService', SSEnviarSolicitudModalService);

    SSEnviarSolicitudModalService.$inject = ['$uibModal'];

    function SSEnviarSolicitudModalService ($uibModal) {
        var service = {
        	open: open,
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-enviar-solicitud-dialog.html',
                controller: 'EnviarSolicitudController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                     entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    	 return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                     }],
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }        
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('EnviarSolicitudController', EnviarSolicitudController);

    EnviarSolicitudController.$inject = ['$uibModalInstance', '$rootScope', '$state', 'entity', 'SSProyecto', 'SSPeriodo'];

    function EnviarSolicitudController($uibModalInstance, $rootScope, $state, entity, SSProyecto, SSPeriodo) {
        var vm = this;

        vm.sSProyecto = entity;
        vm.clear = clear;
        vm.confirmSend = confirmSend;        

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
		function confirmSend() {
			SSProyecto.register(vm.sSProyecto, onSaveSuccess, onSaveError);			
		}
		
		function onSaveSuccess(result) {
        	$uibModalInstance.close(true);
			$state.go('ss-proyectos');
			$rootScope.$broadcast('sendSolicitudSuccess');
		}

		function onSaveError() {
		}
		
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('EditarVigenciaDialogController', EditarVigenciaDialogController);

    EditarVigenciaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSProyecto', 'AlertService'];

    function EditarVigenciaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSProyecto, AlertService) {
        var vm = this;

        entity.$promise.then(function(result) {
        	vm.sSProyecto = result;
        });

        vm.clear = clear;
        vm.save = save;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;        
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            SSProyecto.updateVigencia(
        		vm.sSProyecto
            , onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSProyectoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        
        vm.datePickerOpenStatus.finVigencia = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function onSaveError () {
            vm.isSaving = false;
        	AlertService.error("Ocurrió un error al editar la vigencia del proyecto.");
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('SSEditarEstatusModalService', SSEditarEstatusModalService);

    SSEditarEstatusModalService.$inject = ['$uibModal'];

    function SSEditarEstatusModalService ($uibModal) {
        var service = {
        	openCentral: openCentral,
        	openComite: openComite
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function openCentral (idProyecto) {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-editar-estatus-central-dialog.html',
                controller: 'SSEditarEstatusController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            fechaMovimiento: null,
                            estatusMovimiento: null,
                            observaciones: null,
                            altaReg: null,
                            bajaReg: null,
                            ultActReg: null,
                            activo: null,
                            usuarioUltAct: null,
                            id: null,
                            proyecto: idProyecto
                        };
                    },
                     proyecto: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    	 return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                     }],
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function openComite (idProyecto) {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-editar-estatus-comite-dialog.html',
                controller: 'SSEditarEstatusController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            fechaMovimiento: null,
                            estatusMovimiento: null,
                            observaciones: null,
                            altaReg: null,
                            bajaReg: null,
                            ultActReg: null,
                            activo: null,
                            usuarioUltAct: null,
                            id: null,
                            proyecto: idProyecto
                        };
                    },
                    proyecto: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                   	 return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                    }],
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSEditarEstatusController', SSEditarEstatusController);

    SSEditarEstatusController.$inject = ['$timeout', '$scope', '$rootScope', '$state', '$stateParams', '$uibModalInstance', 'entity', 'proyecto', 'SSMovimientoEstatusProyecto', 'SSProyecto'];

    function SSEditarEstatusController ($timeout, $scope, $rootScope, $state, $stateParams, $uibModalInstance, entity, proyecto, SSMovimientoEstatusProyecto, SSProyecto) {
        var vm = this;

        vm.sSEstatusProyecto = proyecto.estatus;
        vm.sSMovimientoEstatusProyecto = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.sSMovimientoEstatusProyecto.proyecto = {id: $stateParams.id};
            vm.sSMovimientoEstatusProyecto.fechaMovimiento = new Date();
            SSMovimientoEstatusProyecto.create(vm.sSMovimientoEstatusProyecto, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
            $state.go($state.current.name);
            $rootScope.$broadcast('updateEstatusProyectoSuccess');
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechaMovimiento = false;
        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CertificarDialogController', CertificarDialogController);

    CertificarDialogController.$inject = ['$timeout', '$http', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSAsignacion', 'CertificadoDownloadService', 'AlertService'];

    function CertificarDialogController ($timeout, $http, $scope, $stateParams, $uibModalInstance, entity, SSAsignacion, CertificadoDownloadService, AlertService) {
        var vm = this;

        entity.$promise.then(function(result) {
        	vm.sSAsignacion = result;
        });

        vm.numRecibo = "";
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;        
        vm.clear = clear;
        vm.save = save;
        vm.validateDates = validateDates;
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            SSAsignacion.cambiarFechas(vm.sSAsignacion, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
        	vm.sSAsignacion = result;
            CertificadoDownloadService.download(vm.sSAsignacion.id, vm.numRecibo, vm.sSAsignacion.prestador.matriculaParteInvariable)
            .then(function(data) {
            	onDownloadSuccess(vm.sSAsignacion.id);
            })
            .catch(function(err) {
            	onDownloadError();
            });
        }

        function onDownloadSuccess (result) {
            $scope.$emit('serviciosocialApp:sSProyectoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        	AlertService.error("Ocurrió un error al liberar al alumno.");
        }
        
        function onDownloadError () {
            vm.isSaving = false;
        	AlertService.error("Ocurrió un error al generar la carta de liberación");
        }

        vm.datePickerOpenStatus.iniPrestacion = false;
        vm.datePickerOpenStatus.finPrestacion = false;
        
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function validateDates(){
        	console.log();
        	var startDate = vm.sSAsignacion.iniPrestacion;
        	var endDate = vm.sSAsignacion.finPrestacion;
        	console.log(startDate);
        	console.log(endDate);
        	$scope.editForm.finPrestacion.$setValidity("endBeforeStart", endDate > startDate);
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CancelarLiberacionController', CancelarLiberacionController);

    CancelarLiberacionController.$inject = ['$uibModalInstance', '$state', '$scope', 'entity', 'SSAsignacion'];

    function CancelarLiberacionController($uibModalInstance, $state, $scope, entity, SSAsignacion) {
        var vm = this;

        vm.sSAsignacion = entity;
		vm.motivo = '';
		
        vm.clear = clear;
        vm.confirmCancel = confirmCancel;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmCancel(id) {
            SSAsignacion.cancelarLiberacion({
				idAsignacion: id,
				'motivo': vm.motivo,
			}, onSaveSuccess, onSaveError);
        }
		
		function onSaveSuccess (result) {
			console.log(result)
		    $scope.$emit('serviciosocialApp:sSAsignacionUpdate', result);
		    $uibModalInstance.close(result);
		}
		        	
		function onSaveError () {
		}		
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CancelarBajaController',CancelarBajaController);

    CancelarBajaController.$inject = ['$uibModalInstance', 'entity', 'SSAsignacion'];

    function CancelarBajaController($uibModalInstance, entity, SSAsignacion) {
        var vm = this;

        vm.sSAsignacion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
		
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSAsignacion.cancelarBaja({idAsignacion: id},
                onSuccess, onError);
        }
		
		function onSuccess(){
			$uibModalInstance.close(true);			
		}
		
		function onError(){
			$uibModalInstance.dismiss();			
		}
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CancelarAsignacionController', CancelarAsignacionController);

    CancelarAsignacionController.$inject = ['$uibModalInstance', '$state', 'entity', 'SSAsignacion'];

    function CancelarAsignacionController($uibModalInstance, $state, entity, SSAsignacion) {
        var vm = this;

        vm.sSAsignacion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSAsignacion.cancelarAsignacion({idAsignacion: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CambiarFechasDialogController', CambiarFechasDialogController);

    CambiarFechasDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'SSAsignacion', 'AlertService'];

    function CambiarFechasDialogController ($timeout, $scope, $uibModalInstance, entity, SSAsignacion, AlertService) {
        var vm = this;

        entity.$promise.then(function(result) {
        	vm.sSAsignacionDTO = result;
        	vm.motivo = '';
        	        	
			vm.iniPrestacionOptions = {
			    enableTime: false,
			  };

			vm.finPrestacionOptions = {
			    enableTime: false,
			  };  

			vm.fechaLiberacionOptions = {
			    enableTime: false,
			  };  

		});

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

		$scope.format = 'yyyy/MM/dd';
        
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;        

        vm.clear = clear;
        vm.save = save;
        vm.validateDates = validateDates;
        
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {
        	SSAsignacion.cambiarFechasAdmin({
				'asignacion': vm.sSAsignacionDTO,
				'motivo': vm.motivo,
			}, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSAsignacionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        	
        function onSaveError () {
            vm.isSaving = false;
        }
        
        vm.datePickerOpenStatus.iniPrestacion = false;
        vm.datePickerOpenStatus.finPrestacion = false;
        vm.datePickerOpenStatus.fechaLiberacion = false;
        
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function validateDates(){
        	var startDate = vm.sSAsignacionDTO.iniPrestacion;
        	var endDate = vm.sSAsignacionDTO.finPrestacion;
        	var minEndDate = angular.copy(startDate);
        	if(startDate != null && endDate != null){
	        	minEndDate.setMonth(startDate.getMonth() + 6);
	        	$scope.editForm.finPrestacion.$setValidity("endBeforeStart", endDate > startDate);
	        	$scope.editForm.finPrestacion.$setValidity("end6months", endDate >= minEndDate);
        	}
        	console.log($scope.editForm);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSCambiarFechasConfirmacionController',SSCambiarFechasConfirmacionController);

    SSCambiarFechasConfirmacionController.$inject = ['$uibModalInstance', '$state', 'entity'];

    function SSCambiarFechasConfirmacionController($uibModalInstance, $state, entity) {
        var vm = this;

        vm.sSAsignacion = entity;
        vm.clear = clear;
        vm.confirmDateChange = confirmDateChange;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDateChange (id) {
            $uibModalInstance.close(true);
		}
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('BajaDialogController', BajaDialogController);

    BajaDialogController.$inject = ['$timeout', '$uibModalInstance', 'sSAsignacion', 'sSBaja', 'TipoBaja', 'SSAsignacion', 'AlertService'];

    function BajaDialogController ($timeout, $uibModalInstance, sSAsignacion, sSBaja, TipoBaja, SSAsignacion, AlertService) {
        var vm = this;

        vm.sSBaja = sSBaja;
		
        sSAsignacion.$promise.then(function(result) {
        	vm.sSBaja.asignacion = result;
        });
        
        vm.tipoBajas = TipoBaja.all();

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.clear = clear;
        vm.save = save;
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            SSAsignacion.darDeBaja(vm.sSBaja, 
				onSaveSuccess, 
				onSaveError);
        }

        function onSaveSuccess() {
            $uibModalInstance.close(true);

        }
        	
        function onSaveError () {
            vm.isSaving = false;
        	AlertService.error("Ocurrió un error al dar de baja al alumno.");
        }

        vm.datePickerOpenStatus.fechaBaja = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('AsignarDialogController', AsignarDialogController);

    AsignarDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'sSProyecto', 'sSPerfil', 'sSPeriodo', 'SSAsignacion', 'AlumnoUadyMatriculado', 'AlertService'];

    function AsignarDialogController ($scope, $stateParams, $uibModalInstance, entity, sSProyecto, sSPerfil, sSPeriodo, SSAsignacion, AlumnoUadyMatriculado, AlertService) {
        var vm = this;

        sSProyecto.$promise.then(function(result) {
        	vm.sSAsignacionDTO = entity;
        	vm.sSAsignacionDTO.unidadReceptora = result.unidadesReceptoras[0];
        	vm.sSAsignacionDTO.asignacion.duracionHoras = 480;
        	
			vm.iniPrestacionOptions = {
			    minDate: getToday(),
			    initDate: getToday()
			  };

			vm.finPrestacionOptions = {
			    minDate: getEnd(),
			    initDate: getEnd()
			  };
        });
        
        sSPerfil.$promise.then(function(result) {
        	vm.sSAsignacionDTO.perfil = result;
        }); 

        sSPeriodo.$promise.then(function(result) {
        	vm.sSAsignacionDTO.periodo = result;
        }); 
        
        
        vm.searchValue = '';
        vm.alumnoUadyMatriculados = null;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;        
        vm.clear = clear;
        vm.save = save;
        vm.searchStudent = searchStudent;
        vm.validateDates = validateDates;
        
        function getToday () {
        	var today = new Date();
        	today.setHours(0, 0, 0, 0);
        	return today;
        }
        
        function getEnd () {
        	var end = getToday();
        	end.setMonth(end.getMonth() + 6);
        	return end;
        }
        
        function getEndFromIni () {
        	if(vm.iniPrestacion == '')
        		console.log("EMPTY");
        	else
        		console.log("value : " + vm.iniPrestacion );
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function searchStudent () {
        	vm.sSAsignacionDTO.asignacion.prestador = null;
        	AlumnoUadyMatriculado.getActiveByCGSE({cgse : vm.sSAsignacionDTO.perfil.programaEducativo.claveCGSE, search : vm.searchValue}).$promise.then(function(result){
        		vm.alumnoUadyMatriculados = result;
        	});
        }
        function save () {
        	SSAsignacion.asignar(vm.sSAsignacionDTO, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSAsignacionCreate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        	
        function onSaveError () {
            vm.isSaving = false;
        }
        
        vm.datePickerOpenStatus.iniPrestacion = false;
        vm.datePickerOpenStatus.finPrestacion = false;
        
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function validateDates(){
        	var startDate = vm.sSAsignacionDTO.asignacion.iniPrestacion;
        	var endDate = vm.sSAsignacionDTO.asignacion.finPrestacion;
        	var minEndDate = angular.copy(startDate);
        	if(startDate != null && endDate != null){
	        	minEndDate.setMonth(startDate.getMonth() + 6);
	        	$scope.editForm.finPrestacion.$setValidity("endBeforeStart", endDate > startDate);
	        	$scope.editForm.finPrestacion.$setValidity("end6months", endDate >= minEndDate);
        	}
        }

    }
})();


(function() {
    'use strict';
    
    angular
    	.module('serviciosocialApp')
    	.factory('SolicitudDownloadService', SolicitudDownloadService);

    SolicitudDownloadService.$inject = ['$q','$http'];
    
        function SolicitudDownloadService($q, $http) {
        	return {
        		download: download
        	}
        			
        	function download(idProyecto) {
	        	var defer = $q.defer();
	                
	            $http({
					url: 'api/s-s-proyectos/solicitud/'+ idProyecto,
					method : 'POST',
					params : {},
					headers : {
						'Content-type' : 'application/octet-stream',
					},
					responseType : 'arraybuffer'
	            }).success(function(data, status, headers, config) {
					var file = new Blob([ data ], {
						type : 'application/pdf'
					});
					//trick to download store a file having its URL
					var fileURL = URL.createObjectURL(file);
					var a         = document.createElement('a');
					a.href        = fileURL; 
					a.target      = '_blank';
					a.download    = "SolicitudServicioSocial_" + idProyecto;
					document.body.appendChild(a);
					a.click();
					defer.resolve('success');
	            }).error(function() {
					defer.reject('error');
				});
	            return defer.promise;
	        };
        }
})();

(function() {
    'use strict';
    
    angular
    	.module('serviciosocialApp')
    	.factory('CertificadoDownloadService', CertificadoDownloadService);

    CertificadoDownloadService.$inject = ['$q','$http'];
    
        function CertificadoDownloadService($q, $http) {
        	return {
        		download: download
        	}
        			
        	function download(idAsignacion, numRecibo, matricula) {
            
	        	var defer = $q.defer();
	                
	            $http({
					url: 'api/s-s-asignacions/certificacion/'+ idAsignacion + "/" + numRecibo,
					method : 'POST',
					params : {},
					headers : {
						'Content-type' : 'application/octet-stream',
					},
					responseType : 'arraybuffer'
	            }).success(function(data, status, headers, config) {
					var file = new Blob([ data ], {
						type : 'application/pdf'
					});
					//trick to download store a file having its URL
					var fileURL = URL.createObjectURL(file);
					var a         = document.createElement('a');
					a.href        = fileURL; 
					a.target      = '_blank';
					a.download    = "CertificadoServicioSocial_" + matricula;
					document.body.appendChild(a);
					a.click();
					defer.resolve('success');
					console.log(data);
	            }).error(function() {
					defer.reject('error');
				});
	            return defer.promise;
	        };
        }
})();

(function() {
    'use strict';
    
    angular
    	.module('serviciosocialApp')
    	.factory('CartaLiberacionDownloadService', CartaLiberacionDownloadService);

    CartaLiberacionDownloadService.$inject = ['$q','$http'];
    
        function CartaLiberacionDownloadService($q, $http) {
        	return {
        		download: download
        	}
        			
        	function download(idAsignacion, matricula) {
            
	        	var defer = $q.defer();
	                
	            $http({
					url: 'api/s-s-asignacions/liberacion/'+ idAsignacion + '/imprimir',
					method : 'POST',
					params : {},
					headers : {
						'Content-type' : 'application/octet-stream',
					},
					responseType : 'arraybuffer'
	            }).success(function(data, status, headers, config) {
					var file = new Blob([ data ], {
						type : 'application/pdf'
					});
					//trick to download store a file having its URL
					var fileURL = URL.createObjectURL(file);
					var a         = document.createElement('a');
					a.href        = fileURL; 
					a.target      = '_blank';
					a.download    = "CartaLiberacion_" + matricula;
					document.body.appendChild(a);
					a.click();
					defer.resolve('success');
	            }).error(function(data, status, headers, config) {
					defer.reject('error');
				});
	            return defer.promise;
	        };
        }
})();

(function() {
    'use strict';
    
    angular
    	.module('serviciosocialApp')
    	.factory('CartaAsignacionDownloadService', CartaAsignacionDownloadService);

    CartaAsignacionDownloadService.$inject = ['$q','$http'];
    
        function CartaAsignacionDownloadService($q, $http) {
        	return {
        		download: download
        	}
        			
        	function download(idAsignacion, matricula) {
            
	        	var defer = $q.defer();
	                
	            $http({
					url: 'api/s-s-asignacions/asignacion/'+ idAsignacion + '/imprimir',
					method : 'POST',
					params : {},
					headers : {
						'Content-type' : 'application/octet-stream',
					},
					responseType : 'arraybuffer'
	            }).success(function(data, status, headers, config) {
					var file = new Blob([ data ], {
						type : 'application/pdf'
					});
					//trick to download store a file having its URL
					var fileURL = URL.createObjectURL(file);
					var a         = document.createElement('a');
					a.href        = fileURL; 
					a.target      = '_blank';
					a.download    = "CartaAsignacion_" + matricula;
					document.body.appendChild(a);
					a.click();
					defer.resolve('success');
	            }).error(function(data, status, headers, config) {
					defer.reject('error');
				});
	            return defer.promise;
	        };
        }
})();

(function() {
    'use strict';
    
    angular
    	.module('serviciosocialApp')
    	.factory('AcuseDownloadService', AcuseDownloadService);

    AcuseDownloadService.$inject = ['$q','$http'];
    
        function AcuseDownloadService($q, $http) {
        	return {
        		download: download
        	}
        			
        	function download(idProyecto) {
	        	var defer = $q.defer();
	                
	            $http({
					url: 'api/s-s-proyectos/acuse/'+ idProyecto,
					method : 'POST',
					params : {},
					headers : {
						'Content-type' : 'application/octet-stream',
					},
					responseType : 'arraybuffer'
	            }).success(function(data, status, headers, config) {
					var file = new Blob([ data ], {
						type : 'application/pdf'
					});
					//trick to download store a file having its URL
					var fileURL = URL.createObjectURL(file);
					var a         = document.createElement('a');
					a.href        = fileURL; 
					a.target      = '_blank';
					a.download    = "AcuseServicioSocial_" + idProyecto;
					document.body.appendChild(a);
					a.click();
					defer.resolve('success');
	            }).error(function() {
					defer.reject('error');
				});
	            return defer.promise;
	        };
        }
})();
(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPersonaDialogController', SSPersonaDialogController);

    SSPersonaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSPersona', 'SSProyecto'];

    function SSPersonaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSPersona, SSProyecto) {
        var vm = this;

        vm.sSPersona = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssproyectos = SSProyecto.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSPersona.id !== null) {
                SSPersona.update(vm.sSPersona, onSaveSuccess, onSaveError);
            } else {
                SSPersona.save(vm.sSPersona, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSPersonaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPersonaDetailController', SSPersonaDetailController);

    SSPersonaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSPersona', 'SSProyecto'];

    function SSPersonaDetailController($scope, $rootScope, $stateParams, previousState, entity, SSPersona, SSProyecto) {
        var vm = this;

        vm.sSPersona = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSPersonaUpdate', function(event, result) {
            vm.sSPersona = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPersonaDeleteController',SSPersonaDeleteController);

    SSPersonaDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSPersona'];

    function SSPersonaDeleteController($uibModalInstance, entity, SSPersona) {
        var vm = this;

        vm.sSPersona = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSPersona.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-persona', {
            parent: 'entity',
            url: '/ss-persona',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSPersonas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-persona/s-s-personas.html',
                    controller: 'SSPersonaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-persona-detail', {
            parent: 'ss-persona',
            url: '/ss-persona/{id}',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSPersona'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-persona/ss-persona-detail.html',
                    controller: 'SSPersonaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSPersona', function($stateParams, SSPersona) {
                    return SSPersona.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-persona',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-persona-detail.edit', {
            parent: 'ss-persona-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-persona/ss-persona-dialog.html',
                    controller: 'SSPersonaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSPersona', function(SSPersona) {
                            return SSPersona.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-persona.new', {
            parent: 'ss-persona',
            url: '/new',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-persona/ss-persona-dialog.html',
                    controller: 'SSPersonaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombres: null,
                                primerApellido: null,
                                segundoApellido: null,
                                sexo: null,
                                titulo: null,
                                telefono: null,
                                telefono2: null,
                                email: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-persona', null, { reload: 'ss-persona' });
                }, function() {
                    $state.go('ss-persona');
                });
            }]
        })
        .state('ss-persona.edit', {
            parent: 'ss-persona',
            url: '/{id}/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-persona/ss-persona-dialog.html',
                    controller: 'SSPersonaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSPersona', function(SSPersona) {
                            return SSPersona.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-persona', null, { reload: 'ss-persona' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-persona.delete', {
            parent: 'ss-persona',
            url: '/{id}/delete',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-persona/ss-persona-delete-dialog.html',
                    controller: 'SSPersonaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSPersona', function(SSPersona) {
                            return SSPersona.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-persona', null, { reload: 'ss-persona' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSPersona', SSPersona);

    SSPersona.$inject = ['$resource', 'DateUtils'];

    function SSPersona ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-personas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPersonaController', SSPersonaController);

    SSPersonaController.$inject = ['SSPersona'];

    function SSPersonaController(SSPersona) {

        var vm = this;

        vm.sSPersonas = [];

        loadAll();

        function loadAll() {
            SSPersona.query(function(result) {
                vm.sSPersonas = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPeriodoDialogController', SSPeriodoDialogController);

    SSPeriodoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSPeriodo', 'SSAnio'];

    function SSPeriodoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSPeriodo, SSAnio) {
        var vm = this;

        vm.sSPeriodo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssanios = SSAnio.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSPeriodo.id !== null) {
                SSPeriodo.update(vm.sSPeriodo, onSaveSuccess, onSaveError);
            } else {
                SSPeriodo.save(vm.sSPeriodo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSPeriodoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.iniPeriodo = false;
        vm.datePickerOpenStatus.finPeriodo = false;
        vm.datePickerOpenStatus.iniConvocatoria = false;
        vm.datePickerOpenStatus.finConvocatoria = false;
        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPeriodoDetailController', SSPeriodoDetailController);

    SSPeriodoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSPeriodo', 'SSAnio'];

    function SSPeriodoDetailController($scope, $rootScope, $stateParams, previousState, entity, SSPeriodo, SSAnio) {
        var vm = this;

        vm.sSPeriodo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSPeriodoUpdate', function(event, result) {
            vm.sSPeriodo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPeriodoDeleteController',SSPeriodoDeleteController);

    SSPeriodoDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSPeriodo'];

    function SSPeriodoDeleteController($uibModalInstance, entity, SSPeriodo) {
        var vm = this;

        vm.sSPeriodo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSPeriodo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-periodo', {
            parent: 'entity',
            url: '/ss-periodo',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSPeriodos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-periodo/s-s-periodos.html',
                    controller: 'SSPeriodoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-periodo-detail', {
            parent: 'ss-periodo',
            url: '/ss-periodo/{id}',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSPeriodo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-periodo/ss-periodo-detail.html',
                    controller: 'SSPeriodoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSPeriodo', function($stateParams, SSPeriodo) {
                    return SSPeriodo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-periodo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-periodo-detail.edit', {
            parent: 'ss-periodo-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-periodo/ss-periodo-dialog.html',
                    controller: 'SSPeriodoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSPeriodo', function(SSPeriodo) {
                            return SSPeriodo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-periodo.new', {
            parent: 'ss-periodo',
            url: '/new',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-periodo/ss-periodo-dialog.html',
                    controller: 'SSPeriodoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                iniPeriodo: null,
                                finPeriodo: null,
                                indiceAnual: null,
                                iniConvocatoria: null,
                                finConvocatoria: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-periodo', null, { reload: 'ss-periodo' });
                }, function() {
                    $state.go('ss-periodo');
                });
            }]
        })
        .state('ss-periodo.edit', {
            parent: 'ss-periodo',
            url: '/{id}/edit',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-periodo/ss-periodo-dialog.html',
                    controller: 'SSPeriodoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSPeriodo', function(SSPeriodo) {
                            return SSPeriodo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-periodo', null, { reload: 'ss-periodo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-periodo.delete', {
            parent: 'ss-periodo',
            url: '/{id}/delete',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-periodo/ss-periodo-delete-dialog.html',
                    controller: 'SSPeriodoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSPeriodo', function(SSPeriodo) {
                            return SSPeriodo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-periodo', null, { reload: 'ss-periodo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSPeriodo', SSPeriodo);

    SSPeriodo.$inject = ['$resource', 'DateUtils'];

    function SSPeriodo ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-periodos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'all': { 
            	method: 'GET',
            	url:'api/s-s-periodos-all',
            	isArray: true
           	},
            'getPeriodoVigente': {
                method: 'GET',
                url:'api/s-s-periodo-vigente',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.iniPeriodo = DateUtils.convertDateTimeFromServer(data.iniPeriodo);
                        data.finPeriodo = DateUtils.convertDateTimeFromServer(data.finPeriodo);
                        data.iniConvocatoria = DateUtils.convertDateTimeFromServer(data.iniConvocatoria);
                        data.finConvocatoria = DateUtils.convertDateTimeFromServer(data.finConvocatoria);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    } else {
                    	data = null;
                    }
                    return data;
                }
            },
            'getPeriodoConvocatoriaVigente': {
                method: 'GET',
                url:'api/s-s-periodo-convocatoria-vigente',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.iniPeriodo = DateUtils.convertDateTimeFromServer(data.iniPeriodo);
                        data.finPeriodo = DateUtils.convertDateTimeFromServer(data.finPeriodo);
                        data.iniConvocatoria = DateUtils.convertDateTimeFromServer(data.iniConvocatoria);
                        data.finConvocatoria = DateUtils.convertDateTimeFromServer(data.finConvocatoria);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    } else {
                    	data = null;
                    }
                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.iniPeriodo = DateUtils.convertDateTimeFromServer(data.iniPeriodo);
                        data.finPeriodo = DateUtils.convertDateTimeFromServer(data.finPeriodo);
                        data.iniConvocatoria = DateUtils.convertDateTimeFromServer(data.iniConvocatoria);
                        data.finConvocatoria = DateUtils.convertDateTimeFromServer(data.finConvocatoria);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPeriodoController', SSPeriodoController);

    SSPeriodoController.$inject = ['SSPeriodo'];

    function SSPeriodoController(SSPeriodo) {

        var vm = this;

        vm.sSPeriodos = [];

        loadAll();

        function loadAll() {
            SSPeriodo.query(function(result) {
                vm.sSPeriodos = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPerfilDialogController', SSPerfilDialogController);

    SSPerfilDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSPerfil', 'SSActividad', 'SSAsignacion', 'ProgramaEducativo', 'SSProyecto'];

    function SSPerfilDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSPerfil, SSActividad, SSAsignacion, ProgramaEducativo, SSProyecto) {
        var vm = this;

        vm.sSPerfil = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssactividads = SSActividad.query();
        vm.ssasignacions = SSAsignacion.query();
        vm.programaeducativos = ProgramaEducativo.query();
        vm.ssproyectos = SSProyecto.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSPerfil.id !== null) {
                SSPerfil.update(vm.sSPerfil, onSaveSuccess, onSaveError);
            } else {
                SSPerfil.save(vm.sSPerfil, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSPerfilUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPerfilDetailController', SSPerfilDetailController);

    SSPerfilDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSPerfil', 'SSActividad', 'SSAsignacion', 'ProgramaEducativo', 'SSProyecto'];

    function SSPerfilDetailController($scope, $rootScope, $stateParams, previousState, entity, SSPerfil, SSActividad, SSAsignacion, ProgramaEducativo, SSProyecto) {
        var vm = this;

        vm.sSPerfil = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSPerfilUpdate', function(event, result) {
            vm.sSPerfil = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPerfilDeleteController',SSPerfilDeleteController);

    SSPerfilDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSPerfil'];

    function SSPerfilDeleteController($uibModalInstance, entity, SSPerfil) {
        var vm = this;

        vm.sSPerfil = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSPerfil.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-perfil', {
            parent: 'entity',
            url: '/ss-perfil',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSPerfils'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-perfil/s-s-perfils.html',
                    controller: 'SSPerfilController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-perfil-detail', {
            parent: 'ss-perfil',
            url: '/ss-perfil/{id}',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSPerfil'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-perfil/ss-perfil-detail.html',
                    controller: 'SSPerfilDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSPerfil', function($stateParams, SSPerfil) {
                    return SSPerfil.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-perfil',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-perfil-detail.edit', {
            parent: 'ss-perfil-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-perfil/ss-perfil-dialog.html',
                    controller: 'SSPerfilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSPerfil', function(SSPerfil) {
                            return SSPerfil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-perfil.new', {
            parent: 'ss-perfil',
            url: '/new',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-perfil/ss-perfil-dialog.html',
                    controller: 'SSPerfilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                solicitados: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-perfil', null, { reload: 'ss-perfil' });
                }, function() {
                    $state.go('ss-perfil');
                });
            }]
        })
        .state('ss-perfil.edit', {
            parent: 'ss-perfil',
            url: '/{id}/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-perfil/ss-perfil-dialog.html',
                    controller: 'SSPerfilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSPerfil', function(SSPerfil) {
                            return SSPerfil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-perfil', null, { reload: 'ss-perfil' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-perfil.delete', {
            parent: 'ss-perfil',
            url: '/{id}/delete',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-perfil/ss-perfil-delete-dialog.html',
                    controller: 'SSPerfilDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSPerfil', function(SSPerfil) {
                            return SSPerfil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-perfil', null, { reload: 'ss-perfil' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSPerfil', SSPerfil);

    SSPerfil.$inject = ['$resource', 'DateUtils'];

    function SSPerfil ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-perfils/:id';

        return $resource(resourceUrl, {}, {
            'query': { 
				method: 'GET', 
				isArray: true
			},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { 
				method:'PUT' 
			},
            'deactivate': { 
            	method:'PUT',
            	url:'api/s-s-perfils/deactivate', 
            },
            'reactivate': { 
            	method:'PUT',
            	url:'api/s-s-perfils/reactivate', 
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPerfilController', SSPerfilController);

    SSPerfilController.$inject = ['SSPerfil'];

    function SSPerfilController(SSPerfil) {

        var vm = this;

        vm.sSPerfils = [];

        loadAll();

        function loadAll() {
            SSPerfil.query(function(result) {
                vm.sSPerfils = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSMovimientoEstatusProyectoDialogController', SSMovimientoEstatusProyectoDialogController);

    SSMovimientoEstatusProyectoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSMovimientoEstatusProyecto', 'SSProyecto'];

    function SSMovimientoEstatusProyectoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSMovimientoEstatusProyecto, SSProyecto) {
        var vm = this;

        vm.sSMovimientoEstatusProyecto = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssproyectos = SSProyecto.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSMovimientoEstatusProyecto.id !== null) {
                SSMovimientoEstatusProyecto.update(vm.sSMovimientoEstatusProyecto, onSaveSuccess, onSaveError);
            } else {
                SSMovimientoEstatusProyecto.save(vm.sSMovimientoEstatusProyecto, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSMovimientoEstatusProyectoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechaMovimiento = false;
        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSMovimientoEstatusProyectoDetailController', SSMovimientoEstatusProyectoDetailController);

    SSMovimientoEstatusProyectoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSMovimientoEstatusProyecto', 'SSProyecto'];

    function SSMovimientoEstatusProyectoDetailController($scope, $rootScope, $stateParams, previousState, entity, SSMovimientoEstatusProyecto, SSProyecto) {
        var vm = this;

        vm.sSMovimientoEstatusProyecto = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSMovimientoEstatusProyectoUpdate', function(event, result) {
            vm.sSMovimientoEstatusProyecto = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSMovimientoEstatusProyectoDeleteController',SSMovimientoEstatusProyectoDeleteController);

    SSMovimientoEstatusProyectoDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSMovimientoEstatusProyecto'];

    function SSMovimientoEstatusProyectoDeleteController($uibModalInstance, entity, SSMovimientoEstatusProyecto) {
        var vm = this;

        vm.sSMovimientoEstatusProyecto = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSMovimientoEstatusProyecto.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-movimiento-estatus-proyecto', {
            parent: 'entity',
            url: '/ss-movimiento-estatus-proyecto',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSMovimientoEstatusProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-movimiento-estatus-proyecto/s-s-movimiento-estatus-proyectos.html',
                    controller: 'SSMovimientoEstatusProyectoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-movimiento-estatus-proyecto-detail', {
            parent: 'ss-movimiento-estatus-proyecto',
            url: '/ss-movimiento-estatus-proyecto/{id}',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSMovimientoEstatusProyecto'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-movimiento-estatus-proyecto/ss-movimiento-estatus-proyecto-detail.html',
                    controller: 'SSMovimientoEstatusProyectoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSMovimientoEstatusProyecto', function($stateParams, SSMovimientoEstatusProyecto) {
                    return SSMovimientoEstatusProyecto.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-movimiento-estatus-proyecto',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-movimiento-estatus-proyecto-detail.edit', {
            parent: 'ss-movimiento-estatus-proyecto-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-movimiento-estatus-proyecto/ss-movimiento-estatus-proyecto-dialog.html',
                    controller: 'SSMovimientoEstatusProyectoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSMovimientoEstatusProyecto', function(SSMovimientoEstatusProyecto) {
                            return SSMovimientoEstatusProyecto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-movimiento-estatus-proyecto.new', {
            parent: 'ss-movimiento-estatus-proyecto',
            url: '/new',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-movimiento-estatus-proyecto/ss-movimiento-estatus-proyecto-dialog.html',
                    controller: 'SSMovimientoEstatusProyectoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fechaMovimiento: null,
                                estatusMovimiento: null,
                                observaciones: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-movimiento-estatus-proyecto', null, { reload: 'ss-movimiento-estatus-proyecto' });
                }, function() {
                    $state.go('ss-movimiento-estatus-proyecto');
                });
            }]
        })
        .state('ss-movimiento-estatus-proyecto.edit', {
            parent: 'ss-movimiento-estatus-proyecto',
            url: '/{id}/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-movimiento-estatus-proyecto/ss-movimiento-estatus-proyecto-dialog.html',
                    controller: 'SSMovimientoEstatusProyectoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSMovimientoEstatusProyecto', function(SSMovimientoEstatusProyecto) {
                            return SSMovimientoEstatusProyecto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-movimiento-estatus-proyecto', null, { reload: 'ss-movimiento-estatus-proyecto' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-movimiento-estatus-proyecto.delete', {
            parent: 'ss-movimiento-estatus-proyecto',
            url: '/{id}/delete',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-movimiento-estatus-proyecto/ss-movimiento-estatus-proyecto-delete-dialog.html',
                    controller: 'SSMovimientoEstatusProyectoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSMovimientoEstatusProyecto', function(SSMovimientoEstatusProyecto) {
                            return SSMovimientoEstatusProyecto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-movimiento-estatus-proyecto', null, { reload: 'ss-movimiento-estatus-proyecto' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSMovimientoEstatusProyecto', SSMovimientoEstatusProyecto);

    SSMovimientoEstatusProyecto.$inject = ['$resource', 'DateUtils'];

    function SSMovimientoEstatusProyecto ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-movimiento-estatus-proyectos/:id';

        return $resource(resourceUrl, {}, {
            'query': { 
            	method: 'GET', 
            	isArray: true
          	},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechaMovimiento = DateUtils.convertDateTimeFromServer(data.fechaMovimiento);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'getByProyecto': {
                method: 'GET',
                isArray: true,
                url:'api/s-s-movimiento-estatus-proyectos/proyecto/:idProyecto',
            },            
            'update': { method:'PUT' },
            'create': { 
            	method:'POST', 
                url:'api/s-s-movimiento-estatus-proyectos/proyecto',
            },
            'hasBeenRegistered': {
                method: 'GET',
                isArray: false,
                url:'api/s-s-movimiento-estatus-proyectos/hasBeenRegistered/:idProyecto',
                transformResponse: function (data) {
                    return {boolean: angular.fromJson(data)};
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSMovimientoEstatusProyectoController', SSMovimientoEstatusProyectoController);

    SSMovimientoEstatusProyectoController.$inject = ['SSMovimientoEstatusProyecto'];

    function SSMovimientoEstatusProyectoController(SSMovimientoEstatusProyecto) {

        var vm = this;

        vm.sSMovimientoEstatusProyectos = [];

        loadAll();

        function loadAll() {
            SSMovimientoEstatusProyecto.query(function(result) {
                vm.sSMovimientoEstatusProyectos = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSModalidadDialogController', SSModalidadDialogController);

    SSModalidadDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSModalidad'];

    function SSModalidadDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSModalidad) {
        var vm = this;

        vm.sSModalidad = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSModalidad.id !== null) {
                SSModalidad.update(vm.sSModalidad, onSaveSuccess, onSaveError);
            } else {
                SSModalidad.save(vm.sSModalidad, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSModalidadUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSModalidadDetailController', SSModalidadDetailController);

    SSModalidadDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSModalidad'];

    function SSModalidadDetailController($scope, $rootScope, $stateParams, previousState, entity, SSModalidad) {
        var vm = this;

        vm.sSModalidad = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSModalidadUpdate', function(event, result) {
            vm.sSModalidad = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSModalidadDeleteController',SSModalidadDeleteController);

    SSModalidadDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSModalidad'];

    function SSModalidadDeleteController($uibModalInstance, entity, SSModalidad) {
        var vm = this;

        vm.sSModalidad = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSModalidad.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-modalidad', {
            parent: 'entity',
            url: '/ss-modalidad',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSModalidads'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-modalidad/s-s-modalidads.html',
                    controller: 'SSModalidadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-modalidad-detail', {
            parent: 'ss-modalidad',
            url: '/ss-modalidad/{id}',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSModalidad'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-modalidad/ss-modalidad-detail.html',
                    controller: 'SSModalidadDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSModalidad', function($stateParams, SSModalidad) {
                    return SSModalidad.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-modalidad',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-modalidad-detail.edit', {
            parent: 'ss-modalidad-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-modalidad/ss-modalidad-dialog.html',
                    controller: 'SSModalidadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSModalidad', function(SSModalidad) {
                            return SSModalidad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-modalidad.new', {
            parent: 'ss-modalidad',
            url: '/new',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-modalidad/ss-modalidad-dialog.html',
                    controller: 'SSModalidadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                descripcion: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-modalidad', null, { reload: 'ss-modalidad' });
                }, function() {
                    $state.go('ss-modalidad');
                });
            }]
        })
        .state('ss-modalidad.edit', {
            parent: 'ss-modalidad',
            url: '/{id}/edit',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-modalidad/ss-modalidad-dialog.html',
                    controller: 'SSModalidadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSModalidad', function(SSModalidad) {
                            return SSModalidad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-modalidad', null, { reload: 'ss-modalidad' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-modalidad.delete', {
            parent: 'ss-modalidad',
            url: '/{id}/delete',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-modalidad/ss-modalidad-delete-dialog.html',
                    controller: 'SSModalidadDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSModalidad', function(SSModalidad) {
                            return SSModalidad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-modalidad', null, { reload: 'ss-modalidad' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSModalidad', SSModalidad);

    SSModalidad.$inject = ['$resource', 'DateUtils'];

    function SSModalidad ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-modalidads/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSModalidadController', SSModalidadController);

    SSModalidadController.$inject = ['SSModalidad'];

    function SSModalidadController(SSModalidad) {

        var vm = this;

        vm.sSModalidads = [];

        loadAll();

        function loadAll() {
            SSModalidad.query(function(result) {
                vm.sSModalidads = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionarioDialogController', SSFuncionarioDialogController);

    SSFuncionarioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'SSFuncionario', 'SSPersona', 'Sexo'];

    function SSFuncionarioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, SSFuncionario, SSPersona, Sexo) {
        var vm = this;

        vm.sSFuncionario = entity;
        vm.sexos = Sexo.query();
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            console.log(vm.sSFuncionario);
            if (vm.sSFuncionario.id !== null) {
                SSFuncionario.update(vm.sSFuncionario, onSaveSuccess, onSaveError);
            } else {
                SSFuncionario.save(vm.sSFuncionario, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSFuncionarioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.iniFunciones = false;
        vm.datePickerOpenStatus.finFunciones = false;
        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionarioDetailController', SSFuncionarioDetailController);

    SSFuncionarioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSFuncionario', 'SSPersona'];

    function SSFuncionarioDetailController($scope, $rootScope, $stateParams, previousState, entity, SSFuncionario, SSPersona) {
        var vm = this;

        vm.sSFuncionario = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSFuncionarioUpdate', function(event, result) {
            vm.sSFuncionario = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionarioDeleteController',SSFuncionarioDeleteController);

    SSFuncionarioDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSFuncionario'];

    function SSFuncionarioDeleteController($uibModalInstance, entity, SSFuncionario) {
        var vm = this;

        vm.sSFuncionario = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSFuncionario.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-funcionario', {
            parent: 'entity',
            url: '/ss-funcionario',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSFuncionarios'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-funcionario/s-s-funcionarios.html',
                    controller: 'SSFuncionarioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-funcionario-detail', {
            parent: 'ss-funcionario',
            url: '/ss-funcionario/{id}',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSFuncionario'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-funcionario/ss-funcionario-detail.html',
                    controller: 'SSFuncionarioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSFuncionario', function($stateParams, SSFuncionario) {
                    return SSFuncionario.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-funcionario',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-funcionario-detail.edit', {
            parent: 'ss-funcionario-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcionario/ss-funcionario-dialog.html',
                    controller: 'SSFuncionarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSFuncionario', function(SSFuncionario) {
                            return SSFuncionario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-funcionario.new', {
            parent: 'ss-funcionario',
            url: '/new',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcionario/ss-funcionario-dialog.html',
                    controller: 'SSFuncionarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                puesto: null,
                                iniFunciones: null,
                                finFunciones: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-funcionario', null, { reload: 'ss-funcionario' });
                }, function() {
                    $state.go('ss-funcionario');
                });
            }]
        })
        .state('ss-funcionario.edit', {
            parent: 'ss-funcionario',
            url: '/{id}/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcionario/ss-funcionario-dialog.html',
                    controller: 'SSFuncionarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSFuncionario', function(SSFuncionario) {
                            return SSFuncionario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-funcionario', null, { reload: 'ss-funcionario' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-funcionario.delete', {
            parent: 'ss-funcionario',
            url: '/{id}/delete',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcionario/ss-funcionario-delete-dialog.html',
                    controller: 'SSFuncionarioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSFuncionario', function(SSFuncionario) {
                            return SSFuncionario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-funcionario', null, { reload: 'ss-funcionario' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSFuncionario', SSFuncionario);

    SSFuncionario.$inject = ['$resource', 'DateUtils'];

    function SSFuncionario ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-funcionarios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.iniFunciones = DateUtils.convertDateTimeFromServer(data.iniFunciones);
                        data.finFunciones = DateUtils.convertDateTimeFromServer(data.finFunciones);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionarioController', SSFuncionarioController);

    SSFuncionarioController.$inject = ['SSFuncionario'];

    function SSFuncionarioController(SSFuncionario) {

        var vm = this;

        vm.sSFuncionarios = [];

        loadAll();

        function loadAll() {
            SSFuncionario.query(function(result) {
                vm.sSFuncionarios = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionDialogController', SSFuncionDialogController);

    SSFuncionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSFuncion'];

    function SSFuncionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSFuncion) {
        var vm = this;

        vm.sSFuncion = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSFuncion.id !== null) {
                SSFuncion.update(vm.sSFuncion, onSaveSuccess, onSaveError);
            } else {
                SSFuncion.save(vm.sSFuncion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSFuncionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionDetailController', SSFuncionDetailController);

    SSFuncionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSFuncion'];

    function SSFuncionDetailController($scope, $rootScope, $stateParams, previousState, entity, SSFuncion) {
        var vm = this;

        vm.sSFuncion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSFuncionUpdate', function(event, result) {
            vm.sSFuncion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionDeleteController',SSFuncionDeleteController);

    SSFuncionDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSFuncion'];

    function SSFuncionDeleteController($uibModalInstance, entity, SSFuncion) {
        var vm = this;

        vm.sSFuncion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSFuncion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-funcion', {
            parent: 'entity',
            url: '/ss-funcion',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSFuncions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-funcion/s-s-funcions.html',
                    controller: 'SSFuncionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-funcion-detail', {
            parent: 'ss-funcion',
            url: '/ss-funcion/{id}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSFuncion'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-funcion/ss-funcion-detail.html',
                    controller: 'SSFuncionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSFuncion', function($stateParams, SSFuncion) {
                    return SSFuncion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-funcion',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-funcion-detail.edit', {
            parent: 'ss-funcion-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcion/ss-funcion-dialog.html',
                    controller: 'SSFuncionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSFuncion', function(SSFuncion) {
                            return SSFuncion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-funcion.new', {
            parent: 'ss-funcion',
            url: '/new',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcion/ss-funcion-dialog.html',
                    controller: 'SSFuncionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                descripcion: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-funcion', null, { reload: 'ss-funcion' });
                }, function() {
                    $state.go('ss-funcion');
                });
            }]
        })
        .state('ss-funcion.edit', {
            parent: 'ss-funcion',
            url: '/{id}/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcion/ss-funcion-dialog.html',
                    controller: 'SSFuncionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSFuncion', function(SSFuncion) {
                            return SSFuncion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-funcion', null, { reload: 'ss-funcion' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-funcion.delete', {
            parent: 'ss-funcion',
            url: '/{id}/delete',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcion/ss-funcion-delete-dialog.html',
                    controller: 'SSFuncionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSFuncion', function(SSFuncion) {
                            return SSFuncion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-funcion', null, { reload: 'ss-funcion' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSFuncion', SSFuncion);

    SSFuncion.$inject = ['$resource', 'DateUtils'];

    function SSFuncion ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-funcions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionController', SSFuncionController);

    SSFuncionController.$inject = ['SSFuncion'];

    function SSFuncionController(SSFuncion) {

        var vm = this;

        vm.sSFuncions = [];

        loadAll();

        function loadAll() {
            SSFuncion.query(function(result) {
                vm.sSFuncions = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSBajaDialogController', SSBajaDialogController);

    SSBajaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'SSBaja', 'SSAsignacion'];

    function SSBajaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, SSBaja, SSAsignacion) {
        var vm = this;

        vm.sSBaja = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.asignacions = SSAsignacion.query({filter: 'ssbaja-is-null'});
        $q.all([vm.sSBaja.$promise, vm.asignacions.$promise]).then(function() {
            if (!vm.sSBaja.asignacion || !vm.sSBaja.asignacion.id) {
                return $q.reject();
            }
            return SSAsignacion.get({id : vm.sSBaja.asignacion.id}).$promise;
        }).then(function(asignacion) {
            vm.asignacions.push(asignacion);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSBaja.id !== null) {
                SSBaja.update(vm.sSBaja, onSaveSuccess, onSaveError);
            } else {
                SSBaja.save(vm.sSBaja, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSBajaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechaBaja = false;
        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSBajaDetailController', SSBajaDetailController);

    SSBajaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSBaja', 'SSAsignacion'];

    function SSBajaDetailController($scope, $rootScope, $stateParams, previousState, entity, SSBaja, SSAsignacion) {
        var vm = this;

        vm.sSBaja = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSBajaUpdate', function(event, result) {
            vm.sSBaja = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSBajaDeleteController',SSBajaDeleteController);

    SSBajaDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSBaja'];

    function SSBajaDeleteController($uibModalInstance, entity, SSBaja) {
        var vm = this;

        vm.sSBaja = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSBaja.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-baja', {
            parent: 'entity',
            url: '/ss-baja',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSBajas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-baja/s-s-bajas.html',
                    controller: 'SSBajaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-baja-detail', {
            parent: 'ss-baja',
            url: '/ss-baja/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSBaja'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-baja/ss-baja-detail.html',
                    controller: 'SSBajaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSBaja', function($stateParams, SSBaja) {
                    return SSBaja.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-baja',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-baja-detail.edit', {
            parent: 'ss-baja-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-baja/ss-baja-dialog.html',
                    controller: 'SSBajaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSBaja', function(SSBaja) {
                            return SSBaja.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-baja.new', {
            parent: 'ss-baja',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-baja/ss-baja-dialog.html',
                    controller: 'SSBajaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fechaBaja: null,
                                tipoBaja: null,
                                motivo: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-baja', null, { reload: 'ss-baja' });
                }, function() {
                    $state.go('ss-baja');
                });
            }]
        })
        .state('ss-baja.edit', {
            parent: 'ss-baja',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-baja/ss-baja-dialog.html',
                    controller: 'SSBajaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSBaja', function(SSBaja) {
                            return SSBaja.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-baja', null, { reload: 'ss-baja' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-baja.delete', {
            parent: 'ss-baja',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-baja/ss-baja-delete-dialog.html',
                    controller: 'SSBajaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSBaja', function(SSBaja) {
                            return SSBaja.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-baja', null, { reload: 'ss-baja' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSBaja', SSBaja);

    SSBaja.$inject = ['$resource', 'DateUtils'];

    function SSBaja ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-bajas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechaBaja = DateUtils.convertDateTimeFromServer(data.fechaBaja);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSBajaController', SSBajaController);

    SSBajaController.$inject = ['SSBaja'];

    function SSBajaController(SSBaja) {

        var vm = this;

        vm.sSBajas = [];

        loadAll();

        function loadAll() {
            SSBaja.query(function(result) {
                vm.sSBajas = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAsignacionDialogController', SSAsignacionDialogController);

    SSAsignacionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSAsignacion', 'SSPeriodo', 'SSUnidadReceptora', 'SSPersona', 'AlumnoUadyMatriculado', 'SSPerfil'];

    function SSAsignacionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSAsignacion, SSPeriodo, SSUnidadReceptora, SSPersona, AlumnoUadyMatriculado, SSPerfil) {
        var vm = this;

        vm.sSAsignacion = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssperiodos = SSPeriodo.query();
        vm.ssunidadreceptoras = SSUnidadReceptora.query();
        vm.sspersonas = SSPersona.query();
        vm.alumnouadymatriculados = AlumnoUadyMatriculado.query();
        vm.ssperfils = SSPerfil.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSAsignacion.id !== null) {
                SSAsignacion.update(vm.sSAsignacion, onSaveSuccess, onSaveError);
            } else {
                SSAsignacion.save(vm.sSAsignacion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSAsignacionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.iniPrestacion = false;
        vm.datePickerOpenStatus.finPrestacion = false;
        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;
        vm.datePickerOpenStatus.fechaLiberacion = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAsignacionDetailController', SSAsignacionDetailController);

    SSAsignacionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSAsignacion', 'SSPeriodo', 'SSUnidadReceptora', 'SSPersona', 'AlumnoUadyMatriculado', 'SSPerfil'];

    function SSAsignacionDetailController($scope, $rootScope, $stateParams, previousState, entity, SSAsignacion, SSPeriodo, SSUnidadReceptora, SSPersona, AlumnoUadyMatriculado, SSPerfil) {
        var vm = this;

        vm.sSAsignacion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSAsignacionUpdate', function(event, result) {
            vm.sSAsignacion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAsignacionDeleteController',SSAsignacionDeleteController);

    SSAsignacionDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSAsignacion'];

    function SSAsignacionDeleteController($uibModalInstance, entity, SSAsignacion) {
        var vm = this;

        vm.sSAsignacion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSAsignacion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-asignacion', {
            parent: 'entity',
            url: '/ss-asignacion?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSAsignacions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-asignacion/s-s-asignacions.html',
                    controller: 'SSAsignacionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('ss-asignacion-detail', {
            parent: 'ss-asignacion',
            url: '/ss-asignacion/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSAsignacion'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-asignacion/ss-asignacion-detail.html',
                    controller: 'SSAsignacionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSAsignacion', function($stateParams, SSAsignacion) {
                    return SSAsignacion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-asignacion',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-asignacion-detail.edit', {
            parent: 'ss-asignacion-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-asignacion/ss-asignacion-dialog.html',
                    controller: 'SSAsignacionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-asignacion.new', {
            parent: 'ss-asignacion',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-asignacion/ss-asignacion-dialog.html',
                    controller: 'SSAsignacionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                iniPrestacion: null,
                                finPrestacion: null,
                                duracionHoras: null,
                                estatusPrestador: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                expediente: null,
                                fechaLiberacion: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-asignacion', null, { reload: 'ss-asignacion' });
                }, function() {
                    $state.go('ss-asignacion');
                });
            }]
        })
        .state('ss-asignacion.edit', {
            parent: 'ss-asignacion',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-asignacion/ss-asignacion-dialog.html',
                    controller: 'SSAsignacionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-asignacion', null, { reload: 'ss-asignacion' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-asignacion.delete', {
            parent: 'ss-asignacion',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-asignacion/ss-asignacion-delete-dialog.html',
                    controller: 'SSAsignacionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-asignacion', null, { reload: 'ss-asignacion' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSAsignacion', SSAsignacion);

    SSAsignacion.$inject = ['$resource', 'DateUtils'];

    function SSAsignacion ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-asignacions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.iniPrestacion = DateUtils.convertDateTimeFromServer(data.iniPrestacion);
                        data.finPrestacion = DateUtils.convertDateTimeFromServer(data.finPrestacion);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                        data.fechaLiberacion = DateUtils.convertDateTimeFromServer(data.fechaLiberacion);
                    }
                    return data;
                }
            },
            'getById': {
                method: 'GET',
            	url:'api/s-s-asignacion/liberacion/:id',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.iniPrestacion = DateUtils.convertDateTimeFromServer(data.iniPrestacion);
                        data.finPrestacion = DateUtils.convertDateTimeFromServer(data.finPrestacion);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                        data.fechaLiberacion = DateUtils.convertDateTimeFromServer(data.fechaLiberacion);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'liberar': { 
            	method: 'GET', 
            	url:'api/s-s-asignacions/liberacion/:idAsignacion/:numExpediente',
            	isArray: false
           	},
            'cancelarBaja': { 
            	method: 'GET', 
            	url:'api/s-s-asignacions/cancelar-baja/:idAsignacion',
            	isArray: false
           	},
            'cancelarAsignacion': { 
            	method: 'GET', 
            	url:'api/s-s-asignacions/cancelar-asignacion/:idAsignacion',
            	isArray: false
           	},
            'darDeBaja': { 
            	method: 'POST', 
            	url:'api/s-s-asignacions/baja'
           	},
            'asignar': { 
            	method: 'POST', 
            	url:'api/s-s-asignacions/asignacion'
           	},
            'cambiarFechas': { 
            	method: 'PUT', 
            	url:'api/s-s-asignacions/cambiarFechas'
           	},
            'cambiarFechasAdmin': { 
            	method: 'PUT', 
            	url:'api/s-s-asignacions/fechas'
           	},
			'cancelarLiberacion': { 
			    method: 'PUT', 
			    url:'api/s-s-asignacions/cancelar-liberacion'
			},
            'validarStatusAlumno': { 
            	method: 'GET', 
            	url:'api/s-s-asignacions/validarStatusAlumno/:idAsignacion',
           		isArray: false
           	}, 
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAsignacionController', SSAsignacionController);

    SSAsignacionController.$inject = ['$state', 'SSAsignacion', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SSAsignacionController($state, SSAsignacion, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            SSAsignacion.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sSAsignacions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAreaDialogController', SSAreaDialogController);

    SSAreaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSArea'];

    function SSAreaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSArea) {
        var vm = this;

        vm.sSArea = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSArea.id !== null) {
                SSArea.update(vm.sSArea, onSaveSuccess, onSaveError);
            } else {
                SSArea.save(vm.sSArea, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSAreaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAreaDetailController', SSAreaDetailController);

    SSAreaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSArea'];

    function SSAreaDetailController($scope, $rootScope, $stateParams, previousState, entity, SSArea) {
        var vm = this;

        vm.sSArea = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSAreaUpdate', function(event, result) {
            vm.sSArea = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAreaDeleteController',SSAreaDeleteController);

    SSAreaDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSArea'];

    function SSAreaDeleteController($uibModalInstance, entity, SSArea) {
        var vm = this;

        vm.sSArea = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSArea.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-area', {
            parent: 'entity',
            url: '/ss-area',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSAreas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-area/s-s-areas.html',
                    controller: 'SSAreaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-area-detail', {
            parent: 'ss-area',
            url: '/ss-area/{id}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSArea'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-area/ss-area-detail.html',
                    controller: 'SSAreaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSArea', function($stateParams, SSArea) {
                    return SSArea.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-area',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-area-detail.edit', {
            parent: 'ss-area-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-area/ss-area-dialog.html',
                    controller: 'SSAreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSArea', function(SSArea) {
                            return SSArea.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-area.new', {
            parent: 'ss-area',
            url: '/new',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-area/ss-area-dialog.html',
                    controller: 'SSAreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                descripcion: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-area', null, { reload: 'ss-area' });
                }, function() {
                    $state.go('ss-area');
                });
            }]
        })
        .state('ss-area.edit', {
            parent: 'ss-area',
            url: '/{id}/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-area/ss-area-dialog.html',
                    controller: 'SSAreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSArea', function(SSArea) {
                            return SSArea.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-area', null, { reload: 'ss-area' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-area.delete', {
            parent: 'ss-area',
            url: '/{id}/delete',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-area/ss-area-delete-dialog.html',
                    controller: 'SSAreaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSArea', function(SSArea) {
                            return SSArea.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-area', null, { reload: 'ss-area' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSArea', SSArea);

    SSArea.$inject = ['$resource', 'DateUtils'];

    function SSArea ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-areas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAreaController', SSAreaController);

    SSAreaController.$inject = ['SSArea'];

    function SSAreaController(SSArea) {

        var vm = this;

        vm.sSAreas = [];

        loadAll();

        function loadAll() {
            SSArea.query(function(result) {
                vm.sSAreas = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAnioDialogController', SSAnioDialogController);

    SSAnioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSAnio', 'SSPeriodo'];

    function SSAnioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSAnio, SSPeriodo) {
        var vm = this;

        vm.sSAnio = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssperiodos = SSPeriodo.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSAnio.id !== null) {
                SSAnio.update(vm.sSAnio, onSaveSuccess, onSaveError);
            } else {
                SSAnio.save(vm.sSAnio, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSAnioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAnioDetailController', SSAnioDetailController);

    SSAnioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSAnio', 'SSPeriodo'];

    function SSAnioDetailController($scope, $rootScope, $stateParams, previousState, entity, SSAnio, SSPeriodo) {
        var vm = this;

        vm.sSAnio = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSAnioUpdate', function(event, result) {
            vm.sSAnio = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAnioDeleteController',SSAnioDeleteController);

    SSAnioDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSAnio'];

    function SSAnioDeleteController($uibModalInstance, entity, SSAnio) {
        var vm = this;

        vm.sSAnio = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSAnio.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-anio', {
            parent: 'entity',
            url: '/ss-anio',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSAnios'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-anio/s-s-anios.html',
                    controller: 'SSAnioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-anio-detail', {
            parent: 'ss-anio',
            url: '/ss-anio/{id}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSAnio'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-anio/ss-anio-detail.html',
                    controller: 'SSAnioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSAnio', function($stateParams, SSAnio) {
                    return SSAnio.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-anio',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-anio-detail.edit', {
            parent: 'ss-anio-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-anio/ss-anio-dialog.html',
                    controller: 'SSAnioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSAnio', function(SSAnio) {
                            return SSAnio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-anio.new', {
            parent: 'ss-anio',
            url: '/new',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-anio/ss-anio-dialog.html',
                    controller: 'SSAnioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                anio: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-anio', null, { reload: 'ss-anio' });
                }, function() {
                    $state.go('ss-anio');
                });
            }]
        })
        .state('ss-anio.edit', {
            parent: 'ss-anio',
            url: '/{id}/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-anio/ss-anio-dialog.html',
                    controller: 'SSAnioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSAnio', function(SSAnio) {
                            return SSAnio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-anio', null, { reload: 'ss-anio' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-anio.delete', {
            parent: 'ss-anio',
            url: '/{id}/delete',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-anio/ss-anio-delete-dialog.html',
                    controller: 'SSAnioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSAnio', function(SSAnio) {
                            return SSAnio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-anio', null, { reload: 'ss-anio' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSAnio', SSAnio);

    SSAnio.$inject = ['$resource', 'DateUtils'];

    function SSAnio ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-anios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAnioController', SSAnioController);

    SSAnioController.$inject = ['SSAnio'];

    function SSAnioController(SSAnio) {

        var vm = this;

        vm.sSAnios = [];

        loadAll();

        function loadAll() {
            SSAnio.query(function(result) {
                vm.sSAnios = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSAmbito', SSAmbito);

    SSAmbito.$inject = ['$resource', 'DateUtils'];

    function SSAmbito ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-ambitos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSActividadDialogController', SSActividadDialogController);

    SSActividadDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSActividad', 'SSPerfil'];

    function SSActividadDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSActividad, SSPerfil) {
        var vm = this;

        vm.sSActividad = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssperfils = SSPerfil.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSActividad.id !== null) {
                SSActividad.update(vm.sSActividad, onSaveSuccess, onSaveError);
            } else {
                SSActividad.save(vm.sSActividad, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSActividadUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSActividadDetailController', SSActividadDetailController);

    SSActividadDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSActividad', 'SSPerfil'];

    function SSActividadDetailController($scope, $rootScope, $stateParams, previousState, entity, SSActividad, SSPerfil) {
        var vm = this;

        vm.sSActividad = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSActividadUpdate', function(event, result) {
            vm.sSActividad = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSActividadDeleteController',SSActividadDeleteController);

    SSActividadDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSActividad'];

    function SSActividadDeleteController($uibModalInstance, entity, SSActividad) {
        var vm = this;

        vm.sSActividad = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSActividad.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-actividad', {
            parent: 'entity',
            url: '/ss-actividad',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSActividads'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-actividad/s-s-actividads.html',
                    controller: 'SSActividadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-actividad-detail', {
            parent: 'ss-actividad',
            url: '/ss-actividad/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSActividad'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-actividad/ss-actividad-detail.html',
                    controller: 'SSActividadDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSActividad', function($stateParams, SSActividad) {
                    return SSActividad.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-actividad',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-actividad-detail.edit', {
            parent: 'ss-actividad-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-actividad/ss-actividad-dialog.html',
                    controller: 'SSActividadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSActividad', function(SSActividad) {
                            return SSActividad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-actividad.new', {
            parent: 'ss-actividad',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-actividad/ss-actividad-dialog.html',
                    controller: 'SSActividadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                descripcion: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-actividad', null, { reload: 'ss-actividad' });
                }, function() {
                    $state.go('ss-actividad');
                });
            }]
        })
        .state('ss-actividad.edit', {
            parent: 'ss-actividad',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-actividad/ss-actividad-dialog.html',
                    controller: 'SSActividadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSActividad', function(SSActividad) {
                            return SSActividad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-actividad', null, { reload: 'ss-actividad' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-actividad.delete', {
            parent: 'ss-actividad',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-actividad/ss-actividad-delete-dialog.html',
                    controller: 'SSActividadDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSActividad', function(SSActividad) {
                            return SSActividad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-actividad', null, { reload: 'ss-actividad' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSActividad', SSActividad);

    SSActividad.$inject = ['$resource', 'DateUtils'];

    function SSActividad ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-actividads/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSActividadController', SSActividadController);

    SSActividadController.$inject = ['SSActividad'];

    function SSActividadController(SSActividad) {

        var vm = this;

        vm.sSActividads = [];

        loadAll();

        function loadAll() {
            SSActividad.query(function(result) {
                vm.sSActividads = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProgramaEducativoDialogController', ProgramaEducativoDialogController);

    ProgramaEducativoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProgramaEducativo'];

    function ProgramaEducativoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProgramaEducativo) {
        var vm = this;

        vm.programaEducativo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.programaEducativo.id !== null) {
                ProgramaEducativo.update(vm.programaEducativo, onSaveSuccess, onSaveError);
            } else {
                ProgramaEducativo.save(vm.programaEducativo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:programaEducativoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProgramaEducativoDetailController', ProgramaEducativoDetailController);

    ProgramaEducativoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProgramaEducativo'];

    function ProgramaEducativoDetailController($scope, $rootScope, $stateParams, previousState, entity, ProgramaEducativo) {
        var vm = this;

        vm.programaEducativo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:programaEducativoUpdate', function(event, result) {
            vm.programaEducativo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProgramaEducativoDeleteController',ProgramaEducativoDeleteController);

    ProgramaEducativoDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProgramaEducativo'];

    function ProgramaEducativoDeleteController($uibModalInstance, entity, ProgramaEducativo) {
        var vm = this;

        vm.programaEducativo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProgramaEducativo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('programa-educativo', {
            parent: 'entity',
            url: '/programa-educativo',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ProgramaEducativos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/programa-educativo/programa-educativos.html',
                    controller: 'ProgramaEducativoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('programa-educativo-detail', {
            parent: 'programa-educativo',
            url: '/programa-educativo/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ProgramaEducativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/programa-educativo/programa-educativo-detail.html',
                    controller: 'ProgramaEducativoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ProgramaEducativo', function($stateParams, ProgramaEducativo) {
                    return ProgramaEducativo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'programa-educativo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('programa-educativo-detail.edit', {
            parent: 'programa-educativo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/programa-educativo/programa-educativo-dialog.html',
                    controller: 'ProgramaEducativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProgramaEducativo', function(ProgramaEducativo) {
                            return ProgramaEducativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('programa-educativo.new', {
            parent: 'programa-educativo',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/programa-educativo/programa-educativo-dialog.html',
                    controller: 'ProgramaEducativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('programa-educativo', null, { reload: 'programa-educativo' });
                }, function() {
                    $state.go('programa-educativo');
                });
            }]
        })
        .state('programa-educativo.edit', {
            parent: 'programa-educativo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/programa-educativo/programa-educativo-dialog.html',
                    controller: 'ProgramaEducativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProgramaEducativo', function(ProgramaEducativo) {
                            return ProgramaEducativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('programa-educativo', null, { reload: 'programa-educativo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('programa-educativo.delete', {
            parent: 'programa-educativo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/programa-educativo/programa-educativo-delete-dialog.html',
                    controller: 'ProgramaEducativoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProgramaEducativo', function(ProgramaEducativo) {
                            return ProgramaEducativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('programa-educativo', null, { reload: 'programa-educativo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('ProgramaEducativo', ProgramaEducativo);

    ProgramaEducativo.$inject = ['$resource'];

    function ProgramaEducativo ($resource) {
        var resourceUrl =  'api/programa-educativos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'all': { 
            	method: 'GET',
            	url:'api/programa-educativos-all',
            	isArray: true
           	},
            'distinct': { 
            	method: 'GET',
            	url:'api/programas-educativos-distinct',
            	isArray: true
           	},
            'allByCentroDocente': { 
            	method: 'GET',
            	url:'api/programa-educativos-all/:idCentroDocente',
            	isArray: true
           	},
            'getByCurrentUser': {
                method: 'GET',
            	url:'api/programa-educativos-by-current-user',
            	isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProgramaEducativoController', ProgramaEducativoController);

    ProgramaEducativoController.$inject = ['ProgramaEducativo'];

    function ProgramaEducativoController(ProgramaEducativo) {

        var vm = this;

        vm.programaEducativos = [];

        loadAll();

        function loadAll() {
            ProgramaEducativo.query(function(result) {
                vm.programaEducativos = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PlanDeEstudiosDialogController', PlanDeEstudiosDialogController);

    PlanDeEstudiosDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PlanDeEstudios'];

    function PlanDeEstudiosDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PlanDeEstudios) {
        var vm = this;

        vm.planDeEstudios = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.planDeEstudios.id !== null) {
                PlanDeEstudios.update(vm.planDeEstudios, onSaveSuccess, onSaveError);
            } else {
                PlanDeEstudios.save(vm.planDeEstudios, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:planDeEstudiosUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PlanDeEstudiosDetailController', PlanDeEstudiosDetailController);

    PlanDeEstudiosDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PlanDeEstudios'];

    function PlanDeEstudiosDetailController($scope, $rootScope, $stateParams, previousState, entity, PlanDeEstudios) {
        var vm = this;

        vm.planDeEstudios = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:planDeEstudiosUpdate', function(event, result) {
            vm.planDeEstudios = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PlanDeEstudiosDeleteController',PlanDeEstudiosDeleteController);

    PlanDeEstudiosDeleteController.$inject = ['$uibModalInstance', 'entity', 'PlanDeEstudios'];

    function PlanDeEstudiosDeleteController($uibModalInstance, entity, PlanDeEstudios) {
        var vm = this;

        vm.planDeEstudios = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PlanDeEstudios.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('plan-de-estudios', {
            parent: 'entity',
            url: '/plan-de-estudios',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'PlanDeEstudios'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/plan-de-estudios/plan-de-estudios.html',
                    controller: 'PlanDeEstudiosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('plan-de-estudios-detail', {
            parent: 'plan-de-estudios',
            url: '/plan-de-estudios/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'PlanDeEstudios'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/plan-de-estudios/plan-de-estudios-detail.html',
                    controller: 'PlanDeEstudiosDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PlanDeEstudios', function($stateParams, PlanDeEstudios) {
                    return PlanDeEstudios.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'plan-de-estudios',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('plan-de-estudios-detail.edit', {
            parent: 'plan-de-estudios-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plan-de-estudios/plan-de-estudios-dialog.html',
                    controller: 'PlanDeEstudiosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PlanDeEstudios', function(PlanDeEstudios) {
                            return PlanDeEstudios.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('plan-de-estudios.new', {
            parent: 'plan-de-estudios',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plan-de-estudios/plan-de-estudios-dialog.html',
                    controller: 'PlanDeEstudiosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('plan-de-estudios', null, { reload: 'plan-de-estudios' });
                }, function() {
                    $state.go('plan-de-estudios');
                });
            }]
        })
        .state('plan-de-estudios.edit', {
            parent: 'plan-de-estudios',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plan-de-estudios/plan-de-estudios-dialog.html',
                    controller: 'PlanDeEstudiosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PlanDeEstudios', function(PlanDeEstudios) {
                            return PlanDeEstudios.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('plan-de-estudios', null, { reload: 'plan-de-estudios' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('plan-de-estudios.delete', {
            parent: 'plan-de-estudios',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plan-de-estudios/plan-de-estudios-delete-dialog.html',
                    controller: 'PlanDeEstudiosDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PlanDeEstudios', function(PlanDeEstudios) {
                            return PlanDeEstudios.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('plan-de-estudios', null, { reload: 'plan-de-estudios' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('PlanDeEstudios', PlanDeEstudios);

    PlanDeEstudios.$inject = ['$resource'];

    function PlanDeEstudios ($resource) {
        var resourceUrl =  'api/plan-de-estudios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PlanDeEstudiosController', PlanDeEstudiosController);

    PlanDeEstudiosController.$inject = ['PlanDeEstudios'];

    function PlanDeEstudiosController(PlanDeEstudios) {

        var vm = this;

        vm.planDeEstudios = [];

        loadAll();

        function loadAll() {
            PlanDeEstudios.query(function(result) {
                vm.planDeEstudios = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PersonaDialogController', PersonaDialogController);

    PersonaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Persona'];

    function PersonaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Persona) {
        var vm = this;

        vm.persona = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.persona.id !== null) {
                Persona.update(vm.persona, onSaveSuccess, onSaveError);
            } else {
                Persona.save(vm.persona, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:personaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PersonaDetailController', PersonaDetailController);

    PersonaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Persona'];

    function PersonaDetailController($scope, $rootScope, $stateParams, previousState, entity, Persona) {
        var vm = this;

        vm.persona = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:personaUpdate', function(event, result) {
            vm.persona = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PersonaDeleteController',PersonaDeleteController);

    PersonaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Persona'];

    function PersonaDeleteController($uibModalInstance, entity, Persona) {
        var vm = this;

        vm.persona = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Persona.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('persona', {
            parent: 'entity',
            url: '/persona',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Personas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/persona/personas.html',
                    controller: 'PersonaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('persona-detail', {
            parent: 'persona',
            url: '/persona/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Persona'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/persona/persona-detail.html',
                    controller: 'PersonaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Persona', function($stateParams, Persona) {
                    return Persona.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'persona',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('persona-detail.edit', {
            parent: 'persona-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/persona/persona-dialog.html',
                    controller: 'PersonaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Persona', function(Persona) {
                            return Persona.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('persona.new', {
            parent: 'persona',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/persona/persona-dialog.html',
                    controller: 'PersonaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('persona', null, { reload: 'persona' });
                }, function() {
                    $state.go('persona');
                });
            }]
        })
        .state('persona.edit', {
            parent: 'persona',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/persona/persona-dialog.html',
                    controller: 'PersonaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Persona', function(Persona) {
                            return Persona.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('persona', null, { reload: 'persona' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('persona.delete', {
            parent: 'persona',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/persona/persona-delete-dialog.html',
                    controller: 'PersonaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Persona', function(Persona) {
                            return Persona.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('persona', null, { reload: 'persona' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('Persona', Persona);

    Persona.$inject = ['$resource'];

    function Persona ($resource) {
        var resourceUrl =  'api/personas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PersonaController', PersonaController);

    PersonaController.$inject = ['Persona'];

    function PersonaController(Persona) {

        var vm = this;

        vm.personas = [];

        loadAll();

        function loadAll() {
            Persona.query(function(result) {
                vm.personas = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('InstitucionDialogController', InstitucionDialogController);

    InstitucionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Institucion'];

    function InstitucionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Institucion) {
        var vm = this;

        vm.institucion = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.institucion.id !== null) {
                Institucion.update(vm.institucion, onSaveSuccess, onSaveError);
            } else {
                Institucion.save(vm.institucion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:institucionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('InstitucionDetailController', InstitucionDetailController);

    InstitucionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Institucion'];

    function InstitucionDetailController($scope, $rootScope, $stateParams, previousState, entity, Institucion) {
        var vm = this;

        vm.institucion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:institucionUpdate', function(event, result) {
            vm.institucion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('InstitucionDeleteController',InstitucionDeleteController);

    InstitucionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Institucion'];

    function InstitucionDeleteController($uibModalInstance, entity, Institucion) {
        var vm = this;

        vm.institucion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Institucion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('institucion', {
            parent: 'entity',
            url: '/institucion',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Institucions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/institucion/institucions.html',
                    controller: 'InstitucionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('institucion-detail', {
            parent: 'institucion',
            url: '/institucion/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Institucion'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/institucion/institucion-detail.html',
                    controller: 'InstitucionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Institucion', function($stateParams, Institucion) {
                    return Institucion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'institucion',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('institucion-detail.edit', {
            parent: 'institucion-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/institucion/institucion-dialog.html',
                    controller: 'InstitucionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Institucion', function(Institucion) {
                            return Institucion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('institucion.new', {
            parent: 'institucion',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/institucion/institucion-dialog.html',
                    controller: 'InstitucionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('institucion', null, { reload: 'institucion' });
                }, function() {
                    $state.go('institucion');
                });
            }]
        })
        .state('institucion.edit', {
            parent: 'institucion',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/institucion/institucion-dialog.html',
                    controller: 'InstitucionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Institucion', function(Institucion) {
                            return Institucion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('institucion', null, { reload: 'institucion' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('institucion.delete', {
            parent: 'institucion',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/institucion/institucion-delete-dialog.html',
                    controller: 'InstitucionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Institucion', function(Institucion) {
                            return Institucion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('institucion', null, { reload: 'institucion' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('Institucion', Institucion);

    Institucion.$inject = ['$resource'];

    function Institucion ($resource) {
        var resourceUrl =  'api/institucions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('InstitucionController', InstitucionController);

    InstitucionController.$inject = ['Institucion'];

    function InstitucionController(Institucion) {

        var vm = this;

        vm.institucions = [];

        loadAll();

        function loadAll() {
            Institucion.query(function(result) {
                vm.institucions = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CentroDocenteDialogController', CentroDocenteDialogController);

    CentroDocenteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CentroDocente'];

    function CentroDocenteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CentroDocente) {
        var vm = this;

        vm.centroDocente = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.centroDocente.id !== null) {
                CentroDocente.update(vm.centroDocente, onSaveSuccess, onSaveError);
            } else {
                CentroDocente.save(vm.centroDocente, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:centroDocenteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CentroDocenteDetailController', CentroDocenteDetailController);

    CentroDocenteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CentroDocente'];

    function CentroDocenteDetailController($scope, $rootScope, $stateParams, previousState, entity, CentroDocente) {
        var vm = this;

        vm.centroDocente = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:centroDocenteUpdate', function(event, result) {
            vm.centroDocente = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CentroDocenteDeleteController',CentroDocenteDeleteController);

    CentroDocenteDeleteController.$inject = ['$uibModalInstance', 'entity', 'CentroDocente'];

    function CentroDocenteDeleteController($uibModalInstance, entity, CentroDocente) {
        var vm = this;

        vm.centroDocente = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CentroDocente.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('centro-docente', {
            parent: 'entity',
            url: '/centro-docente',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'CentroDocentes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/centro-docente/centro-docentes.html',
                    controller: 'CentroDocenteController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('centro-docente-detail', {
            parent: 'centro-docente',
            url: '/centro-docente/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'CentroDocente'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/centro-docente/centro-docente-detail.html',
                    controller: 'CentroDocenteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CentroDocente', function($stateParams, CentroDocente) {
                    return CentroDocente.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'centro-docente',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('centro-docente-detail.edit', {
            parent: 'centro-docente-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/centro-docente/centro-docente-dialog.html',
                    controller: 'CentroDocenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CentroDocente', function(CentroDocente) {
                            return CentroDocente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('centro-docente.new', {
            parent: 'centro-docente',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/centro-docente/centro-docente-dialog.html',
                    controller: 'CentroDocenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('centro-docente', null, { reload: 'centro-docente' });
                }, function() {
                    $state.go('centro-docente');
                });
            }]
        })
        .state('centro-docente.edit', {
            parent: 'centro-docente',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/centro-docente/centro-docente-dialog.html',
                    controller: 'CentroDocenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CentroDocente', function(CentroDocente) {
                            return CentroDocente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('centro-docente', null, { reload: 'centro-docente' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('centro-docente.delete', {
            parent: 'centro-docente',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/centro-docente/centro-docente-delete-dialog.html',
                    controller: 'CentroDocenteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CentroDocente', function(CentroDocente) {
                            return CentroDocente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('centro-docente', null, { reload: 'centro-docente' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('CentroDocente', CentroDocente);

    CentroDocente.$inject = ['$resource'];

    function CentroDocente ($resource) {
        var resourceUrl =  'api/centro-docentes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'all': { 
            	method: 'GET',
            	url:'api/centro-docentes-all',
            	isArray: true
           	},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getByCurrentUser': {
                method: 'GET',
            	url:'api/centro-docentes-by-current-user',
            	isArray: true
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CentroDocenteController', CentroDocenteController);

    CentroDocenteController.$inject = ['CentroDocente'];

    function CentroDocenteController(CentroDocente) {

        var vm = this;

        vm.centroDocentes = [];

        loadAll();

        function loadAll() {
            CentroDocente.query(function(result) {
                vm.centroDocentes = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CampusDialogController', CampusDialogController);

    CampusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Campus'];

    function CampusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Campus) {
        var vm = this;

        vm.campus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.campus.id !== null) {
                Campus.update(vm.campus, onSaveSuccess, onSaveError);
            } else {
                Campus.save(vm.campus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:campusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CampusDetailController', CampusDetailController);

    CampusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Campus'];

    function CampusDetailController($scope, $rootScope, $stateParams, previousState, entity, Campus) {
        var vm = this;

        vm.campus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:campusUpdate', function(event, result) {
            vm.campus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CampusDeleteController',CampusDeleteController);

    CampusDeleteController.$inject = ['$uibModalInstance', 'entity', 'Campus'];

    function CampusDeleteController($uibModalInstance, entity, Campus) {
        var vm = this;

        vm.campus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Campus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('campus', {
            parent: 'entity',
            url: '/campus',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Campuses'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campus/campuses.html',
                    controller: 'CampusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('campus-detail', {
            parent: 'campus',
            url: '/campus/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Campus'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campus/campus-detail.html',
                    controller: 'CampusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Campus', function($stateParams, Campus) {
                    return Campus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'campus',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('campus-detail.edit', {
            parent: 'campus-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campus/campus-dialog.html',
                    controller: 'CampusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campus', function(Campus) {
                            return Campus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campus.new', {
            parent: 'campus',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campus/campus-dialog.html',
                    controller: 'CampusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('campus', null, { reload: 'campus' });
                }, function() {
                    $state.go('campus');
                });
            }]
        })
        .state('campus.edit', {
            parent: 'campus',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campus/campus-dialog.html',
                    controller: 'CampusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campus', function(Campus) {
                            return Campus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campus', null, { reload: 'campus' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campus.delete', {
            parent: 'campus',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campus/campus-delete-dialog.html',
                    controller: 'CampusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Campus', function(Campus) {
                            return Campus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campus', null, { reload: 'campus' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('Campus', Campus);

    Campus.$inject = ['$resource'];

    function Campus ($resource) {
        var resourceUrl =  'api/campuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CampusController', CampusController);

    CampusController.$inject = ['Campus'];

    function CampusController(Campus) {

        var vm = this;

        vm.campuses = [];

        loadAll();

        function loadAll() {
            Campus.query(function(result) {
                vm.campuses = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('AlumnoUadyMatriculadoDialogController', AlumnoUadyMatriculadoDialogController);

    AlumnoUadyMatriculadoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AlumnoUadyMatriculado'];

    function AlumnoUadyMatriculadoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AlumnoUadyMatriculado) {
        var vm = this;

        vm.alumnoUadyMatriculado = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.alumnoUadyMatriculado.id !== null) {
                AlumnoUadyMatriculado.update(vm.alumnoUadyMatriculado, onSaveSuccess, onSaveError);
            } else {
                AlumnoUadyMatriculado.save(vm.alumnoUadyMatriculado, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:alumnoUadyMatriculadoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('AlumnoUadyMatriculadoDetailController', AlumnoUadyMatriculadoDetailController);

    AlumnoUadyMatriculadoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AlumnoUadyMatriculado'];

    function AlumnoUadyMatriculadoDetailController($scope, $rootScope, $stateParams, previousState, entity, AlumnoUadyMatriculado) {
        var vm = this;

        vm.alumnoUadyMatriculado = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:alumnoUadyMatriculadoUpdate', function(event, result) {
            vm.alumnoUadyMatriculado = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('AlumnoUadyMatriculadoDeleteController',AlumnoUadyMatriculadoDeleteController);

    AlumnoUadyMatriculadoDeleteController.$inject = ['$uibModalInstance', 'entity', 'AlumnoUadyMatriculado'];

    function AlumnoUadyMatriculadoDeleteController($uibModalInstance, entity, AlumnoUadyMatriculado) {
        var vm = this;

        vm.alumnoUadyMatriculado = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AlumnoUadyMatriculado.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('alumno-uady-matriculado', {
            parent: 'entity',
            url: '/alumno-uady-matriculado',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AlumnoUadyMatriculados'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/alumno-uady-matriculado/alumno-uady-matriculados.html',
                    controller: 'AlumnoUadyMatriculadoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('alumno-uady-matriculado-detail', {
            parent: 'alumno-uady-matriculado',
            url: '/alumno-uady-matriculado/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AlumnoUadyMatriculado'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/alumno-uady-matriculado/alumno-uady-matriculado-detail.html',
                    controller: 'AlumnoUadyMatriculadoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'AlumnoUadyMatriculado', function($stateParams, AlumnoUadyMatriculado) {
                    return AlumnoUadyMatriculado.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'alumno-uady-matriculado',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('alumno-uady-matriculado-detail.edit', {
            parent: 'alumno-uady-matriculado-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alumno-uady-matriculado/alumno-uady-matriculado-dialog.html',
                    controller: 'AlumnoUadyMatriculadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AlumnoUadyMatriculado', function(AlumnoUadyMatriculado) {
                            return AlumnoUadyMatriculado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('alumno-uady-matriculado.new', {
            parent: 'alumno-uady-matriculado',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alumno-uady-matriculado/alumno-uady-matriculado-dialog.html',
                    controller: 'AlumnoUadyMatriculadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('alumno-uady-matriculado', null, { reload: 'alumno-uady-matriculado' });
                }, function() {
                    $state.go('alumno-uady-matriculado');
                });
            }]
        })
        .state('alumno-uady-matriculado.edit', {
            parent: 'alumno-uady-matriculado',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alumno-uady-matriculado/alumno-uady-matriculado-dialog.html',
                    controller: 'AlumnoUadyMatriculadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AlumnoUadyMatriculado', function(AlumnoUadyMatriculado) {
                            return AlumnoUadyMatriculado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('alumno-uady-matriculado', null, { reload: 'alumno-uady-matriculado' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('alumno-uady-matriculado.delete', {
            parent: 'alumno-uady-matriculado',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alumno-uady-matriculado/alumno-uady-matriculado-delete-dialog.html',
                    controller: 'AlumnoUadyMatriculadoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AlumnoUadyMatriculado', function(AlumnoUadyMatriculado) {
                            return AlumnoUadyMatriculado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('alumno-uady-matriculado', null, { reload: 'alumno-uady-matriculado' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('AlumnoUadyMatriculado', AlumnoUadyMatriculado);

    AlumnoUadyMatriculado.$inject = ['$resource'];

    function AlumnoUadyMatriculado ($resource) {
        var resourceUrl =  'api/alumno-uady-matriculados/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'getActiveByProgramaEducativo': { 
            	method: 'GET', 
            	isArray: true,
            	url:'api/alumno-uady-matriculados/search/:programaEducativo,:search',
            },
            'getActiveByCGSE': { 
            	method: 'GET', 
            	isArray: true,
            	url:'api/alumno-uady-matriculados/searchAll/:cgse,:search',
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('AlumnoUadyMatriculadoController', AlumnoUadyMatriculadoController);

    AlumnoUadyMatriculadoController.$inject = ['AlumnoUadyMatriculado'];

    function AlumnoUadyMatriculadoController(AlumnoUadyMatriculado) {

        var vm = this;

        vm.alumnoUadyMatriculados = [];

        loadAll();

        function loadAll() {
            AlumnoUadyMatriculado.query(function(result) {
                vm.alumnoUadyMatriculados = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('serviciosocialApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.loginSicei = loginSicei;
        vm.passwordSicei = null;
        vm.usernameSicei = null;
        vm.loginExterno = loginExterno;
        vm.passwordExterno = null;
        vm.usernameExterno = null;
        vm.rememberMe = true;

        vm.cancel = cancel;
        vm.credentials = {};
        vm.requestResetPassword = requestResetPassword;
        vm.register = register;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }
        
        function loginSicei (event) {
            event.preventDefault();
            Auth.login({
                username: vm.usernameSicei + "@sicei",
                password: vm.passwordSicei,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function loginExterno (event) {
            event.preventDefault();
            Auth.login({
                username: vm.usernameExterno + "@externo",
                password: vm.passwordExterno,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('serviciosocialApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('serviciosocialApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 403:
                addErrorAlert('No está autorizado para visualizar la información.','error.url.unautorized');
                break;
                
            case 404:
                addErrorAlert('No se encontró ningún resultado.','error.url.not.found');
                break;
                
            case 418:
                addErrorAlert('No hay periodo de convocatoria vigente.','error.url.teapot');
                break;
                
                
            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('serviciosocialApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('serviciosocialApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$location'];

    function authExpiredInterceptor($rootScope, $q, $injector, $location) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                
                var LoginService = $injector.get('LoginService');
                LoginService.open();
//                $location.url('/sessionexpired');
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'serviciosocial' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('serviciosocialApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;



        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User', 'Principal'];

    function UserManagementDetailController ($stateParams, User, Principal) {
        var vm = this;

        vm.load = load;
        vm.user = {};
        vm.isAdmin = false;
        
        vm.load($stateParams.login);

        Principal.hasAuthority('ROLE_ADMIN')
			.then(function (result) {
            	if (result) {
                	vm.isAdmin = true;
        		}
		});

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }
        })
        .state('ss-user', {
            parent: 'entity',
            url: '/ss-user?search&page&sort',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: {
                    value: '',
                    squash: true
                },
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        search: $stateParams.search,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }
        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('ss-user.new', {
            url: '/new',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-user', null, { reload: true });
                }, function() {
                    $state.go('ss-user');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-user', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-user.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-user', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/user/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'serviciosocial'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('ss-user-detail', {
            parent: 'ss-user',
            url: '/ss-user/{login}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'serviciosocial'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-user.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-user', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', '$stateParams', 'pagingParams', 'paginationConstants'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, $stateParams, pagingParams, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchText = $stateParams.search;
        vm.transition = transition;
        vm.isAdmin = false;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        Principal.hasAuthority('ROLE_ADMIN')
			.then(function (result) {
            	if (result) {
                	vm.isAdmin = true;
        		}
		});

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
			User.search({
				searchText: vm.searchText.length > 0 ? vm.searchText : null,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.searchText
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('serviciosocialApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER', 'ADMINISTRADOR', 'SUPERVISOR'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'Registration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = [ '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('serviciosocialApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/buscador-proyectos-solicitud.html','<div ng-show="vm.sSProyecto.id == null && vm.periodoVigente == null" class="alert alert-info alert-important" role="alert">No se encuentra abierto el periodo de convocatoria.</div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class="modal-header"><h2 class="modal-title" id="mySSProyectoLabel">Solicitud de Registro de Proyecto</h2><div class="btn-group" role="group" ng-show="vm.sSProyecto.id !== null"><button class="btn btn-default" disabled="disabled">Estatus: <strong>{{vm.sSProyecto.estatus}}</strong></button></div></div><div class="modal-body"><uib-tabset active="active"><uib-tab index="0" heading="Datos Generales"><fieldset ng-disabled="vm.isDisabled"><h3>Datos Generales</h3><div class="form-group" ng-show="vm.sSProyecto.id"><label for="id">N\xFAm. de Proyecto:</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSProyecto.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="nombre"><span class="required-legend">*</span> Nombre del Proyecto Social:</label><textarea required class="form-control big-textarea" name="nombre" id="nomre" ng-model="vm.sSProyecto.nombre" required ng-maxlength="600"></textarea></div><div class="" ng-repeat="unidadReceptora in vm.sSProyecto.unidadesReceptoras"><div class="form-group"><label for="ur_institucion"><span class="required-legend">*</span> Instituci\xF3n:</label><input type="text" class="form-control" id="ur_institucion" name="ur_institucion" ng-model="unidadReceptora.institucion" required ng-maxlength="200"></div><div class="form-group"><label for="ur_sector">Sector:</label><input type="text" class="form-control" id="ur_sector" name="ur_sector" ng-model="unidadReceptora.sector.nombre" required ng-maxlength="200"></div><div class="form-group"><label for="ur_dependencia">Datos de la dependencia:</label><div class="form-group"><label class="sr-only" for="ur_dependencia">Nombre:</label><input type="text" class="form-control" name="ur_dependencia" id="ur_dependencia" placeholder="Nombre" ng-model="unidadReceptora.dependencia" required ng-maxlength="200"></div><div class="form-group"><label class="sr-only" for="ur_direccion">Direcci\xF3n:</label><input type="text" class="form-control" name="ur_direccion" id="ur_direccion" placeholder="Direcci\xF3n" ng-model="unidadReceptora.direccion" required ng-maxlength="200"></div><div class="form-group"><label class="sr-only" for="ur_telefono">Tel\xE9fono y Fax:</label><input type="text" class="form-control" name="ur_telefono" id="ur_telefono" placeholder="Tel\xE9fono y Fax" ng-model="unidadReceptora.telefono1" required ng-maxlength="30"></div></div><div class="form-group"><label for="ur_unidadReceptora">Unidad Receptora</label><input type="text" class="form-control" id="ur_unidadReceptora" name="ur_unidadReceptora" ng-model="unidadReceptora.unidadReceptora" required ng-maxlength="200"></div></div><div class="form-group"><label class="control-label" for="semestres">N\xFAmero de semestres que estar\xE1 vigente:</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSProyecto.semestres" readonly="readonly"></div><div class="form-group"><label for="funcion">Funci\xF3n en la que incide:</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSProyecto.funcion.nombre" readonly="readonly"></div><div class="form-group"><label for="modalidad">Modalidad:</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSProyecto.modalidad.nombre" readonly="readonly"></div><div class="form-group"><label for="area">\xC1rea prioritaria de desarrollo:</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSProyecto.area.nombre" readonly="readonly"></div></fieldset><p class="text-center"><button type="button" class="btn btn-default" ng-click="active = $parent.$parent.active = 1"><span class="glyphicon glyphicon-chevron-right"></span>&nbsp;<span>Siguiente</span></button></p></uib-tab><uib-tab index="1" heading="Datos del proyecto"><fieldset ng-disabled="vm.isDisabled"><h3>Datos del proyecto</h3><div class="form-group"><label class="control-label" for="recursosMateriales">Recursos con los que dispondr\xE1 el prestador:</label><div class="form-group"><label class="sr-only" for="recursosMateriales">Materiales:</label><textarea required class="form-control big-textarea" name="recursosMateriales" id="recursosMateriales" ng-model="vm.sSProyecto.recursosMateriales" placeholder="Materiales"></textarea></div><div class="form-group"><label class="sr-only" for="recursosHumanos">Humanos:</label><textarea required class="form-control big-textarea" name="recursosHumanos" id="recursosHumanos" ng-model="vm.sSProyecto.recursosHumanos" placeholder="Humanos"></textarea></div><div class="form-group"><label class="sr-only" for="recursosInfraestructura">Infraestructura:</label><textarea required class="form-control big-textarea" name="recursosInfraestructura" id="recursosInfraestructura" ng-model="vm.sSProyecto.recursosInfraestructura" placeholder="Infraestructura"></textarea></div></div><div class="form-group"><label for="monto">Apoyo econ\xF3mico (mensual):</label><input required type="number" class="form-control" id="monto" name="monto" min="0" ng-model="vm.sSProyecto.monto"></div><div class="form-group"><label class="control-label" for="viaticosAlimentos">Vi\xE1ticos:</label><div class="form-group"><label for="viaticosAlimentos"><input type="checkbox" class="form-check-input" id="viaticosAlimentos" name="viaticosAlimentos" ng-model="vm.sSProyecto.viaticosAlimentos"> Alimentos</label></div><div class="form-group"><label for="viaticosTransporte"><input type="checkbox" class="form-check-input" id="viaticosTransporte" name="viaticosTransporte" ng-model="vm.sSProyecto.viaticosTransporte"> Transporte</label></div></div><div class="form-group"><label for="horarioPrestador">Horario del prestador:</label><input type="text" class="form-control" id="horarioPrestador" name="horarioPrestador" ng-model="vm.sSProyecto.horarioPrestador" required ng-maxlength="200"></div><div class="form-group"><label class="control-label" for="induccion">Inducci\xF3n:</label><div class="form-group"><label class="sr-only" for="induccion">Descripci\xF3n:</label><textarea required class="form-control" name="induccion" id="induccion" ng-model="vm.sSProyecto.induccion" placeholder="Descripci\xF3n"></textarea></div><div class="form-group"><label for="horasInduccion">Duraci\xF3n de la inducci\xF3n (horas):</label><input type="number" class="form-control" name="horasInduccion" id="horasInduccion" placeholder="Duraci\xF3n en horas" ng-model="vm.sSProyecto.horasInduccion" required min="0" ng-maxlength="200"></div></div><div class="form-group"><label for="supervisionInstrumentos">Supervisi\xF3n y evaluaci\xF3n del prestador por parte del responsable directo:</label><div class="form-group"><label class="sr-only" for="supervisionInstrumentos">Instrumentos:</label><textarea required class="form-control" name="supervisionInstrumentos" id="supervisionInstrumentos" ng-model="vm.sSProyecto.supervisionInstrumentos" placeholder="Instrumentos"></textarea></div><div class="form-group"><label class="sr-only" for="supervisionPeriodicidad">Periodicidad:</label><textarea required class="form-control" name="supervisionPeriodicidad" id="supervisionPeriodicidad" ng-model="vm.sSProyecto.supervisionPeriodicidad" placeholder="Periodicidad"></textarea></div><div class="form-group"><label class="sr-only" for="supervisionCriterios">Criterios:</label><textarea required class="form-control" name="supervisionCriterios" id="supervisionCriterios" ng-model="vm.sSProyecto.supervisionCriterios" placeholder="Criterios"></textarea></div></div></fieldset><p class="text-center"><button type="button" class="btn btn-default" ng-click="active = $parent.$parent.active = 0"><span class="glyphicon glyphicon-chevron-left"></span>&nbsp;<span>Anterior</span></button> <button type="button" class="btn btn-default" ng-click="active = $parent.$parent.active = 2"><span class="glyphicon glyphicon-chevron-right"></span>&nbsp;<span>Siguiente</span></button></p></uib-tab><uib-tab index="2" heading="Perfiles"><fieldset ng-disabled="vm.isDisabled"><h3>Perfiles Solicitados</h3><div ng-show="vm.sSProyecto.perfils.length == 0" class="alert alert-warning" role="alert">No ha definido ning\xFAn perfil.</div><div class="table-space"><table class="table" ng-show="vm.sSProyecto.perfils.length > 0"><tr><th>Licenciatura</th><th>No. de prestadores</th><th>Tareas</th><th>Responsable de prestadores</th></tr><tr ng-repeat="perfil in vm.sSProyecto.perfils"><td>{{perfil.programaEducativo.nombre}}</td><td>{{perfil.solicitados}}</td><td><ul class="list-space" ng-if="perfil.actividads.length > 0"><li ng-repeat="actividad in perfil.actividads"><strong>{{actividad.nombre}}</strong> - {{actividad.descripcion}}</li></ul></td><td><ul class="list-space" ng-if="perfil.respDePrestadors.length > 0"><li ng-repeat="respDePrestador in perfil.respDePrestadors"><strong>{{respDePrestador.nombres}} {{respDePrestador.primerApellido}} {{respDePrestador.segundoApellido}}</strong><br>{{respDePrestador.titulo}}<br>{{respDePrestador.email}}<br>{{respDePrestador.telefono}}, {{respDePrestador.telefono2}}<br></li></ul></td></tr></table></div></fieldset><p class="text-center"><button type="button" class="btn btn-default" ng-click="active = $parent.$parent.active = 1"><span class="glyphicon glyphicon-chevron-left"></span>&nbsp;<span>Anterior</span></button> <button type="button" class="btn btn-default" ng-click="active = $parent.$parent.active = 3"><span class="glyphicon glyphicon-chevron-right"></span>&nbsp;<span>Siguiente</span></button></p></uib-tab><uib-tab index="3" heading="Responsable de Proyecto"><fieldset ng-disabled="vm.isDisabled"><h3>Responsable de Proyecto</h3><div class="form-horizontal" ng-repeat="respDeProyecto in vm.sSProyecto.respDeProyectos"><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_nombres">Nombres:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_nombres" id="respDeProyectos_nombres" placeholder="Nombres" ng-model="respDeProyecto.nombres" required ng-maxlength="60"></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_primerApellido">Primer apellido:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_primerApellido" id="respDeProyectos_primerApellido" placeholder="Primer apellido" ng-model="respDeProyecto.primerApellido" required ng-maxlength="40"></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_segundoApellido">Segundo apellido:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_segundoApellido" id="respDeProyectos_segundoApellido" placeholder="Segundo apellido" ng-model="respDeProyecto.segundoApellido" ng-maxlength="40"></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_titulo">T\xED\xADtulo:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_titulo" id="respDeProyectos_titulo" placeholder="T\xC3\xADtulo" ng-model="respDeProyecto.titulo" required ng-maxlength="255"></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_cargo">Cargo:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_cargo" id="respDeProyectos_cargo" placeholder="Cargo" ng-model="respDeProyecto.cargo" required ng-maxlength="255"></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_email">Email:</label><div class="col-sm-10"><input type="email" class="form-control" name="respDeProyectos_email" id="respDeProyectos_email" placeholder="Email" ng-model="respDeProyecto.email" required ng-maxlength="255"></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_telefono">Tel\xE9fono:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_telefono" id="respDeProyectos_telefono" placeholder="Tel\xE9fono" ng-model="respDeProyecto.telefono" required ng-maxlength="255"></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyecto_telefono2">Tel\xE9fono 2:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_telefono2" id="respDeProyectos_telefono2" placeholder="Tel\xE9fono 2" ng-model="respDeProyecto.telefono2" ng-maxlength="255"></div></div></div></fieldset><p class="text-center"><button type="button" class="btn btn-default" ng-click="active = $parent.$parent.active = 2"><span class="glyphicon glyphicon-chevron-left"></span>&nbsp;<span>Anterior</span></button></p></uib-tab></uib-tabset><p class="text-center"><button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span>Regresar a buscador de proyectos</span></button></p></div>');
$templateCache.put('app/home/buscador-proyectos.html','<div><div class="page-header"><h2>Buscador de Proyectos</h2></div><jhi-alert></jhi-alert><div class="container-fluid project-filters"><form name="vm.searchForm"><fieldset class="row"><div class="col-md-12"><div class="form-group col-md-4"><label>Periodo:</label><select required name="periodo" class="dropdown form-control" ng-model="vm.selectedPeriodo" ng-options="option as ((option.iniPeriodo|date:\'d MMM yyyy\') + \' - \' + (option.finPeriodo|date:\'d MMM yyyy\')) for option in vm.periodos track by option.id" ng-change="vm.search()"></select></div><div class="form-group col-md-4"><label>Centro Docente:</label><select required name="centroDocente" class="dropdown form-control" ng-model="vm.selectedCentroDocente" ng-options="option as option.nombre + \' - \' + option.abreviatura for option in vm.centrosDocentes track by option.id" ng-change="vm.search()"></select></div><div class="form-group col-md-4"><label>Programa Educativo:</label><select required name="programaEducativo" class="dropdown form-control" ng-model="vm.selectedProgramaEducativo" ng-options="option as option.nombre + \' \' + option.tizimin for option in vm.programasEducativos track by option.id" ng-change="vm.search()"></select></div><div class="form-group col-md-12"><input type="text" ng-model="vm.searchValue" class="form-control" placeholder="Buscar por nombre"></div></div></fieldset></form></div><br><div class="table-responsive table-projects" ng-show="vm.sSProyectos.length > 0"><div class="alert alert-info" role="alert"><p>Resultados: {{vm.sSProyectos.length}}</p></div><table class="jh-table table table-striped table-hover"><thead><tr><th><span>ID</span></th><th class="col-md-4"><span>Nombre</span></th><th class="col-md-3"><span>Unidad Receptora</span></th><th><span>Ambito</span></th><th><span>Estatus</span></th><th><span>Fin Vigencia</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSProyecto in vm.sSProyectos | filter: {nombre:vm.searchValue} track by sSProyecto.id" ng-click="vm.proyectoAccion(sSProyecto.id, true, $event)"><td><a ng-click="vm.proyectoDetalleAsignacion(sSProyecto.id, false, $event)">{{sSProyecto.id}}</a></td><td>{{sSProyecto.nombre}}</td><td>{{sSProyecto.unidadesReceptoras[0].institucion}}</td><td>{{sSProyecto.ambito}}</td><td>{{sSProyecto.estatus}}</td><td>{{sSProyecto.finVigencia | date:\'MMM d, y\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.proyectoDetalleSolicitud(sSProyecto.id, false, $event)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down">Ver solicitud</span></button></div></td></tr></tbody></table></div><div class="alert alert-info" role="alert" ng-hide="vm.sSProyectos.length > 0">No se encontraron resultados.</div></div>');
$templateCache.put('app/home/home.html','<div class="navless-container" ng-cloak><div class="row"><div class="col-md-7 homeMsg"><h1>Programa Institucional de Servicio Social</h1><p class="lead">Direcci\xF3n General de Desarrollo Acad\xE9mico</p><img class="imghome" src="content/images/serviciosocial/logo-proiss.png"></div><div class="col-md-5"><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">Has iniciado sesi&oacuten como usuario "{{vm.account.login}}".</div><div class="login-section" ng-switch-when="false"><uib-tabset active="activeJustified" justified="true"><uib-tab index="0" heading="Acceso a solicitantes"><div class="login-box"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>\xA1No se ha podido iniciar sesi&oacuten!</strong> Por favor comprueba tus credenciales y vuelve a intentarlo.</div><form class="form" role="form" ng-submit="vm.loginExterno($event)"><div class="form-group"><label for="usernameExterno">Usuario</label><input type="text" class="form-control" id="usernameExterno" placeholder="{{\'Nombre de usuario\'}}" ng-model="vm.usernameExterno"></div><div class="form-group"><label for="passwordExterno">Contrase&ntildea</label><input type="password" class="form-control" id="passwordExterno" placeholder="{{\'Contrase\xF1a\'}}" ng-model="vm.passwordExterno"></div><button type="submit" class="btn btn-primary">Iniciar Sesi\xF3n</button></form><div class="spaced"><a class="alert-link" href="" ng-click="vm.requestResetPassword()">\xBFOlvidaste tu contrase\xF1a?</a></div></div></uib-tab><uib-tab index="1" heading="Acceso a administrativos"><div class="login-box"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>\xA1No se ha podido iniciar sesi&oacuten!</strong> Por favor comprueba tus credenciales y vuelve a intentarlo.</div><form class="form" role="form" ng-submit="vm.loginSicei($event)"><div class="form-group"><label for="usernameSicei">Usuario</label><input type="text" class="form-control" id="usernameSicei" placeholder="{{\'Nombre de usuario\'}}" ng-model="vm.usernameSicei"></div><div class="form-group"><label for="passwordSicei">Contrase&ntildea</label><input type="password" class="form-control" id="passwordSicei" placeholder="{{\'Contrase\xF1a\'}}" ng-model="vm.passwordSicei"></div><button type="submit" class="btn btn-primary">Iniciar Sesi\xF3n</button></form></div></uib-tab></uib-tabset><div class="new-session-links"><a href="" ng-click="vm.register()">Suscr\xEDbete para registrar proyectos</a></div></div></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="vm.success"><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Contrase&ntildea para [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>\xA1Contrase&ntildea Cambiada!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>\xA1Ha ocurrido un error!</strong> La contrase&ntildea no puede ser cambiada.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">La contrase&ntildea y su confirmaci&oacuten no coinciden!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">Nueva contrase&ntildea</label><input type="password" class="form-control" id="password" name="password" placeholder="Nueva contrase\xF1a" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Su contrase&ntildea es requerida.</p><p class="help-block" ng-show="form.password.$error.minlength">Su contrase&ntildea debe tener al menos 4 caracteres.</p><p class="help-block" ng-show="form.password.$error.maxlength">Su contrase&ntildea no puede tener m&aacutes de 50 caracteres.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">Confirmaci\xF3n de nueva contrase&ntildea</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirma la nueva contrase\xF1a" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Su confirmaci&oacuten de contrase&ntildea es requerida.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Su confirmaci&oacuten de contrase&ntildea debe tener al menos 4 caracteres.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Su confirmaci&oacuten de contrase&ntildea no puede tener m&aacutes de 50 caracteres.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Guardar</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Crear cuenta de solicitante</h1><div class="alert alert-success" ng-show="vm.success"><strong>\xA1Cuenta Creada!</strong> Por favor checa tu email para confirmaci\xF3n.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Registro Fallo!</strong> Por favor intentalo nuevamente.</div><div class="alert alert-danger" ng-show="vm.errorUserExists"><strong>Usuario ya existe!</strong> Por favor, selecciona otro.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists"><strong>E-mail ya esta en uso!</strong> Por favor, selecciona otro.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">La contrase&ntildea y su confirmaci&oacuten no coinciden!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login">Usuario</label><input type="text" class="form-control" id="login" name="login" placeholder="Su usuario" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required">El nombre del usuario es requerido.</p><p class="help-block" ng-show="form.login.$error.minlength">El nombre del usuario debe tener al menos 1 caracter.</p><p class="help-block" ng-show="form.login.$error.maxlength">El nombre del usuario no puede tener m&aacutes de 50 caracteres.</p><p class="help-block" ng-show="form.login.$error.pattern">Su nombre de usuario s&oacutelo puede contener letras min&uacutesculas y d&iacutegitos.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Su email" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Su email es requerido.</p><p class="help-block" ng-show="form.email.$error.email">Su email es inv&aacutelido.</p><p class="help-block" ng-show="form.email.$error.minlength">Su e-mail debe tener al menos 5 caracteres.</p><p class="help-block" ng-show="form.email.$error.maxlength">Su e-mail no puede tener m\xE1s de 100 caracteres.</p></div></div><div class="form-group"><label class="control-label" for="password">Nueva Contrase&ntildea</label><input type="password" class="form-control" id="password" name="password" placeholder="Nueva contrase\xF1a" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Su contrase&ntildea es requerida.</p><p class="help-block" ng-show="form.password.$error.minlength">Su contrase&ntildea debe tener al menos 4 caracteres.</p><p class="help-block" ng-show="form.password.$error.maxlength">Su contrase&ntildea no puede tener m&aacutes de 50 caracteres.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">Confirmar Nueva Contrase&ntildea</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirma la nueva contrase\xF1a" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Su confirmaci&oacuten de contrase&ntildea es requerida.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Su confirmaci&oacuten de contrase&ntildea debe tener al menos 4 caracteres.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Su confirmaci&oacuten de contrase&ntildea no puede tener m&aacutes de 50 caracteres.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Crear</button></form><p></p></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2>Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>IP Address</th><th>User agent</th><th>Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Ajustes para el usuario [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Ajustes Salvados!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName">Nombres</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Su nombre" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Tu primer nombre es requerido.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Su primer nombre debe tener por lo menos 1 car&aacutecter.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Su primer nombre no puede tener m&aacutes de 50 caracteres.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Apellidos</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="Sus apellidos" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Su primer nombre es requerido.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Su primer nombre debe tener por lo menos 1 car&aacutecter.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Su primer nombre debe tener por lo menos 1 car&aacutecter.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Su e-mail" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Su email es requerido.</p><p class="help-block" ng-show="form.email.$error.email">Su email es inv&aacutelido.</p><p class="help-block" ng-show="form.email.$error.minlength">Su e-mail debe tener al menos 5 caracteres.</p><p class="help-block" ng-show="form.email.$error.maxlength">Su e-mail no puede tener m\xE1s de 100 caracteres.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Guardar</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2>Audits</h2><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2>Configuration</h2><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2>Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2>Logs</h2><p>There are {{ vm.loggers.length }} loggers.</p><span>Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2>Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span>User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span>Usuario</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated">Desactivado</span> <span class="label label-success" ng-show="vm.user.activated">Acivado</span></dd><dt><span>Correo</span></dt><dd>{{vm.user.email}}</dd><dt><span>Creado por</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span>Fecha de creaci\xF3n</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span>\xDAltima modificaci\xF3n por</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span>Fecha de \xFAltima modificaci\xF3n</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span>Perfiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ng-if="vm.isAdmin" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="submit" ng-if="!vm.isAdmin" ui-sref="ss-user" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Usuario</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">Correo</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span>Activado</span></label></div><div class="form-group"><label>Perfiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2>Usuarios</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new" ng-if="vm.isAdmin"><span class="glyphicon glyphicon-flash"></span> <span>Create a new User</span></button></div></div><div class="container-fluid projects-filters"><fieldset class="row"><div class="col-md-12"><div class="form-group col-md-8"><input class="form-control" type="text" ng-model="vm.searchText" class="form-control" placeholder="Buscar por nombre o correo electr&oacute;nico"></div><div class="form-group col-sm-2"><button class="btn btn-primary" ng-click="vm.loadAll()"><span data-translate="entity.action.search">Buscar</span></button></div></div></fieldset></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span>Usuario</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Correo</span> <span class="glyphicon glyphicon-sort"></span></th><th>Estado</th><th><span>Perfiles</span></th><th jh-sort-by="createdDate"><span>Fecha de Creaci\xF3n</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>\xDAltima modificaci\xF3n</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated">Desactivado</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login==user.login">Activado</button></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-if="vm.isAdmin" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ng-if="vm.isAdmin" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ng-if="vm.isAdmin" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ng-if="!vm.isAdmin" ui-sref="ss-user-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ng-if="!vm.isAdmin" ui-sref="ss-user.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Iniciar sesi\xF3n</h4></div><div class="modal-body"><div class="row"><div class="login-section col-md-8 col-md-offset-2"><uib-tabset active="activeJustified" justified="true"><uib-tab index="0" heading="Acceso a solicitantes"><div class="login-box"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>\xA1No se ha podido iniciar sesi&oacuten!</strong> Por favor comprueba tus credenciales y vuelve a intentarlo.</div><form class="form" role="form" ng-submit="vm.loginExterno($event)"><div class="form-group"><label for="usernameExterno">Usuario</label><input type="text" class="form-control" id="usernameExterno" placeholder="{{\'Nombre de usuario\'}}" ng-model="vm.usernameExterno"></div><div class="form-group"><label for="passwordExterno">Contrase&ntildea</label><input type="password" class="form-control" id="passwordExterno" placeholder="{{\'Contrase\xF1a\'}}" ng-model="vm.passwordExterno"></div><button type="submit" class="btn btn-primary">Iniciar Sesi\xF3n</button></form><div class="spaced"><a class="alert-link" href="" ng-click="vm.requestResetPassword()">\xBFOlvidaste tu contrase\xF1a?</a></div></div></uib-tab><uib-tab index="1" heading="Acceso a administrativos"><div class="login-box"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>\xA1No se ha podido iniciar sesi&oacuten!</strong> Por favor comprueba tus credenciales y vuelve a intentarlo.</div><form class="form" role="form" ng-submit="vm.loginSicei($event)"><div class="form-group"><label for="usernameSicei">Usuario</label><input type="text" class="form-control" id="usernameSicei" placeholder="{{\'Nombre de usuario\'}}" ng-model="vm.usernameSicei"></div><div class="form-group"><label for="passwordSicei">Contrase&ntildea</label><input type="password" class="form-control" id="passwordSicei" placeholder="{{\'Contrase\xF1a\'}}" ng-model="vm.passwordSicei"></div><button type="submit" class="btn btn-primary">Iniciar Sesi\xF3n</button></form></div></uib-tab></uib-tabset></div></div></div><div class="modal-footer"><div class="new-session-links"><a href="" ng-click="vm.register()">Suscr\xEDbete para registrar proyectos</a></div></div>');
$templateCache.put('app/entities/alumno-uady-matriculado/alumno-uady-matriculado-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.alumnoUadyMatriculado.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Alumno Uady Matriculado?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/alumno-uady-matriculado/alumno-uady-matriculado-detail.html','<div><h2><span>Alumno Uady Matriculado</span> {{vm.alumnoUadyMatriculado.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="alumno-uady-matriculado-detail.edit({id:vm.alumnoUadyMatriculado.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/alumno-uady-matriculado/alumno-uady-matriculado-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAlumnoUadyMatriculadoLabel">Create or edit a Alumno Uady Matriculado</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.alumnoUadyMatriculado.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.alumnoUadyMatriculado.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/alumno-uady-matriculado/alumno-uady-matriculados.html','<div><h2>Alumno Uady Matriculados</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="alumno-uady-matriculado.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Alumno Uady Matriculado</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th></th></tr></thead><tbody><tr ng-repeat="alumnoUadyMatriculado in vm.alumnoUadyMatriculados track by alumnoUadyMatriculado.id"><td><a ui-sref="alumno-uady-matriculado-detail({id:alumnoUadyMatriculado.id})">{{alumnoUadyMatriculado.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="alumno-uady-matriculado-detail({id:alumnoUadyMatriculado.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="alumno-uady-matriculado.edit({id:alumnoUadyMatriculado.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="alumno-uady-matriculado.delete({id:alumnoUadyMatriculado.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/campus/campus-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.campus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Campus?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/campus/campus-detail.html','<div><h2><span>Campus</span> {{vm.campus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="campus-detail.edit({id:vm.campus.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/campus/campus-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCampusLabel">Create or edit a Campus</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.campus.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.campus.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/campus/campuses.html','<div><h2>Campuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="campus.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Campus</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th></th></tr></thead><tbody><tr ng-repeat="campus in vm.campuses track by campus.id"><td><a ui-sref="campus-detail({id:campus.id})">{{campus.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="campus-detail({id:campus.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="campus.edit({id:campus.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="campus.delete({id:campus.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/centro-docente/centro-docente-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.centroDocente.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Centro Docente?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/centro-docente/centro-docente-detail.html','<div><h2><span>Centro Docente</span> {{vm.centroDocente.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="centro-docente-detail.edit({id:vm.centroDocente.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/centro-docente/centro-docente-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCentroDocenteLabel">Create or edit a Centro Docente</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.centroDocente.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.centroDocente.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/centro-docente/centro-docentes.html','<div><h2>Centro Docentes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="centro-docente.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Centro Docente</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th></th></tr></thead><tbody><tr ng-repeat="centroDocente in vm.centroDocentes track by centroDocente.id"><td><a ui-sref="centro-docente-detail({id:centroDocente.id})">{{centroDocente.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="centro-docente-detail({id:centroDocente.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="centro-docente.edit({id:centroDocente.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="centro-docente.delete({id:centroDocente.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/institucion/institucion-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.institucion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Institucion?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/institucion/institucion-detail.html','<div><h2><span>Institucion</span> {{vm.institucion.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="institucion-detail.edit({id:vm.institucion.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/institucion/institucion-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInstitucionLabel">Create or edit a Institucion</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.institucion.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.institucion.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/institucion/institucions.html','<div><h2>Institucions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="institucion.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Institucion</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th></th></tr></thead><tbody><tr ng-repeat="institucion in vm.institucions track by institucion.id"><td><a ui-sref="institucion-detail({id:institucion.id})">{{institucion.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="institucion-detail({id:institucion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="institucion.edit({id:institucion.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="institucion.delete({id:institucion.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/persona/persona-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.persona.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Persona?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/persona/persona-detail.html','<div><h2><span>Persona</span> {{vm.persona.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="persona-detail.edit({id:vm.persona.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/persona/persona-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPersonaLabel">Create or edit a Persona</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.persona.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.persona.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/persona/personas.html','<div><h2>Personas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="persona.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Persona</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th></th></tr></thead><tbody><tr ng-repeat="persona in vm.personas track by persona.id"><td><a ui-sref="persona-detail({id:persona.id})">{{persona.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="persona-detail({id:persona.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="persona.edit({id:persona.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="persona.delete({id:persona.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/plan-de-estudios/plan-de-estudios-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.planDeEstudios.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Plan De Estudios?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/plan-de-estudios/plan-de-estudios-detail.html','<div><h2><span>Plan De Estudios</span> {{vm.planDeEstudios.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="plan-de-estudios-detail.edit({id:vm.planDeEstudios.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/plan-de-estudios/plan-de-estudios-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPlanDeEstudiosLabel">Create or edit a Plan De Estudios</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.planDeEstudios.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.planDeEstudios.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/plan-de-estudios/plan-de-estudios.html','<div><h2>Plan De Estudios</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="plan-de-estudios.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Plan De Estudios</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th></th></tr></thead><tbody><tr ng-repeat="planDeEstudios in vm.planDeEstudios track by planDeEstudios.id"><td><a ui-sref="plan-de-estudios-detail({id:planDeEstudios.id})">{{planDeEstudios.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="plan-de-estudios-detail({id:planDeEstudios.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="plan-de-estudios.edit({id:planDeEstudios.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="plan-de-estudios.delete({id:planDeEstudios.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/programa-educativo/programa-educativo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.programaEducativo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Programa Educativo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/programa-educativo/programa-educativo-detail.html','<div><h2><span>Programa Educativo</span> {{vm.programaEducativo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="programa-educativo-detail.edit({id:vm.programaEducativo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/programa-educativo/programa-educativo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProgramaEducativoLabel">Create or edit a Programa Educativo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.programaEducativo.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.programaEducativo.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/programa-educativo/programa-educativos.html','<div><h2>Programa Educativos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="programa-educativo.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Programa Educativo</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th></th></tr></thead><tbody><tr ng-repeat="programaEducativo in vm.programaEducativos track by programaEducativo.id"><td><a ui-sref="programa-educativo-detail({id:programaEducativo.id})">{{programaEducativo.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="programa-educativo-detail({id:programaEducativo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="programa-educativo.edit({id:programaEducativo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="programa-educativo.delete({id:programaEducativo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-actividad/s-s-actividads.html','<div><h2>SS Actividads</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-actividad.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Actividad</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Nombre</span></th><th><span>Descripcion</span></th><th><span>Alta Reg</span></th><th><span>Baja Reg</span></th><th><span>Ult Act Reg</span></th><th><span>Activo</span></th><th><span>Usuario Ult Act</span></th><th><span>Perfil</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSActividad in vm.sSActividads track by sSActividad.id"><td><a ui-sref="ss-actividad-detail({id:sSActividad.id})">{{sSActividad.id}}</a></td><td>{{sSActividad.nombre}}</td><td>{{sSActividad.descripcion}}</td><td>{{sSActividad.altaReg | date:\'medium\'}}</td><td>{{sSActividad.bajaReg | date:\'medium\'}}</td><td>{{sSActividad.ultActReg | date:\'medium\'}}</td><td>{{sSActividad.activo}}</td><td>{{sSActividad.usuarioUltAct}}</td><td><a ui-sref="ss-perfil-detail({id:sSActividad.perfil.id})">{{sSActividad.perfil.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-actividad-detail({id:sSActividad.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-actividad.edit({id:sSActividad.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-actividad.delete({id:sSActividad.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-actividad/ss-actividad-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSActividad.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Actividad?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-actividad/ss-actividad-detail.html','<div><h2><span>SS Actividad</span> {{vm.sSActividad.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nombre</span></dt><dd><span>{{vm.sSActividad.nombre}}</span></dd><dt><span>Descripcion</span></dt><dd><span>{{vm.sSActividad.descripcion}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSActividad.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSActividad.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSActividad.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSActividad.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSActividad.usuarioUltAct}}</span></dd><dt><span>Perfil</span></dt><dd><a ui-sref="ss-perfil-detail({id:vm.sSActividad.perfil.id})">{{vm.sSActividad.perfil.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-actividad-detail.edit({id:vm.sSActividad.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-actividad/ss-actividad-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSActividadLabel">Create or edit a SS Actividad</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSActividad.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSActividad.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.sSActividad.nombre" required ng-maxlength="50"><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.nombre.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_descripcion">Descripcion</label><input type="text" class="form-control" name="descripcion" id="field_descripcion" ng-model="vm.sSActividad.descripcion" ng-maxlength="200"><div ng-show="editForm.descripcion.$invalid"><p class="help-block" ng-show="editForm.descripcion.$error.maxlength">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_altaReg">Alta Reg</label><div class="input-group"><input id="field_altaReg" type="text" class="form-control" name="altaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSActividad.altaReg" is-open="vm.datePickerOpenStatus.altaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'altaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_bajaReg">Baja Reg</label><div class="input-group"><input id="field_bajaReg" type="text" class="form-control" name="bajaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSActividad.bajaReg" is-open="vm.datePickerOpenStatus.bajaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'bajaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_ultActReg">Ult Act Reg</label><div class="input-group"><input id="field_ultActReg" type="text" class="form-control" name="ultActReg" datetime-picker="{{dateformat}}" ng-model="vm.sSActividad.ultActReg" is-open="vm.datePickerOpenStatus.ultActReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'ultActReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_activo">Activo</label><input type="checkbox" name="activo" id="field_activo" ng-model="vm.sSActividad.activo"></div><div class="form-group"><label class="control-label" for="field_usuarioUltAct">Usuario Ult Act</label><input type="text" class="form-control" name="usuarioUltAct" id="field_usuarioUltAct" ng-model="vm.sSActividad.usuarioUltAct"></div><div class="form-group"><label for="field_perfil">Perfil</label><select class="form-control" id="field_perfil" name="perfil" ng-model="vm.sSActividad.perfil" ng-options="sSPerfil as sSPerfil.id for sSPerfil in vm.ssperfils track by sSPerfil.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-anio/s-s-anios.html','<div><h2>SS Anios</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-anio.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Anio</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Anio</span></th><th><span>Alta Reg</span></th><th><span>Baja Reg</span></th><th><span>Ult Act Reg</span></th><th><span>Activo</span></th><th><span>Usuario Ult Act</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSAnio in vm.sSAnios track by sSAnio.id"><td><a ui-sref="ss-anio-detail({id:sSAnio.id})">{{sSAnio.id}}</a></td><td>{{sSAnio.anio}}</td><td>{{sSAnio.altaReg | date:\'medium\'}}</td><td>{{sSAnio.bajaReg | date:\'medium\'}}</td><td>{{sSAnio.ultActReg | date:\'medium\'}}</td><td>{{sSAnio.activo}}</td><td>{{sSAnio.usuarioUltAct}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-anio-detail({id:sSAnio.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-anio.edit({id:sSAnio.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-anio.delete({id:sSAnio.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-anio/ss-anio-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSAnio.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Anio?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-anio/ss-anio-detail.html','<div><h2><span>SS Anio</span> {{vm.sSAnio.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Anio</span></dt><dd><span>{{vm.sSAnio.anio}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSAnio.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSAnio.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSAnio.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSAnio.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSAnio.usuarioUltAct}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-anio-detail.edit({id:vm.sSAnio.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-anio/ss-anio-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSAnioLabel">Create or edit a SS Anio</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSAnio.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSAnio.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_anio">Anio</label><input type="number" class="form-control" name="anio" id="field_anio" ng-model="vm.sSAnio.anio" required><div ng-show="editForm.anio.$invalid"><p class="help-block" ng-show="editForm.anio.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.anio.$error.number">This field should be a number.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-area/s-s-areas.html','<div><h2>SS Areas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-area.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Area</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Nombre</span></th><th><span>Descripcion</span></th><th><span>Alta Reg</span></th><th><span>Baja Reg</span></th><th><span>Ult Act Reg</span></th><th><span>Activo</span></th><th><span>Usuario Ult Act</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSArea in vm.sSAreas track by sSArea.id"><td><a ui-sref="ss-area-detail({id:sSArea.id})">{{sSArea.id}}</a></td><td>{{sSArea.nombre}}</td><td>{{sSArea.descripcion}}</td><td>{{sSArea.altaReg | date:\'medium\'}}</td><td>{{sSArea.bajaReg | date:\'medium\'}}</td><td>{{sSArea.ultActReg | date:\'medium\'}}</td><td>{{sSArea.activo}}</td><td>{{sSArea.usuarioUltAct}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-area-detail({id:sSArea.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-area.edit({id:sSArea.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-area.delete({id:sSArea.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-area/ss-area-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSArea.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Area?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-area/ss-area-detail.html','<div><h2><span>SS Area</span> {{vm.sSArea.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nombre</span></dt><dd><span>{{vm.sSArea.nombre}}</span></dd><dt><span>Descripcion</span></dt><dd><span>{{vm.sSArea.descripcion}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSArea.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSArea.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSArea.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSArea.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSArea.usuarioUltAct}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-area-detail.edit({id:vm.sSArea.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-area/ss-area-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSAreaLabel">Create or edit a SS Area</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSArea.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSArea.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.sSArea.nombre" required ng-maxlength="50"><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.nombre.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_descripcion">Descripcion</label><input type="text" class="form-control" name="descripcion" id="field_descripcion" ng-model="vm.sSArea.descripcion" ng-maxlength="200"><div ng-show="editForm.descripcion.$invalid"><p class="help-block" ng-show="editForm.descripcion.$error.maxlength">This field cannot be longer than 200 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-asignacion/s-s-asignacions.html','<div><h2>SS Asignacions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-asignacion.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Asignacion</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="iniPrestacion"><span>Ini Prestacion</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="finPrestacion"><span>Fin Prestacion</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="duracionHoras"><span>Duracion Horas</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="estatusPrestador"><span>Estatus Prestador</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="altaReg"><span>Alta Reg</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bajaReg"><span>Baja Reg</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ultActReg"><span>Ult Act Reg</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="activo"><span>Activo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="usuarioUltAct"><span>Usuario Ult Act</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="expediente"><span>Expediente</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fechaLiberacion"><span>Fecha Liberacion</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="periodo.id"><span>Periodo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="unidadReceptora.id"><span>Unidad Receptora</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="respDePrestador.id"><span>Resp De Prestador</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="prestador.id"><span>Prestador</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="perfil.id"><span>Perfil</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="sSAsignacion in vm.sSAsignacions track by sSAsignacion.id"><td><a ui-sref="ss-asignacion-detail({id:sSAsignacion.id})">{{sSAsignacion.id}}</a></td><td>{{sSAsignacion.iniPrestacion | date:\'medium\'}}</td><td>{{sSAsignacion.finPrestacion | date:\'medium\'}}</td><td>{{sSAsignacion.duracionHoras}}</td><td>{{sSAsignacion.estatusPrestador}}</td><td>{{sSAsignacion.altaReg | date:\'medium\'}}</td><td>{{sSAsignacion.bajaReg | date:\'medium\'}}</td><td>{{sSAsignacion.ultActReg | date:\'medium\'}}</td><td>{{sSAsignacion.activo}}</td><td>{{sSAsignacion.usuarioUltAct}}</td><td>{{sSAsignacion.expediente}}</td><td>{{sSAsignacion.fechaLiberacion | date:\'medium\'}}</td><td><a ui-sref="ss-periodo-detail({id:sSAsignacion.periodo.id})">{{sSAsignacion.periodo.id}}</a></td><td><a ui-sref="ss-unidad-receptora-detail({id:sSAsignacion.unidadReceptora.id})">{{sSAsignacion.unidadReceptora.id}}</a></td><td><a ui-sref="ss-persona-detail({id:sSAsignacion.respDePrestador.id})">{{sSAsignacion.respDePrestador.id}}</a></td><td><a ui-sref="alumno-uady-matriculado-detail({id:sSAsignacion.prestador.id})">{{sSAsignacion.prestador.id}}</a></td><td><a ui-sref="ss-perfil-detail({id:sSAsignacion.perfil.id})">{{sSAsignacion.perfil.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-asignacion-detail({id:sSAsignacion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-asignacion.edit({id:sSAsignacion.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-asignacion.delete({id:sSAsignacion.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/s-s-asignacion/ss-asignacion-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSAsignacion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Asignacion?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-asignacion/ss-asignacion-detail.html','<div><h2><span>SS Asignacion</span> {{vm.sSAsignacion.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Ini Prestacion</span></dt><dd><span>{{vm.sSAsignacion.iniPrestacion | date:\'medium\'}}</span></dd><dt><span>Fin Prestacion</span></dt><dd><span>{{vm.sSAsignacion.finPrestacion | date:\'medium\'}}</span></dd><dt><span>Duracion Horas</span></dt><dd><span>{{vm.sSAsignacion.duracionHoras}}</span></dd><dt><span>Estatus Prestador</span></dt><dd><span>{{vm.sSAsignacion.estatusPrestador}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSAsignacion.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSAsignacion.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSAsignacion.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSAsignacion.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSAsignacion.usuarioUltAct}}</span></dd><dt><span>Expediente</span></dt><dd><span>{{vm.sSAsignacion.expediente}}</span></dd><dt><span>Fecha Liberacion</span></dt><dd><span>{{vm.sSAsignacion.fechaLiberacion | date:\'medium\'}}</span></dd><dt><span>Periodo</span></dt><dd><a ui-sref="ss-periodo-detail({id:vm.sSAsignacion.periodo.id})">{{vm.sSAsignacion.periodo.id}}</a></dd><dt><span>Unidad Receptora</span></dt><dd><a ui-sref="ss-unidad-receptora-detail({id:vm.sSAsignacion.unidadReceptora.id})">{{vm.sSAsignacion.unidadReceptora.id}}</a></dd><dt><span>Resp De Prestador</span></dt><dd><a ui-sref="ss-persona-detail({id:vm.sSAsignacion.respDePrestador.id})">{{vm.sSAsignacion.respDePrestador.id}}</a></dd><dt><span>Prestador</span></dt><dd><a ui-sref="alumno-uady-matriculado-detail({id:vm.sSAsignacion.prestador.id})">{{vm.sSAsignacion.prestador.id}}</a></dd><dt><span>Perfil</span></dt><dd><a ui-sref="ss-perfil-detail({id:vm.sSAsignacion.perfil.id})">{{vm.sSAsignacion.perfil.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-asignacion-detail.edit({id:vm.sSAsignacion.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-asignacion/ss-asignacion-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSAsignacionLabel">Create or edit a SS Asignacion</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSAsignacion.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSAsignacion.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_iniPrestacion">Ini Prestacion</label><div class="input-group"><input id="field_iniPrestacion" type="text" class="form-control" name="iniPrestacion" datetime-picker="{{dateformat}}" ng-model="vm.sSAsignacion.iniPrestacion" is-open="vm.datePickerOpenStatus.iniPrestacion" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'iniPrestacion\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.iniPrestacion.$invalid"><p class="help-block" ng-show="editForm.iniPrestacion.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.iniPrestacion.$error.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" for="field_finPrestacion">Fin Prestacion</label><div class="input-group"><input id="field_finPrestacion" type="text" class="form-control" name="finPrestacion" datetime-picker="{{dateformat}}" ng-model="vm.sSAsignacion.finPrestacion" is-open="vm.datePickerOpenStatus.finPrestacion"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'finPrestacion\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_duracionHoras">Duracion Horas</label><input type="number" class="form-control" name="duracionHoras" id="field_duracionHoras" ng-model="vm.sSAsignacion.duracionHoras"></div><div class="form-group"><label class="control-label" for="field_estatusPrestador">Estatus Prestador</label><select class="form-control" name="estatusPrestador" ng-model="vm.sSAsignacion.estatusPrestador" id="field_estatusPrestador"><option value="ASIGNADO">ASIGNADO</option><option value="LIBERADO">LIBERADO</option><option value="BAJA">BAJA</option></select></div><div class="form-group"><label class="control-label" for="field_altaReg">Alta Reg</label><div class="input-group"><input id="field_altaReg" type="text" class="form-control" name="altaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSAsignacion.altaReg" is-open="vm.datePickerOpenStatus.altaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'altaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_bajaReg">Baja Reg</label><div class="input-group"><input id="field_bajaReg" type="text" class="form-control" name="bajaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSAsignacion.bajaReg" is-open="vm.datePickerOpenStatus.bajaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'bajaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_ultActReg">Ult Act Reg</label><div class="input-group"><input id="field_ultActReg" type="text" class="form-control" name="ultActReg" datetime-picker="{{dateformat}}" ng-model="vm.sSAsignacion.ultActReg" is-open="vm.datePickerOpenStatus.ultActReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'ultActReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_activo">Activo</label><input type="checkbox" name="activo" id="field_activo" ng-model="vm.sSAsignacion.activo"></div><div class="form-group"><label class="control-label" for="field_usuarioUltAct">Usuario Ult Act</label><input type="text" class="form-control" name="usuarioUltAct" id="field_usuarioUltAct" ng-model="vm.sSAsignacion.usuarioUltAct"></div><div class="form-group"><label class="control-label" for="field_expediente">Expediente</label><input type="text" class="form-control" name="expediente" id="field_expediente" ng-model="vm.sSAsignacion.expediente"></div><div class="form-group"><label class="control-label" for="field_fechaLiberacion">Fecha Liberacion</label><div class="input-group"><input id="field_fechaLiberacion" type="text" class="form-control" name="fechaLiberacion" datetime-picker="{{dateformat}}" ng-model="vm.sSAsignacion.fechaLiberacion" is-open="vm.datePickerOpenStatus.fechaLiberacion"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaLiberacion\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="field_periodo">Periodo</label><select class="form-control" id="field_periodo" name="periodo" ng-model="vm.sSAsignacion.periodo" ng-options="sSPeriodo as sSPeriodo.id for sSPeriodo in vm.ssperiodos track by sSPeriodo.id"><option value=""></option></select></div><div class="form-group"><label for="field_unidadReceptora">Unidad Receptora</label><select class="form-control" id="field_unidadReceptora" name="unidadReceptora" ng-model="vm.sSAsignacion.unidadReceptora" ng-options="sSUnidadReceptora as sSUnidadReceptora.id for sSUnidadReceptora in vm.ssunidadreceptoras track by sSUnidadReceptora.id"><option value=""></option></select></div><div class="form-group"><label for="field_respDePrestador">Resp De Prestador</label><select class="form-control" id="field_respDePrestador" name="respDePrestador" ng-model="vm.sSAsignacion.respDePrestador" ng-options="sSPersona as sSPersona.id for sSPersona in vm.sspersonas track by sSPersona.id"><option value=""></option></select></div><div class="form-group"><label for="field_prestador">Prestador</label><select class="form-control" id="field_prestador" name="prestador" ng-model="vm.sSAsignacion.prestador" ng-options="alumnoUadyMatriculado as alumnoUadyMatriculado.id for alumnoUadyMatriculado in vm.alumnouadymatriculados track by alumnoUadyMatriculado.id"><option value=""></option></select></div><div class="form-group"><label for="field_perfil">Perfil</label><select class="form-control" id="field_perfil" name="perfil" ng-model="vm.sSAsignacion.perfil" ng-options="sSPerfil as sSPerfil.id for sSPerfil in vm.ssperfils track by sSPerfil.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-baja/s-s-bajas.html','<div><h2>SS Bajas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-baja.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Baja</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Fecha Baja</span></th><th><span>Tipo Baja</span></th><th><span>Motivo</span></th><th><span>Alta Reg</span></th><th><span>Baja Reg</span></th><th><span>Ult Act Reg</span></th><th><span>Activo</span></th><th><span>Usuario Ult Act</span></th><th><span>Asignacion</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSBaja in vm.sSBajas track by sSBaja.id"><td><a ui-sref="ss-baja-detail({id:sSBaja.id})">{{sSBaja.id}}</a></td><td>{{sSBaja.fechaBaja | date:\'medium\'}}</td><td>{{sSBaja.tipoBaja}}</td><td>{{sSBaja.motivo}}</td><td>{{sSBaja.altaReg | date:\'medium\'}}</td><td>{{sSBaja.bajaReg | date:\'medium\'}}</td><td>{{sSBaja.ultActReg | date:\'medium\'}}</td><td>{{sSBaja.activo}}</td><td>{{sSBaja.usuarioUltAct}}</td><td><a ui-sref="ss-asignacion-detail({id:sSBaja.asignacion.id})">{{sSBaja.asignacion.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-baja-detail({id:sSBaja.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-baja.edit({id:sSBaja.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-baja.delete({id:sSBaja.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-baja/ss-baja-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSBaja.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Baja?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-baja/ss-baja-detail.html','<div><h2><span>SS Baja</span> {{vm.sSBaja.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Fecha Baja</span></dt><dd><span>{{vm.sSBaja.fechaBaja | date:\'medium\'}}</span></dd><dt><span>Tipo Baja</span></dt><dd><span>{{vm.sSBaja.tipoBaja}}</span></dd><dt><span>Motivo</span></dt><dd><span>{{vm.sSBaja.motivo}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSBaja.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSBaja.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSBaja.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSBaja.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSBaja.usuarioUltAct}}</span></dd><dt><span>Asignacion</span></dt><dd><a ui-sref="ss-asignacion-detail({id:vm.sSBaja.asignacion.id})">{{vm.sSBaja.asignacion.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-baja-detail.edit({id:vm.sSBaja.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-baja/ss-baja-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSBajaLabel">Create or edit a SS Baja</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSBaja.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSBaja.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_fechaBaja">Fecha Baja</label><div class="input-group"><input id="field_fechaBaja" type="text" class="form-control" name="fechaBaja" datetime-picker="{{dateformat}}" ng-model="vm.sSBaja.fechaBaja" is-open="vm.datePickerOpenStatus.fechaBaja"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaBaja\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_tipoBaja">Tipo Baja</label><select class="form-control" name="tipoBaja" ng-model="vm.sSBaja.tipoBaja" id="field_tipoBaja" required><option value="VOLUNTARIA">VOLUNTARIA</option><option value="POR_DIRECTOR" data-translate="serviciosocialApp.TipoBaja.POR_DIRECTOR">POR_DIRECTOR</option><option value="POR_ADMON_CENTRAL" data-translate="serviciosocialApp.TipoBaja.POR_ADMON_CENTRAL">POR_ADMON_CENTRAL</option></select><div ng-show="editForm.tipoBaja.$invalid"><p class="help-block" ng-show="editForm.tipoBaja.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_motivo">Motivo</label><input type="text" class="form-control" name="motivo" id="field_motivo" ng-model="vm.sSBaja.motivo" required><div ng-show="editForm.motivo.$invalid"><p class="help-block" ng-show="editForm.motivo.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_altaReg">Alta Reg</label><div class="input-group"><input id="field_altaReg" type="text" class="form-control" name="altaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSBaja.altaReg" is-open="vm.datePickerOpenStatus.altaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'altaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_bajaReg">Baja Reg</label><div class="input-group"><input id="field_bajaReg" type="text" class="form-control" name="bajaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSBaja.bajaReg" is-open="vm.datePickerOpenStatus.bajaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'bajaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_ultActReg">Ult Act Reg</label><div class="input-group"><input id="field_ultActReg" type="text" class="form-control" name="ultActReg" datetime-picker="{{dateformat}}" ng-model="vm.sSBaja.ultActReg" is-open="vm.datePickerOpenStatus.ultActReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'ultActReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_activo">Activo</label><input type="checkbox" name="activo" id="field_activo" ng-model="vm.sSBaja.activo"></div><div class="form-group"><label class="control-label" for="field_usuarioUltAct">Usuario Ult Act</label><input type="text" class="form-control" name="usuarioUltAct" id="field_usuarioUltAct" ng-model="vm.sSBaja.usuarioUltAct"></div><div class="form-group"><label for="field_asignacion">Asignacion</label><select class="form-control" id="field_asignacion" name="asignacion" ng-model="vm.sSBaja.asignacion" ng-options="sSAsignacion as sSAsignacion.id for sSAsignacion in vm.asignacions | orderBy:\'id\' track by sSAsignacion.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-funcion/s-s-funcions.html','<div><h2>SS Funcions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-funcion.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Funcion</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Nombre</span></th><th><span>Descripcion</span></th><th><span>Alta Reg</span></th><th><span>Baja Reg</span></th><th><span>Ult Act Reg</span></th><th><span>Activo</span></th><th><span>Usuario Ult Act</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSFuncion in vm.sSFuncions track by sSFuncion.id"><td><a ui-sref="ss-funcion-detail({id:sSFuncion.id})">{{sSFuncion.id}}</a></td><td>{{sSFuncion.nombre}}</td><td>{{sSFuncion.descripcion}}</td><td>{{sSFuncion.altaReg | date:\'medium\'}}</td><td>{{sSFuncion.bajaReg | date:\'medium\'}}</td><td>{{sSFuncion.ultActReg | date:\'medium\'}}</td><td>{{sSFuncion.activo}}</td><td>{{sSFuncion.usuarioUltAct}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-funcion-detail({id:sSFuncion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-funcion.edit({id:sSFuncion.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-funcion.delete({id:sSFuncion.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-funcion/ss-funcion-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSFuncion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Funcion?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-funcion/ss-funcion-detail.html','<div><h2><span>SS Funcion</span> {{vm.sSFuncion.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nombre</span></dt><dd><span>{{vm.sSFuncion.nombre}}</span></dd><dt><span>Descripcion</span></dt><dd><span>{{vm.sSFuncion.descripcion}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSFuncion.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSFuncion.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSFuncion.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSFuncion.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSFuncion.usuarioUltAct}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-funcion-detail.edit({id:vm.sSFuncion.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-funcion/ss-funcion-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSFuncionLabel">Create or edit a SS Funcion</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSFuncion.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSFuncion.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.sSFuncion.nombre" required ng-maxlength="50"><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.nombre.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_descripcion">Descripcion</label><input type="text" class="form-control" name="descripcion" id="field_descripcion" ng-model="vm.sSFuncion.descripcion" ng-maxlength="200"><div ng-show="editForm.descripcion.$invalid"><p class="help-block" ng-show="editForm.descripcion.$error.maxlength">This field cannot be longer than 200 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-funcionario/s-s-funcionarios.html','<div><h2>SS Funcionarios</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-funcionario.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Funcionario</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Puesto</span></th><th><span>Ini Funciones</span></th><th><span>Fin Funciones</span></th><th><span>Alta Reg</span></th><th><span>Baja Reg</span></th><th><span>Ult Act Reg</span></th><th><span>Activo</span></th><th><span>Usuario Ult Act</span></th><th><span>Persona</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSFuncionario in vm.sSFuncionarios track by sSFuncionario.id"><td><a ui-sref="ss-funcionario-detail({id:sSFuncionario.id})">{{sSFuncionario.id}}</a></td><td>{{sSFuncionario.puesto}}</td><td>{{sSFuncionario.iniFunciones | date:\'medium\'}}</td><td>{{sSFuncionario.finFunciones | date:\'medium\'}}</td><td>{{sSFuncionario.altaReg | date:\'medium\'}}</td><td>{{sSFuncionario.bajaReg | date:\'medium\'}}</td><td>{{sSFuncionario.ultActReg | date:\'medium\'}}</td><td>{{sSFuncionario.activo}}</td><td>{{sSFuncionario.usuarioUltAct}}</td><td><a ui-sref="ss-persona-detail({id:sSFuncionario.persona.id})">{{sSFuncionario.persona.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-funcionario-detail({id:sSFuncionario.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-funcionario.edit({id:sSFuncionario.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-funcionario.delete({id:sSFuncionario.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-funcionario/ss-funcionario-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSFuncionario.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Funcionario?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-funcionario/ss-funcionario-detail.html','<div><h2><span>SS Funcionario</span> {{vm.sSFuncionario.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Puesto</span></dt><dd><span>{{vm.sSFuncionario.puesto}}</span></dd><dt><span>Ini Funciones</span></dt><dd><span>{{vm.sSFuncionario.iniFunciones | date:\'medium\'}}</span></dd><dt><span>Fin Funciones</span></dt><dd><span>{{vm.sSFuncionario.finFunciones | date:\'medium\'}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSFuncionario.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSFuncionario.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSFuncionario.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSFuncionario.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSFuncionario.usuarioUltAct}}</span></dd><dt><span>Persona</span></dt><dd><a ui-sref="ss-persona-detail({id:vm.sSFuncionario.persona.id})">{{vm.sSFuncionario.persona.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-funcionario-detail.edit({id:vm.sSFuncionario.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-funcionario/ss-funcionario-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSFuncionarioLabel">Create or edit a SS Funcionario</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSFuncionario.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSFuncionario.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_puesto">Puesto</label><select class="form-control" name="puesto" ng-model="vm.sSFuncionario.puesto" id="field_puesto" required><option value="RESPONSABLE_SS" data-translate="serviciosocialApp.SSPuesto.RESPONSABLE_SS">RESPONSABLE_SS</option><option value="TITULAR_SAIE" data-translate="serviciosocialApp.SSPuesto.TITULAR_SAIE">TITULAR_SAIE</option><option value="DGDA" data-translate="serviciosocialApp.SSPuesto.DGDA">DGDA</option><option value="COORDINADOR_CGSL" data-translate="serviciosocialApp.SSPuesto.COORDINADOR_CGSL">COORDINADOR_CGSL</option></select><div ng-show="editForm.puesto.$invalid"><p class="help-block" ng-show="editForm.puesto.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_iniFunciones">Ini Funciones</label><div class="input-group"><input id="field_iniFunciones" type="text" class="form-control" name="iniFunciones" datetime-picker="{{dateformat}}" ng-model="vm.sSFuncionario.iniFunciones" is-open="vm.datePickerOpenStatus.iniFunciones"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'iniFunciones\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_finFunciones">Fin Funciones</label><div class="input-group"><input id="field_finFunciones" type="text" class="form-control" name="finFunciones" datetime-picker="{{dateformat}}" ng-model="vm.sSFuncionario.finFunciones" is-open="vm.datePickerOpenStatus.finFunciones"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'finFunciones\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="persona_nombres">Nombres:</label><input required type="text" class="form-control" name="persona_nombres" id="persona_nombres" placeholder="Nombres" ng-model="vm.sSFuncionario.persona.nombres"></div><div class="form-group"><label class="control-label" for="persona_primerApellido">Primer apellido:</label><input required type="text" class="form-control" name="persona_primerApellido" id="persona_primerApellido" placeholder="Primer apellido" ng-model="vm.sSFuncionario.persona.primerApellido"></div><div class="form-group"><label class="control-label" for="persona_segundoApellido">Segundo apellido:</label><input type="text" class="form-control" name="persona_segundoApellido" id="persona_segundoApellido" placeholder="Segundo apellido" ng-model="vm.sSFuncionario.persona.segundoApellido"></div><div class="form-group"><label class="control-label" for="persona_sexo">Sexo:</label><select required class="form-control" id="persona_sexo" name="persona_sexo" ng-model="vm.sSFuncionario.persona.sexo" ng-options="option for option in vm.sexos track by option"></select></div><div class="form-group"><label class="control-label" for="persona_titulo">T\xEDtulo:</label><input required type="text" class="form-control" name="persona_titulo" id="persona_titulo" placeholder="T\xEDtulo" ng-model="vm.sSFuncionario.persona.titulo"></div><div class="form-group"><label class="control-label" for="respDeProyectos_{{$index}}_email">Email:</label><input required type="email" class="form-control" name="persona_email" id="persona_email" placeholder="Email" ng-model="vm.sSFuncionario.persona.email"><div ng-show="editForm.persona_email.$invalid"><p class="help-block" ng-show="editForm.persona_email.$error.email">The e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" for="persona_telefono">Tel\xE9fono:</label><input required type="text" class="form-control" name="persona_telefono" id="persona_telefono" placeholder="Tel\xE9fono" ng-model="vm.sSFuncionario.persona.telefono"></div><div class="form-group"><label class="control-label" for="persona_telefono2">Tel\xE9fono 2:</label><input type="text" class="form-control" name="persona_telefono2" id="persona_telefono2" placeholder="Tel\xE9fono 2" ng-model="vm.sSFuncionario.persona.telefono2"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-modalidad/s-s-modalidads.html','<div><h2>SS Modalidads</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-modalidad.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Modalidad</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Nombre</span></th><th><span>Descripcion</span></th><th><span>Alta Reg</span></th><th><span>Baja Reg</span></th><th><span>Ult Act Reg</span></th><th><span>Activo</span></th><th><span>Usuario Ult Act</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSModalidad in vm.sSModalidads track by sSModalidad.id"><td><a ui-sref="ss-modalidad-detail({id:sSModalidad.id})">{{sSModalidad.id}}</a></td><td>{{sSModalidad.nombre}}</td><td>{{sSModalidad.descripcion}}</td><td>{{sSModalidad.altaReg | date:\'medium\'}}</td><td>{{sSModalidad.bajaReg | date:\'medium\'}}</td><td>{{sSModalidad.ultActReg | date:\'medium\'}}</td><td>{{sSModalidad.activo}}</td><td>{{sSModalidad.usuarioUltAct}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-modalidad-detail({id:sSModalidad.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-modalidad.edit({id:sSModalidad.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-modalidad.delete({id:sSModalidad.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-modalidad/ss-modalidad-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSModalidad.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Modalidad?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-modalidad/ss-modalidad-detail.html','<div><h2><span>SS Modalidad</span> {{vm.sSModalidad.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nombre</span></dt><dd><span>{{vm.sSModalidad.nombre}}</span></dd><dt><span>Descripcion</span></dt><dd><span>{{vm.sSModalidad.descripcion}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSModalidad.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSModalidad.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSModalidad.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSModalidad.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSModalidad.usuarioUltAct}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-modalidad-detail.edit({id:vm.sSModalidad.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-modalidad/ss-modalidad-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSModalidadLabel">Create or edit a SS Modalidad</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSModalidad.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSModalidad.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.sSModalidad.nombre" required ng-maxlength="50"><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.nombre.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_descripcion">Descripcion</label><input type="text" class="form-control" name="descripcion" id="field_descripcion" ng-model="vm.sSModalidad.descripcion" ng-maxlength="200"><div ng-show="editForm.descripcion.$invalid"><p class="help-block" ng-show="editForm.descripcion.$error.maxlength">This field cannot be longer than 200 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-movimiento-estatus-proyecto/s-s-movimiento-estatus-proyectos.html','<div><h2>SS Movimiento Estatus Proyectos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-movimiento-estatus-proyecto.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Movimiento Estatus Proyecto</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Fecha Movimiento</span></th><th><span>Estatus Movimiento</span></th><th><span>Observaciones</span></th><th><span>Alta Reg</span></th><th><span>Baja Reg</span></th><th><span>Ult Act Reg</span></th><th><span>Activo</span></th><th><span>Usuario Ult Act</span></th><th><span>Proyecto</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSMovimientoEstatusProyecto in vm.sSMovimientoEstatusProyectos track by sSMovimientoEstatusProyecto.id"><td><a ui-sref="ss-movimiento-estatus-proyecto-detail({id:sSMovimientoEstatusProyecto.id})">{{sSMovimientoEstatusProyecto.id}}</a></td><td>{{sSMovimientoEstatusProyecto.fechaMovimiento | date:\'medium\'}}</td><td>{{sSMovimientoEstatusProyecto.estatusMovimiento}}</td><td>{{sSMovimientoEstatusProyecto.observaciones}}</td><td>{{sSMovimientoEstatusProyecto.altaReg | date:\'medium\'}}</td><td>{{sSMovimientoEstatusProyecto.bajaReg | date:\'medium\'}}</td><td>{{sSMovimientoEstatusProyecto.ultActReg | date:\'medium\'}}</td><td>{{sSMovimientoEstatusProyecto.activo}}</td><td>{{sSMovimientoEstatusProyecto.usuarioUltAct}}</td><td><a ui-sref="ss-proyecto-detail({id:sSMovimientoEstatusProyecto.proyecto.id})">{{sSMovimientoEstatusProyecto.proyecto.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-movimiento-estatus-proyecto-detail({id:sSMovimientoEstatusProyecto.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-movimiento-estatus-proyecto.edit({id:sSMovimientoEstatusProyecto.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-movimiento-estatus-proyecto.delete({id:sSMovimientoEstatusProyecto.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-movimiento-estatus-proyecto/ss-movimiento-estatus-proyecto-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSMovimientoEstatusProyecto.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Movimiento Estatus Proyecto?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-movimiento-estatus-proyecto/ss-movimiento-estatus-proyecto-detail.html','<div><h2><span>SS Movimiento Estatus Proyecto</span> {{vm.sSMovimientoEstatusProyecto.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Fecha Movimiento</span></dt><dd><span>{{vm.sSMovimientoEstatusProyecto.fechaMovimiento | date:\'medium\'}}</span></dd><dt><span>Estatus Movimiento</span></dt><dd><span>{{vm.sSMovimientoEstatusProyecto.estatusMovimiento}}</span></dd><dt><span>Observaciones</span></dt><dd><span>{{vm.sSMovimientoEstatusProyecto.observaciones}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSMovimientoEstatusProyecto.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSMovimientoEstatusProyecto.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSMovimientoEstatusProyecto.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSMovimientoEstatusProyecto.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSMovimientoEstatusProyecto.usuarioUltAct}}</span></dd><dt><span>Proyecto</span></dt><dd><a ui-sref="ss-proyecto-detail({id:vm.sSMovimientoEstatusProyecto.proyecto.id})">{{vm.sSMovimientoEstatusProyecto.proyecto.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-movimiento-estatus-proyecto-detail.edit({id:vm.sSMovimientoEstatusProyecto.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-movimiento-estatus-proyecto/ss-movimiento-estatus-proyecto-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSMovimientoEstatusProyectoLabel">Create or edit a SS Movimiento Estatus Proyecto</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSMovimientoEstatusProyecto.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSMovimientoEstatusProyecto.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_fechaMovimiento">Fecha Movimiento</label><div class="input-group"><input id="field_fechaMovimiento" type="text" class="form-control" name="fechaMovimiento" datetime-picker="{{dateformat}}" ng-model="vm.sSMovimientoEstatusProyecto.fechaMovimiento" is-open="vm.datePickerOpenStatus.fechaMovimiento" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaMovimiento\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.fechaMovimiento.$invalid"><p class="help-block" ng-show="editForm.fechaMovimiento.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.fechaMovimiento.$error.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" for="field_estatusMovimiento">Estatus Movimiento</label><select class="form-control" name="estatusMovimiento" ng-model="vm.sSMovimientoEstatusProyecto.estatusMovimiento" id="field_estatusMovimiento" required><option value="EDICION">EDICION</option><option value="REGISTRADO">REGISTRADO</option><option value="DICTAMEN">DICTAMEN</option><option value="APROBADO">APROBADO</option><option value="RECHAZADO">RECHAZADO</option><option value="BAJA_TEMPORAL">BAJA_TEMPORAL</option><option value="BAJA_DEFINITIVA">BAJA_DEFINITIVA</option></select><div ng-show="editForm.estatusMovimiento.$invalid"><p class="help-block" ng-show="editForm.estatusMovimiento.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_observaciones">Observaciones</label><input type="text" class="form-control" name="observaciones" id="field_observaciones" ng-model="vm.sSMovimientoEstatusProyecto.observaciones"></div><div class="form-group"><label class="control-label" for="field_altaReg">Alta Reg</label><div class="input-group"><input id="field_altaReg" type="text" class="form-control" name="altaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSMovimientoEstatusProyecto.altaReg" is-open="vm.datePickerOpenStatus.altaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'altaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_bajaReg">Baja Reg</label><div class="input-group"><input id="field_bajaReg" type="text" class="form-control" name="bajaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSMovimientoEstatusProyecto.bajaReg" is-open="vm.datePickerOpenStatus.bajaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'bajaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_ultActReg">Ult Act Reg</label><div class="input-group"><input id="field_ultActReg" type="text" class="form-control" name="ultActReg" datetime-picker="{{dateformat}}" ng-model="vm.sSMovimientoEstatusProyecto.ultActReg" is-open="vm.datePickerOpenStatus.ultActReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'ultActReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_activo">Activo</label><input type="checkbox" name="activo" id="field_activo" ng-model="vm.sSMovimientoEstatusProyecto.activo"></div><div class="form-group"><label class="control-label" for="field_usuarioUltAct">Usuario Ult Act</label><input type="text" class="form-control" name="usuarioUltAct" id="field_usuarioUltAct" ng-model="vm.sSMovimientoEstatusProyecto.usuarioUltAct"></div><div class="form-group"><label for="field_proyecto">Proyecto</label><select class="form-control" id="field_proyecto" name="proyecto" ng-model="vm.sSMovimientoEstatusProyecto.proyecto" ng-options="sSProyecto as sSProyecto.id for sSProyecto in vm.ssproyectos track by sSProyecto.id" required></select></div><div ng-show="editForm.proyecto.$invalid"><p class="help-block" ng-show="editForm.proyecto.$error.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-perfil/s-s-perfils.html','<div><h2>SS Perfils</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-perfil.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Perfil</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Solicitados</span></th><th><span>Alta Reg</span></th><th><span>Baja Reg</span></th><th><span>Ult Act Reg</span></th><th><span>Activo</span></th><th><span>Usuario Ult Act</span></th><th><span>Programa Educativo</span></th><th><span>Proyecto</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSPerfil in vm.sSPerfils track by sSPerfil.id"><td><a ui-sref="ss-perfil-detail({id:sSPerfil.id})">{{sSPerfil.id}}</a></td><td>{{sSPerfil.solicitados}}</td><td>{{sSPerfil.altaReg | date:\'medium\'}}</td><td>{{sSPerfil.bajaReg | date:\'medium\'}}</td><td>{{sSPerfil.ultActReg | date:\'medium\'}}</td><td>{{sSPerfil.activo}}</td><td>{{sSPerfil.usuarioUltAct}}</td><td><a ui-sref="programa-educativo-detail({id:sSPerfil.programaEducativo.id})">{{sSPerfil.programaEducativo.id}}</a></td><td><a ui-sref="ss-proyecto-detail({id:sSPerfil.proyecto.id})">{{sSPerfil.proyecto.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-perfil-detail({id:sSPerfil.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-perfil.edit({id:sSPerfil.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-perfil.delete({id:sSPerfil.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-perfil/ss-perfil-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSPerfil.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Perfil?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-perfil/ss-perfil-detail.html','<div><h2><span>SS Perfil</span> {{vm.sSPerfil.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Solicitados</span></dt><dd><span>{{vm.sSPerfil.solicitados}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSPerfil.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSPerfil.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSPerfil.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSPerfil.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSPerfil.usuarioUltAct}}</span></dd><dt><span>Programa Educativo</span></dt><dd><a ui-sref="programa-educativo-detail({id:vm.sSPerfil.programaEducativo.id})">{{vm.sSPerfil.programaEducativo.id}}</a></dd><dt><span>Proyecto</span></dt><dd><a ui-sref="ss-proyecto-detail({id:vm.sSPerfil.proyecto.id})">{{vm.sSPerfil.proyecto.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-perfil-detail.edit({id:vm.sSPerfil.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-perfil/ss-perfil-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSPerfilLabel">Create or edit a SS Perfil</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSPerfil.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSPerfil.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_solicitados">Solicitados</label><input type="number" class="form-control" name="solicitados" id="field_solicitados" ng-model="vm.sSPerfil.solicitados" required><div ng-show="editForm.solicitados.$invalid"><p class="help-block" ng-show="editForm.solicitados.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.solicitados.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_altaReg">Alta Reg</label><div class="input-group"><input id="field_altaReg" type="text" class="form-control" name="altaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSPerfil.altaReg" is-open="vm.datePickerOpenStatus.altaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'altaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_bajaReg">Baja Reg</label><div class="input-group"><input id="field_bajaReg" type="text" class="form-control" name="bajaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSPerfil.bajaReg" is-open="vm.datePickerOpenStatus.bajaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'bajaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_ultActReg">Ult Act Reg</label><div class="input-group"><input id="field_ultActReg" type="text" class="form-control" name="ultActReg" datetime-picker="{{dateformat}}" ng-model="vm.sSPerfil.ultActReg" is-open="vm.datePickerOpenStatus.ultActReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'ultActReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_activo">Activo</label><input type="checkbox" name="activo" id="field_activo" ng-model="vm.sSPerfil.activo"></div><div class="form-group"><label class="control-label" for="field_usuarioUltAct">Usuario Ult Act</label><input type="text" class="form-control" name="usuarioUltAct" id="field_usuarioUltAct" ng-model="vm.sSPerfil.usuarioUltAct"></div><div class="form-group"><label for="field_programaEducativo">Programa Educativo</label><select class="form-control" id="field_programaEducativo" name="programaEducativo" ng-model="vm.sSPerfil.programaEducativo" ng-options="programaEducativo as programaEducativo.id for programaEducativo in vm.programaeducativos track by programaEducativo.id"><option value=""></option></select></div><div class="form-group"><label for="field_proyecto">Proyecto</label><select class="form-control" id="field_proyecto" name="proyecto" ng-model="vm.sSPerfil.proyecto" ng-options="sSProyecto as sSProyecto.id for sSProyecto in vm.ssproyectos track by sSProyecto.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-periodo/s-s-periodos.html','<div><h2>SS Periodos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-periodo.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Periodo</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Ini Periodo</span></th><th><span>Fin Periodo</span></th><th><span>Indice Anual</span></th><th><span>Ini Convocatoria</span></th><th><span>Fin Convocatoria</span></th><th><span>Alta Reg</span></th><th><span>Baja Reg</span></th><th><span>Ult Act Reg</span></th><th><span>Activo</span></th><th><span>Usuario Ult Act</span></th><th><span>Anio</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSPeriodo in vm.sSPeriodos track by sSPeriodo.id"><td><a ui-sref="ss-periodo-detail({id:sSPeriodo.id})">{{sSPeriodo.id}}</a></td><td>{{sSPeriodo.iniPeriodo | date:\'medium\'}}</td><td>{{sSPeriodo.finPeriodo | date:\'medium\'}}</td><td>{{sSPeriodo.indiceAnual}}</td><td>{{sSPeriodo.iniConvocatoria | date:\'medium\'}}</td><td>{{sSPeriodo.finConvocatoria | date:\'medium\'}}</td><td>{{sSPeriodo.altaReg | date:\'medium\'}}</td><td>{{sSPeriodo.bajaReg | date:\'medium\'}}</td><td>{{sSPeriodo.ultActReg | date:\'medium\'}}</td><td>{{sSPeriodo.activo}}</td><td>{{sSPeriodo.usuarioUltAct}}</td><td><a ui-sref="ss-anio-detail({id:sSPeriodo.anio.id})">{{sSPeriodo.anio.anio}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-periodo-detail({id:sSPeriodo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-periodo.edit({id:sSPeriodo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-periodo.delete({id:sSPeriodo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-periodo/ss-periodo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSPeriodo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Periodo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-periodo/ss-periodo-detail.html','<div><h2><span>SS Periodo</span> {{vm.sSPeriodo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Ini Periodo</span></dt><dd><span>{{vm.sSPeriodo.iniPeriodo | date:\'medium\'}}</span></dd><dt><span>Fin Periodo</span></dt><dd><span>{{vm.sSPeriodo.finPeriodo | date:\'medium\'}}</span></dd><dt><span>Indice Anual</span></dt><dd><span>{{vm.sSPeriodo.indiceAnual}}</span></dd><dt><span>Ini Convocatoria</span></dt><dd><span>{{vm.sSPeriodo.iniConvocatoria | date:\'medium\'}}</span></dd><dt><span>Fin Convocatoria</span></dt><dd><span>{{vm.sSPeriodo.finConvocatoria | date:\'medium\'}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSPeriodo.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSPeriodo.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSPeriodo.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSPeriodo.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSPeriodo.usuarioUltAct}}</span></dd><dt><span>Anio</span></dt><dd><a ui-sref="ss-anio-detail({id:vm.sSPeriodo.anio.id})">{{vm.sSPeriodo.anio.anio}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-periodo-detail.edit({id:vm.sSPeriodo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-periodo/ss-periodo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSPeriodoLabel">Create or edit a SS Periodo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSPeriodo.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSPeriodo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_iniPeriodo">Ini Periodo</label><div class="input-group"><input id="field_iniPeriodo" type="text" class="form-control" name="iniPeriodo" datetime-picker="{{dateformat}}" ng-model="vm.sSPeriodo.iniPeriodo" is-open="vm.datePickerOpenStatus.iniPeriodo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'iniPeriodo\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_finPeriodo">Fin Periodo</label><div class="input-group"><input id="field_finPeriodo" type="text" class="form-control" name="finPeriodo" datetime-picker="{{dateformat}}" ng-model="vm.sSPeriodo.finPeriodo" is-open="vm.datePickerOpenStatus.finPeriodo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'finPeriodo\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_indiceAnual">Indice Anual</label><input type="number" class="form-control" name="indiceAnual" id="field_indiceAnual" ng-model="vm.sSPeriodo.indiceAnual" required><div ng-show="editForm.indiceAnual.$invalid"><p class="help-block" ng-show="editForm.indiceAnual.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.indiceAnual.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_iniConvocatoria">Ini Convocatoria</label><div class="input-group"><input id="field_iniConvocatoria" type="text" class="form-control" name="iniConvocatoria" datetime-picker="{{dateformat}}" ng-model="vm.sSPeriodo.iniConvocatoria" is-open="vm.datePickerOpenStatus.iniConvocatoria"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'iniConvocatoria\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_finConvocatoria">Fin Convocatoria</label><div class="input-group"><input id="field_finConvocatoria" type="text" class="form-control" name="finConvocatoria" datetime-picker="{{dateformat}}" ng-model="vm.sSPeriodo.finConvocatoria" is-open="vm.datePickerOpenStatus.finConvocatoria"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'finConvocatoria\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="field_anio">Anio</label><select class="form-control" id="field_anio" name="anio" ng-model="vm.sSPeriodo.anio" ng-options="sSAnio as sSAnio.anio for sSAnio in vm.ssanios track by sSAnio.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-persona/s-s-personas.html','<div><h2>SS Personas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-persona.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Persona</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Nombres</span></th><th><span>Primer Apellido</span></th><th><span>Segundo Apellido</span></th><th><span>Sexo</span></th><th><span>Titulo</span></th><th><span>Telefono</span></th><th><span>Telefono 2</span></th><th><span>Email</span></th><th><span>Alta Reg</span></th><th><span>Baja Reg</span></th><th><span>Ult Act Reg</span></th><th><span>Activo</span></th><th><span>Usuario Ult Act</span></th><th><span>Proyecto A Cargo</span></th><th><span>Proyecto</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSPersona in vm.sSPersonas track by sSPersona.id"><td><a ui-sref="ss-persona-detail({id:sSPersona.id})">{{sSPersona.id}}</a></td><td>{{sSPersona.nombres}}</td><td>{{sSPersona.primerApellido}}</td><td>{{sSPersona.segundoApellido}}</td><td>{{sSPersona.sexo}}</td><td>{{sSPersona.titulo}}</td><td>{{sSPersona.telefono}}</td><td>{{sSPersona.telefono2}}</td><td>{{sSPersona.email}}</td><td>{{sSPersona.altaReg | date:\'medium\'}}</td><td>{{sSPersona.bajaReg | date:\'medium\'}}</td><td>{{sSPersona.ultActReg | date:\'medium\'}}</td><td>{{sSPersona.activo}}</td><td>{{sSPersona.usuarioUltAct}}</td><td><a ui-sref="ss-proyecto-detail({id:sSPersona.proyectoACargo.id})">{{sSPersona.proyectoACargo.id}}</a></td><td><a ui-sref="ss-proyecto-detail({id:sSPersona.proyecto.id})">{{sSPersona.proyecto.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-persona-detail({id:sSPersona.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-persona.edit({id:sSPersona.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-persona.delete({id:sSPersona.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-persona/ss-persona-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSPersona.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Persona?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-persona/ss-persona-detail.html','<div><h2><span>SS Persona</span> {{vm.sSPersona.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nombres</span></dt><dd><span>{{vm.sSPersona.nombres}}</span></dd><dt><span>Primer Apellido</span></dt><dd><span>{{vm.sSPersona.primerApellido}}</span></dd><dt><span>Segundo Apellido</span></dt><dd><span>{{vm.sSPersona.segundoApellido}}</span></dd><dt><span>Sexo</span></dt><dd><span>{{vm.sSPersona.sexo}}</span></dd><dt><span>Titulo</span></dt><dd><span>{{vm.sSPersona.titulo}}</span></dd><dt><span>Telefono</span></dt><dd><span>{{vm.sSPersona.telefono}}</span></dd><dt><span>Telefono 2</span></dt><dd><span>{{vm.sSPersona.telefono2}}</span></dd><dt><span>Email</span></dt><dd><span>{{vm.sSPersona.email}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSPersona.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSPersona.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSPersona.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSPersona.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSPersona.usuarioUltAct}}</span></dd><dt><span>Proyecto A Cargo</span></dt><dd><a ui-sref="ss-proyecto-detail({id:vm.sSPersona.proyectoACargo.id})">{{vm.sSPersona.proyectoACargo.id}}</a></dd><dt><span>Proyecto</span></dt><dd><a ui-sref="ss-proyecto-detail({id:vm.sSPersona.proyecto.id})">{{vm.sSPersona.proyecto.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-persona-detail.edit({id:vm.sSPersona.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-persona/ss-persona-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSPersonaLabel">Create or edit a SS Persona</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSPersona.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSPersona.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_nombres">Nombres</label><input type="text" class="form-control" name="nombres" id="field_nombres" ng-model="vm.sSPersona.nombres" required ng-maxlength="60"><div ng-show="editForm.nombres.$invalid"><p class="help-block" ng-show="editForm.nombres.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.nombres.$error.maxlength">This field cannot be longer than 60 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_primerApellido">Primer Apellido</label><input type="text" class="form-control" name="primerApellido" id="field_primerApellido" ng-model="vm.sSPersona.primerApellido" required ng-maxlength="40"><div ng-show="editForm.primerApellido.$invalid"><p class="help-block" ng-show="editForm.primerApellido.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.primerApellido.$error.maxlength">This field cannot be longer than 40 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_segundoApellido">Segundo Apellido</label><input type="text" class="form-control" name="segundoApellido" id="field_segundoApellido" ng-model="vm.sSPersona.segundoApellido" ng-maxlength="40"><div ng-show="editForm.segundoApellido.$invalid"><p class="help-block" ng-show="editForm.segundoApellido.$error.maxlength">This field cannot be longer than 40 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_sexo">Sexo</label><select class="form-control" name="sexo" ng-model="vm.sSPersona.sexo" id="field_sexo"><option value="MASCULINO">MASCULINO</option><option value="FEMENINO">FEMENINO</option></select></div><div class="form-group"><label class="control-label" for="field_titulo">Titulo</label><input type="text" class="form-control" name="titulo" id="field_titulo" ng-model="vm.sSPersona.titulo"></div><div class="form-group"><label class="control-label" for="field_telefono">Telefono</label><input type="text" class="form-control" name="telefono" id="field_telefono" ng-model="vm.sSPersona.telefono"></div><div class="form-group"><label class="control-label" for="field_telefono2">Telefono 2</label><input type="text" class="form-control" name="telefono2" id="field_telefono2" ng-model="vm.sSPersona.telefono2"></div><div class="form-group"><label class="control-label" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.sSPersona.email"></div><div class="form-group"><label class="control-label" for="field_altaReg">Alta Reg</label><div class="input-group"><input id="field_altaReg" type="text" class="form-control" name="altaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSPersona.altaReg" is-open="vm.datePickerOpenStatus.altaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'altaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_bajaReg">Baja Reg</label><div class="input-group"><input id="field_bajaReg" type="text" class="form-control" name="bajaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSPersona.bajaReg" is-open="vm.datePickerOpenStatus.bajaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'bajaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_ultActReg">Ult Act Reg</label><div class="input-group"><input id="field_ultActReg" type="text" class="form-control" name="ultActReg" datetime-picker="{{dateformat}}" ng-model="vm.sSPersona.ultActReg" is-open="vm.datePickerOpenStatus.ultActReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'ultActReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_activo">Activo</label><input type="checkbox" name="activo" id="field_activo" ng-model="vm.sSPersona.activo"></div><div class="form-group"><label class="control-label" for="field_usuarioUltAct">Usuario Ult Act</label><input type="text" class="form-control" name="usuarioUltAct" id="field_usuarioUltAct" ng-model="vm.sSPersona.usuarioUltAct"></div><div class="form-group"><label for="field_proyectoACargo">Proyecto A Cargo</label><select class="form-control" id="field_proyectoACargo" name="proyectoACargo" ng-model="vm.sSPersona.proyectoACargo" ng-options="sSProyecto as sSProyecto.id for sSProyecto in vm.ssproyectos track by sSProyecto.id"><option value=""></option></select></div><div class="form-group"><label for="field_proyecto">Proyecto</label><select class="form-control" id="field_proyecto" name="proyecto" ng-model="vm.sSPersona.proyecto" ng-options="sSProyecto as sSProyecto.id for sSProyecto in vm.ssproyectos track by sSProyecto.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-asignar-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSAsignacionLabel">Asignar Alumno</h4></div><div class="modal-body"><dl class="dl-horizontal jh-entity-details"><dt><span>Perfil</span></dt><dd><span>{{vm.sSAsignacionDTO.perfil.programaEducativo.nombre}}</span></dd><dt ng-hide="vm.sSAsignacionDTO.asignacion.unidadReceptora.institucion == null || vm.sSAsignacionDTO.asignacion.unidadReceptora.institucion == \'\'"><span>Institucion</span></dt><dd ng-hide="vm.sSAsignacionDTO.asignacion.unidadReceptora.institucion == null || vm.sSAsignacionDTO.asignacion.unidadReceptora.institucion == \'\'"><span>{{vm.sSAsignacionDTO.asignacion.unidadReceptora.institucion}}</span></dd><dt ng-hide="vm.sSAsignacionDTO.asignacion.unidadReceptora.unidadReceptora == null || vm.sSAsignacionDTO.asignacion.unidadReceptora.unidadReceptora == \'\'"><span>Unidad Receptora</span></dt><dd ng-hide="vm.sSAsignacionDTO.asignacion.unidadReceptora.unidadReceptora == null || vm.sSAsignacionDTO.asignacion.unidadReceptora.unidadReceptora == \'\'"><span>{{vm.sSAsignacionDTO.asignacion.unidadReceptora.unidadReceptora}}</span></dd><dt><span>Alumno</span></dt><dd><div class="container-fluid"><div class="row"><div class="form-group col-md-9"><input type="text" class="form-control" placeholder="Buscar por matr\xEDcula o nombre" ng-model="vm.searchValue" name="searchValue" id="field_searchValue"></div><div class="col-md-3"><button type="button" class="btn btn-default" ng-click="vm.searchStudent()" ng-disabled="vm.searchValue == \'\' || vm.searchValue == null">Buscar</button></div></div><div class="list-alumnos"><h5 ng-hide="vm.alumnoUadyMatriculados == null">Resultados encontrados: {{vm.alumnoUadyMatriculados.length}}</h5><table class="table" ng-hide="vm.alumnoUadyMatriculados.length < 1"><tr ng-repeat="alumno in vm.alumnoUadyMatriculados"><td><input ng-required="vm.sSAsignacionDTO.asignacion.prestador" type="radio" name="prestador" id="field_prestador" ng-model="vm.sSAsignacionDTO.asignacion.prestador" ng-value="alumno"></td><td>{{alumno.matriculaParteInvariable}}</td><td>{{alumno.persona.nombres}} {{alumno.persona.apellidoPaterno}} {{alumno.persona.apellidoMaterno}}</td></tr></table></div></div></dd><dt><span>Inicio de prestaci\xF3n</span></dt><dd><div class="container-fluid"><div class="row"><div class="form-group col-md-9"><div class="input-group"><input required id="field_iniPrestacion" type="text" class="form-control" name="iniPrestacion" datetime-picker="{{dateformat}}" enable-time="false" ng-model="vm.sSAsignacionDTO.asignacion.iniPrestacion" datepicker-options="vm.iniPrestacionOptions" is-open="vm.datePickerOpenStatus.iniPrestacion" ng-change="vm.validateDates()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'iniPrestacion\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></dd><dt><span>Fin de prestaci\xF3n</span></dt><dd><div class="container-fluid"><div class="row"><div class="form-group col-md-9"><div class="input-group"><input required id="field_finPrestacion" type="text" class="form-control" name="finPrestacion" datetime-picker="{{dateformat}}" enable-time="false" ng-model="vm.sSAsignacionDTO.asignacion.finPrestacion" datepicker-options="vm.finPrestacionOptions" is-open="vm.datePickerOpenStatus.finPrestacion" ng-change="vm.validateDates()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'finPrestacion\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.finPrestacion.$invalid"><p class="help-block" ng-show="editForm.finPrestacion.$error.endBeforeStart">This field is invalid.</p></div></div></div></div></dd><dt><span>Duraci\xF3n en horas</span></dt><dd><div class="container-fluid"><div class="row"><div class="form-group col-md-9"><input type="number" class="form-control" name="duracionHoras" id="field_duracionHoras" ng-model="vm.sSAsignacionDTO.asignacion.duracionHoras" required></div></div></div></dd><dt><span>Expediente</span></dt><dd><div class="container-fluid"><div class="row"><div class="form-group col-md-9"><input type="text" class="form-control" name="expediente" id="field_expediente" ng-model="vm.sSAsignacionDTO.asignacion.expediente" required></div></div></div></dd><dt><span>Responsable</span></dt><dd><div class="container-fluid"><div class="row"><div class="form-group col-md-9"><select required name="respDePrestador" id="field_respDePrestador" class="dropdown form-control" ng-model="vm.sSAsignacionDTO.asignacion.respDePrestador" ng-options="option as (option.nombres + \' \' + option.primerApellido + \' \' + option.segundoApellido) for option in vm.sSAsignacionDTO.perfil.respDePrestadors track by option.id" ng-change="vm.search()"></select></div></div></div></dd></dl></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.sSAsignacionDTO.asignacion.prestador == null || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-baja-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSAsignacionLabel">Dar de Baja Alumno</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-sm-4 control-label">Matr&iacute;cula</label><div class="col-sm-8 control-text">{{vm.sSBaja.asignacion.prestador.matriculaParteInvariable}}</div></div><div class="form-group"><label class="col-sm-4 control-label">Nombre</label><div class="col-sm-8 control-text">{{vm.sSBaja.asignacion.prestador.persona.apellidoPaterno}} {{vm.sSBaja.asignacion.prestador.persona.apellidoMaterno}} {{vm.sSBaja.asignacion.prestador.persona.nombres}}</div></div><div class="form-group"><label class="col-sm-4 control-label" for="field_fechaBaja">Fecha Baja</label><div class="col-sm-8"><div class="input-group"><input id="field_fechaBaja" type="text" class="form-control" name="fechaBaja" datetime-picker="{{dateformat}}" ng-model="vm.sSBaja.fechaBaja" is-open="vm.datePickerOpenStatus.fechaBaja"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaBaja\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-4 control-label" for="field_tipoBaja">Tipo Baja</label><div class="col-sm-8"><select class="col-sm-8 form-control" name="tipoBaja" ng-model="vm.sSBaja.tipoBaja" id="field_tipoBaja" ng-options="option for option in vm.tipoBajas track by option" required></select></div></div><div class="form-group"><label class="col-sm-4 control-label" for="field_motivo">Motivo</label><div class="col-sm-8"><input type="text" class="form-control" name="motivo" id="field_motivo" ng-model="vm.sSBaja.motivo" required></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Regresar</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span>Dar de baja</span></button></div></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-cambiar-fechas-confirmacion-dialog.html','<form name="confirmForm" ng-submit="vm.confirmDateChange(vm.sSAsignacion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmar cambio de fecha</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Este alumno tiene una carta de asignaci\xF3n, \xBFDesea continuar con el cambio de fechas?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="confirmForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-check-circle"></span>&nbsp;<span>Confirmar</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-cambiar-fechas-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSAsignacionLabel">Cambiar fechas de asignaci\xF3n del Alumno</h4></div><div class="modal-body"><dl class="dl-horizontal jh-entity-details"><div class="form-group"><label class="col-sm-4 control-label">Matr&iacute;cula</label><div class="col-sm-8 control-text">{{vm.sSAsignacionDTO.prestador.matriculaParteInvariable}}</div></div><div class="form-group"><label class="col-sm-4 control-label">Nombre</label><div class="col-sm-8 control-text">{{vm.sSAsignacionDTO.prestador.persona.apellidoPaterno}} {{vm.sSAsignacionDTO.prestador.persona.apellidoMaterno}} {{vm.sSAsignacionDTO.prestador.persona.nombres}}</div></div><dt><span>Inicio de prestaci\xF3n</span></dt><dd><div class="container-fluid"><div class="row"><div class="form-group col-md-9"><div class="input-group"><input required id="field_iniPrestacion" type="text" class="form-control" name="iniPrestacion" uib-datepicker-popup="{{format}}" enable-time="false" ng-model="vm.sSAsignacionDTO.iniPrestacion" datepicker-options="vm.iniPrestacionOptions" is-open="vm.datePickerOpenStatus.iniPrestacion" ng-change="vm.validateDates()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'iniPrestacion\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></dd><dt><span>Fin de prestaci\xF3n</span></dt><dd><div class="container-fluid"><div class="row"><div class="form-group col-md-9"><div class="input-group"><input required id="field_finPrestacion" type="text" class="form-control" name="finPrestacion" uib-datepicker-popup="{{format}}" enable-time="false" ng-model="vm.sSAsignacionDTO.finPrestacion" datepicker-options="vm.finPrestacionOptions" is-open="vm.datePickerOpenStatus.finPrestacion" ng-change="vm.validateDates()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'finPrestacion\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.finPrestacion.$invalid"><p class="help-block" ng-show="editForm.finPrestacion.$error.required">Este campo es obligatorio.</p><p class="help-block" ng-show="editForm.finPrestacion.$error.endBeforeStart">El fin del periodo no puede ser menor que el inicio</p></div></div></div></div></dd><dt><span>Fecha de liberaci\xF3n</span></dt><dd><div class="container-fluid"><div class="row"><div class="form-group col-md-9"><div class="input-group"><input id="field_fechaLiberacion" type="text" class="form-control" name="fechaLiberacion" uib-datepicker-popup="{{format}}" enable-time="false" ng-model="vm.sSAsignacionDTO.fechaLiberacion" datepicker-options="vm.fechaLiberacionOptions" is-open="vm.datePickerOpenStatus.fechaLiberacion" ng-change="vm.validateDates()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaLiberacion\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></dd><dt><span>Motivo</span></dt><dd><div class="container-fluid"><div class="row"><div class="form-group col-md-9"><textarea required class="form-control" name="motivo" minlength="100" maxlength="300" rows="6" ng-model="vm.motivo"></textarea><div ng-show="editForm.motivo.$invalid"><p class="help-block" ng-show="editForm.motivo.$error.required">Este campo es obligatorio.</p><p class="help-block" ng-show="editForm.motivo.$error.minlength || editForm.motivo.$error.maxlength">El motivo debe tener entre 100 y 300 caracteres.</p></div></div></div></div></dd></dl></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-cancelar-asignacion-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSAsignacion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xBFEst\xE1 seguro de que desea cancelar esta asignaci\xF3n?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-cancelar-baja-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSAsignacion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Cancelar Baja de Asignaci\xF3n</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xBFEst\xE1 seguro de que desea cancelar esta baja?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Regresar</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Cancelar baja</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-cancelar-liberacion-dialog.html','<form name="deleteForm" ng-submit="vm.confirmCancel(vm.sSAsignacion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmar cancelaci\xF3n de liberaci\xF3n</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xBFEst\xE1 seguro de que desea cancelar esta liberaci\xF3n? Esta operaci\xF3n es irreversible.</p><hr><dl class="dl-horizontal jh-entity-details"><dt><span>Motivo</span></dt><dd><div class="container-fluid"><div class="row"><div class="form-group col-md-9"><textarea required class="form-control" name="motivo" minlength="100" maxlength="300" rows="6" ng-model="vm.motivo"></textarea><div ng-show="deleteForm.motivo.$invalid"><p class="help-block" ng-show="deleteForm.motivo.$error.required">Este campo es obligatorio.</p><p class="help-block" ng-show="deleteForm.motivo.$error.minlength || deleteForm.motivo.$error.maxlength">El motivo debe tener entre 100 y 300 caracteres.</p></div></div></div></div></dd></dl></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Regresar</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Confirmar cancelaci\xF3n</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-certificar-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSAsignacionLabel">Certificar Alumno</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-sm-4 control-label">Matr&iacute;cula</label><div class="col-sm-8 control-text">{{vm.sSAsignacion.prestador.matriculaParteInvariable}}</div></div><div class="form-group"><label class="col-sm-4 control-label">Nombre</label><div class="col-sm-8 control-text">{{vm.sSAsignacion.prestador.persona.apellidoPaterno}} {{vm.sSAsignacion.prestador.persona.apellidoMaterno}} {{vm.sSAsignacion.prestador.persona.nombres}}</div></div><div class="form-group"><label class="col-sm-4 control-label" for="num_recibo">N&uacute;mero de Recibo</label><div class="col-sm-8"><input type="text" class="form-control" name="num_recibo" id="field_recibo" ng-model="vm.numRecibo"></div></div><div class="form-group"><label class="col-sm-4 control-label">Inicio de prestaci\xF3n</label><div class="col-sm-8"><div class="input-group"><input required id="field_iniPrestacion" type="text" class="form-control" name="iniPrestacion" datetime-picker="{{dateformat}}" enable-time="false" ng-model="vm.sSAsignacion.iniPrestacion" is-open="vm.datePickerOpenStatus.iniPrestacion" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'iniPrestacion\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-4 control-label">Fin de prestaci\xF3n</label><div class="col-sm-8"><div class="input-group"><input required id="field_finPrestacion" type="text" class="form-control" name="finPrestacion" datetime-picker="{{dateformat}}" enable-time="false" ng-model="vm.sSAsignacion.finPrestacion" ng-change="vm.validateDates()" is-open="vm.datePickerOpenStatus.finPrestacion"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'finPrestacion\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-editar-estatus-central-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSMovimientoEstatusProyectoLabel">Create or edit a SS Movimiento Estatus Proyecto</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSMovimientoEstatusProyecto.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSMovimientoEstatusProyecto.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_estatusMovimiento">Estatus Movimiento</label><select class="form-control" name="estatusMovimiento" ng-model="vm.sSMovimientoEstatusProyecto.estatusMovimiento" id="field_estatusMovimiento" required><option ng-show="vm.sSEstatusProyecto == \'REGISTRADO\' || vm.sSEstatusProyecto == \'BAJA_TEMPORAL\' || vm.sSEstatusProyecto == \'BAJA_DEFINITIVA\'" value="EDICION">EDICION</option><option ng-show="vm.sSEstatusProyecto == \'REGISTRADO\' || vm.sSEstatusProyecto == \'BAJA_TEMPORAL\' || vm.sSEstatusProyecto == \'BAJA_DEFINITIVA\'" value="DICTAMEN">DICTAMEN</option><option value="BAJA_TEMPORAL">BAJA_TEMPORAL</option><option value="BAJA_DEFINITIVA">BAJA_DEFINITIVA</option></select><div ng-show="editForm.estatusMovimiento.$invalid"><p class="help-block" ng-show="editForm.estatusMovimiento.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_observaciones">Observaciones</label><textarea type="text" class="form-control" name="observaciones" id="field_observaciones" ng-model="vm.sSMovimientoEstatusProyecto.observaciones"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-editar-estatus-comite-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSMovimientoEstatusProyectoLabel">Create or edit a SS Movimiento Estatus Proyecto</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSMovimientoEstatusProyecto.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSMovimientoEstatusProyecto.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_estatusMovimiento">Estatus Movimiento</label><select class="form-control" name="estatusMovimiento" ng-model="vm.sSMovimientoEstatusProyecto.estatusMovimiento" id="field_estatusMovimiento" required><option ng-show="vm.sSEstatusProyecto == \'APROBADO\' || vm.sSEstatusProyecto == \'NO_APROBADO\'" value="DICTAMEN">DICTAMEN</option><option ng-show="vm.sSEstatusProyecto == \'DICTAMEN\' || vm.sSEstatusProyecto == \'APROBADO\' || vm.sSEstatusProyecto == \'NO_APROBADO\'" value="REPLANTEADO">REPLANTEADO</option><option ng-show="vm.sSEstatusProyecto == \'DICTAMEN\'" value="APROBADO">APROBADO</option><option ng-show="vm.sSEstatusProyecto == \'DICTAMEN\'" value="NO_APROBADO">NO APROBADO</option></select><div ng-show="editForm.estatusMovimiento.$invalid"><p class="help-block" ng-show="editForm.estatusMovimiento.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_observaciones">Observaciones</label><textarea type="text" class="form-control" name="observaciones" id="field_observaciones" ng-model="vm.sSMovimientoEstatusProyecto.observaciones"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-editar-vigencia-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSAsignacionLabel">Actualizar Vigencia del Proyecto</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-sm-4 control-label">N\xFAm. de Proyecto</label><div class="col-sm-8 control-text">{{vm.sSProyecto.id}}</div></div><div class="form-group"><label class="col-sm-4 control-label">Nombre</label><div class="col-sm-8 control-text">{{vm.sSProyecto.nombre}}</div></div><div class="form-group"><label class="col-sm-4 control-label">N\xFAm. de semestres que estar\xE1 vigente:</label><div class="col-sm-8 control-text">{{vm.sSProyecto.semestres}}</div></div><div class="form-group"><label class="col-sm-4 control-label">Fecha de inicio de vigencia:</label><div class="col-sm-8 control-text">{{vm.sSProyecto.inicioVigencia | date:\'longDate\'}}</div></div><div class="form-group"><label class="col-sm-4 control-label" for="num_expediente">Fecha de fin de vigencia:</label><div class="col-sm-8"><div class="input-group"><input required id="field_finVigencia" type="text" class="form-control" name="finVigencia" datetime-picker="{{dateformat}}" enable-time="false" ng-model="vm.sSProyecto.finVigencia" is-open="vm.datePickerOpenStatus.finVigencia" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'finVigencia\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span>Save</span></button></div></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-enviar-solicitud-dialog.html','<form name="deleteForm" ng-submit="vm.confirmSend(vm.sSProyecto.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmar env\xEDo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xBFEst\xE1 seguro de que desea enviar la solicitud? Una vez enviada, no podr\xE1 ser modificada.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-info"><span class="glyphicon glyphicon-send"></span>&nbsp;<span>Enviar</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-liberar-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSAsignacionLabel">Liberar Alumno</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-sm-4 control-label">Matr&iacute;cula</label><div class="col-sm-8 control-text">{{vm.sSAsignacion.prestador.matriculaParteInvariable}}</div></div><div class="form-group"><label class="col-sm-4 control-label">Nombre</label><div class="col-sm-8 control-text">{{vm.sSAsignacion.prestador.persona.apellidoPaterno}} {{vm.sSAsignacion.prestador.persona.apellidoMaterno}} {{vm.sSAsignacion.prestador.persona.nombres}}</div></div><div class="form-group"><label class="col-sm-4 control-label" for="num_expediente">N&uacute;mero de Expediente</label><div class="col-sm-8"><input type="text" class="form-control" name="num_expediente" id="field_expediente" ng-model="vm.numExpediente"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-proyecto-comite.html','<div><div class="page-header"><h2>Administrador de Proyectos Comit&eacute</h2></div><jhi-alert></jhi-alert><div class="container-fluid project-filters"><form name="vm.searchForm"><div class="row"><div class="col-md-12"><label class="radio-inline projects-filters-option"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="student" ng-model="vm.searchType" ng-change="vm.search()"> Buscar por alumno</label></div></div><fieldset class="row" ng-disabled="vm.searchType != \'student\'"><div class="col-md-12"><div class="form-group col-md-8"><input class="form-control" type="text" ng-model="vm.alumno" class="form-control" placeholder="Buscar por nombre o matr&iacute;cula"></div><div class="form-group col-sm-2"><button class="btn btn-primary" ng-click="vm.search()" ng-disabled="vm.alumno == null || vm.alumno == \'\'"><span data-translate="entity.action.search">Buscar</span></button></div></div></fieldset><div class="row"><div class="col-md-12"><label class="radio-inline projects-filters-option"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="filters" ng-model="vm.searchType" ng-change="vm.search()"> Buscar por filtros</label></div></div><fieldset class="row" ng-disabled="vm.searchType != \'filters\'"><div class="col-md-12"><div class="form-group col-md-3"><label>Periodo:</label><select required name="periodo" class="dropdown form-control" ng-model="vm.selectedPeriodo" ng-options="option as ((option.iniPeriodo|date:\'d MMM yyyy\') + \' - \' + (option.finPeriodo|date:\'d MMM yyyy\')) for option in vm.periodos track by option.id" ng-change="vm.search()"></select></div><div class="form-group col-md-3"><label>Centro Docente:</label><select required name="centroDocente" class="dropdown form-control" ng-model="vm.selectedCentroDocente" ng-options="option as option.nombre + \' - \' + option.abreviatura for option in vm.centrosDocentes track by option.id" ng-change="vm.search()"></select></div><div class="form-group col-md-3"><label>Programa Educativo:</label><select required name="programaEducativo" class="dropdown form-control" ng-model="vm.selectedProgramaEducativo" ng-options="option as (option.nombre + \' - \' + option.abreviatura) for option in vm.programasEducativos track by option.id" ng-change="vm.search()"></select></div><div class="form-group col-md-3"><label>Estatus:</label><select required name="estatus" class="dropdown form-control" ng-model="vm.selectedEstatusProyecto" ng-options="option for option in vm.estatusProyecto track by option" ng-change="vm.search()"></select></div><div class="form-group col-md-6"><input type="text" ng-model="vm.searchValue" class="form-control" placeholder="Buscar por nombre"></div></div></fieldset></form></div><br><div class="table-responsive table-projects" ng-show="vm.sSProyectos.length > 0"><table class="jh-table table table-striped table-hover"><thead><tr><th><span>ID</span></th><th class="col-md-4"><span>Nombre</span></th><th class="col-md-3"><span>Unidad Receptora</span></th><th><span>Ambito</span></th><th><span>Estatus</span></th><th><span>Inicio Vigencia</span></th><th><span>Fin Vigencia</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSProyecto in vm.sSProyectos | filter: {nombre:vm.searchValue} track by sSProyecto.id" ng-click="vm.proyectoAccion(sSProyecto.id, true, $event)"><td><a ng-click="vm.proyectoDetalleAsignacion(sSProyecto.id, false, $event)">{{sSProyecto.id}}</a></td><td>{{sSProyecto.nombre}}</td><td>{{sSProyecto.unidadesReceptoras[0].institucion}}</td><td>{{sSProyecto.ambito}}</td><td><a ng-click="vm.proyectoSeguimiento(sSProyecto.id, false, $event)">{{sSProyecto.estatus}}</a></td><td>{{sSProyecto.inicioVigencia | date:\'MMM d, y\'}}</td><td>{{sSProyecto.finVigencia | date:\'MMM d, y\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.proyectoDetalleSolicitud(sSProyecto.id, false, $event)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down">Ver solicitud</span></button></div></td></tr></tbody></table></div><div class="alert alert-info" role="alert" ng-hide="vm.sSProyectos.length > 0">No se encontraron resultados.</div></div>');
$templateCache.put('app/entities/s-s-proyecto/ss-proyecto-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSProyecto.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmar eliminado</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xBFEst\xE1 seguro de que desea eliminar el proyecto?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancelar</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Eliminar</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-proyecto-fac-detail.html','<div><button type="submit" ui-sref="ss-proyectos-facultad" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button><h2><span>Proyecto</span> {{vm.sSProyecto.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>ID Proyecto</span></dt><dd><span>{{vm.sSProyecto.proyecto.id}}</span></dd><dt><span>Clave SII</span></dt><!--  poner de ultimo, se va a dejar de usar --><dd><span>{{vm.sSProyecto.proyecto.cveProgramaSII}}</span></dd><dt><span>Nombre</span></dt><dd><span>{{vm.sSProyecto.proyecto.nombre}}</span></dd><dt><span>Ambito</span></dt><dd><span>{{vm.sSProyecto.proyecto.ambito}}</span></dd><dt><span>Estatus</span></dt><dd><span>{{vm.sSProyecto.proyecto.estatus}}</span></dd><dt><span>Aprobado con anterioridad</span></dt><dd><span ng-show="vm.sSProyecto.proyecto.aprobadoanteriormente">S\xED</span> <span ng-hide="vm.sSProyecto.proyecto.aprobadoanteriormente">No</span></dd><dt ng-show="vm.sSProyecto.proyecto.aprobadoanteriormente"><span>Num. del proyecto aprobado anteriormente</span></dt><dd ng-show="vm.sSProyecto.proyecto.aprobadoanteriormente"><span>{{vm.sSProyecto.proyecto.proyectoidanterior}}</span></dd><dt><span>Inicio Vigencia</span></dt><dd><span>{{vm.sSProyecto.proyecto.inicioVigencia | date:\'MMM d, y\'}}</span></dd><dt><span>Fin Vigencia</span></dt><dd><span>{{vm.sSProyecto.proyecto.finVigencia | date:\'MMM d, y\'}}</span></dd></dl><h3><strong>Perfiles solicitados</strong></h3><div class="form-group"><select required name="periodo" class="dropdown form-control" ng-model="vm.selectedPeriodo" ng-options="option as ((option.iniPeriodo|date:\'MMM yyyy\') + \' - \' + (option.finPeriodo|date:\'MMM yyyy\')) for option in vm.periodos track by option.id" ng-change="vm.search()"></select></div><div class="panel-perfil panel-group" id="accordion" role="tablist" aria-multiselectable="true" ng-repeat="perfil in vm.sSProyecto.perfiles | filter : filterPerfiles"><div class="panel panel-default"><div class="panel-heading" role="tab" id="headingOne"><div class="panel-title"><h4>{{ perfil.programaEducativo.nombre }} <span class="label label-danger" ng-show="perfil.bajaReg != null">Desactivado</span> <small>(Solicitados: {{ perfil.solicitados }})</small></h4><button ng-hide="perfil.bajaReg != null" ng-disabled="(perfil.asignacions | filter : filterAsignacionesActivasEnPeriodo).length == perfil.solicitados" class="btn btn-default" ui-sref="ss-asignar({perfil:perfil.id, periodo: vm.selectedPeriodo.id})">Asignar</button></div></div><div id="collapseOne" role="tabpanel"><div class="panel-body"><ul class="list-unstyled list-perfil" ng-show="perfil.asignacions.length > 0"><li class="row" ng-repeat="asignacion in perfil.asignacions | filter : {periodo: vm.selectedPeriodo}: true"><div class="student col-md-7">{{ asignacion.prestador.persona.apellidoPaterno }} {{ asignacion.prestador.persona.apellidoMaterno }} {{ asignacion.prestador.persona.nombres }} <span class="label label-success" ng-show="asignacion.estatusPrestador == \'LIBERADO\'">Liberado</span> <span class="label label-primary" ng-show="asignacion.estatusPrestador == \'ASIGNADO\'">Asignado</span> <span class="label label-danger" ng-show="asignacion.estatusPrestador == \'BAJA\'">Baja</span></div><div class="col-md-5 text-right"><button type="submit" ng-show="asignacion.estatusPrestador == \'ASIGNADO\'" ng-click="vm.cartaAsignacion(asignacion.id, asignacion.prestador.matriculaParteInvariable)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-print"></span> <span class="hidden-sm-down"></span> Imprimir</button> <button type="submit" ng-show="asignacion.estatusPrestador == \'ASIGNADO\'" ui-sref="ss-liberar({asig:asignacion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-ok-circle"></span> <span class="hidden-sm-down"></span> Liberar</button> <button type="submit" ng-show="asignacion.estatusPrestador == \'ASIGNADO\'" ui-sref="ss-dar-baja({asig:asignacion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-ban-circle"></span> <span class="hidden-sm-down"></span> Dar de baja</button> <button type="submit" ng-show="asignacion.estatusPrestador == \'BAJA\'" ui-sref="ss-cancelar-baja({asig:asignacion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span> Cancelar baja</button> <button type="submit" ng-show="asignacion.estatusPrestador == \'LIBERADO\'" ng-click="vm.cartaLiberacion(asignacion.id, asignacion.prestador.matriculaParteInvariable)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-print"></span> <span class="hidden-sm-down"></span> Imprimir</button></div></li></ul><div class="alert alert-info text-center" role="alert" ng-show="(perfil.asignacions | filter : {periodo: vm.selectedPeriodo}: true).length == 0">No hay asignaciones.</div></div></div></div></div><button type="submit" ui-sref="ss-proyectos-facultad" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/s-s-proyecto/ss-proyecto-fac.html','<div><div class="page-header"><h2>Administrador de Proyectos de Facultad</h2></div><jhi-alert></jhi-alert><div class="container-fluid projects-filters"><div class="row"><div class="col-md-12"><label class="radio-inline projects-filters-option"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="student" ng-model="vm.searchType" ng-change="vm.search()"> Buscar por alumno</label></div></div><fieldset class="row" ng-disabled="vm.searchType != \'student\'"><div class="col-md-12"><div class="form-group col-md-8"><input class="form-control" type="text" ng-model="vm.alumno" class="form-control" placeholder="Buscar por nombre o matr&iacute;cula"></div><div class="form-group col-sm-2"><button class="btn btn-primary" ng-click="vm.search()" ng-disabled="vm.alumno == null || vm.alumno == \'\'"><span data-translate="entity.action.search">Buscar</span></button></div></div></fieldset><div class="row"><div class="col-md-12"><label class="radio-inline projects-filters-option"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="filters" ng-model="vm.searchType" ng-change="vm.search()"> Buscar por filtros</label></div></div><fieldset class="row" ng-disabled="vm.searchType != \'filters\'"><div class="col-md-12"><div class="form-group col-md-3"><label>Periodo:</label><select required name="periodo" class="dropdown form-control" ng-model="vm.selectedPeriodo" ng-options="option as ((option.iniPeriodo|date:\'d MMM yyyy\') + \' - \' + (option.finPeriodo|date:\'d MMM yyyy\')) for option in vm.periodos track by option.id" ng-change="vm.search()"></select></div><div class="form-group col-md-3"><label>Programa Educativo:</label><select required name="programaEducativo" class="dropdown form-control" ng-model="vm.selectedProgramaEducativo" ng-options="option as (option.nombre + \' - \' + option.abreviatura) for option in vm.programasEducativos track by option.id" ng-change="vm.search()"></select></div><div class="form-group col-md-3"><label>Estatus:</label><select required name="estatus" class="dropdown form-control" ng-model="vm.selectedEstatusProyecto" ng-options="option for option in vm.estatusProyecto track by option" ng-change="vm.search()"></select></div><div class="form-group col-md-3"><label>Palabras clave:</label><input type="text" ng-model="vm.searchValue" class="form-control" placeholder="Buscar por nombre"></div></div></fieldset></div><br><div class="table-responsive table-projects" ng-show="vm.sSProyectos.length > 0"><table class="jh-table table table-striped table-hover"><thead><tr><th><span>ID</span></th><th class="col-md-4"><span>Nombre</span></th><th class="col-md-3"><span>Unidad Receptora</span></th><th><span>Ambito</span></th><th><span>Estatus</span></th><th><span>Inicio Vigencia</span></th><th><span>Fin Vigencia</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSProyecto in vm.sSProyectos | filter: {nombre:vm.searchValue} track by sSProyecto.id" ng-click="vm.proyectoAccion(sSProyecto.id, true, $event)"><td><a ng-click="vm.proyectoDetalle(sSProyecto.id, false, $event)">{{sSProyecto.id}}</a></td><td>{{sSProyecto.nombre}}</td><td>{{sSProyecto.unidadesReceptoras[0].institucion}}</td><td>{{sSProyecto.ambito}}</td><td>{{sSProyecto.estatus}}</td><td>{{sSProyecto.inicioVigencia | date:\'MMM d, y\'}}</td><td>{{sSProyecto.finVigencia | date:\'MMM d, y\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.proyectoDetalleSolicitud(sSProyecto.id, false, $event)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down">Ver solicitud</span></button> <button type="submit" ng-click="vm.proyectoDetalleAsignacion(sSProyecto.id, false, $event)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="alert alert-info" role="alert" ng-hide="vm.sSProyectos.length > 0">No se encontraron resultados.</div></div>');
$templateCache.put('app/entities/s-s-proyecto/ss-proyecto.html','<div><div class="page-header"><h2>Proyectos</h2></div><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><form class=""><div class="form-group col-md-4"><label>Periodo:</label><select required name="periodo" class="dropdown form-control" ng-model="vm.selectedPeriodo" ng-options="option as ((option.iniPeriodo|date:\'d MMM yyyy\') + \' - \' + (option.finPeriodo|date:\'d MMM yyyy\')) for option in vm.periodos track by option.id" ng-change="vm.search()"></select></div><div class="form-group col-md-4"><label>Palabras clave:</label><input type="text" ng-model="vm.searchValue" class="form-control" placeholder="Buscar por nombre"></div></form></div></div><br><div class="table-responsive table-projects" ng-show="vm.sSProyectos.length > 0"><table class="jh-table table table-striped table-hover"><thead><tr><th><span>ID</span></th><th class="col-md-4"><span>Nombre</span></th><th class="col-md-3"><span>Unidad Receptora</span></th><th><span>Ambito</span></th><th><span>Estatus</span></th><th><span>Inicio Vigencia</span></th><th><span>Fin Vigencia</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSProyecto in vm.sSProyectos | filter: {nombre:vm.searchValue} track by sSProyecto.id" ng-click="vm.proyectoAccion(sSProyecto.id, true, $event)"><td><a ui-sref="ss-proyecto-detail({id:sSProyecto.id})">{{sSProyecto.id}}</a></td><td>{{sSProyecto.nombre}}</td><td>{{sSProyecto.unidadesReceptoras[0].institucion}}</td><td>{{sSProyecto.ambito}}</td><td><a ng-click="vm.proyectoSeguimiento(sSProyecto.id, false, $event)">{{sSProyecto.estatus}}</a></td><td>{{sSProyecto.inicioVigencia | date:\'MMM d, y\'}}</td><td>{{sSProyecto.finVigencia | date:\'MMM d, y\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.proyectoDetalle(sSProyecto.id, false, $event)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ng-click="vm.proyectoImprimir(sSProyecto.id, false, $event)" ng-if="sSProyecto.estatus != \'EDICION\' && sSProyecto.estatus != \'REPLANTEADO\' && sSProyecto.estatus != \'NO_APROBADO\'" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-print"></span> <span class="hidden-sm-down"></span> Solicitud</button> <button type="submit" ng-click="vm.proyectoAcuse(sSProyecto.id, false, $event)" ng-if="sSProyecto.estatus != \'EDICION\' && sSProyecto.estatus != \'REPLANTEADO\' && sSProyecto.estatus != \'NO_APROBADO\'" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-print"></span> <span class="hidden-sm-down"></span> Acuse</button> <button type="submit" ng-click="vm.proyectoEliminar(sSProyecto.id, false, $event)" ng-if="sSProyecto.estatus == \'EDICION\'" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="alert alert-info" role="alert" ng-hide="vm.sSProyectos.length > 0">No se encontraron resultados.</div></div>');
$templateCache.put('app/entities/s-s-sector/s-s-sectors.html','<div><h2>SS Sectors</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-sector.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Sector</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Nombre</span></th><th><span>Descripcion</span></th><th><span>Alta Reg</span></th><th><span>Baja Reg</span></th><th><span>Ult Act Reg</span></th><th><span>Activo</span></th><th><span>Usuario Ult Act</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSSector in vm.sSSectors track by sSSector.id"><td><a ui-sref="ss-sector-detail({id:sSSector.id})">{{sSSector.id}}</a></td><td>{{sSSector.nombre}}</td><td>{{sSSector.descripcion}}</td><td>{{sSSector.altaReg | date:\'medium\'}}</td><td>{{sSSector.bajaReg | date:\'medium\'}}</td><td>{{sSSector.ultActReg | date:\'medium\'}}</td><td>{{sSSector.activo}}</td><td>{{sSSector.usuarioUltAct}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-sector-detail({id:sSSector.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-sector.edit({id:sSSector.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-sector.delete({id:sSSector.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-sector/ss-sector-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSSector.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Sector?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-sector/ss-sector-detail.html','<div><h2><span>SS Sector</span> {{vm.sSSector.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nombre</span></dt><dd><span>{{vm.sSSector.nombre}}</span></dd><dt><span>Descripcion</span></dt><dd><span>{{vm.sSSector.descripcion}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSSector.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSSector.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSSector.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSSector.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSSector.usuarioUltAct}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-sector-detail.edit({id:vm.sSSector.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-sector/ss-sector-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSSectorLabel">Create or edit a SS Sector</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSSector.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSSector.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.sSSector.nombre" required ng-maxlength="50"><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.nombre.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_descripcion">Descripcion</label><input type="text" class="form-control" name="descripcion" id="field_descripcion" ng-model="vm.sSSector.descripcion" ng-maxlength="200"><div ng-show="editForm.descripcion.$invalid"><p class="help-block" ng-show="editForm.descripcion.$error.maxlength">This field cannot be longer than 200 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-reporte/reporte.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" id="mySSAsignacionLabel">Reporte: {{vm.reporte}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.sSPeriodos != null"><label class="col-sm-4 control-label">Periodo</label><div class="col-sm-8 control-text"><select required name="periodo" class="dropdown form-control" ng-model="vm.selectedSSPeriodo" ng-options="option as ((option.iniPeriodo|date:\'d MMM yyyy\') + \' - \' + (option.finPeriodo|date:\'d MMM yyyy\')) for option in vm.sSPeriodos track by option.id"></select></div></div><div class="form-group" ng-if="vm.sSAmbitos != null"><label class="col-sm-4 control-label">\xC1mbito</label><div class="col-sm-8 control-text"><select required class="form-control" id="ambito" name="ambito" ng-model="vm.selectedSSAmbito" ng-options="option for option in vm.sSAmbitos track by option"></select></div></div><div class="form-group" ng-if="vm.centrosDocentes != null"><label class="col-sm-4 control-label">Facultad</label><div class="col-sm-8 control-text"><select required name="centroDocente" class="dropdown form-control" ng-model="vm.selectedCentroDocente" ng-options="option as (option.nombre + \' (\' + option.abreviatura + \')\') for option in vm.centrosDocentes track by option.id"></select></div></div><div class="form-group" ng-if="vm.programasEducativos != null"><label class="col-sm-4 control-label">Perfil</label><div class="col-sm-8 control-text"><select required name="programaEducativo" class="dropdown form-control" ng-model="vm.selectedProgramaEducativo" ng-options="option as (option.nombre + \' (\' + option.centroDocente.abreviatura + \')\') for option in vm.programasEducativos track by option.id"></select></div></div><div class="form-group" ng-if="vm.sSEstatusProyecto != null"><label class="col-sm-4 control-label">Estado</label><div class="col-sm-8 control-text"><select required name="estatus" class="dropdown form-control" ng-model="vm.selectedSSEstatusProyecto" ng-options="option for option in vm.sSEstatusProyecto track by option"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span>Save</span></button></div></div></form>');
$templateCache.put('app/entities/s-s-unidad-receptora/s-s-unidad-receptoras.html','<div><h2>SS Unidad Receptoras</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ss-unidad-receptora.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new SS Unidad Receptora</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Institucion</span></th><th><span>Institucion Abrev</span></th><th><span>Dependencia</span></th><th><span>Dependencia Abrev</span></th><th><span>Unidad Receptora</span></th><th><span>Unidad Receptora Abrev</span></th><th><span>Direccion</span></th><th><span>Email</span></th><th><span>Telefono 1</span></th><th><span>Telefono 2</span></th><th><span>Fax</span></th><th><span>Alta Reg</span></th><th><span>Baja Reg</span></th><th><span>Ult Act Reg</span></th><th><span>Activo</span></th><th><span>Usuario Ult Act</span></th><th><span>Sector</span></th><th><span>Proyecto</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSUnidadReceptora in vm.sSUnidadReceptoras track by sSUnidadReceptora.id"><td><a ui-sref="ss-unidad-receptora-detail({id:sSUnidadReceptora.id})">{{sSUnidadReceptora.id}}</a></td><td>{{sSUnidadReceptora.institucion}}</td><td>{{sSUnidadReceptora.institucionAbrev}}</td><td>{{sSUnidadReceptora.dependencia}}</td><td>{{sSUnidadReceptora.dependenciaAbrev}}</td><td>{{sSUnidadReceptora.unidadReceptora}}</td><td>{{sSUnidadReceptora.unidadReceptoraAbrev}}</td><td>{{sSUnidadReceptora.direccion}}</td><td>{{sSUnidadReceptora.email}}</td><td>{{sSUnidadReceptora.telefono1}}</td><td>{{sSUnidadReceptora.telefono2}}</td><td>{{sSUnidadReceptora.fax}}</td><td>{{sSUnidadReceptora.altaReg | date:\'medium\'}}</td><td>{{sSUnidadReceptora.bajaReg | date:\'medium\'}}</td><td>{{sSUnidadReceptora.ultActReg | date:\'medium\'}}</td><td>{{sSUnidadReceptora.activo}}</td><td>{{sSUnidadReceptora.usuarioUltAct}}</td><td><a ui-sref="ss-sector-detail({id:sSUnidadReceptora.sector.id})">{{sSUnidadReceptora.sector.nombre}}</a></td><td><a ui-sref="ss-proyecto-detail({id:sSUnidadReceptora.proyecto.id})">{{sSUnidadReceptora.proyecto.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ss-unidad-receptora-detail({id:sSUnidadReceptora.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-unidad-receptora.edit({id:sSUnidadReceptora.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="ss-unidad-receptora.delete({id:sSUnidadReceptora.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/s-s-unidad-receptora/ss-unidad-receptora-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sSUnidadReceptora.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SS Unidad Receptora?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/s-s-unidad-receptora/ss-unidad-receptora-detail.html','<div><h2><span>SS Unidad Receptora</span> {{vm.sSUnidadReceptora.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Institucion</span></dt><dd><span>{{vm.sSUnidadReceptora.institucion}}</span></dd><dt><span>Institucion Abrev</span></dt><dd><span>{{vm.sSUnidadReceptora.institucionAbrev}}</span></dd><dt><span>Dependencia</span></dt><dd><span>{{vm.sSUnidadReceptora.dependencia}}</span></dd><dt><span>Dependencia Abrev</span></dt><dd><span>{{vm.sSUnidadReceptora.dependenciaAbrev}}</span></dd><dt><span>Unidad Receptora</span></dt><dd><span>{{vm.sSUnidadReceptora.unidadReceptora}}</span></dd><dt><span>Unidad Receptora Abrev</span></dt><dd><span>{{vm.sSUnidadReceptora.unidadReceptoraAbrev}}</span></dd><dt><span>Direccion</span></dt><dd><span>{{vm.sSUnidadReceptora.direccion}}</span></dd><dt><span>Email</span></dt><dd><span>{{vm.sSUnidadReceptora.email}}</span></dd><dt><span>Telefono 1</span></dt><dd><span>{{vm.sSUnidadReceptora.telefono1}}</span></dd><dt><span>Telefono 2</span></dt><dd><span>{{vm.sSUnidadReceptora.telefono2}}</span></dd><dt><span>Fax</span></dt><dd><span>{{vm.sSUnidadReceptora.fax}}</span></dd><dt><span>Alta Reg</span></dt><dd><span>{{vm.sSUnidadReceptora.altaReg | date:\'medium\'}}</span></dd><dt><span>Baja Reg</span></dt><dd><span>{{vm.sSUnidadReceptora.bajaReg | date:\'medium\'}}</span></dd><dt><span>Ult Act Reg</span></dt><dd><span>{{vm.sSUnidadReceptora.ultActReg | date:\'medium\'}}</span></dd><dt><span>Activo</span></dt><dd><span>{{vm.sSUnidadReceptora.activo}}</span></dd><dt><span>Usuario Ult Act</span></dt><dd><span>{{vm.sSUnidadReceptora.usuarioUltAct}}</span></dd><dt><span>Sector</span></dt><dd><a ui-sref="ss-sector-detail({id:vm.sSUnidadReceptora.sector.id})">{{vm.sSUnidadReceptora.sector.nombre}}</a></dd><dt><span>Proyecto</span></dt><dd><a ui-sref="ss-proyecto-detail({id:vm.sSUnidadReceptora.proyecto.id})">{{vm.sSUnidadReceptora.proyecto.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="ss-unidad-receptora-detail.edit({id:vm.sSUnidadReceptora.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/s-s-unidad-receptora/ss-unidad-receptora-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSUnidadReceptoraLabel">Create or edit a SS Unidad Receptora</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sSUnidadReceptora.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSUnidadReceptora.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_institucion">Institucion</label><input type="text" class="form-control" name="institucion" id="field_institucion" ng-model="vm.sSUnidadReceptora.institucion" ng-maxlength="200"><div ng-show="editForm.institucion.$invalid"><p class="help-block" ng-show="editForm.institucion.$error.maxlength">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_institucionAbrev">Institucion Abrev</label><input type="text" class="form-control" name="institucionAbrev" id="field_institucionAbrev" ng-model="vm.sSUnidadReceptora.institucionAbrev" ng-maxlength="100"><div ng-show="editForm.institucionAbrev.$invalid"><p class="help-block" ng-show="editForm.institucionAbrev.$error.maxlength">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_dependencia">Dependencia</label><input type="text" class="form-control" name="dependencia" id="field_dependencia" ng-model="vm.sSUnidadReceptora.dependencia" required ng-maxlength="200"><div ng-show="editForm.dependencia.$invalid"><p class="help-block" ng-show="editForm.dependencia.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.dependencia.$error.maxlength">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_dependenciaAbrev">Dependencia Abrev</label><input type="text" class="form-control" name="dependenciaAbrev" id="field_dependenciaAbrev" ng-model="vm.sSUnidadReceptora.dependenciaAbrev" ng-maxlength="100"><div ng-show="editForm.dependenciaAbrev.$invalid"><p class="help-block" ng-show="editForm.dependenciaAbrev.$error.maxlength">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_unidadReceptora">Unidad Receptora</label><input type="text" class="form-control" name="unidadReceptora" id="field_unidadReceptora" ng-model="vm.sSUnidadReceptora.unidadReceptora" required ng-maxlength="200"><div ng-show="editForm.unidadReceptora.$invalid"><p class="help-block" ng-show="editForm.unidadReceptora.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.unidadReceptora.$error.maxlength">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_unidadReceptoraAbrev">Unidad Receptora Abrev</label><input type="text" class="form-control" name="unidadReceptoraAbrev" id="field_unidadReceptoraAbrev" ng-model="vm.sSUnidadReceptora.unidadReceptoraAbrev" ng-maxlength="100"><div ng-show="editForm.unidadReceptoraAbrev.$invalid"><p class="help-block" ng-show="editForm.unidadReceptoraAbrev.$error.maxlength">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_direccion">Direccion</label><input type="text" class="form-control" name="direccion" id="field_direccion" ng-model="vm.sSUnidadReceptora.direccion" ng-maxlength="200"><div ng-show="editForm.direccion.$invalid"><p class="help-block" ng-show="editForm.direccion.$error.maxlength">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.sSUnidadReceptora.email" ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_telefono1">Telefono 1</label><input type="text" class="form-control" name="telefono1" id="field_telefono1" ng-model="vm.sSUnidadReceptora.telefono1" ng-maxlength="30"><div ng-show="editForm.telefono1.$invalid"><p class="help-block" ng-show="editForm.telefono1.$error.maxlength">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_telefono2">Telefono 2</label><input type="text" class="form-control" name="telefono2" id="field_telefono2" ng-model="vm.sSUnidadReceptora.telefono2" ng-maxlength="30"><div ng-show="editForm.telefono2.$invalid"><p class="help-block" ng-show="editForm.telefono2.$error.maxlength">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_fax">Fax</label><input type="text" class="form-control" name="fax" id="field_fax" ng-model="vm.sSUnidadReceptora.fax" ng-maxlength="30"><div ng-show="editForm.fax.$invalid"><p class="help-block" ng-show="editForm.fax.$error.maxlength">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_altaReg">Alta Reg</label><div class="input-group"><input id="field_altaReg" type="text" class="form-control" name="altaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSUnidadReceptora.altaReg" is-open="vm.datePickerOpenStatus.altaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'altaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_bajaReg">Baja Reg</label><div class="input-group"><input id="field_bajaReg" type="text" class="form-control" name="bajaReg" datetime-picker="{{dateformat}}" ng-model="vm.sSUnidadReceptora.bajaReg" is-open="vm.datePickerOpenStatus.bajaReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'bajaReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_ultActReg">Ult Act Reg</label><div class="input-group"><input id="field_ultActReg" type="text" class="form-control" name="ultActReg" datetime-picker="{{dateformat}}" ng-model="vm.sSUnidadReceptora.ultActReg" is-open="vm.datePickerOpenStatus.ultActReg"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'ultActReg\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_activo">Activo</label><input type="checkbox" name="activo" id="field_activo" ng-model="vm.sSUnidadReceptora.activo"></div><div class="form-group"><label class="control-label" for="field_usuarioUltAct">Usuario Ult Act</label><input type="text" class="form-control" name="usuarioUltAct" id="field_usuarioUltAct" ng-model="vm.sSUnidadReceptora.usuarioUltAct"></div><div class="form-group"><label for="field_sector">Sector</label><select class="form-control" id="field_sector" name="sector" ng-model="vm.sSUnidadReceptora.sector" ng-options="sSSector as sSSector.nombre for sSSector in vm.sssectors track by sSSector.id"><option value=""></option></select></div><div class="form-group"><label for="field_proyecto">Proyecto</label><select class="form-control" id="field_proyecto" name="proyecto" ng-model="vm.sSUnidadReceptora.proyecto" ng-options="sSProyecto as sSProyecto.id for sSProyecto in vm.ssproyectos track by sSProyecto.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.statusAlumnoPlanDeEstudios.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Status Alumno Plan De Estudios?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios-detail.html','<div><h2><span>Status Alumno Plan De Estudios</span> {{vm.statusAlumnoPlanDeEstudios.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="status-alumno-plan-de-estudios-detail.edit({id:vm.statusAlumnoPlanDeEstudios.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myStatusAlumnoPlanDeEstudiosLabel">Create or edit a Status Alumno Plan De Estudios</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.statusAlumnoPlanDeEstudios.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.statusAlumnoPlanDeEstudios.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios.html','<div><h2>Status Alumno Plan De Estudios</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="status-alumno-plan-de-estudios.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Status Alumno Plan De Estudios</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th></th></tr></thead><tbody><tr ng-repeat="statusAlumnoPlanDeEstudios in vm.statusAlumnoPlanDeEstudios track by statusAlumnoPlanDeEstudios.id"><td><a ui-sref="status-alumno-plan-de-estudios-detail({id:statusAlumnoPlanDeEstudios.id})">{{statusAlumnoPlanDeEstudios.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="status-alumno-plan-de-estudios-detail({id:statusAlumnoPlanDeEstudios.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="status-alumno-plan-de-estudios.edit({id:statusAlumnoPlanDeEstudios.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="status-alumno-plan-de-estudios.delete({id:statusAlumnoPlanDeEstudios.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div class="alert alert-danger">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/serviciosocial/logo-uady.png" alt="logo"> <span></span><!-- <div class="titulo-proy">\n                  <span>SAIE Programa Institucional de Servicio Social</span><span class="navbar-version">v{{VERSION}}</span> \n\t\t</div>\n               --></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><!--                 <li ui-sref-active="active">\n                    <a ui-sref="home" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-home"></span>\n                        <span class="hidden-sm">Inicio</span>\n                    </a>\n                </li> --><li ui-sref-active="active" has-authority="ROLE_USER"><a ui-sref="ss-proyectos-solicitud" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-duplicate"></span>&nbsp; <span>Nueva Solicitud</span></a></li><li ui-sref-active="active" has-authority="ROLE_USER"><a ui-sref="ss-proyectos" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-duplicate"></span>&nbsp; <span>Mis Proyectos</span></a></li><li ng-class="{active: vm.$state.includes(\'ss-proyectos-facultad\')}" has-authority="RESPONSABLE_DE_SS_DE_FACULTAD" uib-dropdown class="dropdown pointer"><a ui-sref="ss-proyectos-facultad" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-th-list"></span>&nbsp; <span>Proyectos de Facultad</span></a></li><li ng-class="{active: vm.$state.includes(\'ss-proyectos-comite\')}" has-authority="MIEMBRO_COMITE_SS" uib-dropdown class="dropdown pointer"><a ui-sref="ss-proyectos-comite" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-menu-hamburger"></span>&nbsp; <span>Proyectos</span></a></li><li ng-class="{active: vm.$state.includes(\'ss-proyectos-central\')}" has-authority="ADMINISTRADOR_DE_PROGRAMA_SS" uib-dropdown class="dropdown pointer"><a ui-sref="ss-proyectos-central" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span>Proyectos</span></a></li><li has-any-authority="ADMINISTRADOR_DE_PROGRAMA_SS, MIEMBRO_COMITE_SS" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-list-alt"></span> <span class="hidden-sm">Reportes </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" has-any-authority="ADMINISTRADOR_DE_PROGRAMA_SS, MIEMBRO_COMITE_SS"><a href="" ng-click="vm.proyectosAprobadosPorModalidad()" id="proyectos_1"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Proyectos Aprobados por Modalidad (y Facultad)</span></a></li><li ui-sref-active="active" has-any-authority="ADMINISTRADOR_DE_PROGRAMA_SS, MIEMBRO_COMITE_SS"><a href="" ng-click="vm.proyectosAprobadosPorPerfilModalidad()" id="proyectos_2"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Proyectos Aprobados por Perfil y Modalidad</span></a></li><li ui-sref-active="active" has-authority="ADMINISTRADOR_DE_PROGRAMA_SS"><a href="" ng-click="vm.proyectosPorDependenciaModalidadTipo()" id="proyectos_3"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Proyectos por Dependencia, Modalidad y Tipo (Aprobados y No Aprobados)</span></a></li><li ui-sref-active="active" has-authority="ADMINISTRADOR_DE_PROGRAMA_SS"><a href="" ng-click="vm.proyectosAprobadosPorArea()" id="proyectos_4"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Proyectos Aprobados por \xC1rea Prioritaria de Desarollo con Prestadores</span></a></li><li ui-sref-active="active" has-authority="ADMINISTRADOR_DE_PROGRAMA_SS"><a href="" ng-click="vm.proyectosAprobadosPorFuncion()" id="proyectos_5"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Proyectos Aprobados por Funci\xF3n en la que Inciden con Prestadores</span></a></li><li ui-sref-active="active" has-any-authority="ADMINISTRADOR_DE_PROGRAMA_SS, MIEMBRO_COMITE_SS"><a href="" ng-click="vm.proyectosAprobadosConApoyoEconomico()" id="proyectos_6"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Proyectos Aprobados con Apoyo Econ\xF3mico (por Facultad)</span></a></li><li ui-sref-active="active" has-authority="ADMINISTRADOR_DE_PROGRAMA_SS"><a href="" ng-click="vm.proyectosAprobadosPorDependenciaVigencia()" id="proyectos_7"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Proyectos Aprobados por Dependencia y Vigencia</span></a></li><li ui-sref-active="active" has-authority="ADMINISTRADOR_DE_PROGRAMA_SS"><a href="" ng-click="vm.directorioDependencias()" id="proyectos_8"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Directorio de Dependencias que Registraron Proyectos</span></a></li><li ui-sref-active="active" has-any-authority="ADMINISTRADOR_DE_PROGRAMA_SS"><a href="" ng-click="vm.plazasDisponiblesAll()" id="prestadoes_5"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Proyectos con plazas disponibles</span></a></li><li ui-sref-active="active" has-any-authority="ADMINISTRADOR_DE_PROGRAMA_SS, MIEMBRO_COMITE_SS"><a href="" ng-click="vm.plazasDisponiblesByFac()" id="prestadoes_4"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Proyectos con plazas disponibles (por Facultad)</span></a></li><li ui-sref-active="active" has-any-authority="ADMINISTRADOR_DE_PROGRAMA_SS, MIEMBRO_COMITE_SS"><a href="" ng-click="vm.prestadoresPorPerfil()" id="prestadoes_1"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Prestadores Asignados de Acuerdo al Perfil Solicitado (por Facultad)</span></a></li><li ui-sref-active="active" has-authority="ADMINISTRADOR_DE_PROGRAMA_SS"><a href="" ng-click="vm.prestadoresPorDependenciaProyecto()" id="prestadores_2"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Prestadores Asignados por Dependencia y por Proyectos de Acuerdo al Perfil</span></a></li><li ui-sref-active="active" has-any-authority="ADMINISTRADOR_DE_PROGRAMA_SS, MIEMBRO_COMITE_SS"><a href="" ng-click="vm.bajasPrestadores()" id="prestadores_3"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Bajas de Prestadores de Acuerdo al Perfil (por Facultad)</span></a></li><li ui-sref-active="active" has-authority="ADMINISTRADOR_DE_PROGRAMA_SS"><a href="" ng-click="vm.proyectosPorPeriodo()" id="proyectos_9"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Reporte de proyectos</span></a></li></ul></li><li has-authority="RESPONSABLE_DE_SS_DE_FACULTAD" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-list-alt"></span> <span class="hidden-sm">Reportes de facultad </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" has-authority="RESPONSABLE_DE_SS_DE_FACULTAD"><a href="" ng-click="vm.proyectosAprobadosPorModalidadFac()" id="proyectos_1"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Proyectos Aprobados por Modalidad</span></a></li><li ui-sref-active="active" has-authority="RESPONSABLE_DE_SS_DE_FACULTAD"><a href="" ng-click="vm.proyectosAprobadosPorPerfilModalidadFac()" id="proyectos_2"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Proyectos Aprobados por Perfil y Modalidad</span></a></li><li ui-sref-active="active" has-authority="RESPONSABLE_DE_SS_DE_FACULTAD"><a href="" ng-click="vm.proyectosAprobadosConApoyoEconomicoFac()" id="proyectos_6"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Proyectos Aprobados con Apoyo Econ\xF3mico</span></a></li><li ui-sref-active="active" has-authority="RESPONSABLE_DE_SS_DE_FACULTAD"><a href="" ng-click="vm.plazasDisponibles()" id="prestadoes_4"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Proyectos con plazas disponibles</span></a></li><li ui-sref-active="active" has-authority="RESPONSABLE_DE_SS_DE_FACULTAD"><a href="" ng-click="vm.prestadoresPorPerfilFac()" id="prestadoes_1"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Prestadores Asignados de Acuerdo al Perfil Solicitados</span></a></li><li ui-sref-active="active" has-authority="RESPONSABLE_DE_SS_DE_FACULTAD"><a href="" ng-click="vm.bajasPrestadoresFac()" id="prestadores_3"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Bajas de Prestadores de Acuerdo al Perfil</span></a></li></ul></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" has-authority="ADMINISTRADOR_DE_PROGRAMA_SS" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-asterisk"></span> <span class="hidden-sm">Cat&aacutelogos </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><!--                         <li ui-sref-active="active">\n                                <a ui-sref="ss-baja" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Ss Baja</span>\n                                </a>\n                            </li> --><!--                         <li ui-sref-active="active">\n                                <a ui-sref="alumno-uady-matriculado" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Alumno Uady Matriculado</span>\n                                </a>\n                            </li> --><!--                         <li ui-sref-active="active">\n                                <a ui-sref="centro-docente" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Centro Docente</span>\n                                </a>\n                            </li> --><!--                         <li ui-sref-active="active">\n                                <a ui-sref="institucion" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Institucion</span>\n                                </a>\n                            </li> --><!--                         <li ui-sref-active="active">\n                                <a ui-sref="persona" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Persona</span>\n                                </a>\n                            </li> --><!--                         <li ui-sref-active="active">\n                                <a ui-sref="plan-de-estudios" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Plan De Estudios</span>\n                                </a>\n                            </li> --><!--                         <li ui-sref-active="active">\n                                <a ui-sref="programa-educativo" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Programa Educativo</span>\n                                </a>\n                            </li> --><!--                         <li ui-sref-active="active">\n                                <a ui-sref="ss-actividad" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Ss Actividad</span>\n                                </a>\n                            </li>--><li ui-sref-active="active"><a ui-sref="ss-anio" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-pencil"></span>&nbsp; <span>A&ntilde;os</span></a></li><li ui-sref-active="active"><a ui-sref="ss-periodo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-pencil"></span>&nbsp; <span>Periodos</span></a></li><li ui-sref-active="active"><a ui-sref="ss-area" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-pencil"></span>&nbsp; <span>Areas</span></a></li><!--                         <li ui-sref-active="active">\n                                <a ui-sref="ss-asignacion" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Ss Asignacion</span>\n                                </a>\n                            </li>--><!--                         <li ui-sref-active="active">\n                                <a ui-sref="campus" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Campus</span>\n                                </a>\n                            </li> --><li ui-sref-active="active"><a ui-sref="ss-funcion" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-pencil"></span>&nbsp; <span>Funciones</span></a></li><li ui-sref-active="active"><a ui-sref="ss-funcionario" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-pencil"></span>&nbsp; <span>Funcionarios</span></a></li><li ui-sref-active="active"><a ui-sref="ss-modalidad" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-pencil"></span>&nbsp; <span>Modalidades</span></a></li><!--                         <li ui-sref-active="active">\n                                <a ui-sref="ss-perfil" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Ss Perfil</span>\n                                </a>\n                            </li> --><!--                         <li ui-sref-active="active">\n                                <a ui-sref="ss-persona" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Ss Persona</span>\n                                </a>\n                            </li> --><!--                         <li ui-sref-active="active">\n                                <a ui-sref="ss-proyecto" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Ss Proyecto</span>\n                                </a>\n                            </li> --><li ui-sref-active="active"><a ui-sref="ss-sector" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-pencil"></span>&nbsp; <span>Sectores</span></a></li><!--                         <li ui-sref-active="active">\n                                <a ui-sref="ss-unidad-receptora" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Ss Unidad Receptora</span>\n                                </a>\n                            </li> --><!--                         <li ui-sref-active="active">\n                                <a ui-sref="status-alumno-plan-de-estudios" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span >Status Alumno Plan De Estudios</span>\n                                </a>\n\t\t\t\t\t\t\t</li> --><li ui-sref-active="active"><a ui-sref="ss-user" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-pencil"></span>&nbsp; <span>Usuarios</span></a></li></ul></li><li uib-dropdown class="dropdown pointer" ng-switch-when="true"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm">Cuenta </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" has-authority="ROLE_USER"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span>Ajustes</span></a></li><li ui-sref-active="active" has-authority="ROLE_USER"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span>Contrase&ntildea</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span>Sessions</span></a></li><li ui-sref-active="active"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Cerrar Sesi&oacuten</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span>Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span>Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span>Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span>Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span>Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span>API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Reset password</h1><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Reset your password</h1><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>La cuenta de correo proporcionada no est\xE1 registrada!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p>Ingresa la cuenta de correo que usaste para registrarte.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p>Revisa tu correo electr\xF3nico por detalles sobre como resetear tu contrase\xF1a.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Tu cuenta de correo es obligatoria.</p><p class="help-block" ng-show="form.email.$error.email">Tu cuenta de correo es inv\xE1lida.</p><p class="help-block" ng-show="form.email.$error.minlength">Tu cuenta de correo debe contener al menos 5 caracteres.</p><p class="help-block" ng-show="form.email.$error.maxlength">Tu cuenta de correo no puede ser m\xE1s larga de 100 caracteres.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset</button></form></div></div></div>');
$templateCache.put('app/entities/s-s-proyecto/ss-perfil-proyecto/ss-perfil-proyecto.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySSMovimientoEstatusProyectoLabel">{{vm.perfil.id == null ? \'Agregar\' : \'Editar\'}} perfil <span class="label label-danger" ng-show="vm.perfil.bajaReg != null">Desactivado</span></h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!-- INICIA EDITOR DE PERFIL --><div class="alert alert-info"><strong>Paso 1:</strong> Seleccionar Perfil y n\xFAmero de prestadores solicitados.</div><div class="controls form-inline form-group"><div class="form-group"><label class="sr-only" for="perfil_programaEducativo"><span class="required-legend">*</span> Licenciatura:</label><select class="form-control" id="perfil_programaEducativo" name="perfil_programaEducativo" ng-model="vm.perfil.programaEducativo" ng-disabled="vm.perfil.id != null" ng-options="programaEducativo as (programaEducativo.nombre + \' (\' + programaEducativo.centroDocente.abreviatura + \') (\' + programaEducativo.abreviatura+\')\') for programaEducativo in vm.programasEducativos track by programaEducativo.id"><option value="" selected="selected" disabled="disabled">Nombre de la licenciatura</option></select></div><div class="form-group"><label class="sr-only" for="perfil_solicitados"><span class="required-legend">*</span> No. de prestadores:</label><input type="number" class="form-control" name="perfil_solicitados" id="perfil_solicitados" placeholder="No. de prestadores" min="0" ng-model="vm.perfil.solicitados"> <button type="button" class="btn btn-warning" has-authority="ADMINISTRADOR_DE_PROGRAMA_SS" ng-click="vm.desactivarPerfil()" ng-show="vm.perfil.id != null && vm.perfil.bajaReg == null && vm.isAdminCentral">Desactivar perfil</button> <button type="button" class="btn btn-success" has-authority="ADMINISTRADOR_DE_PROGRAMA_SS" ng-click="vm.reactivarPerfil()" ng-show="vm.perfil.id != null && vm.perfil.bajaReg != null && vm.isAdminCentral">Reactivar perfil</button></div><div ng-show="editForm.perfil_solicitados.$invalid"><p class="help-block" ng-show="editForm.perfil_solicitados.$error.min">The value cannot be less than 1.</p><p class="help-block" ng-show="editForm.perfil_solicitados.$error.number">Debe ingresar un n\xFAmero.</p></div></div><div class="alert alert-info"><strong>Paso 2:</strong> Presione "Nueva Actividad", llene los campos de Actividad y presione el bot\xF3n de "Agregar Actividad". Repita este paso por cada actividad a describir.</div><div class="form-horizontal clearfix"><label class="col-sm-2 control-label"><span class="required-legend">*</span> Actividades: <small class="badge" uib-tooltip="Enlistar las actividades que realizar\uFFFDn los prestadores de acuerdo a su perfil. Los prestadores s\uFFFDlo realizar\uFFFDn las acciones planeadas, propiciando la aplicaci\uFFFDn de sus conocimientos y la adquisici\uFFFDn de otros que contribuyan a su formaci\uFFFDn acad\uFFFDmica y personal. En las actividades debe contemplarse la difusi\uFFFDn de los resultados logrados por el proyecto de Servicio Social." tooltip-placement="right">?</small></label><div class="col-sm-10"><div ng-show="perfil.actividads.length == 0" class="alert alert-warning" role="alert">No ha definido ninguna actividad.</div><ul class="list-space" ng-if="vm.perfil.actividads.length > 0"><li ng-repeat="actividad in vm.perfil.actividads"><strong>{{actividad.nombre}}</strong> - {{actividad.descripcion}} <button type="button" class="btn btn-xs btn-danger" ng-click="vm.removerActividad($index)"><span class="glyphicon glyphicon-remove"></span></button></li></ul><div class="form-group" ng-hide="vm.showActivityForm == true"><div class="col-sm-10"><button type="button" ng-click="vm.showActivityForm = true" class="btn btn-primary">Nueva Actividad</button></div></div><div class="fieldset-border" ng-if="vm.showActivityForm"><h4 class="legend"><span>Agregar actividad al perfil</span></h4><div class="form-group"><div class="col-sm-10"><label class="sr-only" for="perfil_act_nombre"><span class="required-legend">*</span> Nombre de la actividad:</label><input type="text" class="form-control" ng-maxlength="250" ng-model="vm.actividad.nombre" name="perfil_act_nombre" id="perfil_act_nombre" placeholder="Nombre de la actividad"><div ng-show="editForm.perfil_act_nombre.$invalid"><p class="help-block" ng-show="editForm.perfil_act_nombre.$error.maxlength">Este campo no debe tener m\xE1s de 250 caracteres.</p></div></div></div><div class="form-group"><div class="col-sm-10"><label class="sr-only" for="perfil_act_desc"><span class="required-legend">*</span> Descripci\xF3n:</label><textarea class="form-control col-sm-5" ng-model="vm.actividad.descripcion" name="perfil_act_desc" id="perfil_act_desc" placeholder="Descripci\xF3n" rows="2"></textarea></div></div><div class="form-group"><div class="col-sm-10"><button type="button" ng-click="vm.agregarActividad()" class="btn btn-default" ng-disabled="vm.actividad.nombre == \'\' || vm.actividad.descripcion == \'\' || editForm.perfil_act_nombre.$invalid">Agregar actividad</button></div></div></div></div></div><div class="alert alert-info"><strong>Paso 3:</strong> Presione "Nuevo Responsable", llene los campos de Responsable y presione el bot\xF3n de "Agregar responsable". Repita este paso por cada responsable de prestadores a agregar.</div><div class="form-horizontal clearfix"><label class="col-sm-2 control-label"><span class="required-legend">*</span> Responsable de prestadores: <small class="badge" uib-tooltip="Datos de la persona que apoya, supervisa y eval\uFFFDa al prestador durante el desarrollo de sus actividades. Establece la comunicaci\uFFFDn con el responsable del servicio social de la Facultad de la UADY." tooltip-placement="right">?</small></label><div class="col-sm-10"><div ng-show="vm.perfil.respDePrestadors.length == 0" class="alert alert-warning" role="alert">No ha definido ning\xFAn responsable.</div><table class="table" ng-show="vm.perfil.respDePrestadors.length > 0"><tr><th>Nombre</th><th>T\xEDtulo Profesional</th><th>Email</th><th>Tel\xE9fono</th><th>Tel\xE9fono 2</th><th></th></tr><tr ng-repeat="responsable in vm.perfil.respDePrestadors"><td>{{responsable.nombres}} {{responsable.primerApellido}} {{responsable.segundoApellido}}</td><td>{{responsable.titulo}}</td><td>{{responsable.email}}</td><td>{{responsable.telefono}}</td><td>{{responsable.telefono2}}</td><td><button type="button" class="btn btn-sm btn-primary" ng-show="vm.isAdminCentral || (vm.perfil.asignacions | filter : { respDePrestador : {id : responsable.id } } : true).length == 0" ng-click="vm.formEditarRespDePrestador($index, responsable)"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" class="btn btn-sm btn-danger" ng-hide="(vm.perfil.asignacions | filter : { respDePrestador : {id : responsable.id } } : true).length > 0" ng-click="vm.removerRespDePrestador($index)"><span class="glyphicon glyphicon-remove"></span></button></td></tr></table><div class="form-group" ng-hide="vm.showRespDePrestadorForm == true"><div class="col-sm-10"><button type="button" ng-click="vm.showRespDePrestadorForm = true" class="btn btn-primary">Nuevo Responsable</button></div></div><div class="fieldset-border" ng-if="vm.showRespDePrestadorForm"><h4 class="legend"><span>{{vm.indexRespDePrestador == null ? \'Agregar responsable al perfil\' : \'Editar responsable\'}}</span></h4><div class="form-group"><label class="sr-only" for="respDePrestador_nombres"><span class="required-legend">*</span> Nombres:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDePrestador_nombres" id="respDePrestador_nombres" placeholder="Nombres" ng-model="vm.respDePrestador.nombres" ng-maxlength="60"><div ng-show="editForm.respDePrestador_nombres.$invalid"><p class="help-block" ng-show="editForm.respDePrestador_nombres.$error.maxlength">Este campo no debe tener m\xE1s de 60 caracteres.</p></div></div></div><div class="form-group"><label class="sr-only" for="respDePrestador_primerApellido"><span class="required-legend">*</span> Primer apellido:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDePrestador_primerApellido" id="respDePrestador_primerApellido" placeholder="Primer apellido" ng-model="vm.respDePrestador.primerApellido" ng-maxlength="40"><div ng-show="editForm.respDePrestador_primerApellido.$invalid"><p class="help-block" ng-show="editForm.respDePrestador_primerApellido.$error.maxlength">Este campo no debe tener m\xE1s de 40 caracteres.</p></div></div></div><div class="form-group"><label class="sr-only" for="respDePrestador_segundoApellido">Segundo apellido:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDePrestador_segundoApellido" id="respDePrestador_segundoApellido" placeholder="Segundo apellido" ng-model="vm.respDePrestador.segundoApellido" ng-maxlength="40"><div ng-show="editForm.respDePrestador_segundoApellido.$invalid"><p class="help-block" ng-show="editForm.respDePrestador_segundoApellido.$error.maxlength">Este campo no debe tener m\xE1s de 40 caracteres.</p></div></div></div><div class="form-group"><label class="sr-only" for="respDePrestador_titulo"><span class="required-legend">*</span> T\xEDtulo Profesional:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDePrestador_titulo" id="respDePrestador_titulo" placeholder="T\xEDtulo Profesional" ng-model="vm.respDePrestador.titulo" ng-maxlength="255"><div ng-show="editForm.respDePrestador_titulo.$invalid"><p class="help-block" ng-show="editForm.respDePrestador_titulo.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div><div class="form-group"><label class="sr-only" for="respDePrestador_email"><span class="required-legend">*</span> Email:</label><div class="col-sm-10"><input type="email" class="form-control" name="respDePrestador_email" id="respDePrestador_email" placeholder="Email" ng-model="vm.respDePrestador.email" ng-maxlength="255"><div ng-show="editForm.respDePrestador_email.$invalid"><p class="help-block" ng-show="editForm.respDePrestador_email.$error.email">El correo no es v\xE1lido.</p><p class="help-block" ng-show="editForm.respDePrestador_email.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div><div class="form-group"><label class="sr-only" for="respDePrestador_telefono"><span class="required-legend">*</span> Tel\xE9fono:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDePrestador_telefono" id="respDePrestador_telefono" placeholder="Tel\xE9fono" ng-model="vm.respDePrestador.telefono" ng-maxlength="255"><div ng-show="editForm.respDePrestador_telefono.$invalid"><p class="help-block" ng-show="editForm.respDePrestador_telefono.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div><div class="form-group"><label class="sr-only" for="respDePrestador_telefono2">Tel\xE9fono 2:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDePrestador_telefono2" id="respDePrestador_telefono2" placeholder="Tel\xE9fono 2" ng-model="vm.respDePrestador.telefono2" ng-maxlength="255"><div ng-show="editForm.respDePrestador_telefono2.$invalid"><p class="help-block" ng-show="editForm.respDePrestador_telefono2.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div><div class="form-group"><div class="col-sm-10"><button type="button" ng-click="vm.agregarRespDePrestador()" class="btn btn-default" ng-if="vm.indexRespDePrestador == null" ng-disabled="editForm.respDePrestador_email.$error.email || vm.respDePrestador.email == \'\' || vm.respDePrestador.nombres == \'\' || vm.respDePrestador.primerApellido == \'\' || vm.respDePrestador.titulo == \'\' || vm.respDePrestador.titulo == null || vm.respDePrestador.telefono == \'\'">Agregar responsable</button> <button type="button" ng-click="vm.editarRespDePrestador()" class="btn btn-default" ng-if="vm.indexRespDePrestador != null" ng-disabled="editForm.respDePrestador_email.$error.email || vm.respDePrestador.email == \'\' || vm.respDePrestador.nombres == \'\' || vm.respDePrestador.primerApellido == \'\' || vm.respDePrestador.titulo == \'\' || vm.respDePrestador.titulo == null || vm.respDePrestador.telefono == \'\'">Editar responsable</button></div></div></div></div></div><!-- TERMINA EDITOR DE PERFIL --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-disabled="vm.debeGuardar" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="vm.perfil.programaEducativo == \'\' || vm.perfil.programaEducativo == null || vm.perfil.solicitados == null || vm.perfil.solicitados == 0 || vm.perfil.actividads.length == 0 || vm.perfil.respDePrestadors.length == 0"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-proyecto-central/ss-proyecto-central-detail.html','<div><button type="submit" ui-sref="ss-proyectos-central" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button><h2><span>Proyecto</span> {{vm.sSProyecto.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>ID Proyecto</span></dt><dd><span>{{vm.sSProyecto.proyecto.id}}</span></dd><dt><span>Clave SII</span></dt><!--  poner de ultimo, se va a dejar de usar --><dd><span>{{vm.sSProyecto.proyecto.cveProgramaSII}}</span></dd><dt><span>Nombre</span></dt><dd><span>{{vm.sSProyecto.proyecto.nombre}}</span></dd><dt><span>Ambito</span></dt><dd><span>{{vm.sSProyecto.proyecto.ambito}}</span></dd><dt><span>Estatus</span></dt><dd><span>{{vm.sSProyecto.proyecto.estatus}}</span></dd><dt><span>Aprobado anteriormente</span></dt><dd><span ng-show="vm.sSProyecto.proyecto.aprobadoanteriormente">S\xED</span> <span ng-hide="vm.sSProyecto.proyecto.aprobadoanteriormente">No</span></dd><dt ng-show="vm.sSProyecto.proyecto.aprobadoanteriormente"><span>Num. del proyecto aprobado anteriormente</span></dt><dd ng-show="vm.sSProyecto.proyecto.aprobadoanteriormente"><span>{{vm.sSProyecto.proyecto.proyectoidanterior}}</span></dd><dt><span>Inicio Vigencia</span></dt><dd><span>{{vm.sSProyecto.proyecto.inicioVigencia | date:\'MMM d, y\'}}</span></dd><dt><span>Fin Vigencia</span></dt><dd><span>{{vm.sSProyecto.proyecto.finVigencia | date:\'MMM d, y\'}}</span></dd></dl><h3><strong>Perfiles solicitados</strong></h3><div class="form-group"><select required name="periodo" class="dropdown form-control" ng-model="vm.selectedPeriodo" ng-options="option as ((option.iniPeriodo|date:\'MMM yyyy\') + \' - \' + (option.finPeriodo|date:\'MMM yyyy\')) for option in vm.periodos track by option.id" ng-change="vm.search()"></select></div><div class="panel-perfil panel-group" id="accordion" role="tablist" aria-multiselectable="true" ng-repeat="perfil in vm.sSProyecto.perfiles"><div class="panel panel-default"><div class="panel-heading" role="tab" id="headingOne"><div class="panel-title"><h4>{{ perfil.programaEducativo.nombre }} <span class="label label-danger" ng-show="perfil.bajaReg != null">Desactivado</span> <small>(Solicitados: {{ perfil.solicitados }})</small></h4></div></div><div id="collapseOne" role="tabpanel" uib-collapse="isCollapsed"><div class="panel-body"><ul class="list-unstyled list-perfil" ng-show="perfil.asignacions.length > 0"><li class="row" ng-repeat="asignacion in perfil.asignacions | filter : {periodo: vm.selectedPeriodo}: true"><div class="student col-md-6">{{ asignacion.prestador.persona.apellidoPaterno }} {{ asignacion.prestador.persona.apellidoMaterno }} {{ asignacion.prestador.persona.nombres }} <span class="label label-success" ng-show="asignacion.estatusPrestador == \'LIBERADO\'">Liberado</span> <span class="label label-primary" ng-show="asignacion.estatusPrestador == \'ASIGNADO\'">Asignado</span> <span class="label label-danger" ng-show="asignacion.estatusPrestador == \'BAJA\'">Baja</span></div><div class="col-md-6 text-right"><button type="submit" ng-show="asignacion.estatusPrestador == \'ASIGNADO\'" ui-sref="ss-cambiar-fechas({asig:asignacion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-calendar"></span> <span class="hidden-sm-down"></span> Cambiar fechas</button> <button type="submit" ng-show="asignacion.estatusPrestador == \'LIBERADO\'" ui-sref="ss-cambiar-fechas-confirmacion({asig:asignacion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-calendar"></span> <span class="hidden-sm-down"></span> Cambiar fechas</button> <button type="submit" ng-show="asignacion.estatusPrestador == \'LIBERADO\'" ui-sref="ss-certificar({asig:asignacion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-ok-circle"></span> <span class="hidden-sm-down"></span> Certificar</button> <button type="submit" ng-show="asignacion.estatusPrestador == \'ASIGNADO\'" ui-sref="ss-cancelar-asignacion({asig:asignacion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span> Cancelar asignaci&oacute;n</button> <button type="submit" ng-show="asignacion.estatusPrestador == \'LIBERADO\'" ui-sref="ss-cancelar-liberacion({asig:asignacion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span> Cancelar liberaci\xF3n</button></div></li></ul><div class="alert alert-info text-center" role="alert" ng-show="(perfil.asignacions  | filter : {periodo: vm.selectedPeriodo}: true).length == 0">No hay asignaciones.</div></div></div></div></div><button type="submit" ui-sref="ss-proyectos-central" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/s-s-proyecto/ss-proyecto-central/ss-proyecto-central.html','<div><div class="page-header"><h2>Administrador de Proyectos Central</h2></div><jhi-alert></jhi-alert><div class="container-fluid project-filters"><form name="vm.searchForm"><div class="row"><div class="col-md-12"><label class="radio-inline projects-filters-option"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="student" ng-model="vm.searchType" ng-change="vm.search()"> Buscar por alumno</label></div></div><fieldset class="row" ng-disabled="vm.searchType != \'student\'"><div class="col-md-12"><div class="form-group col-md-8"><input class="form-control" type="text" ng-model="vm.alumno" class="form-control" placeholder="Buscar por nombre o matr&iacute;cula"></div><div class="form-group col-sm-2"><button class="btn btn-primary" ng-click="vm.search()" ng-disabled="vm.alumno == null || vm.alumno == \'\'"><span data-translate="entity.action.search">Buscar</span></button></div></div></fieldset><div class="row"><div class="col-md-12"><label class="radio-inline projects-filters-option"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="filters" ng-model="vm.searchType" ng-change="vm.search()"> Buscar por filtros</label></div></div><fieldset class="row" ng-disabled="vm.searchType != \'filters\'"><div class="col-md-12"><div class="form-group col-md-3"><label>Periodo:</label><select required name="periodo" class="dropdown form-control" ng-model="vm.selectedPeriodo" ng-options="option as ((option.iniPeriodo|date:\'d MMM yyyy\') + \' - \' + (option.finPeriodo|date:\'d MMM yyyy\')) for option in vm.periodos track by option.id" ng-change="vm.search()"></select></div><div class="form-group col-md-3"><label>Centro Docente:</label><select required name="centroDocente" class="dropdown form-control" ng-model="vm.selectedCentroDocente" ng-options="option as (option.nombre + \' - \' + option.abreviatura) for option in vm.centrosDocentes track by option.id" ng-change="vm.search()"></select></div><div class="form-group col-md-3"><label>Programa Educativo:</label><select required name="programaEducativo" class="dropdown form-control" ng-model="vm.selectedProgramaEducativo" ng-options="option as (option.nombre + \' - \' + option.abreviatura) for option in vm.programasEducativos track by option.id" ng-change="vm.search()"></select></div><div class="form-group col-md-3"><label>Estatus:</label><select required name="estatus" class="dropdown form-control" ng-model="vm.selectedEstatusProyecto" ng-options="option for option in vm.estatusProyecto track by option" ng-change="vm.search()"></select></div><div class="form-group col-md-6"><input type="text" ng-model="vm.searchValue" class="form-control" placeholder="Buscar por nombre"></div></div></fieldset></form></div><br><div class="table-responsive table-projects" ng-show="vm.sSProyectos.length > 0"><table class="jh-table table table-striped table-hover"><thead><tr><th><span>ID</span></th><th class="col-md-4"><span>Nombre</span></th><th class="col-md-3"><span>Unidad Receptora</span></th><th><span>Ambito</span></th><th><span>Estatus</span></th><th><span>Inicio Vigencia</span></th><th><span>Fin Vigencia</span></th><th></th></tr></thead><tbody><tr ng-repeat="sSProyecto in vm.sSProyectos | filter: {nombre:vm.searchValue} track by sSProyecto.id" ng-click="vm.proyectoAccion(sSProyecto.id, true, $event)"><td><a ng-click="vm.proyectoDetalleAsignacion(sSProyecto.id, false, $event)">{{sSProyecto.id}}</a></td><td>{{sSProyecto.nombre}}</td><td>{{sSProyecto.unidadesReceptoras[0].institucion}}</td><td>{{sSProyecto.ambito}}</td><td><a ng-click="vm.proyectoSeguimiento(sSProyecto.id, false, $event)">{{sSProyecto.estatus}}</a></td><td>{{sSProyecto.inicioVigencia | date:\'MMM d, y\'}}</td><td>{{sSProyecto.finVigencia | date:\'MMM d, y\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.proyectoDetalleSolicitud(sSProyecto.id, false, $event)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down">Ver solicitud</span></button> <button type="submit" ng-click="vm.proyectoDetalleAsignacion(sSProyecto.id, false, $event)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ng-click="vm.proyectoEditarVigencia(sSProyecto.id, false, $event)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon glyphicon-time"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="alert alert-info" role="alert" ng-hide="vm.sSProyectos.length > 0">No se encontraron resultados.</div></div>');
$templateCache.put('app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud-admin.html','<form name="editForm" id="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class="modal-header"><h2 class="modal-title" id="mySSProyectoLabel">Solicitud de Registro de Proyectos</h2><div class="btn-group" role="group" ng-show="vm.sSProyecto.id !== null"><button class="btn btn-default" disabled="disabled">Estatus: <strong>{{vm.sSProyecto.estatus}}</strong></button> <button type="button" class="btn btn-default" ng-click="vm.editarEstatus()" ng-show="vm.editarEstatus != null"><span class="glyphicon glyphicon-pencil"></span>&nbsp;<span>Editar estatus</span></button></div></div><div class="modal-body"><div class="alert alert-info"><p><strong>Instrucciones:</strong></p>Los campos con * son requeridos para guardar el proyecto.<br>Para poder enviar la solicitud debe capturar todos los campos.</div><uib-tabset active="active"><uib-tab index="0" heading="Datos Generales"><fieldset ng-disabled="vm.isDisabled"><h3>Datos Generales</h3><div class="form-group" ng-show="vm.sSProyecto.id"><label for="id">N\xFAm. de Proyecto:</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSProyecto.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="registradoanteriormente"><span class="required-legend">*</span> \xBFEl proyecto que se est\xE1 registrando ha estado aprobado con anterioridad? <small class="badge" uib-tooltip="En caso de responder que si, escriba el Num. del proyecto aprobado anteriormente" tooltip-placement="right">?</small></label><br><label class="radio-label"><input type="radio" ng-model="vm.sSProyecto.aprobadoanteriormente" name="aprobadoanteriormente" ng-value="true" tabindex="-1" required disabled="disabled"> S\xED</label><label class="radio-label"><input type="radio" ng-model="vm.sSProyecto.aprobadoanteriormente" name="aprobadoanteriormente" ng-value="false" tabindex="-1" required disabled="disabled"> No</label><div class="form-group" ng-show="vm.sSProyecto.aprobadoanteriormente"><label for="idProyAnt">Num. del proyecto aprobado anteriormente:</label><input type="number" class="form-control" name="idProyAnte" id="idProyAnte" placeholder="Num. del proyecto aprobado anteriormente" ng-model="vm.sSProyecto.proyectoidanterior" min="0" ng-maxlength="200" readonly="readonly"><div ng-show="editForm.idProyAnte.$invalid"><p class="help-block" ng-show="editForm.idProyAnte.$error.number">Debe ingresar un n\xFAmero.</p><p class="help-block" ng-show="editForm.idProyAnte.$error.min">El valor no puede ser menor que 0.</p><p class="help-block" ng-show="editForm.idProyAnte.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div><div><p class="help-block" ng-show="editForm.idProyAnte.$viewValue == null || editForm.idProyAnte.$viewValue == \'\'">El campo es requerido</p></div></div></div><div class="form-group"><label class="control-label" for="nombre"><span class="required-legend">*</span> Nombre del Proyecto Social: <small class="badge" uib-tooltip="Deber\xE1 integrar las actividades, \xE1mbito de trabajo y poblaci\xF3n beneficiaria del proyecto de servicio social. Ejemplo: Educaci\xF3n B\xE1sica para Adultos." tooltip-placement="right">?</small></label><textarea required class="form-control big-textarea" name="nombre" id="nomre" ng-model="vm.sSProyecto.nombre" required ng-maxlength="600"></textarea><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.maxlength">Este campo no debe tener m\xE1s de 600 caracteres.</p></div></div><div class="" ng-repeat="unidadReceptora in vm.sSProyecto.unidadesReceptoras"><div class="form-group"><label for="ur_institucion"><span class="required-legend">*</span> Instituci\xF3n: <small class="badge" uib-tooltip="Organismo m\xE1ximo que desempe\xF1a una funci\xF3n de car\xE1cter social. Ejemplo: Secretar\xEDa de Educaci\xF3n P\xFAblica." tooltip-placement="right">?</small></label><input type="text" class="form-control" id="ur_institucion" name="ur_institucion" ng-model="unidadReceptora.institucion" required ng-maxlength="200"><div ng-show="editForm.ur_institucion.$invalid"><p class="help-block" ng-show="editForm.ur_institucion.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div></div><div class="form-group"><label for="ur_sector">Sector:</label><select required class="form-control" id="ur_sector" name="ur_sector" ng-model="unidadReceptora.sector" ng-options="sSSector as sSSector.nombre for sSSector in vm.sssectores track by sSSector.id"></select></div><div class="form-group"><label for="ur_dependencia">Datos de la dependencia: <small class="badge" uib-tooltip="Especificar los datos solicitados del organismo dependiente de la instituci\xF3n mencionada. Ejemplo: Direcci\xF3n de Educaci\xF3n Media Superior y Superior." tooltip-placement="right">?</small></label><div class="form-group"><label class="sr-only" for="ur_dependencia">Nombre:</label><input type="text" class="form-control" name="ur_dependencia" id="ur_dependencia" placeholder="Nombre" ng-model="unidadReceptora.dependencia" required ng-maxlength="200"><div ng-show="editForm.ur_dependencia.$invalid"><p class="help-block" ng-show="editForm.ur_dependencia.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div></div><div class="form-group"><label class="sr-only" for="ur_direccion">Direcci\xF3n:</label><input type="text" class="form-control" name="ur_direccion" id="ur_direccion" placeholder="Direcci\xF3n" ng-model="unidadReceptora.direccion" required ng-maxlength="200"><div ng-show="editForm.ur_direccion.$invalid"><p class="help-block" ng-show="editForm.ur_direccion.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div></div><div class="form-group"><label class="sr-only" for="ur_telefono">Tel\xE9fono y Fax:</label><input type="text" class="form-control" name="ur_telefono" id="ur_telefono" placeholder="Tel\xE9fono y Fax" ng-model="unidadReceptora.telefono1" required ng-maxlength="30"><div ng-show="editForm.ur_telefono.$invalid"><p class="help-block" ng-show="editForm.ur_telefono.$error.maxlength">Este campo no debe tener m\xE1s de 30 caracteres.</p></div></div></div><div class="form-group"><label for="ur_unidadReceptora">Unidad Receptora <small class="badge" uib-tooltip="Se refiere al lugar (departamento, servicio o \xE1rea) donde se coordina el proyecto de servicio social. Ejemplo: Departamento de Educaci\xF3n Media Superior." tooltip-placement="right">?</small></label><input type="text" class="form-control" id="ur_unidadReceptora" name="ur_unidadReceptora" ng-model="unidadReceptora.unidadReceptora" required ng-maxlength="200"><div ng-show="editForm.ur_unidadReceptora.$invalid"><p class="help-block" ng-show="editForm.ur_unidadReceptora.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div></div></div><div class="form-group"><label class="control-label" for="semestres">N\xFAmero de semestres que estar\xE1 vigente: <small class="badge" uib-tooltip="Semestres en los que el proyecto en caso de ser aprobado, se difundir\xE1 en las facultades de los perfiles solicitados, permitiendo a los responsables del proyecto no registrarlos en periodos posteriores." tooltip-placement="right">?</small></label><select required class="form-control" id="semestres" name="semestres" ng-model="vm.sSProyecto.semestres" ng-options="option for option in vm.semestres track by option" disabled="disabled"></select></div><div class="form-group"><label for="funcion">Funci\xF3n en la que incide: <small class="badge" uib-tooltip="Deber\xE1 seleccionar la funci\xF3n que m\xE1s se adapta al proyecto seg\xFAn actividades a desarrollar." tooltip-placement="right">?</small></label><select required class="form-control" id="funcion" name="funcion" ng-model="vm.sSProyecto.funcion" ng-options="sSFuncion as sSFuncion.nombre for sSFuncion in vm.ssfuncions track by sSFuncion.id"><option value=""></option></select></div><div class="form-group"><label for="modalidad">Modalidad: <small class="badge" uib-tooltip="Multidisciplinaria: Significa que varias disciplinas tratan simult\xE1neamente de una cuesti\xF3n dada, sin que se consideren las relaciones posibles que pudieran darse entre ellas ni que estas tengan que ser de manera permanente. \n\t\t\t            Unidisciplinaria: Significa una sola disciplina que trata de una cuesti\xF3n dada sin relaci\xF3n con alguna otra disciplina." tooltip-placement="right">?</small></label><select required class="form-control" id="modalidad" name="modalidad" ng-model="vm.sSProyecto.modalidad" ng-options="sSModalidad as sSModalidad.nombre for sSModalidad in vm.ssmodalidads track by sSModalidad.id"><option value=""></option></select></div><div class="form-group"><label for="area">\xC1rea prioritaria de desarrollo: <small class="badge" uib-tooltip="Seleccionar a la que corresponda el proyecto, de acuerdo al objetivo del mismo." tooltip-placement="right">?</small></label><select required class="form-control" id="area" name="area" ng-model="vm.sSProyecto.area" ng-options="sSArea as sSArea.nombre for sSArea in vm.ssareas track by sSArea.id"><option value=""></option></select></div></fieldset><p class="text-center"><button type="button" class="btn btn-default" ng-click="active = $parent.$parent.active = 1"><span class="glyphicon glyphicon-chevron-right"></span>&nbsp;<span>Next</span></button></p></uib-tab><uib-tab index="1" heading="Datos del proyecto"><fieldset ng-disabled="vm.isDisabled"><h3>Datos del proyecto</h3><div class="form-group"><label class="control-label" for="justificacion">Justificaci\xF3n social: <small class="badge" uib-tooltip="Parte fundamental del proyecto. Deber\xE1 especificar en forma breve la necesidad social que se pretende apoyar a trav\xE9s de la prestaci\xF3n del servicio social, la cual debe estar fundamentada y vinculada con un \xE1rea prioritaria de desarrollo, as\xC3\xAD como especificar el impacto esperado de su implementaci\xF3n. Es necesario plantear el por qu\xE9 se requiere prestadores de servicio social y c\xF3mo las actividades contribuyen a su formaci\xF3n." tooltip-placement="right">?</small></label><textarea required class="form-control big-textarea" name="justificacion" id="justificacion" ng-model="vm.sSProyecto.justificacion"></textarea></div><div class="form-group"><label class="control-label" for="objetivosGenerales">Objetivos: <small class="badge" uib-tooltip="Se enuncia lo que se pretende lograr, considerando el qu\xE9, el por qu\xE9, el para qu\xE9, a trav\xE9s de qu\xE9, qui\xE9n y a qui\xE9nes." tooltip-placement="right">?</small></label><div class="form-group"><label class="sr-only" for="objetivosGenerales">Objetivos Generales:</label><textarea required class="form-control big-textarea" name="objetivosGenerales" id="objetivosGenerales" ng-model="vm.sSProyecto.objetivosGenerales" placeholder="Objetivos generales"></textarea></div><div class="form-group"><label class="sr-only" for="objetivoEspecificos">Objetivos Espec\xEDficos:</label><textarea required class="form-control big-textarea" name="objetivoEspecificos" id="objetivoEspecificos" ng-model="vm.sSProyecto.objetivoEspecificos" placeholder="Objetivos espec\xC3\xADficos"></textarea></div></div><div class="form-group"><label class="control-label" for="beneficiarios">Beneficiarios directos del proyecto: <small class="badge" uib-tooltip="Se refiere a los individuos (grupos o comunidades) que espec\xED\xADficamente recibir\xE1n los beneficios por la realizaci\xF3n del proyecto." tooltip-placement="right">?</small></label><textarea required class="form-control big-textarea" name="beneficiarios" id="beneficiarios" ng-model="vm.sSProyecto.beneficiarios"></textarea></div><div class="form-group"><label class="control-label" for="recursosMateriales">Recursos con los que dispondr\xE1 el prestador: <small class="badge" uib-tooltip="Enlistar los recursos disponibles para el desarrollo de las actividades planeadas, de acuerdo con la clasificaci\xF3n dada en el formato. " tooltip-placement="right">?</small></label><div class="form-group"><label class="sr-only" for="recursosMateriales">Materiales:</label><textarea required class="form-control big-textarea" name="recursosMateriales" id="recursosMateriales" ng-model="vm.sSProyecto.recursosMateriales" placeholder="Materiales"></textarea></div><div class="form-group"><label class="sr-only" for="recursosHumanos">Humanos:</label><textarea required class="form-control big-textarea" name="recursosHumanos" id="recursosHumanos" ng-model="vm.sSProyecto.recursosHumanos" placeholder="Humanos"></textarea></div><div class="form-group"><label class="sr-only" for="recursosInfraestructura">Infraestructura:</label><textarea required class="form-control big-textarea" name="recursosInfraestructura" id="recursosInfraestructura" ng-model="vm.sSProyecto.recursosInfraestructura" placeholder="Infraestructura"></textarea></div></div><div class="form-group"><label for="monto">Apoyo econ\xF3mico (mensual):</label><input required type="number" class="form-control" id="monto" name="monto" min="0" ng-model="vm.sSProyecto.monto"><div ng-show="editForm.monto.$invalid"><p class="help-block" ng-show="editForm.monto.$error.number">Debe ingresar un n\xFAmero.</p><p class="help-block" ng-show="editForm.monto.$error.min">El valor no puede ser menor que 0.</p></div></div><div class="form-group"><label class="control-label" for="viaticosAlimentos">Vi\xE1ticos:</label><div class="form-group"><label for="viaticosAlimentos"><input type="checkbox" class="form-check-input" id="viaticosAlimentos" name="viaticosAlimentos" ng-model="vm.sSProyecto.viaticosAlimentos"> Alimentos</label></div><div class="form-group"><label for="viaticosTransporte"><input type="checkbox" class="form-check-input" id="viaticosTransporte" name="viaticosTransporte" ng-model="vm.sSProyecto.viaticosTransporte"> Transporte</label></div></div><div class="form-group"><label for="horarioPrestador">Horario del prestador:</label><input type="text" class="form-control" id="horarioPrestador" name="horarioPrestador" ng-model="vm.sSProyecto.horarioPrestador" required ng-maxlength="200"><div ng-show="editForm.horarioPrestador.$invalid"><p class="help-block" ng-show="editForm.horarioPrestador.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div></div><div class="form-group"><label class="control-label" for="induccion">Inducci\xF3n: <small class="badge" uib-tooltip="Se refiere a la forma en que el prestador conocer\xE1 sus funciones,  responsabilidades y  al personal  a quien reportar\xE1 sus actividades. En este rubro se deber\xE1 establecer la(s) modalidad(es): taller, entrevista, pl\xE1tica, visitas, entre otras; as\xED como la duraci\xF3n y contenido." tooltip-placement="right">?</small></label><div class="form-group"><label class="sr-only" for="induccion">Descripci\xF3n:</label><textarea required class="form-control" name="induccion" id="induccion" ng-model="vm.sSProyecto.induccion" placeholder="Descripci\xF3n"></textarea></div><div class="form-group"><label for="horasInduccion">Duraci\xF3n de la inducci\xF3n (horas):</label><input type="number" class="form-control" name="horasInduccion" id="horasInduccion" placeholder="Duraci\xF3n en horas" ng-model="vm.sSProyecto.horasInduccion" required min="0" ng-maxlength="200"><div ng-show="editForm.horasInduccion.$invalid"><p class="help-block" ng-show="editForm.horasInduccion.$error.number">Debe ingresar un n\xFAmero.</p><p class="help-block" ng-show="editForm.horasInduccion.$error.min">El valor no puede ser menor que 0.</p><p class="help-block" ng-show="editForm.horasInduccion.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div></div></div><div class="form-group"><label for="supervisionInstrumentos">Supervisi\xF3n y evaluaci\xF3n del prestador por parte del responsable directo: <small class="badge" uib-tooltip="Especificar los instrumentos, periodicidad y criterios. La retroalimentaci\xF3n para el prestador es muy importante dado que el servicio social es un escenario real de aprendizaje." tooltip-placement="right">?</small></label><div class="form-group"><label class="sr-only" for="supervisionInstrumentos">Instrumentos:</label><textarea required class="form-control" name="supervisionInstrumentos" id="supervisionInstrumentos" ng-model="vm.sSProyecto.supervisionInstrumentos" placeholder="Instrumentos"></textarea></div><div class="form-group"><label class="sr-only" for="supervisionPeriodicidad">Periodicidad:</label><textarea required class="form-control" name="supervisionPeriodicidad" id="supervisionPeriodicidad" ng-model="vm.sSProyecto.supervisionPeriodicidad" placeholder="Periodicidad"></textarea></div><div class="form-group"><label class="sr-only" for="supervisionCriterios">Criterios:</label><textarea required class="form-control" name="supervisionCriterios" id="supervisionCriterios" ng-model="vm.sSProyecto.supervisionCriterios" placeholder="Criterios"></textarea></div></div></fieldset><p class="text-center"><button type="button" class="btn btn-default" ng-click="active = $parent.$parent.active = 0"><span class="glyphicon glyphicon-chevron-left"></span>&nbsp;<span>Previous</span></button> <button type="button" class="btn btn-default" ng-click="active = $parent.$parent.active = 2"><span class="glyphicon glyphicon-chevron-right"></span>&nbsp;<span>Next</span></button></p></uib-tab><uib-tab index="2" heading="Perfiles"><fieldset ng-disabled="vm.isDisabled"><h3>Perfiles Solicitados <small class="badge" uib-tooltip="Especificar el n\xFAmero de prestadores solicitados de cada uno de los perfiles para el desarrollo del proyecto. Es necesario escribir correctamente los nombres de las licenciaturas ofrecidas por la UADY." tooltip-placement="right">?</small></h3><div ng-show="vm.sSProyecto.perfils.length == 0" class="alert alert-warning" role="alert">No ha definido ning\xFAn perfil.</div><div class="table-space"><table class="table" ng-show="vm.sSProyecto.perfils.length > 0"><tr><th>Licenciatura</th><th>No. de prestadores</th><th>Tareas</th><th>Responsable de prestadores</th><th></th></tr><tr ng-repeat="perfil in vm.sSProyecto.perfils"><td>{{perfil.programaEducativo.nombre}} <span class="label label-danger" ng-show="perfil.bajaReg != null">Desactivado</span></td><td>{{perfil.solicitados}}</td><td><ul class="list-space" ng-if="perfil.actividads.length > 0"><li ng-repeat="actividad in perfil.actividads"><strong>{{actividad.nombre}}</strong> - {{actividad.descripcion}}</li></ul></td><td><ul class="list-space" ng-if="perfil.respDePrestadors.length > 0"><li ng-repeat="respDePrestador in perfil.respDePrestadors"><strong>{{respDePrestador.nombres}} {{respDePrestador.primerApellido}} {{respDePrestador.segundoApellido}}</strong><br>{{respDePrestador.titulo}}<br>{{respDePrestador.email}}<br>{{respDePrestador.telefono}}, {{respDePrestador.telefono2}}<br></li></ul></td><td><button type="button" ng-show="vm.isDisabled == false" class="btn btn-sm btn-primary" ng-click="vm.editarPerfil($index, perfil)"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-show="vm.isDisabled == false && perfil.asignacions.length == 0" class="btn btn-sm btn-danger" ng-click="vm.removerPerfil($index)"><span class="glyphicon glyphicon-remove"></span></button></td></tr></table></div><button type="button" ng-show="vm.isDisabled == false" ng-click="vm.agregarPerfil()" class="btn btn-primary">Nuevo Perfil</button></fieldset><p class="text-center"><button type="button" class="btn btn-default" ng-click="active = $parent.$parent.active = 1"><span class="glyphicon glyphicon-chevron-left"></span>&nbsp;<span>Previous</span></button> <button type="button" class="btn btn-default" ng-click="active = $parent.$parent.active = 3"><span class="glyphicon glyphicon-chevron-right"></span>&nbsp;<span>Next</span></button></p></uib-tab><uib-tab index="3" heading="Responsable de Proyecto"><fieldset ng-disabled="vm.isDisabled"><h3>Responsable de Proyecto <small class="badge" uib-tooltip="Datos de la persona encargada del dise\xF1o, coordinaci\xF3n, gesti\xF3n de los resultados del proyecto (responsable institucional)." tooltip-placement="right">?</small></h3><div class="form-horizontal" ng-repeat="respDeProyecto in vm.sSProyecto.respDeProyectos"><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_nombres">Nombres:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_nombres" id="respDeProyectos_nombres" placeholder="Nombres" ng-model="respDeProyecto.nombres" required ng-maxlength="60"><div ng-show="editForm.respDeProyectos_nombres.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_nombres.$error.maxlength">Este campo no debe tener m\xE1s de 60 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_primerApellido">Primer apellido:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_primerApellido" id="respDeProyectos_primerApellido" placeholder="Primer apellido" ng-model="respDeProyecto.primerApellido" required ng-maxlength="40"><div ng-show="editForm.respDeProyectos_primerApellido.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_primerApellido.$error.maxlength">Este campo no debe tener m\xE1s de 40 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_segundoApellido">Segundo apellido:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_segundoApellido" id="respDeProyectos_segundoApellido" placeholder="Segundo apellido" ng-model="respDeProyecto.segundoApellido" ng-maxlength="40"><div ng-show="editForm.respDeProyectos_segundoApellido.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_segundoApellido.$error.maxlength">Este campo no debe tener m\xE1s de 40 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_titulo">T\xEDtulo Profesional:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_titulo" id="respDeProyectos_titulo" placeholder="T\xEDtulo Profesional" ng-model="respDeProyecto.titulo" required ng-maxlength="255"><div ng-show="editForm.respDeProyectos_titulo.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_titulo.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_cargo">Cargo:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_cargo" id="respDeProyectos_cargo" placeholder="Cargo" ng-model="respDeProyecto.cargo" required ng-maxlength="255"><div ng-show="editForm.respDeProyectos_cargo.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_cargo.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_email">Email:</label><div class="col-sm-10"><input type="email" class="form-control" name="respDeProyectos_email" id="respDeProyectos_email" placeholder="Email" ng-model="respDeProyecto.email" required ng-maxlength="255"><div ng-show="editForm.respDeProyectos_email.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_email.$error.email">El correo no es v\xE1lido.</p><p class="help-block" ng-show="editForm.respDeProyectos_email.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_telefono">Tel\xE9fono:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_telefono" id="respDeProyectos_telefono" placeholder="Tel\xE9fono" ng-model="respDeProyecto.telefono" required ng-maxlength="255"><div ng-show="editForm.respDeProyectos_telefono.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_telefono.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyecto_telefono2">Tel\xE9fono 2:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_telefono2" id="respDeProyectos_telefono2" placeholder="Tel\xE9fono 2" ng-model="respDeProyecto.telefono2" ng-maxlength="255"><div ng-show="editForm.respDeProyectos_telefono2.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_telefono2.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div></div></fieldset><p class="text-center"><button type="button" class="btn btn-default" ng-click="active = $parent.$parent.active = 2"><span class="glyphicon glyphicon-chevron-left"></span>&nbsp;<span>Previous</span></button></p></uib-tab><uib-tab index="4" heading="Seguimiento" ng-show="vm.sSProyecto.id && vm.showSeguimiento"><fieldset><h3>Seguimiento</h3><div class="table-space"><div ng-show="vm.sSMovimientoEstatusProyectos.length == 0" class="alert alert-warning" role="alert">No existe ning\xFAn movimiento de estatus.</div><table class="table" ng-show="vm.sSMovimientoEstatusProyectos.length > 0"><tr><th>Cambio de estatus</th><th>Fecha</th><th>Observaciones</th></tr><tr ng-repeat="sSMovimientoEstatusProyecto in vm.sSMovimientoEstatusProyectos"><td>{{sSMovimientoEstatusProyecto.estatusMovimiento}}</td><td>{{sSMovimientoEstatusProyecto.fechaMovimiento}}</td><td>{{sSMovimientoEstatusProyecto.observaciones}}</td></tr></table></div></fieldset></uib-tab></uib-tabset></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.clear()" ng-show="vm.isDisabled == false"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Descartar</span></button> <button type="submit" class="btn btn-primary" ng-show="vm.isDisabled == false && vm.save != null" ng-disabled="vm.isSaving || vm.sSProyecto.nombre == null || vm.sSProyecto.unidadesReceptoras[0].institucion == null || editForm.horasInduccion.$error.number || editForm.monto.$error.number"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Guardar</span></button></div></form>');
$templateCache.put('app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud.html','<script>document.addEventListener("wheel", function(event){\n    if(document.activeElement.type === "number"){\n        document.activeElement.blur();\n    }\n});</script><div ng-show="vm.sSProyecto.id == null && vm.periodoVigente == null" class="alert alert-info alert-important" role="alert">No se encuentra abierto el periodo de convocatoria.</div><form ng-hide="vm.sSProyecto.id == null && vm.periodoVigente == null" name="editForm" id="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class="modal-header"><h2 class="modal-title" id="mySSProyectoLabel">Solicitud de Registro de Proyectos</h2><div class="btn-group" role="group" ng-show="vm.sSProyecto.id !== null"><button class="btn btn-default" disabled="disabled">Estatus: <strong>{{vm.sSProyecto.estatus}}</strong></button></div></div><div class="modal-body"><div class="alert alert-info"><p><strong>Instrucciones:</strong></p>Los campos con * son requeridos para guardar el proyecto.<br>Para poder enviar la solicitud debe capturar todos los campos.</div><uib-tabset active="active"><uib-tab index="0" heading="Solicitud de Proyecto"><div id="steps-buttons" class="text-center"><div ng-class="{active: vm.section == 1}"><span>1</span> Datos Generales</div><div ng-class="{active: vm.section == 2}"><span>2</span> Datos del proyecto</div><div ng-class="{active: vm.section == 3}"><span>3</span> Perfiles Solicitados</div><div ng-class="{active: vm.section == 4}"><span>4</span> Responsable de Proyecto</div></div><!-- INICIA SECCION 1 --><section ng-show="vm.section == 1"><fieldset ng-disabled="vm.isDisabled"><h3>Solicitud</h3><div class="form-group" ng-show="vm.sSProyecto.id"><label for="id">Num. de Proyecto:</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sSProyecto.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="registradoanteriormente"><span class="required-legend">*</span> \xBFEl proyecto que se est\xE1 registrando ha estado aprobado con anterioridad? <small class="badge" uib-tooltip="En caso de responder que si, escriba el Num. del proyecto aprobado anteriormente" tooltip-placement="right">?</small></label><br><label class="radio-label"><input type="radio" ng-model="vm.sSProyecto.aprobadoanteriormente" name="aprobadoanteriormente" ng-value="true" tabindex="-1" required> S\xED</label><label class="radio-label"><input type="radio" ng-model="vm.sSProyecto.aprobadoanteriormente" name="aprobadoanteriormente" ng-value="false" tabindex="-1" required> No</label><div class="form-group" ng-show="vm.sSProyecto.aprobadoanteriormente"><label for="idProyAnt">Num. del proyecto aprobado anteriormente:</label><input type="number" class="form-control" name="idProyAnte" id="idProyAnte" placeholder="Num. del proyecto aprobado anteriormente" ng-model="vm.sSProyecto.proyectoidanterior" min="0" ng-maxlength="200"><div ng-show="editForm.idProyAnte.$invalid"><p class="help-block" ng-show="editForm.idProyAnte.$error.number">Debe ingresar un n\xFAmero.</p><p class="help-block" ng-show="editForm.idProyAnte.$error.min">El valor no puede ser menor que 0.</p><p class="help-block" ng-show="editForm.idProyAnte.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div><p class="help-block" ng-show="vm.noExisProyAproAnt">El n\xFAmero del proyecto no existe.</p><div><p class="help-block" ng-show="editForm.idProyAnte.$viewValue == null || editForm.idProyAnte.$viewValue == \'\'">El campo es requerido</p></div></div></div><div class="form-group"><label class="control-label" for="nombre"><span class="required-legend">*</span> Nombre del Proyecto Social: <small class="badge" uib-tooltip="Deber\xE1 integrar las actividades, \xE1mbito de trabajo y poblaci\xF3n beneficiaria del proyecto de servicio social. Ejemplo: Educaci\xF3n B\xE1sica para Adultos." tooltip-placement="right">?</small></label><textarea required class="form-control big-textarea" name="nombre" id="nomre" ng-model="vm.sSProyecto.nombre" required ng-maxlength="600"></textarea><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.maxlength">Este campo no debe tener m\xE1s de 600 caracteres.</p></div></div><div class="" ng-repeat="unidadReceptora in vm.sSProyecto.unidadesReceptoras"><div class="form-group"><label for="ur_institucion"><span class="required-legend">*</span> Instituci\xF3n: <small class="badge" uib-tooltip="Organismo m\xE1ximo que desempe\xF1a una funci\xF3n de car\xE1cter social. Ejemplo: Secretar\xE1a de Educaci\xF3n P\xE1blica." tooltip-placement="right">?</small></label><input type="text" class="form-control" id="ur_institucion" name="ur_institucion" ng-model="unidadReceptora.institucion" required ng-maxlength="200"><div ng-show="editForm.ur_institucion.$invalid"><p class="help-block" ng-show="editForm.ur_institucion.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div></div><div class="form-group"><label for="ur_sector"><span class="required-legend">*</span> Sector:</label><select required class="form-control" id="ur_sector" name="ur_sector" ng-model="unidadReceptora.sector" ng-options="sSSector as sSSector.nombre for sSSector in vm.sssectores track by sSSector.id"></select></div><div class="form-group"><label for="ur_dependencia"><span class="required-legend">*</span> Datos de la dependencia: <small class="badge" uib-tooltip="Especificar los datos solicitados del organismo dependiente de la instituci\xF3n mencionada. Ejemplo: Direcci\xF3n de Educaci\xF3n Media Superior y Superior." tooltip-placement="right">?</small></label><div class="form-group"><label class="sr-only" for="ur_dependencia">Nombre:</label><input type="text" class="form-control" name="ur_dependencia" id="ur_dependencia" placeholder="Nombre" ng-model="unidadReceptora.dependencia" required ng-maxlength="200"><div ng-show="editForm.ur_dependencia.$invalid"><p class="help-block" ng-show="editForm.ur_dependencia.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div></div><div class="form-group"><label class="sr-only" for="ur_direccion">Direcci\xF3n:</label><input type="text" class="form-control" name="ur_direccion" id="ur_direccion" placeholder="Direcci\xF3n" ng-model="unidadReceptora.direccion" required ng-maxlength="200"><div ng-show="editForm.ur_direccion.$invalid"><p class="help-block" ng-show="editForm.ur_direccion.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div></div><div class="form-group"><label class="sr-only" for="ur_telefono">Tel\xE9fono y Fax:</label><input type="text" class="form-control" name="ur_telefono" id="ur_telefono" placeholder="Tel\xE9fono y Fax" ng-model="unidadReceptora.telefono1" required ng-maxlength="30"><div ng-show="editForm.ur_telefono.$invalid"><p class="help-block" ng-show="editForm.ur_telefono.$error.maxlength">Este campo no debe tener m\xE1s de 30 caracteres.</p></div></div></div><div class="form-group"><label for="ur_unidadReceptora"><span class="required-legend">*</span> Unidad Receptora <small class="badge" uib-tooltip="Se refiere al lugar (departamento, servicio o \xC1rea) donde se coordina el proyecto de servicio social. Ejemplo: Departamento de Educaci\xF3n Media Superior." tooltip-placement="right">?</small></label><input type="text" class="form-control" id="ur_unidadReceptora" name="ur_unidadReceptora" ng-model="unidadReceptora.unidadReceptora" required ng-maxlength="200"><div ng-show="editForm.ur_unidadReceptora.$invalid"><p class="help-block" ng-show="editForm.ur_unidadReceptora.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div></div></div><div class="form-group"><label class="control-label" for="semestres"><span class="required-legend">*</span> N\xFAmero de semestres que estar\xE1 vigente: <small class="badge" uib-tooltip="Semestres en los que el proyecto en caso de ser aprobado, se difundir\xE1 en las facultades de los perfiles solicitados, permitiendo a los responsables del proyecto no registrarlos en periodos posteriores." tooltip-placement="right">?</small></label><select required class="form-control" id="semestres" name="semestres" ng-model="vm.sSProyecto.semestres" ng-options="option for option in vm.semestres track by option" ng-disabled="vm.periodoVigente == null"></select></div><div class="form-group"><label for="funcion"><span class="required-legend">*</span> Funci\xF3n en la que incide: <small class="badge" uib-tooltip="Deber\xE1 seleccionar la funci\xF3n que m\xE1s se adapta al proyecto seg\xE1n actividades a desarrollar." tooltip-placement="right">?</small></label><select required class="form-control" id="funcion" name="funcion" ng-model="vm.sSProyecto.funcion" ng-options="sSFuncion as sSFuncion.nombre for sSFuncion in vm.ssfuncions track by sSFuncion.id"><option value=""></option></select></div><div class="form-group"><label for="modalidad"><span class="required-legend">*</span> Modalidad: <small class="badge" uib-tooltip="Multidisciplinaria: Significa que varias disciplinas tratan simult\xE1neamente de una cuesti\xE1n dada, sin que se consideren las relaciones posibles que pudieran darse entre ellas ni que estas tengan que ser de manera permanente. \n\t\t\t            Unidisciplinaria: Significa una sola disciplina que trata de una cuesti\xE1n dada sin relaci\xF3n con alguna otra disciplina." tooltip-placement="right">?</small></label><select required class="form-control" id="modalidad" name="modalidad" ng-model="vm.sSProyecto.modalidad" ng-options="sSModalidad as sSModalidad.nombre for sSModalidad in vm.ssmodalidads track by sSModalidad.id"><option value=""></option></select></div><div class="form-group"><label for="area"><span class="required-legend">*</span> \xC1rea prioritaria de desarrollo: <small class="badge" uib-tooltip="Seleccionar a la que corresponda el proyecto, de acuerdo al objetivo del mismo." tooltip-placement="right">?</small></label><select required class="form-control" id="area" name="area" ng-model="vm.sSProyecto.area" ng-options="sSArea as sSArea.nombre for sSArea in vm.ssareas track by sSArea.id"><option value=""></option></select></div></fieldset></section><!-- TERMINA SECCION 1 --><!-- INICIA SECCION 2 --><section ng-show="vm.section == 2"><fieldset ng-disabled="vm.isDisabled"><h3>Datos del proyecto</h3><div class="form-group"><label class="control-label" for="justificacion"><span class="required-legend">*</span> Justificaci\xF3n social: <small class="badge" uib-tooltip="Parte fundamental del proyecto. Deber\xE1 especificar en forma breve la necesidad social que se pretende apoyar a trav\xE9s de la prestaci\xF3n del servicio social, la cual debe estar fundamentada y vinculada con un \xC1rea prioritaria de desarrollo, as\xE1 como especificar el impacto esperado de su implementaci\xF3n. Es necesario plantear el por qu\xE9 se requiere prestadores de servicio social y c\xE1mo las actividades contribuyen a su formaci\xF3n." tooltip-placement="right">?</small></label><textarea required class="form-control big-textarea" name="justificacion" id="justificacion" ng-model="vm.sSProyecto.justificacion"></textarea></div><div class="form-group"><label class="control-label" for="objetivosGenerales"><span class="required-legend">*</span>Objetivos: <small class="badge" uib-tooltip="Se enuncia lo que se pretende lograr, considerando el qu\xE9, el por qu\xE9, el para qu\xE9, a trav\xE9s de qu\xE9, qui\xE9n y a qui\xE9nes." tooltip-placement="right">?</small></label><div class="form-group"><label class="sr-only" for="objetivosGenerales"><span class="required-legend">*</span> Objetivos Generales:</label><textarea required class="form-control big-textarea" name="objetivosGenerales" id="objetivosGenerales" ng-model="vm.sSProyecto.objetivosGenerales" placeholder="Objetivos generales"></textarea></div><div class="form-group"><label class="sr-only" for="objetivoEspecificos"><span class="required-legend">*</span> Objetivos Espec\xEDficos:</label><textarea required class="form-control big-textarea" name="objetivoEspecificos" id="objetivoEspecificos" ng-model="vm.sSProyecto.objetivoEspecificos" placeholder="Objetivos especificos"></textarea></div></div><div class="form-group"><label class="control-label" for="beneficiarios"><span class="required-legend">*</span> Beneficiarios directos del proyecto: <small class="badge" uib-tooltip="Se refiere a los individuos (grupos o comunidades) que espec\xE1ficamente recibir\xE1n los beneficios por la realizaci\xF3n del proyecto." tooltip-placement="right">?</small></label><textarea required class="form-control big-textarea" name="beneficiarios" id="beneficiarios" ng-model="vm.sSProyecto.beneficiarios"></textarea></div><div class="form-group"><label class="control-label" for="recursosMateriales"><span class="required-legend">*</span> Ambiente seguro para el prestador: <small class="badge" uib-tooltip="Enlistar los recursos disponibles para el desarrollo de las actividades planeadas, de acuerdo con la clasificaci\xF3n dada en el formato. " tooltip-placement="right">?</small></label><div class="form-group"><label class="sr-only" for="recursosMateriales"><span class="required-legend">*</span> Enunciar los materiales, recursos humanos y de infraestructura con los que el prestador contar\xE1 para que realizar las actividades de servicio social:</label><textarea required class="form-control big-textarea" name="recursosMateriales" id="recursosMateriales" ng-model="vm.sSProyecto.recursosMateriales" placeholder="Enunciar los materiales, recursos humanos y de infraestructura con los que el prestador contar\xE1 para que realizar las actividades de servicio social"></textarea></div><div class="form-group"><label class="sr-only" for="recursosHumanos"><span class="required-legend">*</span> Enunciar los protocolos, gu\xEDas o mecanismos de actuaci\xF3n con los que cuenta la instituci\xF3n para prevenir y atender situaciones de riesgo profesional, laboral y/o cualquier otro tipo que atenten contra la integridad del estudiante o sus derechos humanos:</label><textarea required class="form-control big-textarea" name="recursosHumanos" id="recursosHumanos" ng-model="vm.sSProyecto.recursosHumanos" placeholder="Enunciar los protocolos, gu\xEDas o mecanismos de actuaci\xF3n con los que cuenta la instituci\xF3n para prevenir y atender situaciones de riesgo profesional, laboral y/o cualquier otro tipo que atenten contra la integridad del estudiante o sus derechos humanos."></textarea></div><!-- <div class="form-group">\n\t\t\t\t            <label class="sr-only" for="recursosInfraestructura">Infraestructura:</label>\n\t\t\t\t            <textarea required class="form-control big-textarea" name="recursosInfraestructura" id="recursosInfraestructura"\n\t\t\t\t                    ng-model="vm.sSProyecto.recursosInfraestructura" placeholder="Infraestructura"></textarea>\n\t\t\t\t        </div> --></div><div class="form-group"><label for="monto"><span class="required-legend">*</span> Apoyo econ\xF3mico (mensual):</label><input required type="number" class="form-control" id="monto" name="monto" min="0" ng-model="vm.sSProyecto.monto"><div ng-show="editForm.monto.$invalid"><p class="help-block" ng-show="editForm.monto.$error.number">Debe ingresar un n\xFAmero.</p><p class="help-block" ng-show="editForm.monto.$error.min">El valor no puede ser menor que 0.</p></div></div><div class="form-group"><label class="control-label" for="viaticosAlimentos">Vi\xE1ticos:</label><div class="form-group"><label for="viaticosAlimentos"><input type="checkbox" class="form-check-input" id="viaticosAlimentos" name="viaticosAlimentos" ng-model="vm.sSProyecto.viaticosAlimentos"> Alimentos</label></div><div class="form-group"><label for="viaticosTransporte"><input type="checkbox" class="form-check-input" id="viaticosTransporte" name="viaticosTransporte" ng-model="vm.sSProyecto.viaticosTransporte"> Transporte</label></div></div><div class="form-group"><label for="horarioPrestador"><span class="required-legend">*</span> Horario del prestador:</label><input type="text" class="form-control" id="horarioPrestador" name="horarioPrestador" ng-model="vm.sSProyecto.horarioPrestador" required ng-maxlength="200"><div ng-show="editForm.horarioPrestador.$invalid"><p class="help-block" ng-show="editForm.horarioPrestador.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div></div><div class="form-group"><label class="control-label" for="induccion"><span class="required-legend">*</span> Inducci\xF3n: <small class="badge" uib-tooltip="Se refiere a la forma en que el prestador conocer\xE1 sus funciones,  responsabilidades y  al personal  a quien reportar\xE1 sus actividades. En este rubro se deber\xE1 establecer la(s) modalidad(es): taller, entrevista, pl\xE1tica, visitas, entre otras; as\xE1 como la duraci\xF3n y contenido." tooltip-placement="right">?</small></label><div class="form-group"><label class="sr-only" for="induccion">Descripci\xF3n:</label><textarea required class="form-control" name="induccion" id="induccion" ng-model="vm.sSProyecto.induccion" placeholder="Descripci\xF3n"></textarea></div><div class="form-group"><label for="horasInduccion"><span class="required-legend">*</span> Duraci\xF3n de la inducci\xF3n (horas):</label><input type="number" class="form-control" name="horasInduccion" id="horasInduccion" placeholder="Duraci\xF3n en horas" ng-model="vm.sSProyecto.horasInduccion" required min="0" ng-maxlength="200"><div ng-show="editForm.horasInduccion.$invalid"><p class="help-block" ng-show="editForm.horasInduccion.$error.number">Debe ingresar un n\xFAmero.</p><p class="help-block" ng-show="editForm.horasInduccion.$error.min">El valor no puede ser menor que 0.</p><p class="help-block" ng-show="editForm.horasInduccion.$error.maxlength">Este campo no debe tener m\xE1s de 200 caracteres.</p></div></div></div><div class="form-group"><label for="supervisionInstrumentos"><span class="required-legend">*</span> Supervisi\xF3n y evaluaci\xF3n del prestador por parte del responsable directo: <small class="badge" uib-tooltip="Especificar los instrumentos, periodicidad y criterios. La retroalimentaci\xF3n para el prestador es muy importante dado que el servicio social es un escenario real de aprendizaje." tooltip-placement="right">?</small></label><div class="form-group"><label class="sr-only" for="supervisionInstrumentos">Describir la forma en la cual se contabilizar\xE1n las horas del servicio social de acuerdo a la modalidad de prestaci\xF3n (presencial, virtual o h\xEDbrida):</label><textarea required class="form-control" name="supervisionInstrumentos" id="supervisionInstrumentos" ng-model="vm.sSProyecto.supervisionInstrumentos" placeholder="Describir la forma en la cual se contabilizar\xE1n las horas del servicio social de acuerdo a la modalidad de prestaci\xF3n (presencial, virtual o h\xEDbrida)"></textarea></div><div class="form-group"><label class="sr-only" for="supervisionPeriodicidad">Enunciar los medios y formas de supervisi\xF3n de los prestadores de servicio social:</label><textarea required class="form-control" name="supervisionPeriodicidad" id="supervisionPeriodicidad" ng-model="vm.sSProyecto.supervisionPeriodicidad" placeholder="Enunciar los medios y formas de supervisi\xF3n de los prestadores de servicio social"></textarea></div><div class="form-group"><label class="sr-only" for="supervisionCriterios">Describa los requerimientos o perfil deseable necesarios que el estudiante deba de cumplir:</label><textarea required class="form-control" name="supervisionCriterios" id="supervisionCriterios" ng-model="vm.sSProyecto.supervisionCriterios" placeholder="Describa los requerimientos o perfil deseable necesarios que el estudiante deba de cumplir"></textarea></div></div></fieldset></section><!-- TERMINA SECCION 2 --><!-- INICIA SECCION 3 --><section ng-show="vm.section == 3"><fieldset ng-disabled="vm.isDisabled"><h3><span class="required-legend">*</span> Perfiles Solicitados <small class="badge" uib-tooltip="Especificar el n\xE1mero de prestadores solicitados de cada uno de los perfiles para el desarrollo del proyecto. Es necesario escribir correctamente los nombres de las licenciaturas ofrecidas por la UADY." tooltip-placement="right">?</small></h3><div ng-show="vm.sSProyecto.perfils.length == 0" class="alert alert-warning" role="alert">No ha definido ning\xFAn perfil.</div><div class="table-space"><table class="table" ng-show="vm.sSProyecto.perfils.length > 0"><tr><th>Licenciatura</th><th>No. de prestadores</th><th>Tareas</th><th>Responsable de prestadores</th><th></th></tr><tr ng-repeat="perfil in vm.sSProyecto.perfils"><td>{{perfil.programaEducativo.nombre}} <span class="label label-danger" ng-show="perfil.bajaReg != null">Desactivado</span></td><td>{{perfil.solicitados}}</td><td><ul class="list-space" ng-if="perfil.actividads.length > 0"><li ng-repeat="actividad in perfil.actividads"><strong>{{actividad.nombre}}</strong> - {{actividad.descripcion}}</li></ul></td><td><ul class="list-space" ng-if="perfil.respDePrestadors.length > 0"><li ng-repeat="respDePrestador in perfil.respDePrestadors"><strong>{{respDePrestador.nombres}} {{respDePrestador.primerApellido}} {{respDePrestador.segundoApellido}}</strong><br>{{respDePrestador.titulo}}<br>{{respDePrestador.email}}<br>{{respDePrestador.telefono}}, {{respDePrestador.telefono2}}<br></li></ul></td><td><button type="button" ng-show="vm.isDisabled == false" class="btn btn-sm btn-primary" ng-click="vm.editarPerfil($index, perfil)"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-show="vm.isDisabled == false && perfil.asignacions.length == 0" class="btn btn-sm btn-danger" ng-click="vm.removerPerfil($index)"><span class="glyphicon glyphicon-remove"></span></button></td></tr></table></div><button type="button" ng-show="vm.isDisabled == false" ng-click="vm.agregarPerfil()" class="btn btn-primary">Nuevo Perfil</button></fieldset></section><!-- TERMINA SECCION 3 --><!-- INICIA SECCION 4 --><section ng-show="vm.section == 4"><fieldset ng-disabled="vm.isDisabled"><h3><span class="required-legend">*</span> Responsable de Proyecto <small class="badge" uib-tooltip="Datos de la persona encargada del dise\xF1o, coordinaci\xF3n, gesti\xE1n de los resultados del proyecto (responsable institucional)." tooltip-placement="right">?</small></h3><div class="form-horizontal" ng-repeat="respDeProyecto in vm.sSProyecto.respDeProyectos"><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_nombres"><span class="required-legend">*</span> Nombres:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_nombres" id="respDeProyectos_nombres" placeholder="Nombres" ng-model="respDeProyecto.nombres" required ng-maxlength="60"><div ng-show="editForm.respDeProyectos_nombres.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_nombres.$error.maxlength">Este campo no debe tener m\xE1s de 60 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_primerApellido"><span class="required-legend">*</span> Primer apellido:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_primerApellido" id="respDeProyectos_primerApellido" placeholder="Primer apellido" ng-model="respDeProyecto.primerApellido" required ng-maxlength="40"><div ng-show="editForm.respDeProyectos_primerApellido.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_primerApellido.$error.maxlength">Este campo no debe tener m\xE1s de 40 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_segundoApellido">Segundo apellido:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_segundoApellido" id="respDeProyectos_segundoApellido" placeholder="Segundo apellido" ng-model="respDeProyecto.segundoApellido" ng-maxlength="40"><div ng-show="editForm.respDeProyectos_segundoApellido.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_segundoApellido.$error.maxlength">Este campo no debe tener m\xE1s de 40 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_titulo"><span class="required-legend">*</span> T\xEDtulo Profesional:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_titulo" id="respDeProyectos_titulo" placeholder="T\xEDtulo Profesional" ng-model="respDeProyecto.titulo" required ng-maxlength="255"><div ng-show="editForm.respDeProyectos_titulo.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_titulo.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_cargo"><span class="required-legend">*</span> Cargo:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_cargo" id="respDeProyectos_cargo" placeholder="Cargo" ng-model="respDeProyecto.cargo" required ng-maxlength="255"><div ng-show="editForm.respDeProyectos_cargo.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_cargo.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_email"><span class="required-legend">*</span> Email:</label><div class="col-sm-10"><input type="email" class="form-control" name="respDeProyectos_email" id="respDeProyectos_email" placeholder="Email" ng-model="respDeProyecto.email" required ng-maxlength="255"><div ng-show="editForm.respDeProyectos_email.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_email.$error.email">El correo no es v\xE1lido.</p><p class="help-block" ng-show="editForm.respDeProyectos_email.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyectos_telefono"><span class="required-legend">*</span> Tel\xE9fono:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_telefono" id="respDeProyectos_telefono" placeholder="Tel\xE9fono" ng-model="respDeProyecto.telefono" required ng-maxlength="255"><div ng-show="editForm.respDeProyectos_telefono.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_telefono.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="respDeProyecto_telefono2">Tel\xE9fono 2:</label><div class="col-sm-10"><input type="text" class="form-control" name="respDeProyectos_telefono2" id="respDeProyectos_telefono2" placeholder="Tel\xE9fono 2" ng-model="respDeProyecto.telefono2" ng-maxlength="255"><div ng-show="editForm.respDeProyectos_telefono2.$invalid"><p class="help-block" ng-show="editForm.respDeProyectos_telefono2.$error.maxlength">Este campo no debe tener m\xE1s de 255 caracteres.</p></div></div></div></div></fieldset></section><!-- TERMINA SECCION 3 --><!-- the links to our nested sections --><!-- add the active class if the state matches our ui-sref --><p class="text-center"><button type="button" class="btn btn-default" ng-click="vm.previousSection()" ng-show="vm.section > 1 && vm.section < 5"><span class="glyphicon glyphicon-chevron-left"></span>&nbsp;<span>Previous</span></button> <button type="button" class="btn btn-default" ng-click="vm.nextSection()" ng-show="vm.section > 0 && vm.section < 4" ng-disabled="vm.isSaving ||\n\t\t\t\t\t\t\t\t\t(vm.section == 1 && (vm.sSProyecto.nombre == null || vm.sSProyecto.unidadesReceptoras[0].institucion == null)) ||\n\t\t\t\t\t\t\t\t\t(vm.section == 2 && (editForm.horasInduccion.$error.number || editForm.monto.$error.number))"><span class="glyphicon glyphicon-chevron-right"></span>&nbsp;<span>Next</span></button> <button type="submit" class="btn btn-primary" ng-disabled="!editForm.$dirty || (vm.sSProyecto.aprobadoanteriormente && editForm.idProyAnte.$viewValue == null) ||\n\t\t\t\t\t\t(vm.sSProyecto.aprobadoanteriormente && editForm.idProyAnte.$viewValue == \'\') "><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Guardar</span></button></p></uib-tab><uib-tab index="1" heading="Seguimiento" ng-show="vm.sSProyecto.id && vm.showSeguimiento"><fieldset><h3>Seguimiento</h3><div class="table-space"><div ng-show="vm.sSMovimientoEstatusProyectos.length == 0" class="alert alert-warning" role="alert">No existe ning\xFAn movimiento de estatus.</div><table class="table" ng-show="vm.sSMovimientoEstatusProyectos.length > 0"><tr><th>Cambio de estatus</th><th>Fecha</th><th>Observaciones</th></tr><tr ng-repeat="sSMovimientoEstatusProyecto in vm.sSMovimientoEstatusProyectos"><td>{{sSMovimientoEstatusProyecto.estatusMovimiento}}</td><td>{{sSMovimientoEstatusProyecto.fechaMovimiento}}</td><td>{{sSMovimientoEstatusProyecto.observaciones}}</td></tr></table></div></fieldset></uib-tab></uib-tabset></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.clear()" ng-show="vm.isDisabled == false"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Descartar</span></button> <button type="button" class="btn btn-info" ng-click="vm.send()" ng-show="vm.isDisabled == false && vm.send != null && vm.sSProyecto.id != null" ng-disabled="vm.isSaving || editForm.$invalid || editForm.$dirty || vm.sSProyecto.perfils.length <= 0 || \n\t        (vm.sSProyecto.aprobadoanteriormente==true && vm.sSProyecto.proyectoidanterior ==null)\n\t        "><span class="glyphicon glyphicon-send"></span>&nbsp;<span>Enviar</span></button></div></form>');}]);})();